{
  "monitors": {
    "alwaysOffer": "Keep offering monitoring for: {{type}}",
    "watching": "Watching",
    "tasks": "To do",
    "tabsLabel": "DoBox view",
    "newWatcher": "New watcher",
    "watchSomething": "Watch something",
    "createDescription": "A delivery, a contract, an approval. Define what to wait for and where to look.",
    "emptyTitle": "No active watchers",
    "emptyDescription": "When an email in Primary or Updates points to a pending delivery or contract, we suggest a watcher here. You can also create one now.",
    "allOnTrack": "No problems reported",
    "needsAttention_one": "{{count}} monitor needs attention",
    "needsAttention_other": "{{count}} monitors need attention",
    "until": "until {{goal}}",
    "everyHours_one": "every hour",
    "everyHours_other": "every {{count}} hours",
    "since": "Since {{date}}",
    "lastCheck": "Last check",
    "nextCheck": "Next check",
    "email": "Email",
    "website": "Website",
    "trackingPage": "Tracking page",
    "pullRequestSource": "Pull request: {{label}}",
    "emailSource": "Email: {{label}}",
    "reviewSuggestion": "Review suggestion",
    "suggestionTitle": "Watch this {{type}}?",
    "progress": "Monitoring stages",
    "history": "History ({{count}})",
    "hideHistory": "Hide history",
    "loadError": "Could not load monitors.",
    "retry": "Try again",
    "actionError": "Could not save. Check the sources and deadline, refresh the list and try again.",
    "title": "Title",
    "type": "Type",
    "stops": "Stops when",
    "goalPlaceholder": "Tell me when the order is delivered.",
    "checkSentence": "I'll check these sources at the chosen interval until the condition is met.",
    "cadence": "Check every",
    "safetyDeadline": "Safety deadline",
    "tellMe": "Tell me",
    "sources": "Where I'll look",
    "trackingUrl": "Public tracking link",
    "addUrl": "Add a link",
    "removeSource": "Remove source",
    "safetyNote": "If the deadline passes without an outcome, the monitor stops and asks for your attention. Sites requiring login need another source.",
    "cancel": "Cancel",
    "save": "Save monitor",
    "start": "Start watching",
    "notNow": "Not now",
    "close": "Close",
    "checkNow": "Check now",
    "pause": "Pause",
    "resume": "Resume watching",
    "edit": "Edit",
    "stop": "Stop watching",
    "updates": "Updates",
    "howItWatches": "How it watches",
    "waitingFirstCheck": "Waiting for the first check",
    "linkedTask": "Open related task",
    "loadMore": "Load earlier updates",
    "noChangeChecks_one": "{{count}} check with no change · show",
    "noChangeChecks_other": "{{count}} checks with no change · show",
    "types": {
      "invoice": "Sent invoice",
      "approval": "Approval",
      "contract": "Contract",
      "delivery": "Delivery",
      "refund": "Refund",
      "reply": "Reply",
      "custom": "Custom",
      "pull_request": "Pull request"
    },
    "states": {
      "suggested": "Suggested",
      "watching": "Watching",
      "needs_you": "Needs you",
      "paused": "Paused",
      "done": "Done",
      "expired": "Expired",
      "stopped": "Stopped",
      "dismissed": "Dismissed",
      "cleared": "Cleared"
    },
    "health": {
      "on_track": "On track",
      "at_risk": "Needs attention"
    },
    "policies": {
      "on_problem_and_done": "On problems and completion",
      "every_change": "Every change",
      "only_done": "Only on completion"
    },
    "stages": {
      "sent": "Sent",
      "received": "Received",
      "approved": "Approved",
      "scheduled": "Scheduled",
      "paid": "Paid",
      "requested": "Requested",
      "seen": "Seen",
      "decided": "Decided",
      "partially_signed": "Partially signed",
      "signed": "Signed",
      "ordered": "Ordered",
      "shipped": "Shipped",
      "in_transit": "In transit",
      "out_for_delivery": "Out for delivery",
      "delivered": "Delivered",
      "open": "Open",
      "checks_passing": "Checks passing",
      "merged": "Merged"
    },
    "events": {
      "analysisFailed": "The sources could not be analyzed during this check. A retry is scheduled for the next cycle.",
      "noReadableSource": "None of this watcher's sources can be read, so it stopped checking. Add a readable source, or it will resume when a matching email arrives.",
      "quiet": "Nothing new yet. Still watching.",
      "suggested": "Suggested from this email.",
      "started": "Started watching.",
      "start": "Started watching.",
      "pause": "Watching paused.",
      "resume": "Watching resumed.",
      "stop": "Stopped watching.",
      "dismiss": "Suggestion dismissed.",
      "check": "Check requested.",
      "update": "Settings updated.",
      "expired": "The safety deadline has passed. Choose a new deadline, change the sources or stop watching.",
      "check_failed": "Could not read the sources. Check the link or choose another source to continue.",
      "partialFailure": "One source could not be read; this check used the other available sources."
    },
    "ui": {
      "finished": "Finished ({{count}})",
      "needsYou": "Needs you",
      "cantCheck": "Can't check",
      "unreadableSource": "Can't be read ({{reason}}) · not checking this anymore",
      "checkingStopped": "checking stopped",
      "noReadableSourceShort": "No readable source",
      "addSource": "Add a source",
      "nextCheck": "Next check {{time}}",
      "nextCheckInline": "next check {{time}}",
      "dates": {
        "tomorrow": "Tomorrow"
      },
      "openOn": "Open {{name}}",
      "sourcesTitle": "Sources",
      "cantReadSince": "Can't read it since {{time}} ({{reason}})",
      "editSources": "Edit sources",
      "connectGithub": "Connect GitHub",
      "failingReasons": {
        "needs_sign_in": "needs sign-in",
        "not_found": "page not found",
        "blocked": "blocked",
        "unreachable": "unreachable",
        "unreadable": "unreadable",
        "mailbox_unavailable": "mailbox unavailable"
      },
      "notifySentences": {
        "on_problem_and_done": "Tells you on problems and when it's done.",
        "every_change": "Tells you on every change.",
        "only_done": "Tells you only when it's done."
      },
      "stopsOn": "Stops on {{date}} if nothing happens.",
      "menu": "More actions",
      "watch": "Watch",
      "dismiss": "Dismiss",
      "dontSuggestLikeThis": "Don't suggest like this",
      "suggestionRules": "Suggestion rules",
      "suggestionRulesDescription": "Monitors matching a rule are never suggested.",
      "suggestionRulesEmpty": "No rules yet.",
      "suggestionRulesCount": "{{count}}/{{max}} rules",
      "suggestionRulesLimitReached": "You've reached the limit of {{max}} rules.",
      "ruleSentenceFrom": "From {{domain}}",
      "ruleSenderDomain": "Sender domain",
      "ruleSenderDomainPlaceholder": "example.com",
      "ruleTypeAny": "Any type",
      "ruleText": "Match text",
      "ruleTextPlaceholder": "e.g. invoices from this vendor",
      "addRule": "Add rule",
      "ruleRequiredField": "Set at least a sender domain, type or text.",
      "ruleTextTooLong": "Keep it under {{max}} characters.",
      "deleteRule": "Delete rule",
      "suggestedHeading": "Suggested",
      "suggestedHelper": "Nothing runs until you say so",
      "watchingHeading": "Watching",
      "needsYouHeading": "Needs you",
      "watchingTabName": "{{label}} {{count}}",
      "needsYouTabName_one": "{{count}} needs you",
      "needsYouTabName_other": "{{count}} need you",
      "tabNameSeparator": ", ",
      "finishedHeading": "Finished",
      "clear": "Clear",
      "clearAll": "Clear all",
      "clearTitle": "Clear {{title}}",
      "watchAgain": "Watch again",
      "seeCleared": "See cleared ({{count}})",
      "newBadge_one": "{{count}} new",
      "newBadge_other": "{{count}} new",
      "titleWithCondition": "{{title}} · {{condition}}",
      "suggestionSupport": "From {{origin}} · {{cadence}}",
      "stoppedOn": "Stopped on {{date}} · didn't finish",
      "breadcrumb": "DoBox / {{section}}"
    },
    "agent": {
      "create": {
        "title": "New agent watcher",
        "intro": "Describe it in a sentence. I'll suggest where to look, what to warn you about and how often to check. Everything is editable.",
        "goalLabel": "What should I keep an eye on?",
        "goalPlaceholder": "Track what's in Doing and Review on the board and the related PRs. Tell me if anything looks stuck or won't make Oct 31.",
        "suggest": "Suggest",
        "suggesting": "Thinking it through…",
        "suggestError": "Couldn't build a suggestion. Your text is kept, so you can try again.",
        "measureLabel": "What I'll measure",
        "measureType": "number · {{unit}}",
        "sourcesLabel": "Where I'll look",
        "addSource": "+ Add a source",
        "addSourceConfirm": "Add",
        "sourceUrlLabel": "Public HTTPS link",
        "sourcePlaceholder": "https://",
        "sourceInvalid": "Use a public link that starts with https://.",
        "removeSource": "Remove {{name}}",
        "notConnected": "{{name}} · not connected",
        "triggersLabel": "When to warn me",
        "noTriggers": "No warnings. I'll only keep the summary up to date.",
        "cadenceLabel": "Check every",
        "weekdaysOnly": "Weekdays only",
        "digestLabel": "Summary",
        "digestWeekday": "Summary day",
        "digestHour": "Summary time",
        "readOnlyNote": "Read-only. If something needs a decision, I'll tell you instead of acting.",
        "manual": "Set it up manually",
        "backToAgent": "Back to the agent watcher"
      },
      "sourceKinds": {
        "dobox": "DoBox",
        "connection": "Connection",
        "pullRequest": "Pull request",
        "web": "Web",
        "email": "Email",
        "optional": "{{kind}} · optional"
      },
      "triggers": {
        "stale_one": "A card hasn't moved in {{count}} day",
        "stale_other": "A card hasn't moved in {{count}} days",
        "pace": "At the current pace, it won't finish by {{date}}",
        "beforeDeadline_one": "{{count}} day before {{date}}, if anything is still open",
        "beforeDeadline_other": "{{count}} days before {{date}}, if anything is still open",
        "thresholdBelow": "Drops below {{value}}",
        "thresholdAbove": "Goes above {{value}}",
        "changePctDay": "Moves more than {{pct}}% in a day",
        "changePctWeek": "Moves more than {{pct}}% in a week",
        "onDate": "On {{date}}, tell me where it ended",
        "anyChange": "Anything on the page changes",
        "sectionChange": "The {{hint}} changes"
      },
      "triggersShort": {
        "stale": "stuck cards",
        "pace": "pace",
        "beforeDeadline_one": "{{count}} day before {{date}}",
        "beforeDeadline_other": "{{count}} days before {{date}}",
        "thresholdBelow": "it drops below {{value}}",
        "thresholdAbove": "it goes above {{value}}",
        "changePctDay": "{{pct}}% daily moves",
        "changePctWeek": "{{pct}}% weekly moves",
        "onDate": "{{date}}",
        "anyChange": "any change",
        "sectionChange": "changes to the {{hint}}"
      },
      "fields": {
        "days": "Days",
        "byDate": "Date",
        "value": "Value",
        "pct": "Percent",
        "date": "Date",
        "hint": "Section"
      },
      "digest": {
        "none": "None",
        "daily": "Daily",
        "weekly": "Weekly"
      },
      "weekdays": {
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday"
      },
      "warnsOn": "Warns on {{list}}.",
      "warnsWhen": "Warns when {{list}}.",
      "warnsOnAndWhen": "Warns on {{nouns}} and when {{clauses}}.",
      "warnsNothing": "No warnings set.",
      "everyHoursOnWeekdays_one": "every hour on weekdays",
      "everyHoursOnWeekdays_other": "every {{count}} hours on weekdays",
      "view": {
        "itemListTitle": "What I'm tracking",
        "atRisk": "At risk",
        "onTrack": "On track",
        "before": "Before",
        "after": "After",
        "noChangeSince": "No change since {{date}}",
        "firstCheck": "First check is on its way"
      },
      "metric": {
        "today": "{{change}} today",
        "aboveAlert": "{{distance}} above your {{alert}} alert",
        "belowAlert": "{{distance}} below your {{alert}} alert",
        "alertLabel": "Alert {{value}}",
        "rangeLabel": "Range",
        "ranges": {
          "1w": "1W",
          "1m": "1M",
          "all": "Since start"
        },
        "chartLabel": "{{label}} over the selected range: from {{from}} to {{to}}, low {{low}}, high {{high}}",
        "seriesLoading": "Loading history…",
        "seriesError": "Couldn't load the history.",
        "seriesEmpty": "Not enough history yet."
      },
      "row": {
        "atRisk": "At risk",
        "changed": "Changed",
        "noChangeSince": "No change since {{date}}",
        "sparklineLabel": "Trend from {{from}} to {{to}}"
      }
    }
  },
  "appName": "this+that",
  "suggestionTabAlerts": {
    "tabTitle_one": "({{displayCount}}) New suggestion · {{appName}}",
    "tabTitle_other": "({{displayCount}}) New suggestions · {{appName}}"
  },
  "adminGuard": {
    "accessDeniedTitle": "Access denied",
    "accessDeniedSubtitle": "You don't have the required role to access this app."
  },
  "auth": {
    "logoAlt": "this+that",
    "theme": {
      "light": "Light theme",
      "dark": "Dark theme"
    },
    "terms": {
      "agreement": "By continuing, you agree to our",
      "terms": "Terms",
      "and": "and",
      "privacyPolicy": "Privacy Policy"
    },
    "viewLinkedin": "View LinkedIn profile",
    "testimonials": {
      "davidCorts": {
        "quote": "“t+t transforms scattered communication threads into synthesized action. The combination of the DoBox with customized workflows changes the way I work. In short, it delivers meaningful productivity gains in ways other AI tools only promise.”",
        "name": "David Corts",
        "role": "CEO · Fresh Technology"
      },
      "kailyIronsFuda": {
        "quote": "“I've been using this+that for a few months now and it's been a total game changer. I love how it automatically pulls any action items from my email and Slack and puts them in one to-do list. It's easy to get distracted by a full inbox and a Slack feed that never quiets down. t+t serves as my safety net, giving me a one-stop shop to review all of my tasks and act on them right from the app, without losing the context of where they came from.”",
        "name": "Kaily Irons-Fuda",
        "role": "Operations & Program Leader"
      },
      "jasonPinto": {
        "quote": "“t+t quiets messaging noise and gets me to action on important issues fast.”",
        "name": "Jason Pinto",
        "role": "CEO · Appendix 3"
      },
      "artiModhwadia": {
        "quote": "“As a Fractional CFO, I've found this+that to be a genuinely useful way to keep on top of everything that normally slips through the cracks in a busy week. It quietly pulls together tasks and follow-ups from emails, Slack and meetings, so I don't have to rely on memory or scattered to-do lists. What's been most helpful is how it turns all that noise into something structured and actionable. Instead of spending time figuring out what I said I'd do and where I wrote it, I can just focus on priorities, decisions, and moving things forward. It's basically reduced a lot of the mental overhead that comes with juggling multiple clients and conversations at once.”",
        "name": "Arti Modhwadia",
        "role": "Fractional CFO · The Art of Numbers"
      },
      "jonathanKennell": {
        "quote": "“I've been using my inbox as a task list for ages but unless I labeled messages it was hard to tell what was what. With this+that, task emails go into the DoBox where I can manage them and everything else stays in my inbox.”",
        "name": "Jonathan Kennell",
        "role": "Director of Product Management · Canary Technologies"
      },
      "tyranSpeed": {
        "quote": "“this+that has been a game-changer for our firm. As a CPA firm owner, email can take up a significant part of the day, and the automatic draft responses have made that process much more efficient. It gives both me and my staff a strong starting point for client communications, helping us respond faster, stay organized, and spend more time focused on serving our clients.”",
        "name": "Tyran Speed",
        "role": "Co-Owner · Speed Financial Group"
      }
    },
    "security": {
      "passwordNote": "We never see or store your password.",
      "trustHeading": "Built to stay private",
      "commitmentsLink": "Our security commitments",
      "encrypted": "Encrypted in transit & at rest",
      "noTraining": "Never used to train AI",
      "bedrock": "AI runs only inside AWS Bedrock",
      "soc2": "SOC 2 Type I",
      "soc2Type2": "SOC 2 Type II underway",
      "gdpr": "GDPR, CCPA & DPA"
    }
  },
  "markdown": {
    "imageLink": "Image from {{host}}",
    "imageUnavailable": "Image"
  },
  "meta": {
    "description": "this+that - your assistant for effortless communication management"
  },
  "roles": {
    "admin": "Admin",
    "member": "Member",
    "owner": "Owner"
  },
  "dateFormats": {
    "hoursMinutes": "h:mm A",
    "longDate": "MMMM D, YYYY",
    "longDateWithDay": "dddd MMMM D, YYYY",
    "24HourTime": "HH:mm",
    "longDateTime": "MMMM D, YYYY, h:mm A",
    "day": "DD",
    "shortDate": "MM/DD/YYYY",
    "middleDate": "MMMM D, YYYY",
    "inFullDateFormat": "ddd, MMMM DD YYYY - h:mm A",
    "shortDateWithMonth": "MMM D",
    "shortDateWithMonthAndYear": "M/D/YYYY",
    "today": "Today",
    "yesterday": "Yesterday",
    "fullMonthYear": "MMMM yyyy",
    "shortMonthDayYear": "MMM d, yyyy",
    "shortWeekdayMonthOrdinalDayYear": "EEE, MMM do, yyyy",
    "dayOfTheWeekFullName": "EEEE",
    "dayOrdinal": "do",
    "numericDate": "MM/dd/yyyy",
    "shortDateWithTime": "MMM d, HH:mm",
    "shortDateWithMonthDateFns": "MMM d",
    "shortDateTimeWithYear": "MMM D, YYYY HH:mm",
    "shortDateWithMonthAndYearDayjs": "MMM D, YYYY",
    "shortDateTimeAmPm": "MMM D, YYYY h:mm A",
    "shortDateTime": "MM/DD/YYYY, HH:mm",
    "shortDayMonthNumeric": "MM/DD",
    "weekdayDateTimeAmPm": "ddd MMM D, YYYY · h:mm A",
    "noDueDate": "Set due date"
  },
  "common": {
    "previous": "Previous",
    "close": "Close",
    "me": "me",
    "you": "You",
    "gotIt": "Got it!",
    "to": "To",
    "required": "field is required",
    "return": "Return",
    "scrollToViewAll": "Scroll to view all content",
    "cancel": "Cancel",
    "remove": "Remove",
    "next": "Next",
    "move": "Move",
    "create": "Create",
    "schedule": "Schedule",
    "show": "Show",
    "hide": "Hide",
    "loading": {
      "label": "Loading...",
      "message": "Please, wait a moment...",
      "topicsMessage": "Processing topics..."
    },
    "and": "and",
    "errorLoadingData": "Error loading data",
    "processing": "Processing...",
    "form": {
      "emailLabel": "Email",
      "emailPlaceholder": "jane@thisandthat.chat",
      "emailRequired": "Email is required",
      "validEmailRequired": "Please enter a valid email address",
      "firstNameLabel": "First name",
      "firstNamePlaceholder": "Jane",
      "firstNameRequired": "First name is required",
      "lastNameLabel": "Last name",
      "lastNamePlaceholder": "Smith",
      "lastNameRequired": "Last name is required",
      "titleLabel": "Job title",
      "titlePlaceholder": "Senior Manager",
      "titleRequired": "Job title is required"
    },
    "confirmationModal": {
      "confirmAction": "Confirm",
      "confirmDeletionTitle": "Confirm deletion",
      "deleteConfirmationDescription": "Are you sure you want to delete the selected item(s)? This action cannot be undone.",
      "deleteActionButtonLabel": "Delete",
      "cancelButtonLabel": "Cancel",
      "leaveTaskGroup": {
        "title": "Leave this task group?",
        "description": "If you leave, you'll lose access to this task group unless someone adds you back.",
        "actionLabel": "Leave task group"
      }
    },
    "signupFooterBanner": {
      "dontHaveAnAccount": "Don’t have an account?",
      "signup": "Sign up"
    },
    "sidebar": {
      "home": "Home",
      "doBox": "DoBox",
      "tutorial": "Tutorial",
      "account": "Account settings",
      "integration": "Integrations",
      "team": "Team",
      "inbox": "Inbox",
      "support": "Help + support",
      "defaultUserName": "Unnamed User",
      "signOut": "Sign out",
      "terms": "Terms",
      "dotSeparator": "⏺",
      "policy": "Policy",
      "website": "Visit our website",
      "websiteUrl": "https://www.thisandthat.chat",
      "hiUser": {
        "title": "Hi {{firstName}}!",
        "subtitle": "Select below to change your current email",
        "addEmail": "Add new email"
      },
      "logo": "this+that",
      "logoContracted": "t+t",
      "flows": "Flows",
      "mcpConnections": "MCP Servers",
      "billing": "Billing",
      "assistant": "Assistant",
      "brain": "Brain",
      "calendar": "Calendar",
      "contacts": "Contacts",
      "teamSettings": "Team settings",
      "teamSwitcher": {
        "label": "ACTIVE TEAM",
        "ariaLabel": "Active team switcher",
        "manageTeams": "Manage teams",
        "switchTeam": "SWITCH TEAM",
        "membersAndRole_one": "{{count}} member · {{role}}",
        "membersAndRole_other": "{{count}} members · {{role}}",
        "pendingInvitesCount_one": "{{count}} pending invite",
        "pendingInvitesCount_other": "{{count}} pending invites",
        "reviewAndRespond": "Review & respond"
      }
    },
    "theme_light": "Light",
    "theme_dark": "Dark",
    "theme_label": "Theme",
    "calendarSelection": {
      "selectCalendar": "Select calendar",
      "chooseCalendar": "Choose a calendar to connect:",
      "googleCalendar": "Google Calendar",
      "outlookCalendar": "Outlook Calendar"
    },
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "saving": "Saving...",
    "maxEmailCounter": "99+",
    "partialCounter": "{{count}}+",
    "back": "Back",
    "ellipsis": "...",
    "timeInputPlaceholder": "--:--"
  },
  "login": {
    "inAppBrowserTitle": "In-app browser detected",
    "inAppBrowserMessage": "For a secure login experience, please open this page in your system browser. Tap the menu (⋮ or ⋯) and select \"Open in browser\".",
    "signIn": "Log in",
    "orLogInWith": "or log in with",
    "dontHaveAnAccount": "Don't have an account?",
    "signUp": "Sign up",
    "passwordLabel": "Password",
    "passwordPlaceholder": "*********",
    "forgetPassword": "Forgot your password?",
    "loginError": "Please check your credentials and try again.",
    "loginWithGoogle": "Google",
    "loginWithMicrosoft": "Microsoft",
    "loginWithSSO": "SSO",
    "validEmail": "Must be a valid email address",
    "passwordRequired": "Password is required",
    "autoSigningIn": "Signing you in…",
    "mfa": {
      "title": "Two-step verification",
      "instruction": "Enter the 6-digit code from your authenticator app.",
      "backupInstruction": "Enter one of your backup codes (just one, not all of them).",
      "codeLabel": "Verification code",
      "codePlaceholder": "123456",
      "backupCodePlaceholder": "e.g. z77kx90r",
      "useBackupCode": "Use a backup code instead",
      "useAuthenticator": "Use your authenticator app instead",
      "verify": "Verify",
      "error": "Invalid code. Please try again.",
      "clientTrust": "We need to verify this device before continuing. Please follow the verification prompts."
    },
    "welcomeBack": "Welcome back to your assistant",
    "continueWithGoogle": "Continue with Google",
    "continueWithMicrosoft": "Continue with Microsoft",
    "moreSignInOptions": "More sign-in options",
    "orUseEmail": "or use your email"
  },
  "ssoLogin": {
    "title": "Log in",
    "subTitle": "Your organization uses Single Sign-On (SSO). Log in using your SSO credentials.",
    "emailPlaceholder": "Enter your work email",
    "validEmail": "Must be a valid email address",
    "orLogInWith": "or",
    "loginWithoutSSO": "Log in without SSO",
    "loginButton": "Log in",
    "unauthorizedError": "SSO is not enabled for your domain. Please contact our support team for assistance."
  },
  "stats": {
    "dataHealth": {
      "title": "Integrity checks",
      "asOf": "as of {{value}}",
      "columns": {
        "check": "Check",
        "description": "What it means",
        "trend": "Trend",
        "value": "Value",
        "status": "Status"
      },
      "status": {
        "passing": "Passing",
        "warning": "Warning",
        "failing": "Failing"
      },
      "descriptions": {
        "brokenTeams": "Teams with no owner or billing record",
        "brokenTeamInvites": "Invites to teams that no longer exist",
        "orphanedTeamMembers": "Members pointing to deleted users",
        "orphanedInboxEntries": "Entries without a valid owner",
        "orphanedTaskGroups": "Groups whose owner or team no longer exists",
        "orphanedRecurrenceEntries": "Recurring entries without a parent",
        "staleWebSockets": "Connections older than 24h still registered"
      }
    },
    "focusChart": {
      "min": "min {{value}}",
      "max": "max {{value}}",
      "deltaSuffix": "in period"
    },
    "counterGrid": {
      "ariaLabel": "Select a metric to focus"
    },
    "fieldSubLabels": {
      "users": "all accounts",
      "teams": "incl. starter",
      "inboxEntries": "tasks, suggestions, approvals",
      "contacts": "auto-built CRM",
      "taskGroups": "shared lists",
      "pushSubscriptions": "web push",
      "invitedUsers": "pending invites",
      "googleCredentials": "Gmail, Calendar, Drive",
      "microsoftCredentials": "Outlook mail + calendar",
      "slackCredentials": "Slack workspaces",
      "slackUserCredentials": "Slack user tokens",
      "integrationRequests": "user requests",
      "userCommunications": "ingested messages",
      "activityLogs": "audit rows",
      "doBoxConfigs": "users with rules",
      "recurrenceInboxEntries": "recurring tasks",
      "bannerContent": "active banners",
      "userCommunicationAgents": "automations",
      "agentExecutions": "flow runs",
      "orphanedTeamMembers": "no matching team",
      "brokenTeams": "missing owner",
      "orphanedInboxEntries": "no matching user",
      "orphanedTaskGroups": "no matching user",
      "orphanedRecurrenceEntries": "no matching entry",
      "staleWebSockets": "dead connections",
      "brokenTeamInvites": "invalid invites"
    },
    "pageTitle": "Database statistics",
    "mobilePageTitle": "Statistics",
    "pageDescription": "Times are shown in the local timezone",
    "loadingChart": "Loading {{name}}...",
    "loadingCharts": "Loading charts...",
    "tabs": {
      "ariaLabel": "Stats tabs",
      "overview": "Overview",
      "integrations": "Integrations",
      "engagement": "Engagement",
      "aiAgents": "AI Agents",
      "dataHealth": "Data Health"
    },
    "fieldLabels": {
      "users": "Users",
      "teams": "Teams",
      "invitedUsers": "Invited users",
      "googleCredentials": "Google",
      "microsoftCredentials": "Microsoft",
      "slackCredentials": "Slack",
      "slackUserCredentials": "Slack (User)",
      "orphanedTeamMembers": "Orphaned team members",
      "brokenTeams": "Broken teams",
      "orphanedInboxEntries": "Orphaned inbox entries",
      "orphanedTaskGroups": "Orphaned task groups",
      "orphanedRecurrenceEntries": "Orphaned recurrence entries",
      "staleWebSockets": "Stale websockets",
      "brokenTeamInvites": "Broken team invites",
      "bannerContent": "Banner content",
      "userCommunications": "User communications",
      "integrationRequests": "Integration requests",
      "inboxEntries": "Inbox entries",
      "recurrenceInboxEntries": "Recurring inbox entries",
      "taskGroups": "Task groups",
      "contacts": "Contacts",
      "doBoxConfigs": "DoBox configs",
      "pushSubscriptions": "Push subscriptions",
      "userCommunicationAgents": "Communication agents",
      "agentExecutions": "Agent executions",
      "activityLogs": "Activity logs"
    },
    "window": {
      "label_one": "{{start}} → {{end}} · {{count}} snapshot",
      "label_other": "{{start}} → {{end}} · {{count}} snapshots"
    },
    "staleSnapshotBanner": {
      "title": "Snapshot data is frozen",
      "body_one": "Last snapshot on {{date}}, {{count}} day ago",
      "body_other": "Last snapshot on {{date}}, {{count}} days ago"
    }
  },
  "adminTeams": {
    "pageTitle": "Teams",
    "pageDescription": "Plan, members, wallets and credits per team",
    "search": {
      "mode": {
        "ariaLabel": "Search mode",
        "email": "Email",
        "name": "Team name",
        "id": "ID"
      },
      "placeholder": {
        "email": "customer@company.com",
        "name": "Team name",
        "id": "tm_… or user_…"
      },
      "hint": {
        "email": "Exact and fast: email is the user table key and is stored in plaintext.",
        "name": "Matches decrypted team names.",
        "id": "Team id, Clerk user id, or wallet key."
      },
      "inputAriaLabel": "Search teams",
      "noMatches": "No team or wallet matches “{{query}}”.",
      "matchNote": {
        "member": "member {{value}}",
        "name": "name match",
        "teamId": "team id",
        "memberId": "member id {{value}}"
      },
      "columns": {
        "team": "Team",
        "plan": "Plan",
        "subscription": "Subscription",
        "trial": "Trial",
        "members": "Members",
        "teamWallet": "Team wallet"
      },
      "noTeamWallet": "No team wallet",
      "memberCount": "{{count}} members",
      "orphanedWallets": {
        "title": "Orphaned wallets",
        "deletedAccount": "Deleted account",
        "personalWallet": "Personal wallet · {{balance}} credits",
        "note": "User row removed; wallet retained because a balance is money."
      },
      "submit": "Search",
      "loading": "Searching…",
      "errors": {
        "nameTooShort": "Type at least {{min}} characters to search by team name.",
        "invalidEmail": "Enter a valid email address.",
        "failed": "The search failed. Try again."
      }
    },
    "status": {
      "active": "Active",
      "pastDue": "Past due",
      "none": "No Stripe subscription",
      "trialing": "Trialing",
      "unpaid": "Unpaid",
      "canceled": "Canceled",
      "incomplete": "Incomplete",
      "incompleteExpired": "Incomplete (expired)",
      "paused": "Paused"
    },
    "trial": {
      "appEnds": "In-app trial ends {{date}}",
      "stripeEnded": "Stripe trial ended {{date}}",
      "none": "None"
    },
    "detail": {
      "addCredits": "Add credits",
      "teamIdSubtitle": "Team ID: {{id}}",
      "loading": "Loading team…",
      "errors": {
        "failed": "Could not load this team. Try again."
      }
    },
    "tabs": {
      "ariaLabel": "Team detail sections",
      "overview": "Overview",
      "members": "Members",
      "history": "History",
      "usage": "Usage"
    },
    "overview": {
      "wallet": {
        "title": "Team wallet",
        "balance": "Balance",
        "updatedMeta": "credits · updated {{date}}",
        "negativeBanner": "Negative balance. Nothing blocks spend before a model call, so this keeps falling until credited.",
        "grantedPlan": "Granted · plan",
        "grantedPurchased": "Granted · purchased",
        "grantedTransferIn": "Granted · transfer in",
        "spent": "Spent",
        "adjustments": "Adjustments & transfers out",
        "footnote": "Adjustments move only the balance, so they are listed apart from the granted/spent counters.",
        "emptyHeading": "No team wallet",
        "emptyBody": "No movement has ever been written to this team, so the row does not exist. This is not a zero balance. While the team is unfunded, each member's spend is charged to their personal wallet and tagged with this team.",
        "emptyCreates": "Adding credits here creates the wallet.",
        "noWallet": "no wallet"
      },
      "billing": {
        "title": "Billing",
        "source": "from owner row",
        "plan": "Plan",
        "status": "Status",
        "seats": "Seats",
        "seatsValue": "{{seats}} billed · {{members}} members",
        "currentPeriod": "Current period",
        "inAppTrial": "In-app trial",
        "stripeTrial": "Stripe trial",
        "trialEnds": "Ends {{date}}",
        "trialEnded": "Ended {{date}}",
        "owner": "Owner",
        "footnote": "No plan allowance exists on any record, so there is no “used of” figure — only the absolute balance.",
        "periodValue": "{{start}} – {{end}}"
      },
      "usage": {
        "title": "{{month}} usage",
        "measured": "measured",
        "creditsMeasured": "credits measured",
        "modelCost": "model cost",
        "billedToTeamWallet": "Billed to team wallet (ledger)",
        "billedToMembers": "Billed to members on behalf of team",
        "footnote": "Measured usage and billed credits differ on purpose.",
        "seeWhy": "See why"
      }
    },
    "members": {
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "personalWallet": "Personal wallet",
        "usageThisMonth": "Usage this month",
        "lastActivity": "Last activity"
      },
      "sort": {
        "ariaLabel": "Sort members",
        "balance": "Balance",
        "usage": "Usage",
        "name": "Name"
      },
      "noWallet": "No wallet yet",
      "usageThisMonth": "Usage {{value}}",
      "lastActivity": "Last {{date}}",
      "add": "Add",
      "footer": "Sorted by balance ascending: negative first, then zero, then positive; members with no wallet are listed last. Usage is measured, not billed."
    },
    "history": {
      "walletSelectAriaLabel": "Select wallet",
      "walletOption": {
        "team": "Team wallet — {{balance}} credits",
        "teamNoWallet": "Team wallet — no wallet",
        "member": "{{name}} — {{balance}} credits",
        "memberNoWallet": "{{name}} — no wallet"
      },
      "kindAriaLabel": "Filter by kind",
      "kind": {
        "all": "All",
        "grants": "Grants",
        "spend": "Spend",
        "adjustments": "Adjustments",
        "expiries": "Expiries"
      },
      "rangeAriaLabel": "Filter by range",
      "range": {
        "allTime": "All time",
        "days30": "30 days",
        "days7": "7 days"
      },
      "addCreditsToWallet": "Add credits to this wallet",
      "columns": {
        "date": "Date",
        "kind": "Kind",
        "amount": "Amount",
        "context": "Context",
        "actor": "Actor",
        "onBehalfOf": "On behalf of"
      },
      "context": {
        "debitMain": "{{feature}} · {{family}}",
        "debitSub": "{{in}} in · {{out}} out · {{cacheRead}} cache read · {{usd}} · rate {{rate}}",
        "grantPlan": "Monthly plan grant",
        "grantPlanUntil": "Monthly plan grant · until {{date}}",
        "expirePlan": "Previous plan balance expired",
        "purchase": "Credit purchase",
        "transferIn": "Transfer received",
        "transferOut": "Transfer sent",
        "adjustment": "Manual adjustment",
        "onBehalf": "{{teamName}} (unfunded)"
      },
      "actor": {
        "operator": "{{email}} (support)",
        "deletedAccount": "Deleted account",
        "system": "System"
      },
      "loadOlder": "Load older",
      "empty": {
        "default": {
          "title": "No movements match these filters",
          "body": "Try a wider date range or another kind."
        },
        "noWallet": {
          "title": "No wallet",
          "body": "Nothing has ever been written to {{walletKey}}, so the wallet row does not exist. Adding credits creates it."
        },
        "noSpend": {
          "title": "No spend lines",
          "body": "Debits are off, so nothing is billed to the ledger. What this team used is in the Usage tab, as measured usage."
        }
      },
      "kindPill": {
        "grantPlan": "Plan grant",
        "purchase": "Purchase",
        "transferIn": "Transfer in",
        "debit": "Debit",
        "adjustment": "Adjustment",
        "transferOut": "Transfer out",
        "expirePlan": "Plan expiry"
      },
      "loading": "Loading history",
      "errors": {
        "failed": "Could not load this wallet history.",
        "loadMoreFailed": "Could not load older movements. Try again."
      }
    },
    "usage": {
      "monthAriaLabel": "Select month",
      "unitAriaLabel": "Select unit",
      "unit": {
        "credits": "Credits",
        "usd": "USD"
      },
      "note": "Measured usage from usage counters — not billed credits.",
      "exempt": "exempt",
      "totalLabelCredits": "credits measured",
      "totalLabelUsd": "model cost, measured",
      "byFeature": "By feature",
      "byModelFamily": "By model family",
      "byFlow": "By flow",
      "explainer": {
        "title": "Why measured usage and billed credits differ",
        "items": {
          "debitsOff": "Debits are off, or the user is not on the allowlist: usage is recorded, no ledger line.",
          "exemptFeatures": "Eight features are exempt from credits (onboarding-style generation, embeddings, internal evaluation): recorded, never charged.",
          "unfundedTeam": "An unfunded team's spend is charged to the member's personal wallet, tagged with the team.",
          "usageExpiry": "Usage daily rows expire after 400 days; ledger lines never expire.",
          "failedDebit": "A failed debit is swallowed so it never breaks a request: usage recorded, no ledger line."
        }
      },
      "loading": "Loading usage",
      "errors": {
        "failed": "Could not load usage for this month."
      },
      "flowDeleted": "Deleted flow"
    },
    "addCredits": {
      "titleForm": "Add credits",
      "titleReview": "Confirm movement",
      "titleDone": "Credits added",
      "walletLabel": "Wallet",
      "amountLabel": "Amount (credits)",
      "amountWarning": "Above 500 credits. Whether this needs a second approver is undecided.",
      "before": "Before",
      "after": "After",
      "createsWallet": "This wallet does not exist yet. This movement will create it.",
      "reasonLabel": "Reason",
      "reasonNote": "required, stored on the ledger line",
      "reasonPlaceholder": "What happened and who approved it",
      "hint": {
        "enterAmount": "Enter an amount above zero.",
        "addReason": "Add a reason.",
        "ready": "Ready to review.",
        "amountTooHigh": "Amount is above the {{max}} credit limit."
      },
      "reviewButton": "Review",
      "back": "Back",
      "confirm": "Confirm and credit",
      "review": {
        "wallet": "Wallet",
        "kind": "Kind",
        "amount": "Amount",
        "balance": "Balance",
        "balanceValue": "{{before}} → {{after}}",
        "reason": "Reason",
        "operator": "Operator",
        "movementId": "Movement id",
        "walletTeam": "{{team}} team wallet",
        "walletPersonal": "{{name}} (personal)",
        "idempotencyNote": "The movement id is fixed for this request. Submitting it twice cannot credit twice.",
        "submitFailed": "Could not apply this movement",
        "submitFailedBody": "Nothing was confirmed. You can confirm again: the same movement id is reused, so it cannot credit twice."
      },
      "done": {
        "credited": "Credited {{amount}} to {{target}}",
        "newBalance": "New balance {{balance}} credits.",
        "meta": "{{movementId}} · recorded by {{email}} · {{recordedAt}}",
        "viewHistory": "View history",
        "done": "Done",
        "alreadyApplied": "This movement was already applied",
        "alreadyAppliedBody": "The same movement id was recorded earlier, so nothing new was credited."
      }
    },
    "notAvailable": "—",
    "plan": {
      "teamMonthly": "Team · monthly",
      "teamAnnual": "Team · annual",
      "none": "No plan"
    }
  },
  "signup": {
    "errorGenericMessage": "Could not create your account. Please try again.",
    "quotes": {
      "1": {
        "text": "“A wealth of information creates a poverty of attention”",
        "author": "Herbert A. Simon (Psychologist, Economist, Nobel Laureate)"
      },
      "2": {
        "text": "“It takes an average of 23 minutes and 15 seconds to get back to the task after an interruption”",
        "author": "Gloria Mark, University of California, Irvine"
      },
      "3": {
        "text": "“If everything is a priority, then nothing is”",
        "author": "Patrick Lencioni"
      },
      "4": {
        "text": "“The average knowledge worker spends 28% of their workweek managing email — nearly 11 hours every week”",
        "author": "McKinsey Global Institute"
      },
      "5": {
        "text": "“Clarity about what matters provides clarity about what does not”",
        "author": "Cal Newport, Deep Work (2016)"
      },
      "6": {
        "text": "“Most of what we call management consists of making it difficult for people to get their work done”",
        "author": "Peter Drucker, The Essential Drucker (2001)"
      },
      "7": {
        "text": "“When trying to juggle many tasks at once, we inevitably pay a price in accuracy and time.”",
        "author": "Daniel Levitin, The Organized Mind (2014)"
      },
      "8": {
        "text": "“Email is having an increasingly pernicious effect. The immediate increasingly crowds out the important.”",
        "author": "Noreena Hertz (Economist, Author)"
      },
      "9": {
        "text": "“No one ever got rich checking their email more often”",
        "author": "Noah Kagan, CEO of AppSumo"
      },
      "10": {
        "text": "“Professionals check email every 6 minutes — about 80 times per workday — yet only 30% of those messages require action”",
        "author": "Workplace productivity research, 2025"
      }
    },
    "waitlist": {
      "title": "Waitlist",
      "validEmail": "Must be a valid email",
      "waitlistButton": "Join the waitlist",
      "joiningWaitlist": "Joining waitlist...",
      "receiveUpdates": "I would like to receive email updates about This and That Technologies, Inc. ('t+t') products, services, events, and other news. If you have any questions, please visit our",
      "receiveUpdatesLink": "FAQ.",
      "onSubmit": {
        "success": "Successfully joined the waitlist!",
        "error": "Something went wrong. Please try again.",
        "networkError": "Network error. Please try again."
      },
      "successScreen": {
        "title": "You're on the List!",
        "message": "Thanks for joining the this+that waiting list. You're one step closer to reclaiming your inbox and transforming your productivity.",
        "secondaryMessage": "We'll be in touch soon with exclusive early access and updates.",
        "thankYou": "Stay tuned—your smarter inbox awaits!",
        "submitAnotherButton": "Submit Another Entry"
      }
    },
    "title": "Sign up",
    "validEmail": "Must be a valid email",
    "passwordLength": "Passwords must be at least 12 characters",
    "passwordsMustMatch": "Passwords must match",
    "passwordLabel": "Password",
    "passwordPlaceholder": "New password",
    "passwordRequired": "Password is required",
    "confirmPasswordLabel": "Confirm password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "receiveUpdates": "I would like to receive email updates about This and That Technologies, Inc.'s ('t+t') products, services, events, and related activities. For further information on how t+t processes your personal data, please see our Privacy Policy.",
    "signUpButton": "Sign up",
    "privacyAgreement": "By registering, you agree to our",
    "privacyPolicy": "Privacy policy",
    "privacyNote": "Do note that we will not share your personal information with anyone outside of our company and we hate spam too, so you'll never get spam emails from us.",
    "successMessage": "Welcome to the platform!",
    "errorMessage": "Could not create your account. Please try again.",
    "scrollToBottomToProceed": "You need to scroll to the bottom of the document to proceed.",
    "enterPin": "We emailed you a 6 digit code. Please enter it below to finish setting up your account.",
    "login": "Login",
    "alreadyHaveAnAccount": "Already have an account?",
    "verificationCodeError": "Invalid verification code",
    "orSignupInWith": "or sign up with",
    "createAccountTitle": "Create your account",
    "freeTrialSubtitle": "Start your free trial — no credit card needed",
    "signUpWithGoogle": "Sign up with Google",
    "signUpWithMicrosoft": "Sign up with Microsoft",
    "moreSignUpOptions": "More sign-up options",
    "orUseEmail": "or sign up with email",
    "startFreeTrial": "Start free trial"
  },
  "resetPassword": {
    "title": "Reset password",
    "subtitle": "Enter your email address and we’ll send you a verification code to reset your password.",
    "passwordLabel": "Password",
    "passwordPlaceholder": "New password",
    "confirmPasswordLabel": "Confirm password",
    "codeLabel": "Code",
    "resetButton": "Reset",
    "backToLogin": "Back to login",
    "successResettingPassword": "Password reset successfully.",
    "errorRequestingCode": "Error requesting code. You may not have an account, you may not have a password because you logged in with Google or Apple, or you may need to try again later.",
    "errorResettingPassword": "Error resetting password, try again later.",
    "codeSentMessage": "We emailed you a six digit code. Please enter it below and set a new password.",
    "validation": {
      "emailInvalid": "Must be a valid email",
      "passwordRequired": "Password is required",
      "passwordsMustMatch": "Passwords must match",
      "codeRequired": "Code is required",
      "codeInvalid": "Invalid code"
    }
  },
  "onboarding": {
    "progress": "Step {{currentStep}} of {{totalSteps}}",
    "welcome": {
      "greeting": "Hey {{firstName}},",
      "greetingFallback": "Hey there,",
      "titleWelcome": "Welcome to",
      "titleThisThat": "this+that",
      "valueProp1": "Same brain. Same page.",
      "valueProp2": "Your AI-powered assistant that turns messages into tasks and tasks into actions",
      "getStartedButton": "Get started",
      "closingTitle": "Everything that matters in one place",
      "closingParagraph": "From 120 messages to 5 tasks.",
      "continueButton": "Continue",
      "scrollHint": "Scroll down",
      "chaosFrame": {
        "title": "Your day probably looks like this",
        "subtitle": "Messages from every channel, all at once — before you've had coffee"
      },
      "destillationFrame": {
        "title": "But what if it didn't have to be this way?",
        "subtitle": "Every message organized and distilled down to what actually needs your attention"
      },
      "flowsFrame": {
        "title": "And shape how you work",
        "subtitle": "Configure flows and agents to turn messages into action"
      }
    },
    "chrome": {
      "stepProgress": "Step {{current}} of {{total}}",
      "goToStep": "Go to step {{index}}",
      "stepsNav": "Onboarding steps"
    },
    "story": {
      "next": "Next",
      "welcome": {
        "valueProp": "Same brain. Same page. Your AI-powered assistant that turns messages into tasks and tasks into actions."
      },
      "payoff": {
        "pillMessages": "120 messages",
        "pillTasks": "5 tasks",
        "headlineL1": "Everything that matters",
        "headlineL2": "in one place",
        "subPre": "No more switching tabs.",
        "subBrand": "this+that",
        "subPost": "brings your whole day into one focused view.",
        "continueButton": "Continue"
      },
      "chaos": {
        "title": "Your day probably looks like this",
        "subtitle": "Email, Slack, GitHub, Figma — every channel firing at once, before you've had coffee.",
        "inboxLabel": "Inbox",
        "inboxHeader": "INBOX · 9:02 AM",
        "unread": "unread",
        "channels": "{{count}} CHANNELS",
        "newMessages": "new",
        "newToday": "{{count}} new today",
        "email": {
          "github": {
            "subject": "New pull request needs your review",
            "preview": "Nadia Osei opened a PR in your-repo/main"
          },
          "figma": {
            "subject": "Dana shared a file with you",
            "preview": "Design system v2 — open in Figma"
          },
          "nadia": {
            "subject": "Re: Q4 Budget Review",
            "preview": "Please return your markup on the NDA by…"
          },
          "notion": {
            "subject": "You were mentioned in a page",
            "preview": "Tom mentioned you in Q4 Roadmap Planning"
          },
          "jira": {
            "subject": "3 issues assigned to you",
            "preview": "PROJ-412, PROJ-418, PROJ-420 need triage"
          },
          "linkedin": {
            "subject": "Recruiter InMail",
            "preview": "Are you open to a Staff Eng role?"
          },
          "calendar": {
            "subject": "Design review · 15 min",
            "preview": "With Sarah, Mike + 3 others — 10:00 AM"
          },
          "zendesk": {
            "subject": "Ticket #5521 escalated",
            "preview": "Customer waiting 26h for a reply"
          }
        },
        "slack": {
          "eng": "Deploy failed — anyone on it?",
          "design": "Figma file updated, need sign-off",
          "dm": "PR blocked — need a second reviewer",
          "leadership": "Heads up — CEO wants a demo Friday",
          "product": "Can you review the onboarding flow?",
          "incidents": "P2 triggered: api latency spike",
          "random": "who took the last coffee ☕",
          "support": "customer asking for the refund again"
        }
      },
      "distilled": {
        "title": "But what if it didn't have to be this way?",
        "subtitle": "Watch the noise collapse — every message pulled in and dropped into your DoBox as one clear task.",
        "windowTitle": "DoBox",
        "yourTasks": "Your tasks",
        "summary": "{{messages}} messages → {{tasks}} tasks",
        "setPriority": "Set priority",
        "setDueDate": "Set due date",
        "addLabel": "Add a label",
        "done": "Done",
        "priority": {
          "urgent": "Urgent",
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "labels": {
          "email": "Email",
          "inProgress": "In progress",
          "feature": "Feature",
          "design": "Design",
          "inReview": "In Review",
          "backend": "Backend",
          "frontend": "Frontend"
        },
        "tasks": {
          "nadia": {
            "title": "Reply to Nadia Osei with the Q4 budget markup",
            "desc": "Send back the reviewed NDA markup and confirm the revised headcount numbers before the finance sync.",
            "due": "Jun 12"
          },
          "ceo": {
            "title": "Prep board slides for the CEO demo",
            "desc": "Build six slides covering roadmap, key metrics and the live product walkthrough for Friday.",
            "due": "Jun 13"
          },
          "figma": {
            "title": "Sign off the Figma v2 design system",
            "desc": "Resolve Mike's spacing-token comments and approve the v2 components for engineering handoff.",
            "due": "Jun 14"
          },
          "pr": {
            "title": "Review & merge the PR in your-repo/main",
            "desc": "Check Nadia's fix for the stream-receiver race condition and merge once CI is green.",
            "due": "Jun 16"
          }
        },
        "chips": {
          "eng": {
            "label": "Sarah · #eng",
            "sub": "Deploy failed — anyone on it?"
          },
          "github": {
            "label": "GitHub",
            "sub": "PR needs your review on main"
          },
          "nadia": {
            "label": "Nadia Osei",
            "sub": "Re: Q4 Budget — markup attached"
          },
          "jordan": {
            "label": "Jordan · Leadership",
            "sub": "CEO wants a demo on Friday"
          },
          "mike": {
            "label": "Mike · #design",
            "sub": "Figma v2 ready for sign-off"
          },
          "pagerduty": {
            "label": "PagerDuty",
            "sub": "P2: api latency spike"
          }
        }
      },
      "flows": {
        "title": "And shape how you work",
        "subtitle": "Describe what you want in plain language and the AI builds the whole flow — agents, tools and all.",
        "suggestion1": "Send me a daily summary of unread emails",
        "suggestion2": "Label emails with action items",
        "suggestion3": "Catch me up on Slack messages",
        "suggestion4": "Track emails that need follow-up",
        "suggestionsLabel": "Try one of these prompts to get started",
        "teamFlow": "Make this a team flow",
        "tabBuilder": "Builder",
        "tabAiChat": "AI Chat",
        "save": "Save",
        "untitledFlow": "Untitled flow",
        "flowTitle": "Archive Promotion Emails",
        "generatingFlow": "Generating your flow...",
        "buildingFlow": "Building your flow...",
        "inputPlaceholder": "Describe what you want your agent to do...",
        "nodeChooseStarter": "Choose a starter",
        "nodeWhenEmail": "When I get an email",
        "nodeAgentTask": "Agent Task",
        "addStep": "Add step",
        "step1": "STEP 1",
        "detailsTitle": "A few more details",
        "detailsSubtitle": "Help us build the perfect flow for you",
        "detailsNameLabel": "Name:",
        "detailsNameValue": "Archive Promotion Emails",
        "detailsTriggerLabel": "Trigger:",
        "detailsTriggerValue": "When an email lands in the \"Promotions\" category",
        "detailsAgentWillLabel": "What the agent will do:",
        "detailsAgentAction": "Automatically archive the incoming email",
        "detailsNotesLabel": "Notes:",
        "detailsNote1": "Every email Gmail tags as a promotion is archived automatically",
        "detailsNote2": "The email isn't deleted — only removed from the inbox (still in \"All Mail\")",
        "detailsYes": "Yes, create the agent",
        "detailsNo": "No, I want to make changes",
        "generateFlow": "Generate flow",
        "configureStep": "Configure step",
        "configureStepSub": "Configure an AI agent that autonomously decides which tools to use to accomplish a goal.",
        "configStepName": "Step name (for variables)",
        "configStepNamePlaceholder": "e.g. loadMessages",
        "systemPromptLabel": "System Prompt (role / persona)",
        "systemPromptPlaceholder": "Optional. Define who the agent is — its role, tone and persona. Prepended to the built-in execution rules so you can keep it out of the goal.",
        "goalLabel": "Goal",
        "goalVariables": "(x) Variables",
        "goalText": "When a promotional email arrives, archive it immediately using",
        "goalTextMid": ". The incoming email has the subject",
        "goalTextSentBy": "sent by",
        "toolSetsLabel": "Tool Sets",
        "subAgentsLabel": "Sub-Agents",
        "createAgent": "+ Create Agent",
        "subAgentName": "this+that Brand Builder",
        "subAgentMeta": "Haiku · 5 turns · 0 tool sets",
        "subAgentShared": "Shared by This and That",
        "addStepTitle": "Add a step",
        "addStepSubtitle": "Choose an action to add to your flow",
        "aiSkills": "AI SKILLS",
        "toolAiAsk": "AI Ask",
        "toolDecide": "Decide",
        "toolSummarize": "Summarize",
        "toolAgentTask": "Agent Task",
        "toolNotify": "Notify assistant",
        "toolRunAssistant": "Run assistant",
        "toolAskUser": "Ask user",
        "toolset": {
          "emailActions": "Email Actions (send, draft, archive, labels)",
          "loadComms": "Load Communications (read emails, Slack messages)",
          "notifications": "Notifications (Slack messages and system emails)",
          "conversational": "Conversational (ask questions, wait for replies)",
          "dobox": "DoBox (tasks, entries)",
          "externalTools": "External Tools (MCP)",
          "memory": "Memory (recall, save, history)",
          "brainReadOnly": "Brain read-only (search & read pages)",
          "calendar": "Calendar (events, meetings, RSVP)"
        }
      }
    },
    "workAreas": {
      "title": "What kind of work do you do?",
      "subtitle": "Pick the area closest to your work. We'll use it to show you automations other people in your role actually keep running — you can change it any time.",
      "footnote": "Connect Gmail or Slack later and we'll narrow this list down even further.",
      "cta": {
        "continue": "Continue",
        "skip": "Skip for now"
      },
      "errors": {
        "save": "Couldn't save your work areas. Please try again."
      },
      "areas": {
        "engineering": {
          "hint": "Ship logs, incidents, releases"
        },
        "hr_people": {
          "hint": "Hiring, onboarding, check-ins"
        },
        "sales": {
          "hint": "Leads, follow-ups, pipeline"
        },
        "marketing": {
          "hint": "Competitors, content, campaigns"
        },
        "support_cs": {
          "hint": "Tickets, escalations, health"
        },
        "finance": {
          "hint": "Invoices, approvals, reporting"
        },
        "operations": {
          "hint": "Vendors, process, logistics"
        },
        "legal": {
          "hint": "Contracts, reviews, renewals"
        },
        "founder_leadership": {
          "hint": "Digests across everything"
        }
      }
    },
    "teamInvites": {
      "pendingBadge": "{{count}} pending invite",
      "pendingBadge_other": "{{count}} pending invites",
      "title": "You've been invited to collaborate",
      "subtitle": "Join now to share tasks, calendars and context — or hold off and decide later from Settings.",
      "accessLabel": "Access",
      "entities": {
        "team": "Team"
      },
      "invitedBy": "Invited by",
      "members": "{{count}} member",
      "members_other": "{{count}} members",
      "roles": {
        "owner": "Owner",
        "admin": "Admin",
        "consultant": "Consultant",
        "member": "Member",
        "viewer": "Viewer"
      },
      "features": {
        "full": "Full access",
        "view": "Can view",
        "create": "Can create",
        "edit": "Can edit",
        "delete": "Can delete"
      },
      "actions": {
        "accept": "Accept",
        "decline": "Decline",
        "later": "Later"
      },
      "status": {
        "joinedAs": "Joined as {{role}}",
        "declined": "Invitation declined",
        "savedForLater": "Saved for later"
      },
      "cta": {
        "skip": "Skip for now",
        "continue": "Continue"
      },
      "footerHelp": "You can accept any invitation later from Settings → Teams.",
      "errors": {
        "accept": "Couldn't accept the invitation. Please try again.",
        "decline": "Couldn't decline the invitation. Please try again."
      }
    },
    "step2": {
      "bodyText": "this+that reads your email and messages, identifies what needs action, and organizes it into your DoBox, a focused task list built from your communications. Use Flows to automate what happens next, like labeling customer feedback, drafting replies to colleagues, forwarding invoices to finance, or finding a requested document and sending it along.",
      "soundsGood": "Sounds good"
    },
    "step3": {
      "speechSubtext": "Connect your accounts and this+that will start organizing your messages, separating what needs action from everything else. It takes less than a minute.",
      "gmail": {
        "title": "Gmail",
        "description": "Connect your Google account",
        "altText": "Gmail logo"
      },
      "outlook": {
        "title": "Outlook",
        "description": "Connect your Microsoft account",
        "altText": "Outlook logo"
      },
      "errors": {
        "gmailConnection": "Failed to connect Gmail. Please try again.",
        "outlookConnection": "Failed to connect Outlook. Please try again."
      }
    },
    "connect": {
      "title": "Connect your accounts",
      "subtitle": "this+that works best with your email. Slack is optional but recommended.",
      "emailRequired": "Email",
      "emailRequiredBadge": "Required",
      "emailRecommendedBadge": "Recommended",
      "slackOptional": "Slack",
      "slackOptionalBadge": "Optional",
      "slackDescription": "Get tasks from your Slack conversations too",
      "connected": "Connected",
      "connectSlack": "Connect Slack",
      "continueButton": "Continue",
      "continueWithoutEmailButton": "Continue without email",
      "errors": {
        "emailConnection": "Failed to connect email. Please try again.",
        "slackConnection": "Failed to connect Slack. Please try again."
      },
      "introTitle": "It all starts by connecting your email",
      "introSubtitle": "We'll monitor your inbox, surface what matters, and turn noise into action — all with one click.",
      "postEmailTitle": "Your email is in — how about Slack?",
      "postEmailSubtitle": "Get tasks from your Slack conversations too. Or skip for now — you can always connect it later from inside the app."
    },
    "discoverFlows": {
      "title": "Discover flows",
      "subtitle": "Explore templates to kickstart your setup",
      "continueButton": "Continue"
    },
    "emailSync": {
      "title": "Setting things up for you",
      "subtitle": "This'll only take a moment",
      "progressLabel": "Sync progress",
      "steps": {
        "connecting": {
          "title": "Connecting to your email"
        },
        "importing": {
          "title": "Importing your messages"
        },
        "indexing": {
          "title": "Organizing everything"
        },
        "preparing": {
          "title": "Preparing your workspace"
        }
      },
      "complete": {
        "title": "All set!"
      },
      "fallback": {
        "title": "Setup complete"
      },
      "errors": {
        "syncFailed": "Email sync failed. Please try again."
      }
    },
    "welcomeDoBox": {
      "subject": "Welcome to DoBox! 👋",
      "description": "DoBox is your action center. It's where everything that needs your attention lives.\n\nHere's how it works:\n- Emails, Slack and Teams messages, and tasks that need action appear here automatically\n- You can also create items manually\n- Organize items into lists to group related tasks\n- Set due dates, add labels, and assign team members\n- When you're done with something, mark it done to keep your DoBox clean\n\nTips to get started:\n- Check your inbox. Our AI will move items to DoBox automatically\n- Create a Flow to automatically organize incoming messages\n\nYou can mark this item done whenever you're ready. Happy organizing!",
      "descriptionNoEmail": "DoBox is your action center. It's where everything that needs your attention lives.\n\nTo get the most out of it, it's great to connect your email, Slack, Teams and other tools — that way, messages and tasks that need action will show up here automatically. Head to the Integrations page whenever you're ready to plug them in.\n\nHere's how it works:\n- Connect your channels (email, Slack, Teams, etc.) on the Integrations page to have items appear here automatically\n- You can also create items manually right now\n- Organize items into lists to group related tasks\n- Set due dates, add labels, and assign team members\n- When you're done with something, mark it done to keep your DoBox clean\n\nTips to get started:\n- Open the Integrations page and connect at least one channel — email or Slack is a great start\n- Create a Flow to automatically organize incoming messages once your channels are connected\n\nYou can mark this item done whenever you're ready. Happy organizing!"
    }
  },
  "account": {
    "pageTitle": "Account",
    "pageDescription": "Welcome to your Account page. Visit this page to manage your settings.",
    "section": {
      "profileInformation": "Profile Information",
      "notifications": "Notifications",
      "email": "Email"
    },
    "email": {
      "taskResolutionSection": "Task resolution",
      "taskResolutionHelper": "When on, resolving a task archives its email in Gmail or Outlook, but only once every other open task linked to that email is resolved too. Off by default.",
      "archiveOnLastTaskResolvedToggle": "Archive the email when its last task is resolved"
    },
    "connect": {
      "setUpIntegration": "Set up integration",
      "setUpIntegrationMessage": "To activate your {{platform}} integration, you need to complete the initial setup. You will now be redirected to the setup page.",
      "confirmAction": "Confirm"
    },
    "disconnect": {
      "disconnectIntegrationError": "There was an issue disconnecting your {{provider}} integration. Please try again.",
      "userIdNotFound": "User ID not found. Please try again.",
      "noDisconnectFunction": "No disconnect function available for the selected provider.",
      "teamsHomeAccountIdNotFound": "Could not find Teams account information. Please try again.",
      "disconnectIntegrationSuccess": "Your {{provider}} integration has been successfully disconnected."
    },
    "notifications": {
      "emailSection": "Newsletter & daily summary",
      "receiveUpdates": "Receive email updates about This and That Technologies, Inc.'s products, services, events, and related activities",
      "receiveUpdatesDelay": "Changes to your email preferences may take up to 24 hours to take effect.",
      "dailyNotification": "Receive daily summary on task suggestions and tasks",
      "transactionSection": "Notifications about tasks",
      "newDiscussionAdded": "New comments have been added to a discussion",
      "youHaveBeenAssignedTo": "A team mate has assigned a task to you",
      "pushSection": "Push notifications",
      "pushSectionHelper": "Choose which push notifications you receive on your devices. Email alerts are off by default.",
      "pushEmailToggle": "New email notifications",
      "pushDoboxToggle": "Task and DoBox notifications",
      "browserSection": "Browser alerts",
      "browserSectionHelper": "Alerts in this browser tab when the assistant creates new suggestions in your personal DoBox.",
      "suggestionSoundToggle": "Play a sound when new suggestions arrive"
    },
    "preferences": {
      "languageLabel": "Language",
      "timeZoneLabel": "Timezone",
      "selectPlaceholder": "Select",
      "languageRequired": "Language is required",
      "timeZoneRequired": "Timezone is required",
      "languages": {
        "enUS": "English (US)",
        "enGB": "English (UK)",
        "ptBR": "Português (Brasil)"
      }
    },
    "buttons": {
      "saveInformationsButton": "Save information",
      "deleteAccountButton": "Close account"
    },
    "form": {
      "validationError": "Please fix the highlighted fields before saving"
    },
    "confirmationModal": {
      "deleteAccountConfirmationTitle": "Close your account?",
      "deleteAccountConfirmationDescription": "Are you sure you want to close your account?",
      "deleteAccountConfirmationAction": "Close"
    },
    "deleteFeedback": {
      "title": "Close your account?",
      "subtitle": "We'll end your access, stop syncing the accounts you connected, and delete your messages, tasks, Brain pages, calendar data, contacts and files.",
      "helpText": "Tell us why you're leaving (optional). We keep your name, email, job title, work areas, team membership, the date you closed your account and these reasons for 24 months, so we can let you know if this+that changes in a way that might bring you back. Email support@thisandthat.chat and we'll remove them sooner.",
      "reasonsGroupLabel": "Reasons for closing your account",
      "reasons": {
        "tooExpensive": "It's too expensive",
        "missingIntegration": "It's missing an integration I need",
        "aiNotUseful": "The AI features weren't useful to me",
        "tooComplex": "It's too complex to use",
        "switchingTool": "I'm switching to another tool",
        "notUsingEnough": "I'm not using it enough",
        "privacy": "Privacy concerns",
        "other": "Other"
      },
      "otherPlaceholder": "Tell us more (optional)...",
      "otherMinLengthHint": "Please write at least {{min}} characters (or leave it empty)",
      "otherCharacterCount": "{{count}}/{{max}}",
      "confirm": "Close my account"
    },
    "deleteAccountSuccess": "Your account has been closed",
    "deleteAccountError": "There was an issue closing your account. Please try again.",
    "profileUpdatedSuccess": "Account updated successfully.",
    "profileUpdateError": "There was an issue updating your account. Please try again.",
    "calendarPrivacy": {
      "toggleLabel": "Share my calendar availability with my team",
      "toggleAriaLabel": "Share calendar availability with team members",
      "description": "When enabled, teammates can see your free/busy status and public events to help schedule meetings. Turn this off to hide your calendar availability from your team.",
      "errors": {
        "saveFailed": "Failed to update your calendar privacy setting. Please try again."
      }
    },
    "security": {
      "section": "Security",
      "twoFactor": {
        "title": "Two-factor authentication",
        "description": "Add an extra layer of security by requiring a code from your authenticator app when you sign in.",
        "statusEnabled": "Enabled",
        "statusDisabled": "Disabled",
        "enable": "Enable",
        "remove": "Remove",
        "manageBackupCodes": "Manage backup codes",
        "setup": {
          "title": "Set up authenticator app",
          "scanInstruction": "Scan this QR code with your authenticator app.",
          "cantScan": "Can't scan the code?",
          "manualInstruction": "Enter this code manually in your authenticator app:",
          "codeLabel": "Verification code",
          "codePlaceholder": "123456",
          "verify": "Verify and enable",
          "success": "Two-factor authentication is now enabled.",
          "cancel": "Cancel",
          "copySecret": "Copy secret key"
        },
        "backupCodes": {
          "title": "Backup codes",
          "description": "Each code can be used once to sign in if you lose access to your authenticator app.",
          "warning": "Save these codes somewhere safe. You won't be able to see them again.",
          "copy": "Copy codes",
          "copied": "Copied",
          "download": "Download",
          "regenerate": "Regenerate codes",
          "done": "Done",
          "regenerateConfirm": {
            "title": "Regenerate backup codes?",
            "description": "Your existing backup codes will stop working. Be sure to save the new ones.",
            "action": "Regenerate"
          }
        },
        "removeConfirm": {
          "title": "Remove two-factor authentication?",
          "description": "This disables two-factor authentication and removes your backup codes. Your account will be less secure.",
          "action": "Remove"
        },
        "errors": {
          "verify": "Invalid code. Please try again.",
          "generic": "Something went wrong. Please try again.",
          "copy": "Couldn't copy to clipboard. Please copy the codes manually."
        },
        "removeSuccess": "Two-factor authentication has been disabled."
      }
    }
  },
  "integration": {
    "pageTitle": "Integrations",
    "pageDescription": "Visit this page to configure your integrations. Sync your most used tools to begin taking charge of your emails, conversations and tasks.",
    "analysisSection": {
      "title": "Setting up analysis",
      "description": "Connect your communication tools, so the assistant can make suggestions."
    },
    "teamSection": {
      "title": "Team integrations",
      "description": "These integrations are shared across your team. Once connected, all team members benefit from the same setup."
    },
    "exportsSection": {
      "title": "Setting up exports",
      "description": "Connect your favorite project management tools to funnel and seamlessly transform suggested items into tasks or tickets."
    },
    "mcpSection": {
      "title": "MCP Servers",
      "description": "Connect external MCP servers to extend your assistant's capabilities with additional tools."
    },
    "integrationOptions": {
      "slack": "Connect your Slack workspace: <br/><ul><li><b>Channels</b></li><li><b>Direct messages</b></li></ul>",
      "slackMobile": "Connect your Slack workspace: <br/><ul><li><b>Channels</b></li><li><b>Direct messages</b></li></ul>",
      "google": "Connect your Google account: <br/><ul><li><b>Gmail</b></li><li><b>Calendar</b></li></ul>",
      "googleMobile": "Connect your Google account: <br/><ul><li><b>Gmail</b></li><li><b>Calendar</b></li></ul>",
      "outlook": "Connect your Outlook account:<br/><ul><li><b>Outlook</b></li><li><b>Calendar</b></li></ul>",
      "outlookMobile": "Connect your Outlook account: <br/><ul><li><b>Outlook</b></li><li><b>Calendar</b></li></ul>",
      "teams": "Connect your Teams account: <br/><ul><li><b>Chats</b></li></ul>",
      "teamsMobile": "Connect your Teams account: <br/><ul><li><b>Chats</b></li></ul>",
      "slackBot": "Connect the t+t bot to your Slack workspace to:<br/><ul><li><b>Add the bot to channels</b></li><li><b>Trigger flows from Slack messages</b></li></ul>",
      "slackBotMobile": "Connect the t+t bot to your Slack workspace to:<br/><ul><li><b>Add the bot to channels</b></li><li><b>Trigger flows from Slack messages</b></li></ul>",
      "instagram": "Connect your Instagram account:<ul><li><b>Conversations</b></li><li><b>Direct messages</b></li></ul>",
      "instagramMobile": "Connect your Instagram account:<ul><li><b>Conversations</b></li><li><b>Direct messages</b></li></ul>",
      "github": "Connect your team's GitHub organizations:<ul><li><b>Issues & pull requests</b></li><li><b>Comments & reviews</b></li></ul>Read-only access. Multiple organizations supported.",
      "githubMobile": "Connect your team's GitHub organizations:<ul><li><b>Issues & pull requests</b></li><li><b>Comments & reviews</b></li></ul>",
      "googleChat": "Enable Google Chat on your connected Google account:<br/><ul><li><b>Spaces</b></li><li><b>Direct messages</b></li></ul>",
      "googleChatMobile": "Enable Google Chat on your connected Google account:<br/><ul><li><b>Spaces</b></li><li><b>Direct messages</b></li></ul>",
      "googleDrive": "Connect Google Drive to let the assistant read and search your files:<br/><ul><li><b>My Drive</b></li><li><b>Shared drives</b></li></ul>",
      "googleDrivePrerequisite": "Connect your Google account before enabling Drive.",
      "googleBusiness": "Connect Google Business Profile to let the assistant track and reply to your reviews:<br/><ul><li><b>Reviews</b></li><li><b>Business locations</b></li></ul>",
      "googleBusinessPrerequisite": "Connect your Google account before enabling Business Profile.",
      "whatsApp": "Connect your WhatsApp Business account to turn messages into <b>suggestions</b> in your inbox.",
      "whatsAppMobile": "Connect your WhatsApp Business account to turn messages into <b>suggestions</b> in your inbox."
    },
    "statusTag": {
      "connected": "Connected",
      "notConnected": "Not connected",
      "pendingApproval": "Pending approval"
    },
    "status": {
      "connecting": "Connecting…"
    },
    "github": {
      "installationRequested": "Installation requested. A GitHub organization owner has to approve it — we'll connect automatically once they do.",
      "pendingApprovalRowDescription": "Waiting for an organization owner to approve. It connects on its own once approved."
    },
    "connecting": {
      "waiting": "Waiting for connection confirmation…"
    },
    "integrateButton": "Connect",
    "connectAccountsButton": "Connect accounts",
    "manageAccounts": "Manage accounts",
    "addAccount": "Add account",
    "disconnectButton": "Disconnect",
    "disconnectModal": {
      "title": "Confirmation",
      "individualDescription": "Are you sure you want to disconnect {{platform}}? Any saved data will be deleted from this+that."
    },
    "adminsOnly": "Admins only",
    "integrationSuccess": "Your integration has been successfully connected.",
    "integrationError": "There was an issue connecting your integration. Please try again.",
    "instagramUnsupportedLoginMethodError": "We couldn't connect this Instagram account. Try again and sign in with your Instagram professional account's username and password instead of continuing with Facebook.",
    "microsoftAccountHeldByAnotherUser": "This Microsoft account is already connected by another this+that user, so it can't be connected again. The access you just approved now belongs to their connection.",
    "microsoftPermissionsNotGranted": "Microsoft didn't grant the permissions this connection needs. Try again and accept them; if your organization manages your account, ask your IT admin to allow this+that.",
    "teamsPersonalAccountNotSupported": "Teams needs a work or school Microsoft account. Personal accounts (Outlook.com, Hotmail, Live) can't connect Teams.",
    "googleAccountHeldByAnotherUser": "This Google account is already connected by another this+that user, so it can't be connected again. The access you just approved now belongs to their connection — we can't undo it without disconnecting them.",
    "oauthRefusal": {
      "title": "Connection not completed",
      "canceled": "You canceled the connection, so nothing was linked.",
      "consentNotGranted": "Consent wasn't granted. If you asked an admin to approve it, try again after.",
      "blockedByOrganization": "Your admin blocked a permission this integration needs. Ask them to allow it.",
      "orgInternal": "This account's organization can't use the app. Try another account.",
      "embeddedBrowser": "Open the app in Chrome, Safari or Edge and try again.",
      "providerUnavailable": "The provider is temporarily unavailable. Try again in a moment.",
      "integrationSuspended": "This integration is unavailable. Please contact support.",
      "generic": "Couldn't connect ({{code}}). Try again or contact support."
    },
    "googleDrive": {
      "disconnectSuccess": "Google Drive disconnected successfully.",
      "disconnectError": "There was an issue disconnecting Google Drive. Please try again.",
      "manageModalSubtitle": "View and manage which Google accounts have Drive connected. You can disconnect or add Drive access anytime."
    },
    "googleBusiness": {
      "disconnectSuccess": "Google Business Profile disconnected successfully.",
      "disconnectError": "There was an issue disconnecting Google Business Profile. Please try again.",
      "manageModalSubtitle": "View and manage which Google accounts have Business Profile connected. You can disconnect or manage locations anytime.",
      "manageLocationsButton": "Manage locations",
      "locationsModal": {
        "title": "Manage locations",
        "monitorAllLabel": "Monitor all locations",
        "monitorAllHint": "By default, the assistant monitors every location under this account. Turn this off to choose specific locations.",
        "emptyState": "No locations were found yet for this account. This can happen while Google reviews API access for Business Profile — check back soon.",
        "loadError": "We couldn't load your Business Profile locations. Please try again.",
        "retryButton": "Try again",
        "selectAtLeastOneHint": "Select at least one location, or turn Monitor all locations back on.",
        "saveButton": "Save",
        "cancelButton": "Cancel",
        "saveSuccess": "Location preferences saved.",
        "saveError": "There was an issue saving your location preferences. Please try again."
      }
    },
    "requestIntegration": {
      "title": "Didn't find the integration you need?",
      "description": "Our list of integrations is growing. If the one you need isn't here yet, feel free to request it and help us prioritize.",
      "button": "Request integration"
    },
    "requestIntegrationModal": {
      "title": "Request integration",
      "subtitle": "Help us understand what you'd like to connect. Your suggestion may shape our next release!",
      "integrationRequested": "Integration name",
      "integrationRequestedPlaceholder": "e.g. Microsoft Planner",
      "integrationRequestedRequired": "Integration name is required",
      "integrationReason": "Why do you need this integration?",
      "integrationReasonPlaceholder": "Briefly describe your use case or goal",
      "integrationReasonRequired": "This field is required",
      "successTitle": "Integration requested successfully!",
      "successMessage": "Your integration request has been successfully submitted.",
      "errorTitle": "Failed to request integration",
      "errorMessage": "There was an issue requesting the integration. Please try again.",
      "cancel": "Cancel",
      "submit": "Submit"
    },
    "whatsApp": {
      "connectSuccess": "WhatsApp Business connected successfully.",
      "connectError": "There was an issue connecting WhatsApp Business. Please try again.",
      "connectTimeout": "WhatsApp connection timed out. Please try again."
    },
    "slackSettingsModal": {
      "title": "Select Slack channels",
      "subtitle": "Choose the channels where you want to add the t+t assistant. Only public channels are listed below",
      "success": "Slack settings saved successfully!",
      "error": "Failed to save Slack settings. Please try again.",
      "cancel": "Cancel",
      "save": "Save",
      "channelsSearch": "Search...",
      "channelsSelectAll": "Select all channels"
    },
    "manageAccountsModal": {
      "title": "Manage accounts",
      "subtitle": "View and manage your connected accounts. You can disconnect or add new ones anytime.",
      "addAnotherAccountButton": "Add another account",
      "addAnotherGmailButton": "Add another Gmail account",
      "addAnotherGoogleCalendarButton": "Add another Google Calendar account",
      "addAnotherGoogleChatButton": "Add another Google Chat account",
      "addAnotherGoogleDriveButton": "Add another Google Drive account",
      "addAnotherGoogleBusinessButton": "Add another Google Business Profile account",
      "addAnotherOutlookButton": "Add another Outlook Mail account",
      "addAnotherOutlookCalendarButton": "Add another Outlook Calendar account",
      "addAnotherTeamsButton": "Add another Teams account",
      "addAnotherSlackWorkspaceButton": "Add another Slack workspace",
      "addAnotherInstagramButton": "Add another Instagram account",
      "addAnotherFacebookPageButton": "Add another Facebook page",
      "addAnotherGitHubOrgButton": "Add another GitHub organization",
      "addAnotherWhatsAppNumberButton": "Add another WhatsApp number",
      "channelsButton": "Channels",
      "githubAllRepositoriesSelected": "All repositories selected",
      "githubMoreRepositories": "+{{remaining}} more",
      "closeButton": "Close",
      "unsubscribeSuccess": "Disconnected {{account}} successfully!",
      "unsubscribeError": "Failed to disconnect. Please try again.",
      "urlError": "Failed to connect. Please try again later."
    },
    "disconnectAccountModal": {
      "title": "Disconnect account",
      "subtitle": "How would you like to disconnect <b>{{account}}</b>?",
      "cancelButton": "Cancel",
      "confirmButton": "Disconnect account",
      "keepDataOption": "Keep my data",
      "keepDataDescription": "Stops syncing and revokes access, but keeps your existing messages and data.",
      "outlookKeepDataDescription": "Stops syncing, and keeps what was already synced.",
      "outlookSharedSignInNote": "Outlook Mail and Outlook Calendar share one Microsoft sign-in, which stays connected until both are disconnected.",
      "deleteDataOption": "Delete my data",
      "deleteDataDescription": "Permanently deletes the data synced for what you are disconnecting here. Everything else connected to this account keeps its data.",
      "typeToConfirm": "This can't be undone — type <b>{{account}}</b> to confirm.",
      "typeToConfirmInputLabel": "Type the account name to confirm deletion"
    },
    "telegramAssistant": {
      "description": "Message the Assistant on Telegram to <b>run actions remotely</b> from your phone, anywhere:<br/><ul><li><b>Run actions and trigger flows</b></li><li><b>Quick replies on the go</b></li></ul>",
      "status": {
        "connected": "Connected",
        "notConnected": "Not connected"
      },
      "pending": {
        "waiting": "Waiting for you to start the bot…"
      },
      "actions": {
        "connect": "Connect bot",
        "openInTelegram": "Open in Telegram",
        "disconnect": "Disconnect"
      },
      "connectError": "Could not open Telegram. Try again.",
      "disconnectSuccess": "Telegram disconnected.",
      "disconnectError": "Could not disconnect Telegram. Try again.",
      "disconnectModal": {
        "title": "Disconnect Telegram bot",
        "description": "You'll stop receiving the Assistant on Telegram until you connect again.",
        "confirm": "Disconnect"
      }
    },
    "refreshFailed": "Some integrations could not be updated. Showing the last known status.",
    "mobileBanner": "Configuring integrations is easier on a computer than on a mobile device",
    "catalog": {
      "view": {
        "grid": "Grid view",
        "list": "List view"
      },
      "scopeToggleAriaLabel": "Integration scope",
      "viewToggleAriaLabel": "Integration view",
      "title": "Integrations",
      "subtitle": "Connect your tools so the assistant can sort emails, conversations and tasks for you.",
      "connectedCount": "{{connected}} of {{total}} connected",
      "scope": {
        "personal": "Personal",
        "team": "Team",
        "ariaLabel": "Integration scope"
      },
      "teamBannerText": "These integrations belong to your team — connected once by an admin and available to all members. Integrations that only you use are in <strong>Personal</strong>.",
      "searchInput": {
        "clearLabel": "Clear search"
      },
      "searchPlaceholderPersonal": "Search integrations…",
      "searchPlaceholderTeam": "Search team integrations…",
      "sort": {
        "recent": "Recent",
        "alpha": "A – Z",
        "status": "By status"
      },
      "viewToggle": {
        "ariaLabel": "View mode",
        "gridLabel": "Grid view",
        "listLabel": "List view"
      },
      "tabs": {
        "all": "All",
        "connected": "Connected",
        "available": "Available"
      },
      "categories": {
        "all": "All",
        "communication": "Communication",
        "emailCalendar": "Email & Calendar",
        "productivity": "Productivity",
        "dataAi": "Data & AI",
        "design": "Design",
        "marketingCrm": "Marketing & CRM",
        "dev": "Dev"
      },
      "status": {
        "connected": "Connected",
        "available": "Available",
        "connecting": "Connecting…",
        "error": "Connection error"
      },
      "actions": {
        "connect": "Connect",
        "manage": "Manage",
        "connecting": "Connecting…",
        "retry": "Try again",
        "configure": "Configure",
        "sync": "Sync now",
        "disconnect": "Disconnect",
        "disconnectTeam": "Disconnect from team",
        "editMcp": "Edit MCP",
        "openInTelegram": "Open in Telegram"
      },
      "busy": {
        "syncing": "Syncing…",
        "disconnecting": "Disconnecting…"
      },
      "disconnectSuccess": "{{name}} disconnected.",
      "disconnectError": "Could not disconnect {{name}}. Try again.",
      "disconnectConfirm": {
        "title": "Disconnect {{name}}?",
        "description": "The assistant stops using this connection. You can connect again later.",
        "action": "Disconnect"
      },
      "teamBadge": "Team",
      "mcpBadge": "MCP",
      "teamOwnerFallback": "Shared with team",
      "emptyState": {
        "title": "No integrations found",
        "subtitle": "Try a different search term or change your selected filters.",
        "clearFilters": "Clear filters"
      },
      "requestFooter": {
        "titlePersonal": "Can't find the integration you need?",
        "subtitlePersonal": "Our catalog is growing. Request one and help prioritize.",
        "titleTeam": "Need another integration for your team?",
        "subtitleTeam": "Request one and our team will review it for the shared catalog."
      },
      "configModal": {
        "subtitle": "Integration settings",
        "permissionsTitle": "Granted permissions",
        "mcpTitle": "Also available as MCP",
        "mcpActiveBadge": "Server active",
        "mcpDescription": "By exposing a Model Context Protocol server, the assistant queries this tool in real time — without scheduled syncing.",
        "mcpEndpointLabel": "Server endpoint",
        "mcpToolsLabel": "Tools exposed to the assistant",
        "scopePersonal": "Personal",
        "scopeTeam": "Team",
        "footNotePersonal": "Only valid for your account.",
        "footNoteTeam": "Valid for all team members."
      },
      "descriptions": {
        "outlookMail": "Read, search and reply to your Outlook email.",
        "outlookCalendar": "See your Outlook schedule and create or update events.",
        "googleChat": "Google Chat spaces and direct messages.",
        "slack": "Slack channels and direct messages.",
        "teams": "Microsoft Teams chats and conversations.",
        "whatsApp": "Turn WhatsApp messages into suggestions.",
        "googleDrive": "Access and manage Drive files and folders.",
        "googleBusiness": "Manage reviews and information on your Google profile.",
        "telegram": "Execute actions and trigger flows via Telegram.",
        "slackBot": "Add the t+t bot to channels and trigger flows from Slack messages.",
        "instagram": "Team Instagram conversations and direct messages.",
        "messenger": "Facebook pages to reply to comments and messages through the assistant.",
        "github": "Issues, pull requests and code from your team repositories.",
        "gmail": "Read, search and reply to your email.",
        "googleCalendar": "See your schedule and create or update events."
      }
    },
    "googleSurfaces": {
      "gmail": "Gmail",
      "calendar": "Google Calendar",
      "chat": "Google Chat",
      "drive": "Google Drive",
      "businessProfile": "Google Business Profile"
    },
    "googleRevokeWarning": {
      "title": "This disconnects your whole Google account",
      "intro": "Disconnecting will remove every Google integration on",
      "reason": "Google grants access to an account as a whole, so there is no way to disconnect one service and keep the others. This is how Google works, not a limitation of this app.",
      "dataKept": "Your messages, events and files stay in the app. Reconnect any time to resume syncing.",
      "confirm": "Disconnect everything",
      "cancel": "Keep connected",
      "heading": "Disconnecting removes every Google service on this account:",
      "reconnect": "You will need to reconnect the ones you want to keep using.",
      "accountDisconnected": "Google account disconnected. Reconnect the services you want to keep using."
    },
    "googleRestoreBanner": {
      "title": "You disconnected {{account}}",
      "surfaces": "Reconnect your {{surfaces}} in a single step by clicking the button in this banner.",
      "restore": "Reconnect",
      "dismiss": "Dismiss",
      "restoreError": "Could not start the reconnection. Please try again."
    }
  },
  "server": {
    "calendar": {
      "defaultMeetingName": "Meeting from calendar"
    }
  },
  "support": {
    "haveQuestions": "Have questions about the product?",
    "consultFAQ": "Consult the FAQ",
    "home": {
      "title": "Help + support",
      "description": "Got questions? Find answers here or contact us, we're ready to help you!",
      "gettingStartedCta": "New to this+that? Read the getting started guide",
      "systemStatus": "System status",
      "sections": [
        {
          "id": "getting-setup",
          "title": "Getting set up",
          "bgColor": "green",
          "description": "Just started? Here’s your guide to getting set up and synced!",
          "contentKey": "getting-setup"
        },
        {
          "id": "using-the-tool",
          "title": "Using the tool",
          "bgColor": "blue",
          "description": "Visit this page to get familiarized with the tool.",
          "contentKey": "using-the-tool"
        },
        {
          "id": "faqs",
          "title": "FAQ | General",
          "bgColor": "blue",
          "description": "Got questions? We might have already answered them!",
          "contentKey": "faqs"
        },
        {
          "id": "security-privacy-FAQ",
          "title": "FAQ | Security + privacy",
          "bgColor": "green",
          "description": "Our dedicated safety FAQ.",
          "contentKey": "security-privacy-FAQ"
        },
        {
          "id": "mcp-server",
          "title": "this+that in your AI tools",
          "bgColor": "green",
          "description": "Use your DoBox and your Brain in AI assistants like Claude.",
          "contentKey": "mcp-server"
        }
      ]
    },
    "sections": {
      "second": {
        "getAnswers": "Get the answers you need",
        "letsConnect": "Let's connect",
        "letsConnectDescription": "Connect with us on social media and stay updated or email us at support@thisandthat.chat!",
        "letsConnectInline": "Got more questions? Email us at support@thisandthat.chat or follow us:"
      }
    }
  },
  "toast": {
    "success": "Success",
    "error": "Error",
    "info": "Info",
    "warning": "Warning",
    "loading": "Loading..."
  },
  "team": {
    "chooseTeamName": "Choose a team name",
    "pageTitle": "Team",
    "noTeamMembers": "No team members yet",
    "pageAdminDescription": "Invite your team members to join and get on top of your communications — together.",
    "pageMemberDescription": "View your team members.",
    "addMember": "Add a member",
    "editMember": "Edit member",
    "delete": "Remove",
    "edit": "Edit",
    "leaveTeam": "Leave team",
    "pendingInvitation": "Pending invitation",
    "resend": "Resend",
    "loadingMessage": "Loading, please wait.",
    "successMessages": {
      "deleteMember": "Member removed successfully!",
      "updateTeamName": "Team name updated successfully!",
      "inviteSent": "Team invite sent successfully!",
      "updateMember": "Team member updated successfully"
    },
    "errorMessage": {
      "somethingWentWrong": "Oops, something went wrong. Please try again."
    },
    "tableTitles": {
      "name": "name",
      "email": "email",
      "title": "job title"
    },
    "modal": {
      "title": "Add new member",
      "editTitle": "Edit member",
      "deleteTitle": "Leave team",
      "deleteDescription": "Are you sure you want to leave this team? This action cannot be undone.",
      "deleteActionButtonLabel": "Leave",
      "cancelButtonLabel": "Cancel"
    },
    "form": {
      "roleLabel": "Role",
      "rolePlaceholder": "Select",
      "roleRequired": "Role is required",
      "emailPlaceholder": "Team member's email"
    },
    "buttons": {
      "addAndClose": "Add & close",
      "addAnother": "Add another",
      "save": "Save"
    }
  },
  "components": {
    "connectProviderEmptyState": {
      "connectButton": "Connect {{provider}}",
      "seeAllIntegrations": "See all integrations",
      "providers": {
        "gmail": "Gmail",
        "google": "Google",
        "outlook": "Outlook"
      }
    },
    "privacyBlock": {
      "heading": "Built to stay private",
      "commitmentsLink": "Our security commitments",
      "encrypted": "Encrypted in transit & at rest",
      "soc2": "SOC 2 Type I",
      "soc2Tag": "Type II underway",
      "noTraining": "Never used to train AI"
    },
    "deleteModal": {
      "cancel": "Cancel"
    },
    "lists": {
      "searchPlaceholder": "Search...",
      "noResults": "No labels found"
    },
    "managePerson": {
      "searchPlaceholder": "Name or email",
      "addMember": "Add a new member",
      "closeButton": "Close",
      "searchNotFound": "No team members match your search.",
      "askAdminToAddMember": "Ask your admin to add a member."
    },
    "timePicker": {
      "title": "Type your duration",
      "doneButton": "Done",
      "minutes": "min",
      "suggestionsLabel": "Time suggestions"
    },
    "timezoneSelector": {
      "searchPlaceholder": "Search timezones...",
      "ariaLabel": "Select timezone",
      "placeholder": "Timezone",
      "noResults": "No timezones found"
    },
    "assigneeDrawer": {
      "title": "Assignees"
    },
    "priorityDrawer": {
      "title": "Priority"
    },
    "activityLog": {
      "title": "Activity log",
      "closeButton": "Close"
    },
    "discussion": {
      "title": "Discussions",
      "send": "Send",
      "noDiscussion": "No discussions yet",
      "placeholder": "Write a comment",
      "collapseAll": "Collapse all",
      "expandAll": "Expand all",
      "openSource": "View original message"
    },
    "durationDrawer": {
      "title": "Duration",
      "minutes": "minutes",
      "setCustomDuration": "Set custom duration",
      "closeButton": "Close"
    },
    "moveToDoBoxModal": {
      "title": "Move to DoBox",
      "loadError": "Failed to load DoBox entries",
      "noDoBoxEntries": "No DoBox entries found. Create a new one to get started.",
      "noDoBoxEntriesMultipleEmails": "No DoBox entries found. To generate a new DoBox entry with AI, please select only one email.",
      "communicationCount": "{{count}} email{{s}}",
      "moving": "Moving...",
      "moveButton": "Move",
      "successSingle": "Email moved to DoBox successfully",
      "successMultiple": "{{count}} emails moved to DoBox successfully",
      "error": "Failed to move emails. Please try again.",
      "segmentExisting": "Existing DoBox",
      "segmentGenerate": "Generate new",
      "generateTaskButton": "Generate task",
      "selectAriaLabel": "Select {{subject}}",
      "infoPanelTitle": "AI will draft a new DoBox task",
      "infoPanelDescription": "It reads this email and proposes a title, summary and due context. You can review and edit everything before it's created.",
      "infoPanelDestLabel": "It will be added to",
      "generatingTitle": "Analyzing email…",
      "generatingDescription": "Drafting a title, summary and due context for your task",
      "generating": "Generating...",
      "participantIdsCount": "{{count}} member{{s}}",
      "alreadyLinked": "Already linked"
    },
    "moveTaskToAnotherList": {
      "title": "Move task to another list",
      "selectedTask": "Selected task",
      "selectList": "Select a list to move your task to",
      "selectPlaceholder": "Select a list"
    },
    "inboxEntryDetailsModal": {
      "suggestionNotice": {
        "title": "AI suggestion",
        "acceptWithList": "<b>Accept</b> creates the task in {{listName}}.",
        "acceptWithoutList": "<b>Accept</b> turns it into a task.",
        "rejectWithSource": "<b>Reject</b> deletes only the suggestion; the original message stays where it is.",
        "rejectWithoutSource": "<b>Reject</b> deletes the suggestion."
      },
      "assistantPanel": {
        "openAssistant": "Open assistant",
        "closeAssistant": "Close assistant",
        "executorPlaceholder": "Tell me what to get done here…"
      },
      "doBoxReplyPanel": {
        "backToOptionsAriaLabel": "Back to options",
        "sentReceiptLabel": "Sent to {{name}} · {{time}}",
        "sentNoteMarkedDone": "Marked this DoBox as done.",
        "sentNoteStillOpen": "This DoBox is still open, so I kept it in your list. Still available:",
        "relativeTime": {
          "justNow": "just now",
          "minutesAgo": "{{count}}m ago",
          "hoursAgo": "{{count}}h ago",
          "daysAgo": "{{count}}d ago"
        },
        "title": {
          "reply": "Reply to {{name}}",
          "replyAll": "Reply all",
          "forward": "Forward",
          "replySlack": "Reply in Slack"
        },
        "subtitle": "Email · {{subject}}",
        "subtitleSlackChannel": "#{{channel}}",
        "subtitleSlackDm": "DM with {{name}}",
        "generatingLabel": "Drafting your reply…",
        "revisingLabel": "Applying your changes…",
        "generateError": "Could not draft a reply. Try again.",
        "reviseError": "Could not apply that change. Try again.",
        "sendPreparationError": "Could not send: the account for this message could not be resolved.",
        "draftCard": {
          "toLabel": "To",
          "ccLabel": "Cc",
          "subjectLabel": "Subject",
          "bodyAriaLabel": "Reply body",
          "bodyPlaceholder": "Write your reply…",
          "openFullEditor": "Open full editor",
          "send": "Send",
          "sendAndMarkDone": "Send & mark done",
          "moreSendOptionsAriaLabel": "More send options"
        },
        "replyWith": {
          "chip": {
            "label": "Write with AI"
          },
          "intent": {
            "placeholder": "Reply with… e.g. 'agree, suggest Thursday'",
            "inputLabel": "Send this adjustment",
            "helper": "Tell me what to change, or what you want to say."
          },
          "context": {
            "label": "Context",
            "thisThread": "This thread",
            "escToClose": "Esc to go back"
          }
        }
      },
      "agentSetupPanel": {
        "header": {
          "backToTaskAriaLabel": "Back to the task",
          "backAriaLabel": "Back",
          "cancelSetupAriaLabel": "Cancel setup",
          "title": "New agent",
          "stepOf": "Step {{step}} of {{total}}"
        },
        "advancedPartialSaveError": "The agent was saved, but some advanced settings could not be applied. Open it from your agents to review them.",
        "saveError": "Could not save this agent. Try again.",
        "step1": {
          "title": "What should it do?",
          "helper": "Explain it like you would to a new teammate. I built this from what you told me.",
          "jobLabel": "The job",
          "learnedFromTaskTitle": "Learned from this task",
          "learnedFromTaskAuthorChannel": "{{author}} · {{channel}}",
          "nameLabel": "Name",
          "nameHint": "You can rename it anytime.",
          "advancedSettings": "Advanced settings",
          "continue": "Continue",
          "buildingYourAgent": "Building your agent…",
          "regenerateError": "Could not rebuild this agent. Try again.",
          "resultDelivery": "Result comes back as {{delivery}}",
          "resultDeliveryLabel": {
            "doBoxComment": "a comment on this task",
            "replyDraft": "an email reply draft",
            "notification": "a notification"
          }
        },
        "conversation": {
          "greeting": "What should this agent do for you? Describe the job like you would to a new teammate. I'll check your connected integrations and ask how you want the result back.",
          "placeholder": "Describe what the agent should do",
          "send": "Send",
          "listAriaLabel": "Agent setup conversation",
          "thinking": "Thinking…",
          "thinkingSlow": "Still working on it. This can take a few more seconds…",
          "limitReached": "This conversation is getting long. Start over to keep describing the agent.",
          "restart": "Start over",
          "turnFailed": "That did not go through. Your message is saved.",
          "retry": "Retry",
          "draftReadyMessage": "Your agent is ready to review. Go back here anytime to change what it does.",
          "blocked": {
            "title": "Not connected yet",
            "connectLink": "Connect integrations"
          },
          "placeholderReply": "Type your reply…"
        },
        "step2": {
          "title": "What can it use?",
          "helper": "Your connections. I turned on only what this job needs.",
          "builtInToolsTitle": "What it will use",
          "otherToolSetsNote": "Also turned on for this agent: {{names}}",
          "connectionsTitle": "Connections it will use",
          "otherConnections": "Other connections ({{count}})",
          "yourConnection": "Your connection",
          "connected": "Connected",
          "viewOnly": "View only",
          "changesData": "Changes data",
          "limitLabel": "Max {{param}} per request",
          "limitLabelGeneric": "Max results per request",
          "limitError": "Enter a number greater than 0",
          "continueBlocked": "Set a number greater than 0 for \"{{tool}}\" to continue.",
          "whoCanUseIt": "Who can use it",
          "onlyMe": "Only me",
          "myTeam": "My team",
          "connectMoreLink": "Need a system that isn't here? Connect it in Integrations",
          "back": "Back",
          "continue": "Continue",
          "missingConnection": {
            "title": "Not connected yet",
            "body": "This job needs {{connection}}. Connect it in Integrations, then come back.",
            "connectLink": "Connect it in Integrations",
            "saveAsDraft": "Save as draft",
            "savedAsDraftToast": "Saved as draft"
          },
          "noToolsSelected": "Nothing turned on yet. Open the list below to add what it needs.",
          "moreToolsTitle": "More it could use ({{count}})",
          "tools": {
            "EMAIL_ACTIONS": "Send, draft and organize emails",
            "NOTIFICATIONS": "Notify you by Slack or email",
            "DOBOX": "Read and edit your tasks",
            "CALENDAR": "Manage your calendar and invites",
            "LOAD_MEETINGS": "Look up your meetings",
            "KNOWLEDGE": "Search and read your Brain pages",
            "KNOWLEDGE_WRITE": "Search, read and edit your Brain pages",
            "PEOPLE": "Look up and update your contacts"
          }
        },
        "step3": {
          "title": "Try it on this task",
          "helper": "Here's what {{name}} would do here. Nothing changes until you approve.",
          "loading": "Working on it…",
          "viewOnlyDone": "Read only · done",
          "changesDataDone": "Made a change · done",
          "changesDataNeedsApproval": "Makes a change · needs your OK",
          "changesDataOnApprove": "Makes a change · applied when you approve",
          "partialPreviewNote": "This preview only shows part of the job: {{name}} creates something first, and the steps that depend on it happen in a full run.",
          "limitLabel": "Max {{param}} per request",
          "limitLabelGeneric": "Max results per request",
          "limitHint": "limit {{max}}",
          "limitError": "Enter a number from 1 to {{max}}",
          "limitErrorRequired": "Enter a number greater than 0",
          "stepFailedGeneric": "This step failed.",
          "editJob": "Edit the job",
          "backToActions": "Back to actions",
          "approveAndSave": "Approve and save agent",
          "wouldSendBot": "Would send to {{destination}} as the bot",
          "wouldSendUser": "Would send to {{destination}} on your behalf",
          "previewOnlyBadge": "Preview · nothing is sent",
          "previewNote": "This is a preview: nothing is sent from here. Hand a task to {{name}} to send the message for real.",
          "saveWithoutRunning": "Save without running",
          "emptyState": "{{name}} found nothing to do on this task. If this task should have been a fit, try again or refine the job. Otherwise you can still save it and it will be ready when a task needs it.",
          "tryAgain": "Try again",
          "refineJob": "Refine the job",
          "runningEmpty": "Trying it on this task…",
          "saveAgent": "Save agent",
          "startError": "Could not start the trial. Try again.",
          "timeoutError": "This is taking longer than expected. Try again.",
          "previewStillRunningError": "The preview is still running. Wait for it to finish, then approve.",
          "approveError": "Could not save this agent. Try again.",
          "showFullText": "Show full text",
          "hideFullText": "Show less",
          "shortenedNote": "This is a shortened preview of what will be written.",
          "safetyNoteAsk": "{{name}} will ask before each change.",
          "safetyNoteSkip": "Once saved, {{name}} will make changes right away on future tasks. A Slack message goes out without asking only when it goes to a destination chosen here, is sent as the bot, and you started the run.",
          "safetyNoteAutonomous": "{{name}} will email and message the people and places saved on it, and book calendar events with invites, without asking you. An email cannot be unsent.",
          "safetyNoteAutonomousStillAsks": "It still asks first about anyone not saved on this agent, deleting, connected apps, money or legal matters, a channel shared with another company, a reply whose sender could not be verified, and whenever a teammate runs it.",
          "wouldSendWithoutAsking": "Would send without asking",
          "wouldCreateWithoutAsking": "Would create without asking",
          "safetyNoteSkipStillAsks": "It still asks first when the message is sent on your behalf, goes anywhere else, mentions money or legal matters, goes to a channel shared with another company, or when a teammate runs the agent.",
          "changeInSettings": "Change this in Flows › your agents",
          "wouldAskAndWait_one": "Would ask {{recipients}} and wait up to {{count}} hour",
          "wouldAskAndWait_other": "Would ask {{recipients}} and wait up to {{count}} hours"
        },
        "done": {
          "readyTitle": "{{name}} is ready",
          "readySubtitle": "You can hand any task to {{name}} from the \"To\" menu.",
          "readySubtitleApplied": "{{name}} already did this on the task. See what it did below.",
          "readySubtitleSetupOnly": "{{name}} only set things up so far. Hand it this task to do the actual work.",
          "whatItDid": "What it did",
          "previewNote": "Nothing was sent: this was a preview. Hand a task to {{name}} to send the message for real.",
          "approvedByYou": "{{label}} · approved by you",
          "partiallyApplied_one": "{{applied}} of {{count}} approved step was applied. The rest were not. See the list below, then open the task's conversation to retry them.",
          "partiallyApplied_other": "{{applied}} of {{count}} approved steps were applied. The rest were not. See the list below, then open the task's conversation to retry them.",
          "noneApplied_one": "The approved step was not applied. See the list below, then open the task's conversation to retry them.",
          "noneApplied_other": "None of the {{count}} approved steps was applied. See the list below, then open the task's conversation to retry them.",
          "openConversation": "Open the task's conversation",
          "cannotUndoMcp": "Can't be undone automatically",
          "next": "Next",
          "replyToRequester": "Reply to the requester",
          "replyToRequesterBadge": "Draft · you review",
          "shareWithTeam": "Share {{name}} with my team",
          "shareWithTeamBadge": "Settings",
          "shareSuccess": "Shared with your team.",
          "shareError": "This task isn't shared with a team.",
          "outcome": {
            "executed": "Done",
            "failed": "Did not work",
            "previewOnly": "Preview · nothing was sent",
            "wouldSendBot": "Would send to {{destination}} as the bot",
            "wouldSendUser": "Would send to {{destination}} on your behalf",
            "notStarted": "Did not run",
            "noReason": "No reason was given.",
            "wouldAskAndWait_one": "Would ask {{recipients}} and wait up to {{count}} hour",
            "wouldAskAndWait_other": "Would ask {{recipients}} and wait up to {{count}} hours"
          },
          "delegateTask": "Hand this task to {{name}}",
          "delegateAgain": "Hand this task to {{name}} again",
          "delegateAgainBadge": "Runs it a second time"
        },
        "leaveConfirm": {
          "title": "Leave without finishing?",
          "body": "This agent is not ready yet and will not appear in your Agents list. If you leave now, setting it up again starts from the beginning.",
          "keepEditing": "Keep editing",
          "leave": "Leave"
        },
        "caveats": {
          "title": "Before this agent can work"
        },
        "saveOutboundError": "Couldn't save where this agent can send. Check that each Slack workspace is connected for the \"Send as\" you chose."
      },
      "activity": {
        "title": "Activity",
        "filterActivity": "Activity",
        "filterComments": "Comments"
      },
      "header": {
        "title": "Task details",
        "copyLink": "Copy link",
        "copyLinkAriaLabel": "Copy link of {{subject}}",
        "copyLinkSuccess": "Link copied to clipboard",
        "copyLinkError": "Failed to copy link to clipboard",
        "complete": "Done",
        "completeAriaLabel": "Mark {{subject}} as done",
        "markDone": "Mark done",
        "completed": "Completed",
        "deleteTask": "Delete task",
        "moveSuccess": "Task moved successfully",
        "maximize": "Maximize",
        "minimize": "Minimize",
        "maximizeAriaLabel": "Maximize dialog",
        "minimizeAriaLabel": "Minimize dialog"
      },
      "notFound": "This DoBox could not be found. It may have been deleted or you may not have access.",
      "removed": {
        "suggestion": "This suggestion was removed: it was deleted, or a newer message in the conversation showed it was already done.",
        "task": "This DoBox was deleted.",
        "taskViewOnly": "You can still view it, but you can't edit it.",
        "writeRejected": "This DoBox was deleted, so your change wasn't saved."
      },
      "deleteSuccess": "Suggested task deleted successfully.",
      "deleteError": "Failed to delete suggested task. Please try again.",
      "updateSuccess": "Task updated successfully.",
      "updateError": "Failed to update task. Please try again.",
      "updateDueDateSuccess": "Due date updated successfully.",
      "updateDueDateError": "Failed to update due date. Please try again.",
      "confirmDelete": {
        "title": "Delete suggested task",
        "message": "Are you sure you want to delete this suggested task? This action cannot be undone.",
        "confirm": "Delete"
      },
      "entryInfo": {
        "subject": "Subject",
        "description": "Description",
        "createdFor": "Created for",
        "createdAt": "Created at",
        "communications": "Communications",
        "noDescription": "No description provided",
        "addDescriptionPlaceholder": "Add a description",
        "showMore": "Show more",
        "showLess": "Show less",
        "editDescription": "Edit description",
        "noSubjectText": "No subject available",
        "priority": "Priority",
        "noPriority": "No priority",
        "labelsTitle": "Labels",
        "descriptionTitle": "Description",
        "markdownBadge": "MARKDOWN"
      },
      "communications": {
        "title": "Communications",
        "emptyTitle": "No communications yet",
        "emptySubtitle": "Chat and email linked to this task will appear here automatically.",
        "emptyTitleChat": "No chats yet",
        "emptySubtitleChat": "Chats linked to this task will appear here automatically.",
        "emptyTitleEmail": "No emails yet",
        "emptySubtitleEmail": "Emails linked to this task will appear here automatically.",
        "filterAriaLabel": "Filter communications",
        "recipients": "Recipients",
        "replyingBadge": "Replying →",
        "newReplyCount_one": "{{count}} new reply",
        "newReplyCount": "{{count}} new replies",
        "newReplyLabel": "New reply",
        "optimisticSentAuthor": "You",
        "optimisticRelativeTime": {
          "justNow": "just now",
          "minutesAgo": "{{count}}m ago",
          "hoursAgo": "{{count}}h ago",
          "daysAgo": "{{count}}d ago"
        },
        "chatActivity": {
          "truncated": "Showing the latest {{count}} messages since the task was created",
          "hiddenForViewer": "Only the conversation owner can read the newer messages in this conversation."
        },
        "tabs": {
          "all": "All",
          "chat": "Chat",
          "email": "Email"
        },
        "thread": {
          "replies": "{{count}} replies in thread",
          "reply": "1 reply in thread",
          "lastReply": "Last reply from {{author}} {{time}}"
        },
        "body": {
          "showMore": "Show more",
          "showLess": "Show less"
        }
      },
      "taskLabelSelector": {
        "buttonLabel": "Labels",
        "title": "Select labels",
        "saveError": "Failed to update labels. Please try again.",
        "addLabel": "Add a label",
        "removeLabel": "Remove label {{labelTitle}}",
        "showHiddenLabels": "Show {{count}} more labels"
      },
      "actionsBar": {
        "dueDate": "Due Date",
        "recurrencePopover": "Recurring task"
      },
      "propertiesGrid": {
        "agentLabel": "Agent",
        "groupLabel": "Properties",
        "priorityLabel": "Priority",
        "recurringLabel": "Recurring",
        "repeatLabel": "Repeat",
        "timezoneLabel": "Timezone",
        "changeTimezoneAriaLabel": "Change timezone from {{timezone}}",
        "dueDateLabel": "Due date",
        "membersLabel": "Members",
        "noMembersDefaultGroup": "This task group has no members",
        "checklistLabel": "Checklist",
        "linkedLabel": "Linked",
        "labelsLabel": "Labels",
        "setPriority": "+ Set",
        "setDueDate": "+ Set",
        "setRecurring": "+ Set",
        "addMembers": "+ Add",
        "addChecklist": "+ Add",
        "addLinked": "+ Add",
        "noneValue": "None"
      },
      "checklistPopover": {
        "sectionTitle": "Checklists",
        "buttonLabel": "Checklist",
        "popoverTitle": "New checklist",
        "inputPlaceholder": "Checklist title",
        "itemsLabel": "Items",
        "itemsOptional": "(optional)",
        "addAnotherItem": "Add another item",
        "itemPlaceholderIndexed": "Item {{index}}",
        "removeItem": "Remove item",
        "save": "Save",
        "close": "Close",
        "delete": "Delete",
        "deleteChecklist": "Delete checklist",
        "deleteSubtask": "Delete subtask",
        "editTitle": "Rename checklist",
        "editSubtask": "Rename item",
        "menuAriaLabel": "Checklist actions",
        "rename": "Rename",
        "hideCheckedItems": "Hide checked items",
        "showCheckedItems": "Show checked items",
        "keyboardHint": "Enter to add, Esc to close",
        "confirmDeleteChecklist": "Delete this checklist?",
        "checklistDeleted": "Checklist deleted",
        "undo": "Undo",
        "showCheckedCount_one": "Show {{count}} checked item",
        "showCheckedCount_other": "Show {{count}} checked items",
        "addSubtask": "Add subtask",
        "addItem": "Add item",
        "addItemPlaceholder": "Add an item",
        "add": "Add",
        "cancel": "Cancel"
      },
      "participantsModal": {
        "buttonLabel": "Members",
        "title": "Manage members",
        "subtitle": "Add or remove members from this entry",
        "done": "Done",
        "save": "Save",
        "cancel": "Cancel",
        "saveError": "Failed to update members. Please try again.",
        "noParticipants": "No members available",
        "searchPlaceholder": "Search members..."
      },
      "dueDateSaveError": "Failed to save due date. Please try again.",
      "checklistCreateError": "Failed to create checklist. Please try again.",
      "checklistDeleteError": "Failed to delete checklist. Please try again.",
      "checklistRenameError": "Failed to rename checklist. Please try again.",
      "checklistTitleRequired": "A checklist title cannot be empty.",
      "checklistLimitReached": "This entry already has the maximum of {{max}} checklists.",
      "subtaskLimitReached": "This entry already has the maximum of {{max}} checklist items.",
      "subtaskTitleRequired": "An item title cannot be empty.",
      "subtaskAddError": "Failed to add subtask. Please try again.",
      "subtaskDeleteError": "Failed to delete subtask. Please try again.",
      "subtaskRenameError": "Failed to rename subtask. Please try again.",
      "subtaskToggleError": "Failed to update subtask. Please try again.",
      "comments": {
        "title": "Comments",
        "emptyTitle": "No comments yet",
        "emptySubtitle": "Be the first to comment. Mention teammates with @ to loop them in.",
        "editorPlaceholder": "Write a comment...",
        "collapsedPlaceholder": "Comment or @mention a teammate",
        "mentionsLoading": "Loading members...",
        "mentionsEmpty": "No members in this task group.",
        "send": "Send",
        "sendComment": "Send comment",
        "characters": "characters",
        "loadMore": "Load more comments",
        "fetchError": "Failed to load comments. Please try again.",
        "createError": "Failed to send comment. Please try again.",
        "deleteError": "Failed to delete comment. Please try again.",
        "updateError": "Failed to update comment. Please try again.",
        "editComment": "Edit comment",
        "deleteComment": "Delete comment",
        "editAction": "Edit",
        "deleteAction": "Delete",
        "enterToSend": "Press Enter to send",
        "saveComment": "Save",
        "cancelEdit": "Cancel",
        "unknownAuthor": "Someone",
        "addAttachment": "Add attachment",
        "removeAttachment": "Remove {{name}}",
        "openAttachment": "Open {{name}}",
        "downloadAttachment": "Download {{name}}",
        "attachmentUploadError": "Failed to upload {{name}}. Please try again.",
        "attachmentUploading": "Uploading {{name}}...",
        "dropToAttach": "Drop files to attach",
        "attachmentFailed": "Failed to attach",
        "imageViewer": {
          "closeAria": "Close image viewer",
          "zoomLevel": "{{percent}}%",
          "imageArea": "Image area"
        }
      },
      "updatePrioritySuccess": "Priority updated successfully.",
      "updatePriorityError": "Failed to update priority. Please try again.",
      "linkedTasks": {
        "linkError": "Failed to update linked tasks. Please try again.",
        "resolveError": "Failed to update the task. Please try again.",
        "title": "Linked tasks",
        "doneOfTotal": "{{resolved}} of {{total}} done",
        "emptyTitle": "No linked tasks yet",
        "emptySubtitle": "Connect tasks that are related to this one.",
        "addLinkedTask": "Add linked task",
        "addShort": "Add",
        "linkTask": "Link a task",
        "ceilingReached": "You've reached the limit of {{max}} linked tasks.",
        "cardMenuAriaLabel": "More actions",
        "openTask": "Open task",
        "markAsDone": "Mark as done",
        "markAsNotDone": "Mark as not done",
        "unlink": "Unlink",
        "unlinked": "Unlinked \"{{subject}}\"",
        "doneGroupTitle": "Done",
        "picker": {
          "title": "Add linked task",
          "searchLabel": "Search tasks",
          "searchPlaceholder": "Search tasks by keyword",
          "searching": "Searching...",
          "alreadyLinked": "Already linked",
          "allowanceReason": "You can only link {{remaining}} more",
          "remainingAllowance": "You can link {{remaining}} more.",
          "confirm": "Link selected ({{count}})",
          "noResults": "No tasks match \"{{term}}\".",
          "createOption": "Create \"{{term}}\" and link it",
          "createdButNotLinked": "\"{{subject}}\" was created but not linked. Select it from the list to try again.",
          "emptyTaskGroup": "No tasks to link yet. Search to find one.",
          "searchFailed": "Search couldn't be completed. Check your connection and try again.",
          "loadingTasks": "Loading tasks...",
          "loadFailed": "Tasks couldn't be loaded. Check your connection and try again.",
          "loadingMoreTasks": "Loading more tasks...",
          "loadMoreFailed": "More tasks couldn't be loaded.",
          "retry": "Try again"
        }
      }
    },
    "tableFooterActions": {
      "selected": "Selected",
      "delete": "Delete",
      "done": "Done"
    },
    "gradientAlert": {
      "checkNow": "Check it out",
      "addNow": "Add now",
      "completeNow": "Complete now",
      "invitationMessage": "{{name}} invited you to join {{team}}! Open your invitation to get started.",
      "title": "a job title",
      "firstName": "your first name",
      "lastName": "your last name",
      "accountWithoutAInformation": "Please add {{missingInfo}} to your account for a better experience! 😊",
      "accountWithMissingInformation": "Please complete your account profile for a better experience! 😊",
      "view": "View",
      "ok": "Ok",
      "notificationAlertTitle": "New notification",
      "syncFailedAlertTitle": "Sync didn't finish",
      "googleRevokeFailedAlertTitle": "Check your Google permissions",
      "inviteBannerTitle": "{{team}} invited you to join",
      "dismissAlert": "Dismiss alert"
    },
    "tooltips": {
      "userCommunication": {
        "forward": "Forward",
        "reply": "Reply",
        "replyAll": "Reply all",
        "deleteSelected": "Delete",
        "back": "Back",
        "archiveSelected": "Archive",
        "refresh": "Refresh",
        "markAsRead": "Mark as read",
        "markAsUnread": "Mark as unread",
        "reportAsSpam": "Report as spam",
        "moveToInbox": "Move to inbox",
        "menu": "Menu",
        "unlink": "Unlink",
        "manageLabels": "Manage labels",
        "snooze": "Snooze",
        "moveTo": "Move to",
        "toDoBoxTooltip": "Convert to Task and move to DoBox",
        "delegateToAgent": "Delegate to agent",
        "delegateToAgentTooltip": "Delegate to agent",
        "expandAll": "Expand all messages",
        "collapseAll": "Collapse all messages"
      },
      "inboxEntry": {
        "delete": "Delete suggested task"
      }
    },
    "attachmentModalViewer": {
      "title": "Attachments"
    },
    "multiSelect": {
      "placeholder": "Select…",
      "searchPlaceholder": "Search…",
      "searchAriaLabel": "Search options",
      "loadingCaption": "Loading options",
      "emptyMessage": "No results",
      "selectAll": "Select all",
      "clear": "Clear",
      "selectedSummary": "{{count}} selected",
      "selectedOfTotal": "{{selected}} of {{total}} selected",
      "applyWithCount": "Apply · {{count}} selected",
      "overflowCount": "+{{count}}"
    },
    "select": {
      "placeholder": "Select…",
      "searchPlaceholder": "Search…",
      "searchAriaLabel": "Search options",
      "loadingCaption": "Loading options",
      "emptyMessage": "No results"
    },
    "warningModal": {
      "okButton": "Got it"
    },
    "notification": {
      "inviteReject": "Decline",
      "inviteAccept": "Accept",
      "title": "Notifications",
      "noNotifications": "No notifications yet",
      "markAllRead": "Mark all as read",
      "clearAll": "Clear all",
      "preferences": "Preferences",
      "viewAll": "View all notifications",
      "updatedJustNow": "Updated just now",
      "needsDecision": "Needs your decision",
      "emptyTitle": "You're all caught up",
      "emptySubtitle": "No new notifications. We'll let you know when something needs your attention.",
      "unreadCount_one": "{{count}} new",
      "unreadCount_other": "{{count}} new",
      "tabUnread": "Unread",
      "tabRead": "Read",
      "emptyReadTitle": "No read notifications",
      "emptyReadSubtitle": "Notifications you've already read will appear here.",
      "doBoxResolved": "Resolved",
      "inviteAccepted": "Accepted",
      "inviteDeclined": "Declined"
    },
    "messageEditor": {
      "send": "Send",
      "scheduleSend": "Schedule send",
      "scheduleSendMenuItem": "Schedule send",
      "scheduleSendCaretLabel": "More send options",
      "placeholder": "Type your message or type \"/\" for AI options...",
      "discardLabel": "Discard draft"
    },
    "scheduleSendModal": {
      "title": "Schedule send",
      "submit": "Schedule send",
      "datetimeLabel": "Send at",
      "dateLabel": "Date",
      "timeLabel": "Time"
    },
    "aiAssistant": {
      "defaultInstructions": {
        "email": "Improve this email to be more professional and clear",
        "title": "Improve this title to be more clear and actionable",
        "description": "Improve this description to be more detailed and clear"
      },
      "instructionModal": {
        "title": "AI Assistant",
        "originalMessage": "Original message",
        "noTextCaptured": "No text captured",
        "instructionLabel": "AI instruction",
        "instructionPlaceholder": "Enter instruction for the AI assistant...",
        "cancelButton": "Cancel",
        "applyButton": "Apply",
        "processingText": "Processing..."
      }
    },
    "search": {
      "defaultPlaceholder": "Search by topic or use from:, subject:…",
      "closeSearch": "Close search",
      "tooltip": {
        "closeSearch": "Close search",
        "openSearch": "Open search"
      }
    },
    "emailSearchResults": {
      "loading": "Loading emails...",
      "emptyTitle": "No emails found",
      "emptyDescription": "Try adjusting your search terms or check your spelling.",
      "resultCount": "{{count}} email{{s}} found",
      "listLabel": "Email search results"
    },
    "emailSearchResultItem": {
      "noSubject": "No subject",
      "emailFromAriaLabel": "Email from {{author}}: {{subject}}",
      "hasAttachments": "Has attachments",
      "unknownAuthor": "Unknown",
      "authorWithMe": "{{author}}, me"
    },
    "doBoxSearch": {
      "placeholder": "Search DoBox..."
    },
    "doBoxSearchResults": {
      "emptyTitle": "No results found",
      "emptyDescription": "Try adjusting your search terms or check your spelling.",
      "resultCount": "{{count}} result{{s}} found",
      "listLabel": "DoBox search results",
      "noSubject": "No subject"
    },
    "boardHeader": {
      "publicBoard": "Public"
    },
    "boardColumn": {
      "pendingTasks": "{{count}} pending task{{s}}"
    },
    "saveStatusIndicator": {
      "saving": "Saving...",
      "saved": "Saved",
      "savedJustNow": "Saved now",
      "savedMinutesAgo": "Saved {{minutes}}m ago",
      "savedHoursAgo": "Saved {{hours}}h ago",
      "failedToSave": "Failed to save",
      "conflict": "Draft changed elsewhere",
      "deleting": "Deleting..."
    },
    "taskManagerMenu": {
      "menu": "Settings",
      "updateList": "Update list",
      "updateListTitle": "Update list",
      "updateListSubtitle": "Pick a color and name for your list",
      "updateListPlaceholder": "List name",
      "participantsLabel": "Members",
      "participantsPlaceholder": "Select members",
      "participantsSearch": "Search...",
      "participantsSelectAll": "Select all members",
      "updateListSuccess": "List updated successfully",
      "updatingList": "Updating list...",
      "updateListError": "Failed to update list. Please try again.",
      "createLabel": "Create label",
      "createLabelTitle": "Create label",
      "createLabelSubtitle": "Pick a color and name for your label",
      "createLabelPlaceholder": "Label name",
      "createLabelSuccess": "Label created successfully",
      "createLabelError": "Failed to create label. Please try again.",
      "updateLabelTitle": "Update label",
      "updateLabelSubtitle": "Pick a color and name for your label",
      "updateLabelPlaceholder": "Label name",
      "updatingLabel": "Updating label...",
      "updateLabelSuccess": "Label updated successfully",
      "updateLabelError": "Failed to update label. Please try again.",
      "duplicate": "Duplicate",
      "duplicateInProgress": "Duplicating list...",
      "duplicateSuccess": "List duplicated successfully",
      "duplicateError": "Failed to duplicate list. Please try again.",
      "delete": "Delete",
      "deleteInProgress": "Deleting list...",
      "deleteSuccess": "List deleted successfully",
      "deleteError": "Failed to delete list. Please try again.",
      "leave": "Leave list",
      "deleteConfirmTitle": "Delete list",
      "deleteConfirmDescription": "Are you sure you want to delete this list? This action cannot be undone.",
      "leaveConfirmActionButtonLabel": "Leave",
      "leaveAsOwnerConfirmTitle": "Leave and delete list",
      "leaveAsOwnerConfirmDescription": "You are the owner of this list. Leaving will remove you and may transfer ownership or delete the list. This action cannot be undone."
    },
    "taskGroup": {
      "cannotRemoveOwner": "The task group owner cannot be removed."
    },
    "moveEmailPopover": {
      "title": "Move to:",
      "spam": "Spam",
      "trash": "Trash"
    },
    "createBoardList": {
      "title": "Create list",
      "pickListColor": "Pick a color for your list",
      "inputPlaceholder": "Enter list title",
      "colorGridAriaLabel": "Select board color",
      "colorAriaLabel": "Color {{color}}"
    },
    "inboxPreview": {
      "header": {
        "generateDoBoxLoading": "Generating your DoBox task...",
        "generateDoBoxSuccess": "DoBox task created successfully! Your email will be moved automatically.",
        "generateDoBoxError": "Failed to generate DoBox task. Please try again.",
        "generateDoBoxInvalidLabelError": "Cannot generate a DoBox task from draft, spam, or trash messages.",
        "generateDoBoxEmptyContentError": "Cannot generate a DoBox task from an empty message."
      }
    },
    "composeButton": {
      "compose": "Compose",
      "createEmail": "Email",
      "createDoBox": "Task",
      "openMenu": "Open create menu"
    },
    "manageList": {
      "title": "Create",
      "pickListColor": "Pick a list color",
      "enterListTitle": "Enter your list title",
      "cancelButton": "Cancel",
      "deleteButton": "Delete",
      "createButton": "Create",
      "updateButton": "Update"
    },
    "boardMembers": {
      "title": "Board members",
      "searchPlaceholder": "Search members"
    },
    "doBoxOptions": {
      "schedule": "Schedule",
      "setRecurrence": "Set recurrence",
      "changeList": "Change list",
      "delete": "Delete"
    },
    "RSVP": {
      "replyFor": "Reply for ",
      "organizer": "Organizer",
      "button": {
        "yes": "Yes",
        "no": "No",
        "maybe": "Maybe"
      }
    },
    "unsubscribeModal": {
      "title": "Unsubscribe",
      "description": "Are you sure you want to unsubscribe from this mailing list?",
      "messages": {
        "success": "Successfully unsubscribed from mailing list",
        "error": "Failed to unsubscribe. Please try again.",
        "manualActionRequired": "Please complete the unsubscription in the opened tab"
      }
    },
    "datePicker": {
      "selectDate": "Select date",
      "next": "Next",
      "datesSelected": "dates selected",
      "rangeSeparator": "→"
    },
    "setRecurrenceContent": {
      "pickDate": "Pick date",
      "noRepeat": "No repeat",
      "everyDay": "Every day",
      "everyWeekday": "Every weekday",
      "everyWeekOnDay": "Every {{day}}",
      "everyMonthOnDay": "Every month on {{day}}",
      "everyMonthOnNthWeekday_ordinal_one": "Monthly on the {{count}}st {{weekday}}",
      "everyMonthOnNthWeekday_ordinal_two": "Monthly on the {{count}}nd {{weekday}}",
      "everyMonthOnNthWeekday_ordinal_few": "Monthly on the {{count}}rd {{weekday}}",
      "everyMonthOnNthWeekday_ordinal_other": "Monthly on the {{count}}th {{weekday}}",
      "timezoneLabel": "Timezone",
      "priorityLabel": "Priority"
    },
    "dueDate": {
      "title": "Dates",
      "startDate": "Start date",
      "dueDate": "Due date",
      "datePlaceholder": "M/D/YYYY"
    },
    "recurrenceEntryDetailsModal": {
      "header": {
        "closeTooltip": "Close",
        "deleteTooltip": "Delete recurrence",
        "recurringBadge": "Recurring"
      },
      "confirmDeleteModal": {
        "title": "Delete recurrence",
        "message": "Are you sure you want to delete this recurrence? This action cannot be undone.",
        "confirmButton": "Delete"
      }
    },
    "participantBubblesPicker": {
      "soloTeamUpsell": {
        "message": "This product gets better with a team. Collaborate and get more done together!",
        "cta": "Bring your team in!"
      }
    },
    "attachmentViewer": {
      "openPdfAria": "Open PDF {{name}}",
      "downloadAria": "Download {{name}}",
      "toolbar": {
        "zoomIn": "Zoom in",
        "zoomOut": "Zoom out",
        "previousPage": "Previous page",
        "nextPage": "Next page",
        "download": "Download",
        "toolbarAria": "Viewer toolbar"
      },
      "pdf": {
        "closeAria": "Close PDF viewer",
        "documentArea": "PDF document area",
        "pageLabel": "{{current}} / {{total}}",
        "zoomLevel": "{{percent}}%",
        "loading": "Loading document…",
        "loadError": "We couldn't load this PDF."
      }
    },
    "agentApprovalModeChoice": {
      "label": "When the agent wants to change something",
      "ask": {
        "title": "Ask me before it changes anything",
        "hint": "You approve each change first."
      },
      "skip": {
        "title": "Let it work without asking",
        "hint": "Changes are made right away. A Slack message goes out without asking only when it goes to a destination chosen here, is sent as the bot, and you started the run.",
        "hintPeople": "Changes are made right away. A Slack message goes out without asking only when it goes to a destination chosen here or to a teammate you let it message, is sent as the bot, and you started the run. Anyone not on your team always asks first.",
        "stillAsks": "It still asks first when the message is sent on your behalf, goes anywhere else, mentions money or legal matters, goes to a channel shared with another company, or when a teammate runs the agent."
      },
      "autonomous": {
        "title": "Let it do everything on its own",
        "hint": "It emails and messages the people and places you saved here. After someone replies, it confirms with them and creates the calendar event with the invite, all without asking you.",
        "hintPeople": "It emails and messages the people and places you saved here, and the teammates you let it message on Slack. After someone replies, it confirms with them and creates the calendar event with the invite, all without asking you. Anyone not on your team always asks first.",
        "stillAsks": "It still asks first about anyone not saved on this agent, deleting, connected apps, messages about money or legal matters, a channel shared with another company, a reply whose sender could not be verified, and whenever a teammate runs the agent.",
        "warning": "This removes your review before messages and invites go out. An email cannot be unsent.",
        "teamNote": "This agent is shared with a team: this level applies only when you run it.",
        "confirm": "I understand messages and invites will go out without my review",
        "participantsCaution": "Together with \"Anyone involved in the task\": a task that comes from a stranger's email makes that stranger someone the agent will answer on its own."
      },
      "ownerOnlyNote": "Only the person who created this agent can change this."
    },
    "agentOutboundSettings": {
      "title": "Where can it send messages?",
      "helper": "Pick the Slack places this agent may post to. It can't post anywhere else.",
      "helperPeople": "Pick the Slack places this agent may post to. Beyond those, it can only message the people you allow below.",
      "noWorkspace": "No Slack workspace is connected yet, so there is nowhere to send to.",
      "connectSlack": "Connect Slack in Integrations",
      "titleEmail": "Who can it contact?",
      "helperEmail": "Pick the people this agent may email and, if you want, the Slack places it may post to. It can't contact anyone else.",
      "helperEmailPeople": "Pick the people this agent may email and, if you want, the Slack places it may post to. Beyond those, it can only message the people you allow below.",
      "scope": {
        "label": "Who it may contact",
        "savedOnly": {
          "title": "Only the people I list here"
        },
        "taskParticipants": {
          "title": "Anyone involved in the task",
          "who": "That is the person who sent the email or message the task came from, people in that conversation, an address written in the task, and anyone the agent already asked.",
          "never": "It never writes to an address that only shows up inside a reply, a Brain page or a search result.",
          "currently": "For this task right now: {{people}}."
        }
      },
      "noRecipients": {
        "title": "Nobody to email yet",
        "body": "As it stands, this agent has no one it is allowed to email, so its first send would be refused. Add someone below, or let it contact the people involved in each task.",
        "add": "Add {{name}}",
        "switch": "Anyone involved in the task"
      },
      "emailNeedsRecipients": "Until you add people here, this agent will only be able to email people you @mention when you hand it a task.",
      "slackSection": "Slack destinations (optional)",
      "cannotSendYet": "This agent won't be able to send Slack messages until you add a destination. You can also add one later.",
      "ownerNotification": "The this+that bot will message you directly in Slack. No destination needed.",
      "botDirectMessageError": "The bot can't write in a private conversation it isn't part of. Send as yourself, or let it notify you directly.",
      "peopleScope": {
        "label": "People it can message on Slack",
        "helper": "Besides the places above, the agent can send a Slack direct message to a person it finds by name.",
        "none": {
          "title": "Nobody",
          "hint": "It only posts to the places you chose above."
        },
        "teammates": {
          "title": "My teammates",
          "hint": "It can message people who are on one of your teams."
        },
        "teammatesAndContacts": {
          "title": "My teammates and my contacts",
          "hint": "It can also message people from your contacts, always after you approve."
        },
        "rules": {
          "teammatesOnTheirOwn": "Teammates can be messaged without asking you when the agent works on its own.",
          "othersAlwaysAsk": "Anyone not on your team always asks you first, and only with \"My teammates and my contacts\".",
          "unclearNameAsksOnce": "When a name is unclear, the agent asks you once and remembers your answer.",
          "connectedWorkspaceOnly": "It only reaches people in a Slack workspace you connected.",
          "sentByBot": "Messages go out from the this+that bot."
        },
        "errors": {
          "disabled": "Messaging people by name isn't available on your account yet, so this setting wasn't saved.",
          "needsNotifications": "The agent needs the \"Notify you by Slack or email\" tool turned on before it can message people."
        }
      },
      "trialSendGap": {
        "noSendPath": "This agent can't send Slack messages yet: it has no destination to send to. Add one, then try again.",
        "sendNotProposed": "This preview has texts but no message to send, so a text may describe a message nobody received. Try the preview again before approving."
      },
      "unavailableChannel": "Unavailable channel",
      "unavailableHint": "This channel or conversation can no longer be found. Remove it and pick another.",
      "removeDestination": "Remove {{name}}",
      "kind": {
        "channel": "Channel",
        "directMessage": "Direct message"
      },
      "destinations": {
        "label": "Destinations",
        "workspace": "Slack workspace",
        "workspacePlaceholder": "Choose a workspace",
        "destination": "Channel or person",
        "destinationPlaceholder": "Choose where to send",
        "search": "Search channels and people",
        "loading": "Loading channels and people...",
        "loadError": "We couldn't load this workspace's channels. Try again in a moment.",
        "capReached": "You can add up to {{max}} destinations."
      },
      "sendAs": {
        "label": "Send as",
        "bot": {
          "title": "The workspace bot",
          "hint": "People see the message from the this+that bot, not from you."
        },
        "user": {
          "title": "Me",
          "hint": "People see the message as if you wrote it, from your own Slack account."
        }
      },
      "mentions": {
        "label": "People it can mention",
        "helper": "It can tag only the people you pick here.",
        "addDestinationFirst": "Add a destination first, then pick people from its workspace.",
        "loading": "Loading people...",
        "search": "Search people",
        "noPeople": "No people to show yet.",
        "selectedCount_one": "{{count}} person selected",
        "selectedCount_other": "{{count}} people selected",
        "capReached": "You can pick up to {{max}} people.",
        "unknownPerson": "Unknown person",
        "broadcast": {
          "title": "Allow @channel and @here",
          "warning": "Off by default. These notify everyone in the channel."
        }
      },
      "readOnly": {
        "title": "Where it sends messages",
        "none": "It can't send Slack messages.",
        "summary_bot_one": "Sends to {{count}} destination as the bot",
        "summary_bot_other": "Sends to {{count}} destinations as the bot",
        "summary_user_one": "Sends to {{count}} destination on its owner's behalf",
        "summary_user_other": "Sends to {{count}} destinations on its owner's behalf",
        "ownerOnly": "Only the person who created this agent can change this.",
        "scopeSavedOnly": "Contacts only the people saved on this agent",
        "scopeTaskParticipants": "Also contacts anyone involved in the task",
        "peopleTeammates": "Can message your teammates on Slack",
        "peopleTeammatesAndContacts": "Can message your teammates and contacts on Slack",
        "emailSummary_one": "Can email {{count}} person",
        "emailSummary_other": "Can email {{count}} people",
        "emailNone": "It can only email people mentioned when a task is handed to it.",
        "waitSummary": "Waits up to {{duration}} for replies"
      },
      "emailRecipients": {
        "title": "People it can email",
        "helper": "Add the addresses this agent may write to. It can't email anyone else.",
        "addressLabel": "Email address",
        "addressPlaceholder": "name@company.com",
        "nameLabel": "Name (optional)",
        "namePlaceholder": "Name (optional)",
        "add": "Add",
        "remove": "Remove {{name}}",
        "capReached": "You can add up to {{max}} people.",
        "alwaysAsks": "An email to one of these people always asks you before it goes out, even when the agent works without asking.",
        "errors": {
          "invalid": "That doesn't look like an email address.",
          "duplicate": "That address is already on the list.",
          "cap": "You can add up to {{max}} people.",
          "labelTooLong": "That name is too long."
        }
      },
      "replyWait": {
        "title": "Wait for replies",
        "helper": "After the agent asks someone a question on Slack or by email, it stops and waits for the answer, then carries on with it.",
        "nobodyToAsk": "Add a Slack destination or an email address above, so it has someone to ask.",
        "waitUpTo": "Wait up to",
        "waitUpToHint": "If nobody has answered by then, the agent carries on without an answer.",
        "duration": {
          "hours_one": "{{count}} hour",
          "hours_other": "{{count}} hours",
          "days_one": "{{count}} day",
          "days_other": "{{count}} days"
        },
        "remind": {
          "title": "Offer one reminder halfway",
          "hint": "Halfway through the wait, the agent asks you to approve a reminder. Nothing is nudged on its own, and an answer to the reminder isn't picked up."
        },
        "rule": {
          "label": "Continue when",
          "all": "Everyone asked has answered",
          "any": "Anyone asked has answered"
        },
        "notes": {
          "pickedUp": "A reply is picked up within about two minutes.",
          "slackDirectMessage": "In a Slack channel it waits for the people it tags; in a direct message sent as you, for the other person. Replies in a direct message from the bot can't be seen, so send questions to a person as \"Me\" or in a channel thread.",
          "stillAsks": "Anything it wants to send or schedule after a reply still asks you first."
        }
      }
    },
    "aiInlinePrompt": {
      "newLineHint": "new line"
    }
  },
  "emailProcessing": {
    "progressNotification": "We're still syncing and analyzing email messages for {{emailAddress}}. We load them from newest to oldest and are back to {{month}} {{year}}. Some operations may be slow",
    "completedNotification": "All email messages for {{emailAddress}} have been synced and analyzed!",
    "failedNotification": "We couldn't finish syncing {{emailAddress}}. Reconnect the account to pick up where we stopped."
  },
  "slackProcessing": {
    "progressNotification": "We're still syncing and analyzing your Slack messages. We've processed {{processedChannels}} of your {{totalChannels}} channels.",
    "completedNotification": "All Slack channels have been synced! {{totalChannels}} channels processed",
    "failedNotification": "We couldn't finish syncing your Slack workspace. We processed {{processedChannels}} channels before stopping — reconnect Slack to finish.",
    "disconnectedNotification": "Slack was disconnected, so we stopped syncing your workspace. We processed {{processedChannels}} channels."
  },
  "priority": {
    "high": "High",
    "medium": "Medium",
    "low": "Low",
    "urgent": "Urgent",
    "placeholder": "No priority",
    "setPriority": "Set priority"
  },
  "copyActionToaster": {
    "linkCopied": "Link copied!",
    "linkCopiedDescription": "The link has been copied to the clipboard.",
    "errorCopying": "Error copying",
    "unableToCopy": "Unable to copy the link. Please try again."
  },
  "notifications": {
    "defaultEmailSubject": "Heads Up from this+that",
    "dailyDoBoxEmailSubject": "t+t | Your tasks for {{date}} are ready! Check them out",
    "dailyDoBoxEmailSubjectWithPreview": "t+t | {{preview}} + {{count}} more",
    "dailyDoBoxEmailSubjectSingle": "t+t | {{preview}}",
    "openDoBoxes": "Active Tasks",
    "suggestedDoBoxes": "Suggested Tasks",
    "teamInvitationEmailSubject": "t+t | {{author}} invited you to join a team! Join now",
    "appIntegrationIssueEmailSubject": "t+t | Your {{appName}} integration is not working! Check it out",
    "googleRevokeFailedEmailSubject": "t+t | Action needed: remove our access from your Google Account",
    "googleRevokeFailed": "Your data is deleted — one step left at Google",
    "googleRevokeFailedDescription": "Your account and all of its data have been deleted, as you asked. One thing we could not finish: removing our app's access to your Google Account. The credentials we needed to do that had already expired, and with your account gone there is nothing left for us to retry with. Please remove it yourself now — it takes a few seconds.",
    "googleRevokeFailedCtaText": "Remove access at Google",
    "highestPriorities": "Highest priorities",
    "openTheApp": "Open the app",
    "ourWebsite": "Our website",
    "support": "Support",
    "unsubscribe": "Unsubscribe",
    "addedBy": "by {{author}}",
    "assignedTo": "You’ve been added to a task",
    "latestUpdates": "Here are the latest updates",
    "viewUpdates": "View updates",
    "teamInvitation": "You’re invited to join a team",
    "acceptInvitation": "Click here to get started!",
    "teamInvitationDescription": "Hi there,<br><strong>{{author}}</strong> has invited you to join their team on <strong>this+that</strong>. We’re a productivity assistant for your email and messaging apps, synthesizing large volumes of project conversation into actionable to-dos. Think of this+that as your personal Chief of Staff or assistant, who organizes everything into a single, user-friendly view. Here, outstanding issues can be marked done offline or dragged and dropped straight into meeting agendas.<br><strong>“You can get tasks down to a science, but communication will always have surprises up its sleeve.”</strong><br>We hope you’ll join <strong>{{teamName}}</strong> and start reading less, and doing more!{{extraMessage}}",
    "teamInvitationExtraMessage": "<br><strong>P.S.</strong> Since you’re already part of another team and can only be on one team at a time, if you join this team your data with your current team will be <strong>lost</strong>. Make sure you’re happy to switch.",
    "whatChanged": "Here’s what changed",
    "detailsUpdated": "&#8226; Previous {{mappedKey}}: <strong>{{oldValue}}</strong> <br> &#8226; New {{mappedKey}}: <strong>{{newValue}}</strong>",
    "attachmentAdded": "<strong>{{userName}}</strong> sent {{count}} attachment(s).",
    "messageAdded": "<strong>{{userName}}</strong> sent a message: {{message}}",
    "messageAndAttachmentAdded": "<strong>{{userName}}</strong> sent a message: {{message}} and {{count}} attachment(s).",
    "appIntegrationIssue": "Action required! <br> Reconnect your {{appName}}.",
    "appIntegrationIssueBanner": "Action required! Reconnect your {{appName}}.",
    "googleReconnectBanner": "Action required! Reconnect your Google account {{account}}.",
    "whatsAppReconnectBanner": "Action required! WhatsApp {{phoneNumber}} was disconnected. Reconnect your WhatsApp Business account.",
    "microsoftReconnectBanner": {
      "outlookMail": "Action required! Reconnect Outlook Mail for {{account}}.",
      "outlookCalendar": "Action required! Reconnect Outlook Calendar for {{account}}.",
      "outlookMailAndCalendar": "Action required! Reconnect Outlook Mail and Outlook Calendar for {{account}}.",
      "teams": "Action required! Reconnect Microsoft Teams for {{account}}."
    },
    "slackWorkspaceReconnectBanner": "Action required! Reconnect your Slack workspace '{{workspaceName}}'.",
    "appIntegrationIssueDescription": "We noticed that your {{appName}} was accidentally disconnected. To continue receiving uninterrupted support and updates, please reconnect it as soon as possible.",
    "reconnectNow": "Reconnect now",
    "evalAnnotationEmailSubject": "New eval annotations are ready for review",
    "evalAnnotationTitle_one": "{{count}} new eval annotation ready for review",
    "evalAnnotationTitle_other": "{{count}} new eval annotations ready for review",
    "evalAnnotationCtaText": "Review annotations",
    "doBoxGenerated": "DoBox \"{{subject}}\" was generated",
    "doBoxAssigned": "You were assigned to \"{{subject}}\"",
    "doBoxGeneratedResolved": "DoBox \"{{subject}}\" was resolved by your assistant",
    "doBoxAssignedResolved": "DoBox \"{{subject}}\" you were assigned to was resolved by your assistant",
    "taskGroupAdded": "You were added to the task group \"{{taskGroupTitle}}\"",
    "doBoxCommentMention": "{{mentionedByName}} mentioned you in \"{{subject}}\"",
    "knowledgePageMention": "{{mentionedByName}} mentioned you in \"{{pageTitle}}\"",
    "teamInvitationPending": "{{inviterUserName}} invited you to {{teamName}}",
    "teamInvitationAccepted": "You joined {{teamName}}",
    "teamInvitationRejected": "You declined the invitation to {{teamName}}"
  },
  "attachments": {
    "success": "Your message has been sent successfully!",
    "deletion": {
      "success": "Attachment deleted successfully!",
      "error": "Error deleting attachment. Please try again later."
    },
    "errors": {
      "notFound": "We're still scanning {{fileName}}. Please try again in a moment.",
      "threatsFound": "{{fileName}} was blocked because it contains malware.",
      "accessDenied": "We couldn't scan {{fileName}} due to a permission issue. Our team has been notified — please try again later.",
      "unsupported": "{{fileName}} couldn't be scanned. It may be password-protected or encrypted — please upload an unlocked version.",
      "default": "Something went wrong while processing {{fileName}}. Please try again.",
      "fileTooLarge": "File {{fileName}} is too large. Maximum size is {{maxSize}}MB.",
      "fileTypeNotSupported": "File type {{fileType}} is not supported for {{fileName}}.",
      "fileContentMismatch": "File {{fileName}} content doesn't match its declared type. Upload blocked for safety.",
      "fileUnreadable": "We couldn't read {{fileName}}. The file appears empty or corrupted — please try again with a different copy.",
      "fileAlreadyAttached": "File {{fileName}} is already attached.",
      "failedToProcessFile": "Failed to process file {{fileName}}",
      "failedToAddFiles": "Failed to add files",
      "presignedUrlFailed": "Failed to prepare upload for {{fileName}}. Please try again.",
      "uploadFailed": "Failed to upload {{fileName}}. Please try again."
    }
  },
  "googleDisconnect": {
    "revokeFailedNotification": "We couldn't confirm that disconnecting {{gmailAddress}} removed our access at Google. Open your Google account permissions and remove this app if it's still listed."
  },
  "inbox": {
    "pageTitle": "Inbox",
    "pageDescription": "This is your inbox for email and messages. It's organized around your tasks.",
    "header": {
      "mobile": {
        "title": "Inbox",
        "openMenu": "Open sidebar menu",
        "searchLabel": "Search",
        "filterLabel": "Filter",
        "selectLabel": "Select",
        "selectAll": "Select all",
        "moreActions": "More actions",
        "exitSelectionMode": "Exit selection mode"
      },
      "moreActions": "More actions"
    },
    "settings": {
      "title": "Inbox Settings",
      "subtitle": "Customize your inbox settings to keep it organized your way",
      "categories": "Categories",
      "tabs": {
        "primary": "Primary",
        "promotions": "Promotions",
        "social": "Social",
        "updates": "Updates",
        "forums": "Forums"
      },
      "signature": {
        "title": "Signature",
        "enable": "Add my signature automatically to new emails, replies and forwards",
        "placeholder": "Write your signature",
        "tooLong": "Your signature is too long. Keep it under {{max}} characters.",
        "hint": "Inserted when you compose in this app. You can still edit it in each email. Images are not supported."
      },
      "saving": "Saving inbox settings...",
      "saveSuccess": "Inbox settings saved successfully.",
      "saveError": "Failed to save inbox settings. Please try again."
    },
    "tabs": {
      "inbox": "Primary",
      "promotions": "Promotions",
      "forums": "Forums",
      "social": "Social",
      "updates": "Updates",
      "aria": {
        "tabListLabel": "Inbox filter tabs"
      }
    },
    "sidebar": {
      "inbox": "Messages",
      "collapseMessages": "Collapse messages",
      "expandMessages": "Expand messages",
      "main": "Inbox",
      "sent": "Sent",
      "draft": "Draft",
      "scheduled": "Scheduled",
      "snoozed": "Snoozed",
      "spam": "Spam",
      "trash": "Trash",
      "archived": "Archived",
      "all": "All Mail",
      "labels": "Labels",
      "dm": "Direct",
      "chats": "Chats",
      "channels": "Channels"
    },
    "scheduled": {
      "title": "Scheduled",
      "subtitle": "Emails waiting to be sent",
      "emptyState": {
        "title": "No scheduled emails",
        "description": "Use the Send caret in the composer to schedule delivery."
      },
      "item": {
        "title": "Scheduled email",
        "to": "To",
        "noSubject": "(no subject)",
        "scheduledFor": "Scheduled for",
        "status": "Status",
        "id": "ID",
        "reschedule": "Reschedule",
        "cancel": "Cancel"
      },
      "modal": {
        "title": "Reschedule email",
        "submit": "Save schedule"
      },
      "toast": {
        "createSuccess": "Email scheduled",
        "createError": "Unable to schedule email",
        "updateSuccess": "Schedule updated",
        "updateError": "Unable to reschedule email",
        "cancelSuccess": "Scheduled email canceled",
        "cancelError": "Unable to cancel scheduled email"
      },
      "cancelConfirm": {
        "title": "Cancel scheduled email?",
        "description": "This email will not be sent. This action cannot be undone.",
        "confirm": "Cancel email"
      },
      "errors": {
        "invalidDate": "Enter a valid date and time",
        "minLead": "Choose a time at least five minutes ahead"
      },
      "row": {
        "to": "To: {{recipient}}",
        "noRecipient": "No recipient",
        "cancelButton": "Cancel"
      },
      "relativeDay": {
        "today": "Today",
        "tomorrow": "Tomorrow"
      },
      "composer": {
        "saveChanges": "Save changes"
      }
    },
    "snooze": {
      "options": {
        "laterToday": "Later today",
        "tomorrow": "Tomorrow",
        "thisWeekend": "This weekend",
        "nextWeek": "Next week",
        "pickDateTime": "Pick date & time",
        "unsnooze": "Remove from snooze"
      },
      "custom": {
        "timeLabel": "Time",
        "save": "Save",
        "minLeadWarning": "Must be at least 6 minutes from now"
      },
      "toast": {
        "success": "Snoozed until {{time}}",
        "successMultiple": "{{count}} messages snoozed until {{time}}",
        "error": "Failed to snooze message",
        "partialError": "{{failed}} of {{total}} messages failed to be snoozed",
        "cancelSuccess": "Snooze canceled",
        "cancelError": "Failed to cancel snooze",
        "updateSuccess": "Snooze time updated",
        "updateSuccessMultiple": "{{count}} snoozes updated",
        "updatePartialError": "{{failed}} of {{total}} snoozes failed to update",
        "updateError": "Failed to update snooze time"
      },
      "view": {
        "emptyState": {
          "title": "No snoozed messages",
          "description": "Snooze a message from your inbox to see it here."
        }
      }
    },
    "userCommunication": {
      "selectedCount": "{{count}} selected",
      "draft": "Draft",
      "noRecipient": "No recipient",
      "to": "To: {{email}}",
      "platformNames": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "slack": "Slack",
        "teams": "Teams",
        "instagram": "Instagram"
      },
      "actions": {
        "partialDeleteError": "Failed to delete {{failed}} of {{total}} messages",
        "createSuccess": "Message created",
        "createError": "Message creation failed. Please try again later.",
        "replySuccess": "Reply sent",
        "replyError": "Message reply failed. Please try again later.",
        "forwardSuccess": "Message forwarded",
        "forwardError": "Message forward failed. Please try again later.",
        "archiving": "Archiving messages...",
        "archiveSuccess": "Message archived",
        "archiveMultipleSuccess": "{{count}} messages archived",
        "archiveError": "Failed to archive message(s)",
        "partialArchiveError": "{{failed}} of {{total}} messages failed to be archived",
        "deleting": "Deleting messages...",
        "deleteSuccess": "Message deleted",
        "deleteMultipleSuccess": "{{count}} messages deleted",
        "deleteError": "Failed to delete message(s)",
        "trashing": "Moving messages to trash...",
        "trashSuccess": "Message moved to trash",
        "trashMultipleSuccess": "{{count}} messages moved to trash",
        "trashError": "Failed to move message(s) to trash",
        "markingAsRead": "Marking messages as read...",
        "markAsReadSuccess": "Message marked as read",
        "markAsReadMultipleSuccess": "{{count}} messages marked as read",
        "markAsReadError": "Failed to mark message(s) as read",
        "markingAsUnread": "Marking messages as unread...",
        "markAsUnreadSuccess": "Message marked as unread",
        "markAsUnreadMultipleSuccess": "{{count}} messages marked as unread",
        "markAsUnreadError": "Failed to mark message(s) as unread",
        "partialMarkAsReadError": "{{failed}} of {{total}} messages failed to be marked as read",
        "partialMarkAsUnreadError": "{{failed}} of {{total}} messages failed to be marked as unread",
        "partialTrashError": "{{failed}} of {{total}} messages failed to be moved to trash",
        "reportingAsSpam": "Reporting messages as spam...",
        "reportAsSpamSuccess": "Message reported as spam",
        "reportAsSpamMultipleSuccess": "{{count}} messages reported as spam",
        "reportAsSpamError": "Failed to report message(s) as spam",
        "partialReportAsSpamError": "{{failed}} of {{total}} messages failed to be reported as spam",
        "movingToInbox": "Moving messages to inbox...",
        "moveToInboxSuccess": "Message moved to inbox",
        "moveToInboxMultipleSuccess": "{{count}} messages moved to inbox",
        "moveToInboxError": "Failed to move message(s) to inbox",
        "saveDraftError": "Failed to save draft. Please try again later.",
        "draftConflictError": "This draft was changed elsewhere. Your text is safe, but autosave is paused until you reload the draft.",
        "deleteDraftError": "Failed to delete draft. Please try again later.",
        "deleteDraftSuccess": "Draft deleted",
        "deleteDraftMultipleSuccess": "{{count}} drafts deleted",
        "partialDeleteDraftError": "{{failed}} of {{total}} drafts failed to be deleted",
        "deletingDraft": "Deleting draft…",
        "deletingDrafts": "Deleting {{count}} drafts…",
        "sendDraftError": "Failed to send draft. Please try again later.",
        "sendDraftSuccess": "Email sent",
        "sendDraftConflictError": "This draft was changed elsewhere and wasn't sent. Reload it and try again.",
        "noEmailAccountError": "No email account connected. Connect Gmail or Outlook to send emails.",
        "deleteLoading": "Deleting message...",
        "archiveLoading": "Archiving message...",
        "moveToInboxLoading": "Moving message to inbox...",
        "unlinkLoading": "Unlinking message...",
        "unlinkSuccess": "Message unlinked",
        "unlinkError": "Failed to unlink message",
        "markReadLoading": "Marking message as read...",
        "markReadSuccess": "Message marked as read",
        "markReadError": "Failed to mark message as read",
        "markUnreadLoading": "Marking message as unread...",
        "markUnreadSuccess": "Message marked as unread",
        "markUnreadError": "Failed to mark message as unread",
        "reportSpamLoading": "Reporting message as spam...",
        "reportSpamSuccess": "Message reported as spam",
        "reportSpamError": "Failed to report message as spam",
        "alreadyInTrash": "Already in trash",
        "markerError": "Couldn't update the email",
        "markImportantSuccess": "Message marked as important",
        "unmarkImportantSuccess": "Message marked as not important"
      },
      "connectEmail": {
        "title": "No email account connected",
        "subtitle": "Connect Gmail or Outlook to see your email here."
      },
      "noCommunications": "Nothing in your inbox right now",
      "noCommunicationsSent": "Nothing in your sent items right now",
      "noCommunicationsDraft": "Nothing in your drafts right now",
      "noCommunicationsSpam": "Nothing in your spam right now",
      "noCommunicationsAll": "Nothing in all mail right now",
      "noCommunicationsArchived": "Nothing in your archived right now",
      "noCommunicationsPromotions": "Nothing in your promotions right now",
      "noCommunicationsForums": "Nothing in your forums right now",
      "noCommunicationsSocial": "Nothing in your social right now",
      "noCommunicationsUpdates": "Nothing in your updates right now",
      "noCommunicationsInbox": "Nothing in your inbox right now",
      "noCommunicationsTrash": "Nothing in your trash right now",
      "noCommunicationsDirect": "Nothing in your direct list right now",
      "noCommunicationsChats": "Nothing in your chat list right now",
      "noCommunicationsChannels": "Nothing in your channel list right now",
      "noCommunicationsLabels": "Select a label to view the emails.",
      "noCommunicationsSearch": "No results found for your search",
      "loadingMessages": "Loading your messages...",
      "searchingMessages": "Searching your emails..."
    },
    "search": {
      "error": "Search failed. Please try again.",
      "resultsFor": "Results for",
      "semanticHint": "Results ranked by relevance across indexed emails. Use operators such as from: or in:draft for a traditional search.",
      "resultsCount": "{{count}} result found",
      "resultsCount_other": "{{count}} results found"
    },
    "slack": {
      "direct": "Direct",
      "channels": "Channels",
      "unknownChannel": "Unknown Channel",
      "loading": "Loading Slack communications...",
      "noCommunications": "No Slack communications found",
      "noMessages": {
        "channel": "No messages in this channel",
        "directMessage": "No messages in this direct message"
      },
      "aria": {
        "tabListLabel": "Slack communications tabs"
      },
      "channel": {
        "channelName": "# {{channelName}}"
      },
      "manageSlackParticipants": {
        "addPeople": "Add people"
      },
      "messageEditor": {
        "placeholder": {
          "directMessage": "Send message to {{userName}}",
          "default": "Type your message here..."
        },
        "characterCount": "{{count}} characters",
        "send": "Send",
        "sendShortcut": "Send ({{shortcut}})",
        "aria": {
          "messageEditor": "Message editor",
          "messageContent": "Message content",
          "sendMessage": "Send message"
        }
      },
      "search": {
        "placeholder": "Search channels and direct messages...",
        "openSearch": "Open search",
        "closeSearch": "Close search",
        "loading": "Searching...",
        "noResults": "No results found"
      },
      "attachments": {
        "count": "{{count}} attachments"
      },
      "reply": {
        "title": "Reply to Slack message",
        "channel": "Channel",
        "dm": "DM",
        "placeholder": "Type your message...",
        "sending": "Sending...",
        "success": "Slack message sent successfully",
        "error": {
          "missingWorkspace": "Cannot reply: workspace information is missing",
          "missingChannel": "Cannot reply: channel information is missing",
          "sendFailed": "Failed to send Slack message. Please try again."
        }
      }
    },
    "teams": {
      "chats": "Chats",
      "groups": "Groups",
      "loading": "Loading Teams communications...",
      "noCommunications": "No Teams communications found",
      "noMessages": {
        "chat": "No messages in this chat",
        "group": "No messages in this group"
      },
      "aria": {
        "tabListLabel": "Teams communications tabs"
      },
      "search": {
        "placeholder": "Search chats and groups...",
        "openSearch": "Open search",
        "closeSearch": "Close search",
        "loading": "Searching...",
        "noResults": "No results found"
      },
      "reply": {
        "title": "Reply to Teams message",
        "dm": "DM",
        "channel": "Channel",
        "placeholder": "Type your message...",
        "success": "Teams message sent successfully",
        "error": {
          "missingAccount": "Cannot reply: no Microsoft account found for this message",
          "missingChat": "Cannot reply: chat information is missing",
          "sendFailed": "Failed to send Teams message. Please try again."
        }
      }
    },
    "googleChat": {
      "reply": {
        "title": "Reply to Google Chat message",
        "placeholder": "Type your message...",
        "success": "Google Chat message sent successfully",
        "error": {
          "missingAccount": "Cannot reply: no Google Chat account found for this message",
          "missingSpace": "Cannot reply: conversation information is missing",
          "sendFailed": "Failed to send Google Chat message. Please try again."
        }
      }
    },
    "instagram": {
      "dms": "Direct",
      "loading": "Loading Instagram conversations...",
      "noCommunications": "No Instagram conversations found",
      "noMessages": {
        "dm": "No messages in this conversation"
      },
      "outsideWindow": "Instagram only allows replies within 24 hours of the last message from this person.",
      "attachments": {
        "count": "{{count}} attachments"
      },
      "aria": {
        "tabListLabel": "Instagram conversations tabs"
      }
    },
    "messaging": {
      "failedSend": "Failed to send message. Please try again.",
      "failedLoadThreadMessages": "Failed to load thread messages. Please try again."
    },
    "messageDialog": {
      "recipients": "Recipients",
      "to": "To",
      "from": "From",
      "cc": "Cc",
      "bcc": "Bcc",
      "ccBcc": "Cc/Bcc",
      "subject": "Subject",
      "newMessage": "New message",
      "searchingContacts": "Searching contacts...",
      "noSuggestionsFound": "No suggestions found",
      "failedToSearchContacts": "Failed to search contacts. Please try again.",
      "more": "+{{count}} more",
      "cannotChangeEmail": "Cannot change email while saving draft",
      "aiReply": {
        "entryButton": "AI Reply",
        "chip": {
          "label": "Write with AI"
        },
        "intent": {
          "placeholder": "Reply with… e.g. 'agree, suggest Thursday'",
          "inputLabel": "Describe what you want to say back",
          "helper": "Leave the idea for this reply here and we will compose it for you."
        },
        "drafting": "Drafting with your context…",
        "refining": "Refining your draft…",
        "error": "Could not reach the assistant. Try again, or keep writing on your own.",
        "tabs": {
          "asYouWriteIt": "As you'd write it",
          "shorter": "Shorter",
          "moreFormal": "More formal"
        },
        "refine": {
          "placeholder": "Refine… e.g. 'make it shorter, suggest two times'",
          "inputLabel": "Ask the AI for an adjustment"
        },
        "context": {
          "label": "CONTEXT",
          "thisThread": "This thread",
          "escToClose": "Esc to close the AI Assistant"
        },
        "footer": {
          "sendAsIs": "Send as is"
        },
        "manual": {
          "label": "You are writing this one yourself",
          "bringBack": "Bring the draft back"
        }
      },
      "aiCompose": {
        "chip": {
          "label": "Write with AI"
        },
        "intent": {
          "placeholder": "Write about… e.g. 'intro, propose a call Thursday'",
          "inputLabel": "Describe what this email should say",
          "helper": "Leave the idea for this email here and we will compose it for you."
        },
        "drafting": "Drafting with your context…",
        "refining": "Refining your draft…",
        "error": "Could not reach the assistant. Try again, or keep writing on your own.",
        "tabs": {
          "asYouWriteIt": "As you'd write it",
          "shorter": "Shorter",
          "moreFormal": "More formal"
        },
        "refine": {
          "placeholder": "Refine… e.g. 'drop the last line, offer Friday too'",
          "inputLabel": "Ask the AI for an adjustment"
        },
        "context": {
          "label": "CONTEXT",
          "thisThread": "This thread",
          "escToClose": "Esc to close the AI Assistant"
        },
        "footer": {
          "sendAsIs": "Send as is"
        },
        "manual": {
          "label": "You are writing this one yourself",
          "bringBack": "Bring the draft back"
        },
        "slashMenu": {
          "ariaLabel": "AI writing actions",
          "empty": "No matching action",
          "sectionWriteWithAi": "Write with AI",
          "sectionFormat": "Format",
          "continueWriting": "Continue writing",
          "draftFromPrompt": "Draft from a prompt",
          "proposeMeetingTimes": "Propose meeting times",
          "suggestSubjectLine": "Suggest a subject line",
          "askAboutRecipient": "Ask about this recipient",
          "bulletedList": "Bulleted list",
          "quote": "Quote"
        },
        "toast": {
          "undo": "Undo",
          "continued": "Continued your draft",
          "proposedTimes": "Added meeting times",
          "recipientContext": "Added recipient context",
          "subjectSuggested": "Subject suggested",
          "rewritten": "Rewritten",
          "rewrittenFromInstruction": "Rewritten from your instruction",
          "toneApplied": "Tone: {{tone}}",
          "translated": "Translated to {{language}}",
          "grammarFixed": "Grammar fixed"
        },
        "suggestSubject": {
          "label": "Suggest subject"
        },
        "selectionBubble": {
          "ariaLabel": "AI selection actions",
          "improve": "Improve",
          "shorter": "Shorter",
          "tone": "Tone",
          "translate": "Translate",
          "fixGrammar": "Fix grammar",
          "editWithAi": "Edit with AI"
        },
        "toneLabel": {
          "formal": "Formal",
          "warmer": "Warmer",
          "direct": "Direct"
        },
        "languageLabel": {
          "ptBr": "Portuguese (BR)",
          "es": "Spanish",
          "enUs": "English (US)"
        },
        "selectionInlineCard": {
          "placeholder": "Tell AI how to rewrite the selection…",
          "send": "Send",
          "selectedText": "Selected text",
          "escToCancel": "Esc to cancel"
        }
      }
    },
    "messagePanel": {
      "unsavedChanges": {
        "title": "Unsaved draft",
        "description": "Your draft may become outdated. Do you want to save it?",
        "save": "Save draft",
        "discard": "Discard"
      }
    },
    "labels": {
      "createLabel": "Create label",
      "tabs": {
        "all": "All",
        "labels": "Labels"
      },
      "title": "Label as:",
      "noLabels": "No labels found",
      "searchLabels": "Search labels",
      "showAllEmails": "Show all emails",
      "all": "All",
      "filterByLabels": "Filter by labels",
      "saveLabels": "Save",
      "modifyLabels": "Modify labels",
      "modifyLabelsSuccess": "Labels updated",
      "modifyLabelsMultipleSuccess": "Labels updated for {{count}} emails",
      "modifyLabelsError": "Failed to update labels. Please try again.",
      "deleteLabelSuccess": "Label removed",
      "deleteLabelError": "Failed to remove label. Please try again.",
      "updateLabelNameError": "Failed to rename label. Please try again.",
      "updateLabelColorError": "Failed to update label color. Please try again.",
      "createLabelError": "Failed to create label. Please try again.",
      "createLabelSuccess": "Label created successfully",
      "cannotModifyLabelsMultipleAccounts": "You can only move emails from the same account into a label.",
      "outlookDoesNotSupportLabels": "Labels are not supported for Outlook accounts.",
      "createLabelModal": {
        "createLabel": "Create label",
        "editLabel": "Edit label",
        "labelName": "Label name",
        "email": "Email",
        "labelAlreadyExists": "A label with this name already exists."
      },
      "updateLabelPopover": {
        "labelOptionsAriaLabel": "Label options",
        "updateColor": "Update color",
        "edit": "Edit",
        "removeLabel": "Remove label",
        "removeLabelModalTitle": "Remove label",
        "removeLabelModalDescription": "Are you sure you want to remove this label? This action cannot be undone.",
        "removeLabelModalActionButton": "Remove",
        "removeLabelModalCancelButton": "Cancel"
      }
    },
    "filter": {
      "title": "Filter",
      "allEmails": "All emails",
      "accounts": "Accounts"
    },
    "keyboardShortcuts": {
      "tooltip": "Keyboard shortcuts",
      "modalTitle": "Keyboard shortcuts",
      "listSection": "Email list",
      "previewSection": "Inside email",
      "moveItems": "Move between emails",
      "switchTabs": "Switch inbox tabs",
      "openEmail": "Open email",
      "archive": "Archive",
      "delete": "Delete",
      "markAsRead": "Mark as read",
      "markAsUnread": "Mark as unread",
      "reportSpam": "Report as spam",
      "select": "Select / deselect email",
      "compose": "Compose new email",
      "openCheatsheet": "Open this cheatsheet",
      "backToList": "Back to list",
      "nextEmail": "Next email",
      "previousEmail": "Previous email",
      "scrollContent": "Scroll email content",
      "reply": "Reply",
      "replyAll": "Reply all",
      "forward": "Forward"
    }
  },
  "messageDialog": {
    "windowBehavior": {
      "minimizeWindow": "Minimize",
      "toggleWindowSize": "Expand",
      "dockWindow": "Dock to corner",
      "closeWindow": "Close"
    }
  },
  "inboxPreview": {
    "to": "to {{email}}",
    "toLabel": "to",
    "from": "from",
    "date": "date",
    "subject": "subject",
    "reply": "Reply",
    "replyAll": "Reply All",
    "forward": "Forward",
    "archive": "Archive",
    "noSubject": "(no subject)",
    "threadMessage": {
      "hide": "Hide details"
    },
    "unsubscribe": "Unsubscribe",
    "star": "Star",
    "unstar": "Remove star",
    "markImportant": "Mark as important",
    "unmarkImportant": "Mark as not important",
    "doBoxControl": {
      "toDoBox": "To DoBox",
      "inDoBoxes": "In DoBoxes",
      "mobileSheetTitle": "DoBoxes",
      "addToAnother": "Add to another DoBox",
      "suggestionSuffix": " · Suggestion",
      "approvalSuffix": " · Needs your approval",
      "mobileButtonAriaLabel": "Add to DoBox",
      "mobileButtonLinkedAriaLabel": "Open DoBoxes menu"
    }
  },
  "doBox": {
    "executor": {
      "slackSend": {
        "sentence": {
          "bot": "Send a Slack message to {{destination}} as the bot",
          "user": "Send a Slack message to {{destination}} on your behalf",
          "unknownSender": "Send a Slack message to {{destination}}",
          "sentBot": "Sent a Slack message to {{destination}} as the bot",
          "sentUser": "Sent a Slack message to {{destination}} on your behalf",
          "sentUnknownSender": "Sent a Slack message to {{destination}}",
          "person": "Send a Slack direct message to {{name}} ({{kind}}) in {{workspace}} as the bot",
          "personNoWorkspace": "Send a Slack direct message to {{name}} ({{kind}}) as the bot",
          "sentPerson": "Sent a Slack direct message to {{name}} ({{kind}}) in {{workspace}} as the bot",
          "sentPersonNoWorkspace": "Sent a Slack direct message to {{name}} ({{kind}}) as the bot"
        },
        "person": {
          "teammate": "teammate",
          "outsider": "not on your team"
        },
        "destination": {
          "loading": "…",
          "unavailable": "an unavailable channel",
          "owner": "you",
          "unavailableHint": "This destination can no longer be found. Open the agent's settings and choose another one.",
          "channelName": "#{{name}}"
        },
        "messageLabel": "Message",
        "mention": {
          "unknownPerson": "@someone",
          "unknownChannel": "#channel",
          "channel": "@channel",
          "here": "@here",
          "everyone": "@everyone"
        },
        "failure": {
          "generic": "The message wasn't sent. Check the agent's Slack destinations and try again.",
          "destination_removed": "The message wasn't sent because this destination was removed from the agent. Add it again in the agent's settings, or choose another one.",
          "bot_not_in_channel": "The message wasn't sent because the bot isn't in this channel. Add the bot to the channel in Slack, then try again.",
          "channel_archived": "The message wasn't sent because this channel is archived. Choose another destination in the agent's settings.",
          "missing_permission": "The message wasn't sent because Slack didn't allow it. Reconnect Slack in Integrations, or choose another destination.",
          "workspace_disconnected": "The message wasn't sent because this Slack workspace is disconnected. Reconnect it in Integrations, then try again.",
          "user_not_connected": "The message wasn't sent because your own Slack account isn't connected. Connect it in Integrations, or switch the agent to send as the bot.",
          "channel_not_found": "The message wasn't sent because Slack couldn't find this destination. Check it in the agent's settings, or choose another one.",
          "rate_limited": "The message wasn't sent because Slack asked for a short pause. Wait a minute and try again.",
          "message_too_long": "The message wasn't sent because it is too long for Slack. Ask the agent to prepare a shorter one.",
          "send_failed": "The message wasn't sent because Slack returned an error. Try again, and if it keeps happening check the agent's Slack destinations.",
          "sender_changed": "The message wasn't sent because the agent's \"send as\" setting changed after this card was created. Ask the agent to prepare it again.",
          "agent_unavailable": "The message wasn't sent because the agent is no longer available. Check that it still exists and is shared with you, then ask again.",
          "unknown_destination": "The message wasn't sent because the destination isn't one of the agent's Slack destinations. Ask the owner to add it in the agent's settings.",
          "actor_not_authorised": "The message wasn't sent because it would go out on the agent owner's behalf, and Slack can't act for you in that workspace. Ask the owner to run it, or to switch the agent to send as the bot.",
          "mention_not_allowed": "The message wasn't sent because it mentions someone the agent isn't allowed to mention. Ask the agent to prepare it without the mention.",
          "unknown_mention_handle": "The message wasn't sent because it mentions someone the agent can't identify. Ask the agent to prepare it again without that mention.",
          "broadcast_not_allowed": "The message wasn't sent because @channel, @here and @everyone aren't allowed. Ask the agent to prepare it without them.",
          "send_cap_reached": "The message wasn't sent because the agent already sent 3 messages to this destination in this run. Start a new run if you need more.",
          "trial_no_send": "This was a preview from setting up the agent, so nothing was sent. Hand the task to the agent to send it for real.",
          "membership_check_failed": "The message wasn't sent because Slack couldn't confirm who is in this destination. Try again in a moment.",
          "bot_cannot_dm": "The message wasn't sent because the bot can't write in this private conversation. Switch the agent to send as you, or choose a channel.",
          "owner_slack_not_connected": "The reminder wasn't sent because your Slack account isn't connected. Connect it in Integrations, then try again.",
          "person_not_resolved": "The message wasn't sent because the agent hadn't identified who this person is. Ask it to find the person first, then prepare the message again.",
          "person_scope_changed": "The message wasn't sent because the agent's settings for messaging people changed after this card was prepared. Hand the task to the agent again.",
          "person_unavailable": "The message wasn't sent because this person is no longer in your team or contacts. Check that they are still there before asking again.",
          "person_identity_changed": "The message wasn't sent because this person's details changed after the message was prepared, so it could have reached someone else. Hand the task to the agent again.",
          "person_class_changed": "The message wasn't sent because this person is no longer on your team, so it needs a fresh approval. Hand the task to the agent again.",
          "person_not_reachable": "The message wasn't sent because this person can't be reached on Slack: they aren't in a Slack workspace you connected, or the bot can't message them. Trying again won't help until that changes.",
          "person_reply_wait_unavailable": "The message wasn't sent because the agent can't wait for a reply to a direct message sent by the bot. Ask it to send the message without waiting.",
          "person_invalid_target": "The message wasn't sent because the agent didn't say clearly who it was for. Hand the task to the agent again and name the person.",
          "person_outsider_not_allowed": "The message wasn't sent because this agent can only message your teammates, and this person isn't on your team. If you want it to reach people outside your team, change the agent's Slack people setting to include your contacts.",
          "person_limit_reached": "The message wasn't sent because the agent reached its limit for one run: up to 5 people and 3 messages for each person.",
          "person_lookup_failed": "The message wasn't sent because we couldn't check who this person is right now. Try again in a moment.",
          "person_identity_unconfirmed": "The message wasn't sent because the agent needs you to confirm who this person is first. Answer its question on the task and it will continue."
        }
      },
      "effect": {
        "unverified": "Not verified",
        "unsupportedClaim": "This wasn't found in the source message",
        "showAll": "Show all",
        "moreRecipients": "+{{count}} more",
        "attachmentsLabel": "Attachments ({{count}})",
        "customServerChip": "Custom server",
        "flowRunNotice": "This will run the flow",
        "fromLabel": "From",
        "inLabel": "In",
        "toLabel": "To",
        "ccLabel": "Cc",
        "memoryOriginWarning": "This wasn't said in exactly these words",
        "brain": {
          "thisPage": "this page",
          "namedPage": "“{{title}}”",
          "thisSection": "a section",
          "namedSection": "the section “{{name}}”",
          "contentLabel": "Text that will be written",
          "showMore": "Show more",
          "showLess": "Show less",
          "create": {
            "titled": "Create the page {{page}}",
            "untitled": "Create a new page"
          },
          "operation": {
            "APPEND": "Add to the end of {{page}}",
            "PREPEND": "Add to the top of {{page}}",
            "INSERT_AFTER_HEADING": "Add under {{heading}} in {{page}}",
            "REPLACE_SECTION": "Replace {{heading}} in {{page}}",
            "REPLACE_ALL": "Replace the whole content of {{page}}",
            "EDIT": "Edit {{page}}",
            "CREATE_PAGE": "Create the page {{page}}",
            "RENAME_PAGE": "Rename {{page}} to “{{newTitle}}”",
            "CREATE_SPACE": "Create the space {{space}}",
            "RENAME_SPACE": "Rename {{space}} to “{{newTitle}}”"
          },
          "thisSpace": "this space",
          "namedSpace": "“{{name}}”"
        },
        "emailSend": {
          "sentence": "Send an email to {{recipients}}",
          "sentenceSent": "Sent an email to {{recipients}}"
        },
        "omittedDetails_one": "{{count}} more detail not shown",
        "omittedDetails_other": "{{count}} more details not shown"
      },
      "critical": {
        "UNTRUSTED_RECIPIENT": "Untrusted recipient",
        "NEW_EXTERNAL_DOMAIN": "New external domain",
        "PUBLIC_OR_SHARED_CHANNEL": "Public or shared channel",
        "EXT_SHARED_UNKNOWN": "Unknown external share",
        "ATTACHMENT": "Has attachment",
        "TOO_MANY_RECIPIENTS": "Too many recipients",
        "TOO_MANY_ITEMS": "Too many items",
        "DESTRUCTIVE": "Destructive",
        "MONEY_OR_LEGAL": "Money or legal",
        "FIRST_CONTACT": "First contact",
        "OTHER_MEMBERS_DOBOX": "Affects other members",
        "PERMANENT_AUTOMATION": "Permanent automation",
        "OUT_OF_THREAD_FACT": "Fact from outside the thread",
        "DOBOX_TRIGGER_MATCH": "Matches a DoBox trigger",
        "HEADERS_UNVERIFIED": "Unverified headers",
        "REPLY_TO_EXTERNAL_DOMAIN": "Reply to external domain",
        "LIST_WITHOUT_SEND_AS": "List without send-as",
        "BCC_ONLY": "Bcc only"
      },
      "provenance": {
        "ONLY_IN_COUNTERPART_MESSAGE": "Only in {{counterpart}}'s message",
        "FROM_YOUR_BRAIN": "From your Brain",
        "FROM_DECISION": "Based on your decision of {{date}}",
        "FROM_YOUR_SENT_MESSAGE": "From your sent message"
      },
      "recipientTrust": {
        "NEW_RECIPIENT": "New recipient",
        "EXTERNAL_DOMAIN": "External domain",
        "SELF_EXCLUDED": "You're excluded",
        "LIST": "Mailing list"
      },
      "platform": {
        "GMAIL": "Gmail",
        "OUTLOOK": "Outlook",
        "SLACK": "Slack",
        "TEAMS": "Teams",
        "GOOGLE_CHAT": "Google Chat",
        "WHATSAPP": "WhatsApp",
        "INSTAGRAM": "Instagram",
        "MESSENGER": "Messenger",
        "TELEGRAM": "Telegram",
        "THIS_THAT": "this+that",
        "GITHUB": "GitHub",
        "CALENDAR": "Calendar",
        "GOOGLE_CALENDAR": "Google Calendar",
        "OUTLOOK_CALENDAR": "Outlook Calendar",
        "generic": "this platform"
      },
      "memoryOrigin": {
        "TYPED_VERBATIM": "Your own words",
        "APPROVED_CARD": "An approved card",
        "PATTERN_OFFER": "A suggested pattern",
        "LEDGER_EXECUTED": "Something already executed"
      },
      "emptyState": {
        "title": "What should I handle?",
        "subtitle": "I'll work on this DoBox from its source and only ask you about the critical steps."
      },
      "unavailable": {
        "title": "The task assistant isn't available",
        "subtitle": "Close this task and open it again in a moment."
      },
      "legacyConversationLink": "See previous conversation",
      "disabledToast": "The task assistant is off for now.",
      "notice": {
        "approvalRequiresClick": "This action needs a click on its card.",
        "capabilityStillMissing": "It is still not connected. Connect it and try again.",
        "capabilityResumeExhausted": "I already tried twice today. Use one of the alternatives on the card."
      },
      "line": {
        "approval": {
          "executed_one": "Done: {{count}} action carried out.",
          "executed_other": "Done: {{count}} actions carried out.",
          "failed": "The action didn't go through.",
          "expired": "This approval expired before anyone clicked it.",
          "stale": "This approval is no longer current — the DoBox changed since it was suggested.",
          "alreadyDone": "This was already done.",
          "needsClick": "Waiting on a click on this card."
        },
        "stop": {
          "batchDone_one": "That's all for now.",
          "batchDone_other": "That's all for now.",
          "askedUser": "Stopped to ask the user a question.",
          "budget": "Stopped — turn budget reached.",
          "dailyCap": "Stopped — this task reached its daily spending limit. You can hand it to the agent again tomorrow.",
          "capability": "Stopped — a required capability is missing."
        },
        "continuation": {
          "started": "Continuing from the previous run.",
          "limit": "Reached the continuation limit ({{count}})."
        },
        "capabilityStillMissing": "{{capability}} is still not connected.",
        "nextStep": {
          "reminderSet": "Set a reminder for {{date}}.",
          "alreadyDone": "This next step was already done."
        }
      },
      "proposal": {
        "title": {
          "SOURCE_REPLY": "Reply ready",
          "OUTBOUND_MESSAGE": "Message ready",
          "CALENDAR_EVENT": "Calendar event ready",
          "DOBOX_INTERNAL": "Update ready",
          "KNOWLEDGE_WRITE": "Brain update ready",
          "FLOW": "Flow ready",
          "AGENT": "Agent task ready",
          "MCP_READ": "Action ready",
          "MCP_WRITE": "Action ready",
          "MEMORY": "Memory ready",
          "CODE_DELEGATION": "Code task ready",
          "CAPABILITY": "Action ready",
          "generic": "Needs your approval"
        },
        "titleDecided": {
          "SOURCE_REPLY": "Reply",
          "OUTBOUND_MESSAGE": "Message",
          "CALENDAR_EVENT": "Calendar event",
          "DOBOX_INTERNAL": "Task update",
          "KNOWLEDGE_WRITE": "Brain update",
          "FLOW": "Flow",
          "AGENT": "Agent task",
          "MCP_READ": "Action",
          "MCP_WRITE": "Action",
          "MEMORY": "Memory",
          "CODE_DELEGATION": "Code task",
          "CAPABILITY": "Action",
          "generic": "Action"
        },
        "tier": {
          "approveOnce": "Needs your approval",
          "alwaysApprove": "This action always needs a click"
        },
        "typedConsentHint": "You can also reply \"go ahead\".",
        "expiresIn": "Expires in {{minutes}} min",
        "runInProgressHint": "The agent is still working. You can approve once it finishes.",
        "actions": {
          "approve": "Approve",
          "cancel": "Cancel",
          "tryAgain": "Try again",
          "redo": "Redo",
          "dismiss": "Dismiss"
        },
        "status": {
          "executing": "Working on it…",
          "executed": "Approved",
          "expired": "Expired",
          "stale": "A new message arrived after this suggestion",
          "superseded": "Replaced by a newer suggestion",
          "dismissed": "Cancelled"
        },
        "failure": {
          "INTEGRATION_NOT_CONNECTED": "The integration isn't connected anymore.",
          "SOURCE_ACCOUNT_DISCONNECTED": "The source account got disconnected.",
          "NOT_DOBOX_OWNER": "You don't have access to this DoBox anymore.",
          "STALE_ENVELOPE": "This request is no longer current.",
          "CONFIRMATION_NOT_MATCHED": "The confirmation didn't match.",
          "INVALID_TOOL_NAME": "This action is no longer available.",
          "UNVERIFIED_NEED": "This still needs to be verified.",
          "CAPABILITY_DECLINED": "This capability was declined.",
          "NO_COUNTERPART": "There's no one to send this to.",
          "UNSUPPORTED_PLATFORM": "This platform isn't supported.",
          "GRANT_MISSING": "A required permission is missing.",
          "generic": "This action failed.",
          "notSent": "The message wasn't sent.",
          "notSaved": "The calendar event wasn't saved.",
          "notApplied": "The change couldn't be applied.",
          "nextStep": "Trying again won't change this. Tell the agent what to do differently, or make the change yourself."
        },
        "toast": {
          "alreadyDone": "Already done",
          "stale": "This suggestion is no longer current — refreshing.",
          "rejected": "Couldn't complete this action."
        },
        "discarded": "You tried this on the task and did not apply the changes."
      },
      "receipt": {
        "action": {
          "SOURCE_REPLY": "Reply sent",
          "OUTBOUND_MESSAGE": "Message sent",
          "CALENDAR_EVENT": "Calendar event created",
          "DOBOX_INTERNAL": "Task updated",
          "KNOWLEDGE_WRITE": "Brain updated",
          "FLOW": "Flow run",
          "AGENT": "Agent task run",
          "MCP_READ": "Action done",
          "MCP_WRITE": "Action done",
          "MEMORY": "Memory saved",
          "CODE_DELEGATION": "Code task started",
          "CAPABILITY": "Action done",
          "generic": "Done",
          "multiple_one": "{{count}} change made",
          "multiple_other": "{{count}} changes made"
        },
        "approvedVia": {
          "click": "Approved by you",
          "typedConsent": "Confirmed by your message",
          "planClick": "Approved from the plan",
          "standingPermission": "Sent under your standing permission",
          "auto": "Done without asking",
          "autonomous": "Done on its own"
        },
        "sendState": {
          "scheduled": "Sends at {{time}}",
          "sending": "Sending…",
          "sent": "Sent at {{time}}",
          "done": "Done at {{time}}",
          "failed": "Send failed"
        },
        "undo": {
          "action": "Undo",
          "retractAction": "Retract",
          "retractConfirmQuestion": "They may have seen it already. Delete it anyway?",
          "retractConfirmYes": "Yes",
          "retractConfirmNo": "No",
          "undone": "Undone",
          "retracted": "Retracted",
          "toast": {
            "tooLate": "Too late to undo this.",
            "notUndoable": "This can't be undone.",
            "providerFailed": "Couldn't undo this — try again.",
            "actionFailed": "Something went wrong undoing this."
          },
          "slackToast": {
            "tooLate": "Too late to delete this message from here. Delete it in Slack if you still need it gone.",
            "notUndoable": "This message can't be deleted from here. Delete it in Slack if you need it gone.",
            "providerFailed": "Slack couldn't delete the message. It may already be deleted, or Slack didn't allow it. Try again, or delete it in Slack."
          },
          "retry": "Try again"
        },
        "failure": {
          "INTEGRATION_NOT_CONNECTED": "The integration isn't connected anymore.",
          "SOURCE_ACCOUNT_DISCONNECTED": "The source account got disconnected.",
          "NOT_DOBOX_OWNER": "You don't have access to this DoBox anymore.",
          "STALE_ENVELOPE": "This request is no longer current.",
          "CONFIRMATION_NOT_MATCHED": "The confirmation didn't match.",
          "INVALID_TOOL_NAME": "This action is no longer available.",
          "UNVERIFIED_NEED": "This still needs to be verified.",
          "CAPABILITY_DECLINED": "This capability was declined.",
          "NO_COUNTERPART": "There's no one to send this to.",
          "UNSUPPORTED_PLATFORM": "This platform isn't supported.",
          "GRANT_MISSING": "A required permission is missing.",
          "generic": "This action failed.",
          "hint": "Tell me how to continue"
        },
        "preview": {
          "show": "Show what was done",
          "hide": "Hide"
        },
        "memory": {
          "why": "Why?",
          "forget": "Forget",
          "forgetConfirmQuestion": "Forget this memory? This can't be undone.",
          "forgetConfirmYes": "Yes, forget it",
          "forgetConfirmNo": "No",
          "forgotten": "Forgotten",
          "forgetFailed": "Couldn't forget this — try again."
        },
        "brainRevertHint": "You can revert this from the page's version history."
      },
      "nextSteps": {
        "markDone": "Mark done",
        "remindIfNoReply": "Remind me if no reply in 2 days"
      },
      "question": {
        "title": "I need one thing from you",
        "otherAnswer": {
          "toggle": "Other answer",
          "placeholder": "Type your answer…",
          "counter": "{{count}}/{{max}}",
          "submit": "Send"
        },
        "status": {
          "answered": "Answered",
          "stale": "Replaced by your newer message",
          "expired": "This question is no longer open.",
          "dismissed": "Dismissed."
        },
        "toast": {
          "alreadyDone": "Already answered",
          "stale": "This question is no longer current — refreshing.",
          "rejected": "Couldn't send this answer."
        }
      },
      "errors": {
        "actionFailed": "Something went wrong with this action.",
        "concurrentRun": "Wait for the current reply",
        "notOwner": "You don't have access to this DoBox anymore.",
        "itemChanged": "This item already changed — refreshing."
      },
      "plan": {
        "header": "Plan ({{count}})",
        "kind": {
          "REPLY": "Reply",
          "COMPOSE": "Compose",
          "ASK_SOMEONE": "Ask someone",
          "SCHEDULE": "Schedule",
          "INTERNAL_UPDATE": "Update this DoBox",
          "DELEGATE_CODE": "Delegate to a coding agent"
        },
        "cta": {
          "EXECUTE": "Do it",
          "REVIEW": "Review",
          "UNAVAILABLE": "Not available"
        },
        "slot": {
          "type": {
            "TEXT": "Text",
            "DATE": "Date",
            "DATE_TIME": "Date & time",
            "PERSON": "Person",
            "EMAIL_ADDRESS": "Email address",
            "CHOICE": "Choice"
          },
          "required": "Required"
        },
        "alreadyExecuted": "Already sent after this plan was made",
        "sendAnyway": "Send another anyway",
        "toast": {
          "stale": "The conversation changed — updating the plan",
          "rejected": "Couldn't complete this action."
        },
        "slotMissingError": "Fill in the required info before continuing."
      },
      "panelOptions": {
        "title": {
          "replyTo": "Reply to {{name}}",
          "replyGeneric": "Reply",
          "remind": "Remind me on {{date}}",
          "delegateAgent": "Delegate to {{agent}}",
          "delegateAgentGeneric": "Delegate to an agent",
          "delegateLocalClaude": "Investigate & fix with Local Claude"
        },
        "badge": {
          "draftReview": "Draft · you review",
          "draftSaved": "Draft saved",
          "readOnly": "Read-only",
          "needsApproval": "Asks before acting",
          "followUp": "Creates a follow-up",
          "opensReply": "Opens the reply",
          "delegates": "Delegates"
        },
        "execute": {
          "failed": "That didn't go through, and nothing was changed. You can hand this task to an agent from the \"To\" menu below instead.",
          "stale": "This suggestion changed while you were looking at it. The list was refreshed; pick it again."
        },
        "remind": {
          "success": "Follow-up set.",
          "error": "Couldn't set the follow-up."
        },
        "agentSetupOffer": {
          "badge": "No agent yet",
          "line": "None of your agents can {{job}}. Set one up here in about a minute.",
          "panelCta": "+ Set up an agent",
          "chatCta": "Set up an agent"
        },
        "agentSetupGeneric": {
          "title": "Teach an agent to do this",
          "line": "Set up an agent from this task in about a minute.",
          "cta": "+ Set up an agent",
          "link": "Happens often?",
          "linkCta": "Teach an agent to handle it"
        },
        "finishedSetup": {
          "link": "See what {{name}} did on this task"
        },
        "delegateLocalClaudeSubtitle": "Runs on your Mac · plans first, you approve",
        "header": {
          "title": "What should happen next?",
          "subtitle": "Hand it to an agent, or pick a quick action."
        },
        "agentShortcuts": {
          "title": "Or hand it to one of your agents",
          "item": "Ask {{name}} to handle it"
        }
      },
      "capability": {
        "CONNECT": {
          "title": "Connect {{integration}}",
          "body": "To {{action}} {{resource}} in {{integration}} and resolve this DoBox, connect {{integration}}.",
          "cta": "Connect {{integration}}"
        },
        "GRANT_SCOPE": {
          "title": "Grant access to {{integration}}",
          "body": "To {{action}} {{resource}} in {{integration}}, grant the missing permission.",
          "cta": "Grant access"
        },
        "RECONNECT": {
          "title": "Reconnect {{integration}}",
          "body": "Your connection to {{integration}} needs to be refreshed to {{action}} {{resource}}.",
          "cta": "Reconnect"
        },
        "ENABLE_TOOL": {
          "title": "Enable a tool in {{integration}}",
          "body": "To {{action}} {{resource}}, enable this tool on your {{integration}} connection.",
          "cta": "Enable tool"
        },
        "RESYNC": {
          "title": "Sync {{integration}}",
          "body": "Your {{integration}} connection needs to sync before it can {{action}} {{resource}}.",
          "cta": "Sync now"
        },
        "CONFIGURE_BYO": {
          "title": "Configure {{integration}}",
          "body": "Finish configuring your {{integration}} connection to {{action}} {{resource}}.",
          "cta": "Configure connection"
        },
        "PAIR_DEVICE": {
          "title": "Pair a device",
          "body": "Pair a coding device to {{action}} {{resource}}.",
          "cta": "Pair device"
        },
        "ASK_TEAM_ADMIN": {
          "title": "Ask your team admin",
          "body": "Only a team admin can connect {{integration}} to {{action}} {{resource}}.",
          "cta": "Ask admin"
        },
        "REQUEST_INTEGRATION": {
          "title": "Request this integration",
          "body": "{{integration}} isn't supported yet. Request it so we can {{action}} {{resource}}.",
          "cta": "Request integration"
        },
        "UNAVAILABLE": {
          "title": "Not available",
          "body": "{{integration}} can't {{action}} {{resource}} right now.",
          "cta": "Not available"
        },
        "SET_UP_AGENT": {
          "title": "Set up an agent",
          "body": "No agent you own can {{action}} {{resource}} yet. Set one up to resolve this DoBox.",
          "cta": "Set up agent"
        },
        "action": {
          "READ_ITEM": "read",
          "UPDATE_ITEM": "update",
          "CREATE_ITEM": "create",
          "SEND_MESSAGE": "send a message about",
          "SCHEDULE": "schedule",
          "SEARCH_WEB": "search the web for",
          "DELEGATE_CODE": "delegate code for"
        },
        "resourceFallback": "it",
        "alternative": {
          "ASK_TEAMMATE": {
            "label": "Ask a teammate",
            "prompt": "Can you ask a teammate to {{action}} {{resource}} in {{integration}} for me?"
          },
          "ASK_FOR_CONTENT": {
            "label": "Ask for the content",
            "prompt": "Can you ask them to send the content directly, so I don't need {{integration}}?"
          },
          "REPLY_AT_SOURCE": {
            "label": "Reply at the source",
            "prompt": "Reply at the source instead of using {{integration}}."
          },
          "SEND_FROM_OTHER_ACCOUNT": {
            "label": "Send from another account",
            "prompt": "Send this from my other account instead of {{integration}}.",
            "warning": "This will send from a different account than usual."
          }
        },
        "accountMismatch": "This account doesn't match the one this DoBox arrived on.",
        "othersWaiting": "Continue in {{count}} more DoBoxes waiting for {{integration}}",
        "dismiss": "Not now",
        "status": {
          "dismissed": "Dismissed",
          "expired": "Expired",
          "satisfied": "Connected"
        },
        "toast": {
          "enableToolSuccess": "Tool enabled",
          "enableToolError": "Couldn't enable this tool",
          "resyncSuccess": "Syncing…",
          "resyncError": "Couldn't sync this connection",
          "requestIntegrationSuccess": "Request sent",
          "requestIntegrationError": "Couldn't send the request",
          "othersWaitingFound": "{{count}} more DoBoxes are waiting on this",
          "othersWaitingNone": "No other DoBoxes are waiting on this"
        },
        "connectedContinue": "Connected · Continue",
        "resume": {
          "stillNotConnected": "Still not connected",
          "exhausted": "This still doesn't work"
        },
        "othersWaitingList": {
          "continue": "Continue"
        }
      },
      "code": {
        "title": "Delegate to {{device}} ({{runtime}}) · {{repo}}",
        "unknownDevice": "your device",
        "runtime": {
          "CLAUDE": "Claude Code",
          "CODEX": "Codex",
          "AIDER": "Aider"
        },
        "machine": {
          "available": "Available",
          "busy": "Busy ({{count}})",
          "offline": "Offline · seen {{ago}}",
          "offlineNeverSeen": "Offline",
          "missingGh": "Missing GitHub CLI"
        },
        "step": {
          "plan": "Plan (read-only)",
          "approve": "You approve",
          "implement": "Implementation & verification",
          "pr": "Draft PR"
        },
        "actions": {
          "planOnDevice": "Plan on {{device}}",
          "delegateWhenOnline": "Delegate when it comes online",
          "reviewPlan": "Review plan",
          "openPr": "Open PR #{{number}}",
          "tryAgain": "Try again",
          "cancel": "Cancel"
        },
        "queuedOffline": {
          "status": "Will run when {{device}} is back · until {{date}}"
        },
        "queuedOnDevice": "{{count}} DoBoxes waiting for {{device}}",
        "notice": {
          "codex": "Content will be sent to OpenAI.",
          "externalOrigin": "External sender: verification is off; the draft PR opens without running the verify command."
        },
        "status": {
          "cancelled": "Cancelled"
        }
      },
      "batch": {
        "title_one": "The same decision resolves {{count}} more DoBox",
        "title_other": "The same decision resolves {{count}} more DoBoxes",
        "partialLabel": "Partial match",
        "openDoBox": "Open DoBox",
        "actions": {
          "apply": "Apply to {{count}}",
          "dismiss": "Dismiss"
        },
        "chip": {
          "sent": "Sent",
          "failed": "Failed",
          "alreadyHandled": "Already handled"
        },
        "status": {
          "applying": "Applying…",
          "applied": "Applied",
          "failed": "Couldn't apply this",
          "dismissed": "Dismissed"
        },
        "toast": {
          "alreadyDone": "Already applied",
          "stale": "This is no longer current — refreshing.",
          "rejected": "Couldn't apply this."
        }
      },
      "memory": {
        "scope": {
          "THREAD": "This conversation",
          "COUNTERPART": "This contact",
          "WORK_KIND": "This kind of work",
          "TASK_GROUP": "This list",
          "GLOBAL": "Everywhere"
        },
        "status": {
          "PAUSED": "Paused",
          "REVIEW_DUE": "Review due"
        },
        "why": {
          "basedOn": "Based on your decision of {{date}}",
          "forgottenNote": "This memory was forgotten.",
          "viewAll": "See all memory"
        },
        "suggestedDecisionNotice": "A decision you made in another DoBox may resolve this one.",
        "rememberOffer": {
          "title": "Should I remember this?",
          "actions": {
            "remember": "Remember",
            "notNow": "Not now"
          },
          "status": {
            "answered": "Remembered",
            "dismissed": "Not saved.",
            "expired": "This offer is no longer open."
          },
          "toast": {
            "alreadyDone": "Already remembered",
            "stale": "This is no longer current — refreshing.",
            "rejected": "Couldn't save this."
          }
        },
        "standingPermissionOffer": {
          "title": "You approved {{count}} in a row for {{counterpart}} over {{channel}}. Do this without asking next time?",
          "unknownCounterpart": "this contact",
          "actionClass": {
            "SCHEDULE_TIMES": "Proposing times",
            "ACK_NO_DEADLINE": "Acknowledging (no deadline)",
            "INFO_REQUEST_IN_THREAD": "Answering in-thread questions"
          },
          "channel": {
            "EMAIL": "Email"
          },
          "exclusions": "Never for attachments, money/legal, public posts, events or deletes.",
          "actions": {
            "accept": "Yes, always",
            "notNow": "Not now"
          },
          "status": {
            "answered": "Standing permission created",
            "dismissed": "Not now.",
            "expired": "This offer is no longer open."
          },
          "toast": {
            "alreadyDone": "Already set up",
            "stale": "This is no longer current — refreshing.",
            "rejected": "Couldn't set this up."
          }
        }
      },
      "routes": {
        "section": {
          "suggestions": "Suggestions",
          "routines": "Routines",
          "emptyRoutines": "No routines yet. Accepted suggestions and routes you set up will show up here."
        },
        "workKind": {
          "REPLY_INFO": "Replying with information",
          "SCHEDULE": "Scheduling",
          "DECIDE_APPROVE": "Deciding or approving",
          "RESEARCH": "Researching",
          "UPDATE_EXTERNAL_TOOL": "Updating an external tool",
          "CODE_CHANGE": "Changing code",
          "WRITE_DOCUMENT": "Writing a document",
          "FOLLOW_UP": "Following up",
          "FYI": "FYI",
          "OTHER": "Other work"
        },
        "mode": {
          "SUGGEST": "Suggest",
          "ASSIGN_AND_PLAN": "Plan",
          "ASSIGN_AND_ACT": "Act"
        },
        "ariaLabel": "Routine mode",
        "modeConfirm": {
          "question": "It will act without asking for non-critical steps.",
          "confirm": "Switch to Act",
          "cancel": "Cancel"
        },
        "modeToast": {
          "success": "Routine mode updated",
          "error": "Couldn't update the routine mode. Please try again."
        },
        "delete": {
          "action": "Delete",
          "confirmQuestion": "Delete this routine?",
          "confirm": "Delete",
          "cancel": "Cancel",
          "success": "Routine deleted",
          "error": "Couldn't delete the routine. Please try again."
        },
        "loadError": "Couldn't load routines. Please try again.",
        "recommendation": {
          "pitch": "This happened {{count}} times in 30 days · Automate cases like this",
          "createAgent": "Create agent",
          "dismiss": "Dismiss",
          "toast": {
            "acceptSuccess": "Routine created",
            "acceptError": "Couldn't create the routine. Please try again.",
            "dismissError": "Couldn't dismiss this suggestion. Please try again."
          },
          "draft": {
            "REPLY_INFO": {
              "name": "Info reply agent",
              "description": "Drafts replies with the information this kind of request usually needs."
            },
            "SCHEDULE": {
              "name": "Scheduling agent",
              "description": "Handles the back-and-forth of finding and confirming a time."
            },
            "DECIDE_APPROVE": {
              "name": "Approval agent",
              "description": "Reviews requests like this one and proposes a decision."
            },
            "RESEARCH": {
              "name": "Research agent",
              "description": "Looks into requests like this one and reports back."
            },
            "UPDATE_EXTERNAL_TOOL": {
              "name": "Tool update agent",
              "description": "Applies updates like this one in the connected tool."
            },
            "CODE_CHANGE": {
              "name": "Code change agent",
              "description": "Plans and applies code changes like this one."
            },
            "WRITE_DOCUMENT": {
              "name": "Document agent",
              "description": "Drafts a document for requests like this one."
            },
            "FOLLOW_UP": {
              "name": "Follow-up agent",
              "description": "Tracks and follows up on requests like this one."
            },
            "FYI": {
              "name": "FYI agent",
              "description": "Reviews and files updates like this one."
            },
            "OTHER": {
              "name": "Automation agent",
              "description": "Handles requests like this one."
            }
          }
        }
      },
      "permissions": {
        "emptyState": "No standing permissions yet.",
        "row": {
          "useCount_one": "Used {{count}} time",
          "useCount_other": "Used {{count}} times"
        },
        "revoke": {
          "action": "Revoke",
          "confirmQuestion": "Revoke this standing permission? The assistant will ask again next time.",
          "confirm": "Revoke",
          "cancel": "Cancel",
          "success": "Revoked",
          "error": "Couldn't revoke this permission"
        }
      },
      "recipientRefusal": {
        "add": "Add {{address}} to this agent's contacts",
        "scope": "Let this agent contact anyone involved in tasks",
        "dismiss": "Dismiss",
        "ownerOnly": "Only the person who created this agent can change who it may contact.",
        "failed": "We couldn't update this agent. Try again in a moment.",
        "answerAdded": "{{address}} is now one of this agent's contacts. Go ahead and send it.",
        "answerScope": "This agent may now contact anyone involved in a task, including {{address}}. Go ahead and send it."
      },
      "replyWait": {
        "title": {
          "one": "Waiting for {{name}}'s reply",
          "many": "Waiting for replies from {{names}}",
          "slack": "Waiting for a reply on Slack",
          "email": "Waiting for a reply by email",
          "generic": "Waiting for a reply"
        },
        "until": "Until {{moment}}",
        "answered": {
          "one": "Reply received",
          "many": "Replies received"
        },
        "expired": {
          "nobody": "Nobody answered by {{moment}}",
          "partial": "Not everyone answered by {{moment}}"
        },
        "cancelled": "You stopped waiting",
        "cancel": "Cancel waiting",
        "cancelling": "Cancelling...",
        "cancelFailed": {
          "generic": "We couldn't stop the wait. Try again in a moment.",
          "notFound": "This wait no longer exists.",
          "notOpen": "This wait already ended, so there is nothing to cancel.",
          "stale": "This question was replaced by a newer one. Reload to see the latest.",
          "rejected": "You can't cancel this wait because you didn't start this run.",
          "alreadyExecuted": "This wait already finished."
        },
        "receiptWaiting": {
          "until": "The agent is waiting for their reply until {{moment}}.",
          "noDeadline": "The agent is waiting for their reply."
        },
        "recipient": {
          "label": "People asked",
          "answered": "answered",
          "waiting": "waiting"
        },
        "replies": {
          "label": "Replies",
          "authorSlack": "Someone on Slack",
          "authorEmail": "Someone by email",
          "meta": "{{author}} · {{when}}"
        },
        "platform": {
          "slack": "Someone on Slack",
          "email": "Someone by email"
        },
        "moment": {
          "today": "today {{time}}",
          "tomorrow": "tomorrow {{time}}",
          "yesterday": "yesterday {{time}}",
          "date": "{{date}} {{time}}"
        }
      }
    },
    "looksResolved": {
      "badge": "Looks resolved",
      "tooltip": "A recent message suggests this is done. Resolve it to confirm, or dismiss if it is still open.",
      "dismiss": "Not done",
      "dismissAriaLabel": "Not done: {{subject}}",
      "keepOpen": "Keep open",
      "keepOpenAriaLabel": "Keep open: {{subject}}",
      "alreadyChanged": "This task changed in the meantime",
      "dismissSuccess": "Kept open",
      "dismissError": "Could not keep it open. Please try again."
    },
    "newReply": {
      "dismiss": "Dismiss",
      "dismissAriaLabel": "Dismiss the new reply: {{subject}}",
      "dismissMenuItem": "Dismiss new reply",
      "dismissAllMenuItem": "Dismiss all new replies",
      "dismissError": "Could not dismiss the reply. Please try again.",
      "inConversation": "There is a new message in the conversation.",
      "dismissAll": "Dismiss all",
      "dismissAllAriaLabel": "Dismiss all: {{subject}}",
      "dismissShown": "Dismiss shown",
      "dismissShownAriaLabel": "Dismiss shown: {{subject}}",
      "dismissReplyAriaLabel": "Dismiss the reply from {{name}}",
      "morePreviews_one": "+{{count}} more message in the conversation",
      "morePreviews": "+{{count}} more messages in the conversation"
    },
    "executorAttention": {
      "SEND_FAILED": {
        "badge": "Send failed",
        "tooltip": "Send failed"
      },
      "NEEDS_APPROVAL": {
        "badge": "Needs your approval",
        "tooltip": "Needs your approval"
      },
      "NEEDS_INPUT": {
        "badge": "Needs your answer",
        "tooltip": "Needs your answer"
      },
      "NEEDS_CONNECTION": {
        "badge": "Connect an app",
        "tooltip": "Connect an app"
      },
      "READY_TO_RESOLVE": {
        "badge": "Ready to close",
        "tooltip": "Ready to close"
      },
      "SUGGESTED_DECISION": {
        "badge": "Suggested decision",
        "tooltip": "Suggested decision"
      },
      "notify": {
        "openAction": "Open",
        "browserBody": "One of your DoBox items needs your attention.",
        "SEND_FAILED": {
          "title": "Send failed"
        },
        "NEEDS_APPROVAL": {
          "title": "Needs your approval"
        },
        "NEEDS_INPUT": {
          "title": "Needs your answer"
        }
      }
    },
    "create": "Create",
    "noSubject": "No subject",
    "generatedChecklistTitle": "Steps",
    "descriptionTruncated": "[Description truncated — the original was too long to display in full]",
    "resolvedByAssistantComment": "The assistant closed this suggestion because a newer message shows it is done or no longer needed.",
    "autoResolvedFallbackComment": "The assistant resolved this task because a recent message in the conversation shows it was done.",
    "delegatedDirectSendComment": {
      "slackReply": "Replied automatically in the source conversation.",
      "emailReply": "Replied automatically to the source email.",
      "calendarEvent": "Scheduled \"{{title}}\" on the calendar."
    },
    "linkedTasksCount_one": "{{count}} linked task",
    "linkedTasksCount": "{{count}} linked tasks",
    "firstRunBanner": {
      "title": "Pull your tasks out of your conversations",
      "subtitle": "DoBox reads your email and Slack, keeps only what is actually work for you, and logs it here as a ticket. Nothing is read until you ask for it.",
      "status": {
        "noAccount": "No account connected yet — Gmail, Outlook, Slack or Teams.",
        "reading": "Reading {{sources}}",
        "manage": "Manage",
        "footnote_one": "One pass over your last {{count}} day of email.",
        "footnote_other": "One pass over your last {{count}} days of email."
      },
      "action": {
        "connectAccount": "Connect an account",
        "connectAccountHint": "Connect an account first",
        "scanAgain": "Scan again",
        "doneHide": "Done, hide this",
        "hide": "Hide this",
        "scan_one": "Scan my last {{count}} day",
        "scan_other": "Scan my last {{count}} days",
        "scanCoverageHint": "Reads email only for now",
        "startScanError": "Couldn't start the scan. Try again.",
        "activateWatcherError": "Couldn't turn on watching, so the scan didn't run. Try again.",
        "scanEnablesWatchHint": "Scanning also turns on watching for new messages"
      },
      "scanning": {
        "chip": "Scanning",
        "title_one": "Reading your last {{count}} day",
        "title_other": "Reading your last {{count}} days",
        "counts_one": "{{count}} message read",
        "counts_other": "{{count}} messages read",
        "errorFallback": "We couldn't finish reading your messages. Try again."
      },
      "result": {
        "qualityHint": "Caught something that is not work? A rule stops that kind of message from ever becoming a ticket.",
        "addRule": "Add a rule",
        "watchOff": "Keep watching new messages for tasks",
        "watchOn": "Still watching new messages for tasks",
        "summary_one": "{{count}} message read",
        "summary_other": "{{count}} messages read",
        "summaryTruncated_one": "{{count}} message read (partial)",
        "summaryTruncated_other": "{{count}} messages read (partial)",
        "newTickets": "— anything that needs action shows up in your list below",
        "truncatedNotice": "— anything that needs action shows up below; another scan picks up the rest",
        "watchToggleError": "Couldn't update. Try again."
      },
      "discovery": {
        "heading": "There's more in here",
        "subheading": "tap one to see it working",
        "cards": {
          "groups": {
            "title": "Task groups",
            "description": "One shared list per team"
          },
          "board": {
            "title": "Board view",
            "description": "Same tickets, by stage"
          },
          "automations": {
            "title": "Automations",
            "description": "Rules, recurring, agents"
          },
          "agents": {
            "title": "Agents",
            "description": "Hand a ticket over"
          }
        }
      },
      "tour": {
        "close": "Close",
        "groups": {
          "body": "A group is a shared DoBox. Everyone sees the same tickets, suggestions land for whoever owns the work, and agents run inside the group.",
          "sampleClientWork": "Client work",
          "sampleEngineering": "Engineering",
          "ticketCount_one": "{{count}} ticket",
          "ticketCount_other": "{{count}} tickets",
          "cta": "Invite your team"
        },
        "board": {
          "body": "Same tickets, arranged by stage. Drag one across and its status follows — including work an agent is running.",
          "columnTodo": "TO DO",
          "columnInProgress": "IN PROGRESS",
          "columnDone": "DONE",
          "cta": "Open my board"
        },
        "automations": {
          "body": "Describe a rule once and DoBox keeps it. This one is ready to switch on:",
          "ruleChipClient": "Mail from a client",
          "ruleChipCreate": "Create a ticket",
          "ruleChipDue": "Due in 2 days",
          "ruleChipPost": "Post to #sales",
          "headerNote": "All four sit behind the layers icon up in the header",
          "ctaShowMenu": "Show me the menu",
          "ctaOpenFlows": "Open it in Flows"
        },
        "delegate": {
          "body": "A ticket does not have to come back to you. Hand it to an agent and it works on its own, reporting each step inside the card.",
          "chipReview": "Waits for your review",
          "cta": "Manage agents",
          "examples": {
            "engineering": {
              "chipStep1": "Reproduces the bug",
              "chipStep2": "Writes the fix",
              "chipStep3": "Opens a PR"
            },
            "hrPeople": {
              "chipStep1": "Reads the new-hire email",
              "chipStep2": "Adds them to Contacts",
              "chipStep3": "Books the onboarding call"
            },
            "sales": {
              "chipStep1": "Reads the inbound lead",
              "chipStep2": "Adds them to CRM",
              "chipStep3": "Drafts the reply"
            },
            "marketing": {
              "chipStep1": "Reads the campaign request",
              "chipStep2": "Pulls the brief from Brain",
              "chipStep3": "Drafts the reply"
            },
            "supportCs": {
              "chipStep1": "Reads the support request",
              "chipStep2": "Checks Brain for the answer",
              "chipStep3": "Drafts the reply"
            },
            "finance": {
              "chipStep1": "Reads the invoice email",
              "chipStep2": "Opens an approval ticket",
              "chipStep3": "Sets the due date"
            },
            "operations": {
              "chipStep1": "Reads the request in Slack",
              "chipStep2": "Opens a ticket",
              "chipStep3": "Posts the update in Slack"
            },
            "legal": {
              "chipStep1": "Reads the contract request",
              "chipStep2": "Checks Brain for the clause",
              "chipStep3": "Opens an approval ticket"
            },
            "founderLeadership": {
              "chipStep1": "Reads the update request",
              "chipStep2": "Pulls the numbers from Brain",
              "chipStep3": "Posts the summary in Slack"
            },
            "default": {
              "chipStep1": "Reads the message",
              "chipStep2": "Drafts a reply",
              "chipStep3": "Opens a ticket"
            }
          }
        }
      },
      "footer": {
        "runsIn": "DoBox also runs in",
        "chipGmailSidebar": "Gmail sidebar",
        "chipClaudeAi": "claude.ai",
        "chipChromeAgent": "Chrome, driven by an agent",
        "chipFlows": "Flows"
      }
    },
    "header": {
      "mobile": {
        "searchLabel": "Search",
        "filterLabel": "Filter",
        "sortLabel": "Sort",
        "openMenu": "Open sidebar menu",
        "automationsLabel": "Automations"
      }
    },
    "showResolvedItems": "Show done",
    "noDoBoxEntries": "No DoBox entries found",
    "noResolvedEntries": "No resolved tasks",
    "noApprovedEntries": "No approved tasks",
    "noRejectedEntries": "No rejected tasks",
    "deepLinkTeamSwitch": {
      "switched": "Switched active team to {{teamName}} to open this item",
      "switchedGeneric": "Switched active team to open this item",
      "noAccess": "You don't have access to this item's team"
    },
    "loadMore": "Load more",
    "suggestionsLabel": "Task suggestions",
    "suggestionsSectionSubtitle": "Review and accept to add to your list",
    "tasksSectionLabel": "Backlog",
    "collapseSuggestions": "Collapse suggestions",
    "expandSuggestions": "Expand suggestions",
    "approvalsLabel": "Approvals",
    "approvalsSectionSubtitle": "Review and approve or reject",
    "collapseApprovals": "Collapse approvals",
    "expandApprovals": "Expand approvals",
    "filters": {
      "title": "Filter",
      "filterByLabel": "Filter",
      "members": "Members",
      "noMembers": "No members",
      "assignedToMe": "Cards assigned to me",
      "readStatus": "Read status",
      "unreadOnly": "Unread only",
      "cardStatus": "Card status",
      "markedAsResolved": "Marked as done",
      "approved": "Approved",
      "rejected": "Rejected",
      "dueDate": "Due date",
      "noDates": "No dates",
      "overdue": "Overdue",
      "dueNextDay": "Due in the next day",
      "dueNextWeek": "Due in the next week",
      "dueNextMonth": "Due in the next month",
      "priority": "Priority",
      "labels": "Labels",
      "noLabels": "No labels",
      "clearAll": "Clear filters",
      "searchMembersPlaceholder": "Search member...",
      "recentMembers": "Recent",
      "allMembers": "All members",
      "noMembersFound": "No members found",
      "today": "Today",
      "week": "Week",
      "month": "Month",
      "readTab": "Read",
      "statusTab": "Status",
      "board": "Board"
    },
    "sort": {
      "tooltip": "Sort by field and order",
      "sortBy": "Sort by",
      "dueDate": "Due date",
      "createdAt": "Date created",
      "updatedAt": "Date updated",
      "priority": "Priority",
      "manual": "Manual",
      "order": "Order",
      "oldestFirst": "Oldest first",
      "newestFirst": "Newest first",
      "lowestFirst": "Lowest first",
      "highestFirst": "Highest first",
      "tooltipSortedBy": "Sorted by {{field}}, {{order}}"
    },
    "search": {
      "genericError": "Search failed. Please try again."
    },
    "backToTasks": "Back to tasks",
    "connectEmailPrompt": {
      "title": "Let this+that handle your inbox",
      "subtitle": "Connect your email and reclaim hours each week without missing anything important.",
      "providerSectionLabel": "Provider",
      "providerGmail": "Gmail",
      "providerOutlook": "Outlook",
      "connectButton": "Connect {{provider}}"
    },
    "tabs": {
      "tasks": "Tasks",
      "recurrences": "Recurring tasks"
    },
    "recurrences": {
      "noEntries": "No recurring tasks found",
      "taskGroupLabel": "List:",
      "loadMore": "Load more",
      "moreActions": "More actions",
      "edit": "Edit",
      "delete": "Delete",
      "moveToList": "Move to list",
      "timeZoneLabel": "Timezone",
      "createError": "Failed to create recurring task. Please try again.",
      "updateError": "Failed to update recurring task. Please try again.",
      "deleteSuccess": "Recurring task deleted successfully",
      "deleteError": "Failed to delete recurring task. Please try again.",
      "moveError": "Failed to move recurring task. Please try again."
    },
    "mcp": {
      "noSubject": "(No subject)",
      "aiSuggestion": "AI suggestion",
      "looksResolved": "Looks resolved, waiting for your confirmation",
      "due": "Due: {{date}}",
      "communicationCount_one": "{{count}} communication",
      "communicationCount_other": "{{count}} communications",
      "noEntries": "No {{filter}} DoBox entries found. Your DoBox is clean!",
      "foundEntries_one": "Found {{count}} {{filter}} DoBox entry:",
      "foundEntries_other": "Found {{count}} {{filter}} DoBox entries:",
      "fetchError": "Failed to fetch DoBox entries. Please try again later.",
      "authRequired": "Authentication required",
      "filter": {
        "unresolved": "unresolved",
        "resolved": "resolved",
        "all": "all"
      }
    },
    "taskGroupSelector": {
      "title": "Taskgroups",
      "buttonLabel": "Taskgroup",
      "doBox": "DoBox",
      "createTitle": "Create list",
      "createSubtitle": "Pick a color for your list",
      "createPlaceholder": "Enter list name",
      "viewMode": {
        "label": "View",
        "listDescription": "Tasks grouped in sections, one below the other.",
        "boardDescription": "Columns per stage. Drag cards to move them."
      },
      "participantsLabel": "Members",
      "participantsPlaceholder": "Select members",
      "participantsSearch": "Search...",
      "participantsSelectAll": "Select all members",
      "defaultListTooltip": "Default list — new tasks will be added here",
      "mobileBackLabel": "Board",
      "mobileSheetTitle": "Lists",
      "mobileCreateButton": "Create new taskgroup",
      "mobileSingleGroupBanner": "Add more lists to switch between them.",
      "mobileEmptyTitle": "No lists yet",
      "mobileEmptySubtitle": "Create your first list to start organizing tasks."
    },
    "actions": {
      "archiving": "Archiving items...",
      "archivedSuccess": "{{count}} items archived successfully",
      "archivedError": "Failed to archive items",
      "movingToInbox": "Moving items to inbox...",
      "movedToInboxSuccess": "{{count}} items moved to inbox successfully",
      "movedToInboxError": "Failed to move items to inbox",
      "markingAsRead": "Marking items as read...",
      "markedAsReadSuccess": "{{count}} items marked as read successfully",
      "markedAsReadError": "Failed to mark items as read",
      "markingAsUnread": "Marking items as unread...",
      "markedAsUnreadSuccess": "{{count}} items marked as unread successfully",
      "markedAsUnreadError": "Failed to mark items as unread",
      "reportingAsSpam": "Reporting items as spam...",
      "reportedAsSpamSuccess": "{{count}} items reported as spam successfully",
      "reportedAsSpamError": "Failed to report items as spam",
      "deleting": "Deleting items...",
      "deletedSuccess": "{{count}} items deleted successfully",
      "deletedError": "Failed to delete items",
      "unlinking": "Unlinking items...",
      "unlinkedSuccess": "{{count}} items unlinked successfully",
      "unlinkedError": "Failed to unlink items",
      "acceptingSuggestion": "Accepting suggestion...",
      "acceptSuggestionSuccess": "Suggestion accepted successfully",
      "acceptSuggestionError": "Failed to accept suggestion. Please try again.",
      "approvingApproval": "Approving...",
      "approveApprovalSuccess": "Flow approved",
      "approveApprovalError": "Failed to approve. Please try again.",
      "rejectingApproval": "Rejecting...",
      "rejectApprovalSuccess": "Flow rejected",
      "rejectApprovalError": "Failed to reject. Please try again."
    },
    "inboxEntriesDropDown": {
      "newTask": "New task",
      "new": "New",
      "newEntry": "New task",
      "noSuggestions": "No suggested tasks",
      "oneSuggestion": "1 suggested task",
      "multipleSuggestions": "{{count}} suggested tasks",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "createEmail": "Create email",
      "createEmailAriaLabel": "Create email for: {{subject}}",
      "acceptSuggestion": "Accept suggestion",
      "acceptSuggestionAriaLabel": "Accept suggestion: {{subject}}",
      "openAssistantAriaLabel": "Ask the assistant: {{subject}}",
      "markAsResolved": "Mark as done",
      "markAsResolvedAriaLabel": "Mark as done: {{subject}}",
      "markAsUnresolved": "Mark as not done",
      "markAsUnresolvedAriaLabel": "Mark as not done: {{subject}}",
      "markAsUnresolvedConfirmTitle": "Mark as not done",
      "deleteAriaLabel": "Delete inbox entry: {{subject}}",
      "markAsUnresolvedDescription": "Are you sure you want to mark this task as not done?",
      "resolvedItem": "This item has been marked done",
      "moveToList": "Move to another list",
      "doBoxListName": "DoBox",
      "editTask": "Edit task",
      "editTaskAriaLabel": "Edit task: {{subject}}",
      "noCommunications": "No messages in this DoBox entry",
      "accept": "Accept",
      "resolve": "Done",
      "unresolve": "Not done",
      "moreActions": "More actions",
      "delete": "Delete",
      "feedback": "Feedback",
      "toggleLabelTitles": "Toggle label title display",
      "recurringTask": "Recurring task",
      "labelsNotAvailable": "Labels not available in DoBox list",
      "approve": "Approve",
      "approveAriaLabel": "Approve flow: {{subject}}",
      "reject": "Reject",
      "rejectAriaLabel": "Reject flow: {{subject}}",
      "rejectSuggestionAriaLabel": "Reject suggestion: {{subject}}",
      "moveToListError": "Failed to move task to list"
    },
    "delegation": {
      "menuAriaLabel": "Delegate to an agent",
      "trigger": {
        "delegate": "Delegate"
      },
      "overflowMenuLabel": "Delegate…",
      "askAssistant": {
        "label": "Ask assistant",
        "subtitle": "Open this task in the assistant"
      },
      "sectionHeader": "Delegate to an agent",
      "agentCount_one": "{{count}} agent",
      "agentCount_other": "{{count}} agents",
      "searchPlaceholder": "Search agents…",
      "searchAriaLabel": "Search agents",
      "createNewAgent": "Create new agent",
      "back": "Back",
      "noMatchingTargets": "No agent matches your search.",
      "noTargets": "No agents available right now",
      "localMachine": {
        "sectionHeader": "Local machine",
        "notPaired": "Not paired",
        "deviceCount_one": "{{count}} device",
        "deviceCount_other": "{{count}} devices",
        "inviteDescription": "Pair your Mac so the assistant can delegate coding tasks to your local Claude Code or Codex CLI.",
        "fix": "Fix",
        "statusConnected": "Connected · {{lastSeen}}",
        "statusOffline": "Offline · {{lastSeen}}",
        "statusConnectionError": "Connection error · {{lastSeen}}",
        "statusChecking": "Checking…"
      },
      "availability": {
        "available": "Available",
        "busy_one": "Busy with {{count}} task",
        "busy_other": "Busy with {{count}} tasks",
        "offline": "Offline"
      },
      "statusLabel": {
        "queued": "Queued",
        "dispatching": "Sending to your device",
        "running": "Running",
        "blocked": "Waiting for your answer",
        "planReady": "Plan ready",
        "done": "Done",
        "failed": "Failed",
        "paused": "Paused",
        "waitingForDevice": "Waiting for your device"
      },
      "statusExplanation": {
        "queued": "Waiting for its turn. Nothing is needed from you.",
        "dispatching": "Handing this to the agent. It starts in a few seconds.",
        "running": "Working on it. You can close this; progress stays here.",
        "blockedNeedsApproval": "Waiting for you. Approve or cancel the change below.",
        "blockedNeedsInput": "Waiting for your answer. Reply below to continue.",
        "blockedNeedsConnection": "An app needs to be connected. Connect it, then try again.",
        "blockedActionFailed": "A change didn't go through. Open its card below to try again or dismiss it.",
        "blockedStoppedEarly": "The agent stopped before finishing. End the run to delegate it again.",
        "blockedGeneric": "The agent stopped and needs you. Read the latest message below, or end the run.",
        "planReady": "The plan is ready. Review it below, then approve it or ask for changes.",
        "done": "The agent finished. Review what it did below.",
        "failed": "The run failed. See what happened below, then try again or end the run.",
        "paused": "Paused. Press Resume to continue, or end the run.",
        "waitingForDevice": "Waiting for your device to come back online. It continues on its own when it does.",
        "blockedWaitingReply": "Waiting for a reply. Nothing for you to do yet."
      },
      "blockedReason": {
        "needsApproval": "Waiting for your approval",
        "needsInput": "Waiting for your answer",
        "needsConnection": "Needs an app connected",
        "sendFailed": "Send failed",
        "waitingReply": "Waiting for reply"
      },
      "activeMenu": {
        "header": "{{targetName}} · {{status}}",
        "cancel": "Cancel delegation",
        "cancelConfirmPrompt": "Cancel this delegation?",
        "cancelConfirmYes": "Yes, cancel",
        "cancelConfirmNo": "No",
        "pause": "Pause delegation",
        "resume": "Resume delegation",
        "clearLabel": "Clear conversation",
        "clearConfirmPrompt": "This will permanently delete the conversation history. This can't be undone.",
        "clearConfirmYes": "Yes, delete"
      },
      "taskType": {
        "technicalAnalysis": "Research & Report",
        "technicalAnalysisDescription": "Researches and reports findings on the ticket",
        "implementAndPr": "Take Action",
        "implementAndPrDescription": "Executes the task directly",
        "instructionsLabel": "Instructions for the agent (optional)",
        "instructionsPlaceholder": "Add tips, links to pages with context, or which MCPs to use…",
        "runModeLabel": "Run mode",
        "runtimeLabel": "Coding agent",
        "runtimeInstalled": "Installed runtimes: {{runtimes}}",
        "runtimeClaude": "Claude Code",
        "runtimeCodex": "Codex",
        "runtimeAider": "Aider (local)",
        "modelLabel": "Model",
        "modelClaudeOpus": "Claude Opus",
        "modelClaudeSonnet": "Claude Sonnet",
        "modelClaudeHaiku": "Claude Haiku",
        "modelCodexDefault": "Default",
        "modelCodexSol": "GPT-5.6 Sol",
        "modelCodexTerra": "GPT-5.6 Terra",
        "modelCodexLuna": "GPT-5.6 Luna",
        "modelQwenCoder7b": "Qwen2.5 Coder 7B",
        "modelQwenCoder14b": "Qwen2.5 Coder 14B",
        "localRuntimeResearchOnlyHint": "Local models support Research & Report only for now.",
        "agentProfileLabel": "Agent profile",
        "agentProfileGenericOption": "Generic run (no profile)",
        "delegateCta": "Delegate task",
        "execute": "Resolve this DoBox",
        "runAgent": "Run agent",
        "executeDescription": "Acts on the source like the panel does; asks you only for critical steps."
      },
      "modelSelection": {
        "title": "Choose a model",
        "description": "This model will run the implementation.",
        "confirm": "Confirm",
        "cancel": "Cancel"
      },
      "success": {
        "canceled": "Delegation canceled",
        "paused": "Delegation paused",
        "resumed": "Delegation resumed",
        "stopped": "Run stopped",
        "endRun": "Run ended."
      },
      "errors": {
        "delegateFailed": "Failed to delegate this task. Please try again.",
        "alreadyDelegated": "This task is already being handled by an agent.",
        "answerFailed": "Failed to send your answer. Please try again.",
        "cancelFailed": "Failed to cancel the delegation. Please try again.",
        "retryFailed": "Could not retry the delegation. Please try again.",
        "confirmApprovalFailed": "Failed to submit your approval. Please try again.",
        "cancelApprovalFailed": "Failed to cancel the proposed actions. Please try again.",
        "pauseFailed": "Failed to pause the delegation. Please try again.",
        "resumeFailed": "Failed to resume the delegation. Please try again.",
        "refinePlanFailed": "Failed to request plan changes. Please try again.",
        "requestPrChangesFailed": "Failed to request changes to the PR. Please try again.",
        "resolvePrCommentsFailed": "Failed to ask the agent to resolve the PR's review comments. Please try again.",
        "watchPrFailed": "Couldn't start watching this pull request. Try again.",
        "watchPrNoPr": "This task has no GitHub pull request to watch.",
        "watchPrLimitReached": "You've reached the limit of active watchers. Stop one to watch this pull request.",
        "watchPrNotFound": "This task could not be found.",
        "watchPrForbidden": "You don't have access to watch this pull request.",
        "planChanged": "The plan changed. Review it again before approving.",
        "stopRunFailed": "Failed to stop the run. Please try again.",
        "endRunFailed": "Couldn't end the run. Try again."
      },
      "approval": {
        "confirmLabel": "Confirm ({{count}})",
        "cancelLabel": "Cancel"
      },
      "banner": {
        "queued": "Delegated to {{targetName}}",
        "running": "Delegated to {{targetName}}",
        "blocked": "{{targetName}} is waiting for your answer",
        "paused": "{{targetName}} is paused",
        "planReadyTitle": "Plan ready",
        "reviewPlan": "Review plan",
        "done": "Agent finished",
        "failed": "Agent failed",
        "openPr": "Open PR",
        "discussInAssistant": "Discuss in assistant",
        "answerPlaceholder": "Or type an answer…",
        "send": "Send",
        "approve": "Approve",
        "expand": "Expand",
        "collapse": "Collapse",
        "dismiss": "Dismiss",
        "stepsLoading": "Loading steps…",
        "approvalNeeded": "{{targetName}} needs your approval",
        "showLog": "Show log",
        "hideLog": "Hide log",
        "askAssistantAboutError": "Ask the assistant about this",
        "attemptLabel": "attempt {{count}}"
      },
      "errorGuidance": {
        "branchExists": {
          "title": "A leftover branch from the previous attempt is blocking a fresh run.",
          "action": "Retry — it cleans up and starts over."
        },
        "needsRepoAccess": {
          "title": "The agent could not access the repository.",
          "action": "Check the GitHub connection permissions, then Retry."
        },
        "timeout": {
          "title": "The task ran past its time limit.",
          "action": "Retry resumes from the saved session when possible."
        },
        "maxTurns": {
          "title": "The agent hit its step limit.",
          "action": "Press Retry to let it continue where it stopped."
        },
        "noSessionToResume": {
          "title": "There is no saved session to resume.",
          "action": "Retry starts the task from scratch."
        },
        "localAgentUnreachable": {
          "title": "Your local machine is not reachable.",
          "action": "Make sure the delegate app is running, then Retry."
        },
        "permissionPolicyBlocked": {
          "title": "Your machine blocked the agent from making changes",
          "action": "Claude Code's settings on the paired machine refused a capability the job needs, so nothing could be written. Allow it there, then retry — retrying as-is will fail the same way."
        },
        "prDescriptionUpdateFailed": {
          "title": "The PR description couldn't be updated.",
          "action": "Ask again here in the chat."
        },
        "noChanges": {
          "title": "The agent finished without changing any file.",
          "action": "Explain in the chat what needs to change and ask again."
        },
        "noStepAttempted": {
          "title": "The agent finished without doing anything on this task.",
          "action": "Tell it what you want done and hand the task over again."
        },
        "noReviewComments": {
          "title": "This PR has no review comments to resolve.",
          "action": "Ask again here in the chat if you want something changed."
        },
        "connectionNotFound": {
          "title": "The coding connection this task was using was removed.",
          "action": "Reconnect it, or pick another machine, then retry."
        },
        "localJobNotFound": {
          "title": "Your machine no longer recognizes this job.",
          "action": "Check the tray app on that device, then retry."
        },
        "deviceOfflineExpired": {
          "title": "Your machine stayed offline for 72 hours.",
          "action": "Reconnect it, then retry."
        },
        "sourceChangedBeforeDispatch": {
          "title": "A new message arrived before this could start.",
          "action": "Review the updated plan, then retry."
        },
        "dispatchUnconfirmed": {
          "title": "An older version of the delegate app didn't confirm this started.",
          "action": "Check the machine, then retry."
        },
        "unknown": {
          "title": "Something went wrong and the agent couldn't finish the task.",
          "action": "Try again. If it keeps failing, contact support."
        }
      },
      "eventKind": {
        "delegated": "Delegated",
        "statusChange": "Status changed",
        "questionAsked": "Question asked",
        "answered": "Answered",
        "failed": "Failed",
        "retried": "Retried",
        "planReady": "Plan ready",
        "planRefined": "Plan revision requested",
        "prUpdateRequested": "PR changes requested",
        "completed": "Completed"
      },
      "panel": {
        "needsDecision": "Needs your approval",
        "requestChangesTitle": "Request changes",
        "requestChangesPlaceholder": "Describe what you want the agent to adjust..."
      },
      "modal": {
        "title": "Agent plan",
        "close": "Close",
        "expand": "Expand",
        "collapse": "Collapse",
        "viewPlan": "View plan",
        "statusLabelBlocked": "Blocked",
        "statusLabelPlanReady": "Ready for approval",
        "answerQuickReplyYes": "Yes",
        "answerQuickReplyNo": "No",
        "answerQuickReplySkip": "Skip"
      },
      "activity": {
        "DELEGATING": "Delegating to a sub-agent…",
        "EDITING": "Editing files…",
        "PLANNING": "Planning the work…",
        "READING": "Reading files…",
        "RESEARCHING": "Looking things up…",
        "RUNNING_COMMANDS": "Running commands…",
        "SEARCHING": "Searching the codebase…",
        "WORKING": "Working…"
      },
      "conversation": {
        "streamAriaLabel": "Agent conversation log",
        "emptyTitle": "Ready when you are",
        "emptyBody": "Claude Code is paired and idle on this task. Send a message or start the run — everything stays inside this task.",
        "emptyTitleCloud": "Waiting for the agent",
        "emptyBodyCloud": "Nothing from the agent yet. Its messages and proposals will show up here as soon as they arrive.",
        "emptyTitleProcessing": "Getting started",
        "emptyBodyProcessing": "The agent is starting the run — activity will show up here shortly.",
        "emptyChipStartRun": "Start run",
        "loading": "Loading conversation",
        "statusIdle": "Idle",
        "statusRunning": "Working",
        "statusWaiting": "Waiting on you",
        "statusCompleted": "Completed",
        "statusFailed": "Failed",
        "modePlan": "Plan Mode",
        "modeImplementing": "Implementing",
        "modeExecuting": "Executing",
        "tabsNotStarted": "not started",
        "tabsElapsed": "{{elapsed}} elapsed",
        "fullHistory_one": "History ({{count}})",
        "fullHistory_other": "History ({{count}})",
        "fullHistoryAriaLabel": "View the full execution history",
        "elapsedMinutes": "{{count}} min",
        "elapsedHours": "{{count}}h",
        "elapsedDays_one": "{{count}} day",
        "elapsedDays_other": "{{count}} days",
        "toolStatusRunning": "running",
        "toolStatusDone": "done",
        "toolStatusFailed": "failed",
        "activityRunToggleAriaLabel": "Toggle activity details",
        "plan": {
          "showFull": "Show full plan",
          "hideFull": "Hide full plan"
        },
        "askGroupAriaLabel": "Agent question",
        "askEyebrow": "Needs your answer",
        "questionAnswerHint": "Pick an option, or type your answer in the box below.",
        "answerSendFailed": "That answer did not go through. Your text is kept, so you can send it again.",
        "askFreeTextHint": "Or write a longer answer in the message box — it counts as the reply.",
        "resultTitle": "Task completed",
        "resolvePrComments": "Resolve review comments",
        "watchPr": "Watch PR",
        "viewWatcher": "View watcher",
        "watchPrCreated": "Watching this pull request. Follow it in the Watching tab.",
        "resultMarkTaskDone": "Mark task done",
        "resultPrDescriptionUpdateFailed": "The code was pushed, but the PR description couldn't be updated. Ask again here in the chat.",
        "failTitle": "Run failed",
        "failRetry": "Retry",
        "failViewFullLog": "View full log",
        "pausedEvent": "Paused by you · agent stopped immediately",
        "messagePending": "Sending…",
        "workingBarPause": "Pause",
        "workingBarPauseAriaLabel": "Pause agent",
        "pausedBarLabel": "Paused",
        "pausedBarResume": "Resume",
        "pausedBarResumeAriaLabel": "Resume agent",
        "composerSendAriaLabel": "Send message",
        "composerInputAriaLabel": "Message the agent",
        "placeholderRunning": "Send a note — held until this run finishes",
        "placeholderIdle": "Message the agent about this task",
        "hintRunning": "Enter sends. The run keeps going; your message lands at the next step boundary.",
        "hintIdle": "Enter sends · Shift+Enter for a new line · files are shared with the agent's workspace",
        "notOwnDelegationHint": "Only the person who started this delegation can send messages or approve here.",
        "localActivityStarting": "Getting started — this'll just take a moment.",
        "historyLimitNotice": "This conversation has a good bit of history — older messages aren't shown here anymore, but the work continues as usual.",
        "newItemsAvailable_one": "{{count}} new update",
        "newItemsAvailable_other": "{{count}} new updates",
        "destinationQueueMessage": "Sends to the agent",
        "destinationAnswerQuestion": "Answers the question",
        "destinationRevisePlan": "Revises the plan",
        "destinationRequestPrChanges": "Requests changes on the PR",
        "destinationRestartTask": "Restarts the task with your message",
        "destinationContinueConversation": "Continues the conversation",
        "destinationRetryWithInstructions": "Retries with your instructions",
        "destinationResumeAndSend": "Resumes the job and sends",
        "destinationQueuedForRunningJob": "Queued — the job is still running",
        "prFeedbackMinLengthHint": "Add at least {{count}} characters to request changes",
        "queuedEyebrow": "Held — not sent yet",
        "queuedCheckNow": "Check now",
        "queuedCancel": "Cancel",
        "queuedCheckNowFailed": "Failed to check the job's status. Please try again.",
        "approvalEyebrow": "Needs your approval",
        "approvalGroupAriaLabel": "Proposed actions",
        "failTechnicalDetails": "Technical details",
        "elapsedLessThanMinute": "less than a minute",
        "activityRunSteps_one": "{{count}} step",
        "activityRunSteps_other": "{{count}} steps",
        "toolGenericLabel": "Step"
      },
      "runView": {
        "statusNeedsApproval_one": "Needs your approval · {{count}} change",
        "statusNeedsApproval_other": "Needs your approval · {{count}} changes",
        "expandAriaLabel": "Open full screen",
        "collapseAriaLabel": "Back to panel",
        "hintRunningHeld": "Enter sends. Your note is held and sent to the agent once this run finishes.",
        "stopConfirmPrompt": "Cancel this run? You can delegate again anytime.",
        "stopConfirmYes": "Yes, cancel run",
        "stopConfirmNo": "Keep running",
        "endRunConfirmPrompt": "Close this run? The task stays open.",
        "endRunConfirmYes": "Close run",
        "endRunConfirmNo": "Keep",
        "planFirstChip": "Plan first — no code changes without your OK",
        "liveLog": {
          "title": "Live log",
          "copy": "Copy",
          "copySuccess": "Log copied to clipboard."
        },
        "approvals": {
          "bar": {
            "skipFuture": "Don't ask again on this task",
            "title_one": "This change is waiting for you",
            "title_other": "{{count}} changes are waiting for you",
            "hint_one": "It only changes this task and your Brain. Messages to people and deletions will still ask first.",
            "hint_other": "These only change this task and your Brain. Messages to people and deletions still ask one by one.",
            "approveAll_one": "Approve",
            "approveAll_other": "Approve all"
          },
          "result": {
            "title": "Approve all result",
            "applied_one": "{{count}} change applied",
            "applied_other": "{{count}} changes applied",
            "failed_one": "{{count}} didn't go through",
            "failed_other": "{{count}} didn't go through",
            "nothingApplied": "Nothing was applied",
            "stepFailed": "Its card below says what happened. Try again from there, or dismiss it.",
            "notStarted": "Didn't start.",
            "leftForIndividual_one": "{{count}} change still needs your decision. It is waiting on its own card below.",
            "leftForIndividual_other": "{{count}} changes still need your decision. They are waiting on their own cards below.",
            "dismiss": "Dismiss"
          },
          "errors": {
            "approveAll": "Couldn't approve these changes. Try again.",
            "turnOffSkip": "Couldn't turn this off. Try again.",
            "turnOnSkip": "Couldn't turn this on. Try again."
          }
        },
        "state": {
          "labelCompact": {
            "needsApproval": "Approval"
          },
          "label": {
            "working": "Working",
            "needsApproval": "Needs your approval",
            "needsYou": "Needs you",
            "prReady": "PR ready",
            "prMerged": "PR merged",
            "prClosed": "PR closed",
            "prChecksFailing": "Checks failing",
            "prChangesRequested": "Changes requested",
            "prComments": "Review comments",
            "prChecksRunning": "Checks running",
            "prApproved": "PR approved",
            "prChecksPassed": "Checks passed",
            "done": "Done",
            "failed": "Failed",
            "waitingReply": "Waiting for reply",
            "stopped": "Stopped",
            "ended": "Ended"
          },
          "meta": {
            "planReady": "plan ready",
            "updateReady": "update ready",
            "actionReady": "action ready",
            "stoppedOnStep": "stopped on step {{step}}",
            "finishedIn": "finished in {{elapsed}}",
            "declinedByOwner": "you declined the action",
            "endedByUser": "Ended by you",
            "replaced": "Replaced by a newer run"
          }
        },
        "pastRun": {
          "endedExplanation": "This run stopped before {{agent}} finished it. Nothing more will happen on it.",
          "composerReplacement": "This run has ended. Use + New to delegate again."
        },
        "topBar": {
          "back": "Back to task",
          "new": "New",
          "metaCloud": "Cloud agent · started {{time}}",
          "metaLocal": "Started {{time}} · {{taskType}}",
          "metaLocalPlanFirst": "Started {{time}} · {{taskType}} · Plan first"
        },
        "menu": {
          "ariaLabel": "Run options",
          "worksWithoutAskingOn": "Works without asking: on",
          "worksWithoutAskingOff": "Works without asking: off",
          "worksWithoutAskingAgent": "Works without asking (set on the agent)",
          "cancelRun": "Cancel run",
          "closeRun": "Close run"
        },
        "card": {
          "plan": {
            "fallbackTitle": "Review the plan",
            "approve": "Approve plan",
            "readFull": "Read full plan",
            "hideFull": "Hide full plan"
          },
          "action": {
            "approve": "Approve",
            "askForChanges": "Ask for changes",
            "toolLine": "Tool: {{tool}}",
            "decline": "Decline",
            "title": {
              "generic": "Approve this action",
              "SOURCE_REPLY": "Send this reply",
              "OUTBOUND_MESSAGE": "Send this message",
              "CALENDAR_EVENT": "Change your calendar",
              "DOBOX_INTERNAL": "Apply this change to the task",
              "KNOWLEDGE_WRITE": "Update your Brain",
              "FLOW": "Change a flow",
              "AGENT": "Change an agent",
              "MCP_READ": "Use a connected app",
              "MCP_WRITE": "Make a change in a connected app",
              "MEMORY": "Save this to memory",
              "CODE_DELEGATION": "Start a code task",
              "CAPABILITY": "Connect what this needs",
              "mcpNeutral": {
                "toolInApp": "Use {{tool}} in {{app}}",
                "tool": "Use {{tool}}",
                "generic": "Use a connected app"
              }
            }
          },
          "done": {
            "fallback": "{{agent}} finished this run.",
            "fallbackPr": "{{agent}} finished and opened a PR. Review what it changed before merging.",
            "fallbackPrSettled": "{{agent}} finished and opened a PR.",
            "more": "Read more",
            "less": "Show less",
            "openPr": "Open PR",
            "nextLabel": "Next with {{agent}}",
            "resolveComments": "Resolve review comments",
            "resolveCommentsHint": "Reads the comments on the PR and pushes fixes",
            "resolveCommentsCount_one": "Resolve {{count}} review comment",
            "resolveCommentsCount_other": "Resolve {{count}} review comments",
            "fixChecks": "Fix failing checks",
            "fixChecksHint": "Writes the instruction in the composer for you to review and send",
            "fixChecksPrefill": "The checks on the PR are failing. Look at the failing checks, fix the cause and push the fix to the same branch.",
            "signals": {
              "checksRunning": "Checks running",
              "checksFailing_one": "{{count}} check failed",
              "checksFailing_other": "{{count}} checks failed",
              "checksPassed": "Checks passed",
              "approved": "Approved",
              "changesRequested": "Changes requested",
              "reviewRequired": "Review required",
              "comments_one": "{{count}} comment to address",
              "comments_other": "{{count}} comments to address"
            },
            "watchHint": "Tells you when checks or reviews change"
          },
          "failed": {
            "title": "The run stopped",
            "titleStep": "The run stopped at “{{step}}”",
            "effects_one": "Before it stopped, {{count}} action already went through.",
            "effects_other": "Before it stopped, {{count}} actions already went through.",
            "retry": "Retry",
            "technicalDetails": "Technical details"
          },
          "declined": {
            "title": "You declined the action",
            "explanation": "Nothing was changed. Use + New to have {{agent}} try another way."
          }
        },
        "earlierPending": {
          "heading": "Pending from an earlier run",
          "explanation": "{{agent}} asked for this before the current run. Decline it to clear the alert, or approve it if you still want it."
        },
        "openQuestions": {
          "title_one": "{{count}} open question",
          "title_other": "{{count}} open questions",
          "subtitle": "The plan already assumes an answer. Approving keeps them.",
          "assumes": "Assumes:",
          "change": "Change",
          "changeAria": "Change the answer to question {{number}}",
          "prefill": "Question {{number}}: "
        },
        "progress": {
          "label": "Progress",
          "waitingForYou": "Waiting for you",
          "stoppedHere": "Stopped here",
          "showPlan": "Show plan",
          "hidePlan": "Hide plan",
          "title": {
            "planWritten": "Read the code and wrote a plan",
            "planApproved": "You approved the plan",
            "localAnalysis": "Read the code and wrote a plan",
            "localAnalysisActive": "Reading the code",
            "localImplementation": "Made the change",
            "localImplementationActive": "Making the change",
            "localImplementationPr": "Made the change and opened the PR",
            "notRun": "Next steps didn't run"
          },
          "decision": {
            "approved": "{{action}} · Approved",
            "declined": "{{action}} · Declined by you",
            "waiting": "{{action}}"
          }
        },
        "composer": {
          "to": "To:",
          "placeholder": {
            "running": "Send a note — it reads it between steps",
            "plan": "Ask for changes to the plan…",
            "action": "Ask for changes, or reply “go ahead”",
            "input": "Type your answer…",
            "done": "Message {{agent}} about this run",
            "failed": "Add a note and retry…"
          },
          "hint": {
            "followUp": "Follow-ups go to this run. For a different agent, use + New.",
            "plan": "Sends the plan back with your note. To cancel the run, use ⋯.",
            "failed": "Sending retries the run with your note."
          }
        }
      },
      "activityDone": {
        "DELEGATING": "Delegated to a sub-agent",
        "EDITING": "Edited files",
        "PLANNING": "Planned the work",
        "READING": "Read files",
        "RESEARCHING": "Looked things up",
        "RUNNING_COMMANDS": "Ran commands",
        "SEARCHING": "Searched the codebase",
        "WORKING": "Worked on it"
      },
      "runList": {
        "title": "Agent work on this task",
        "view": "View",
        "finished": "finished {{time}}",
        "started": "started {{time}}",
        "ended": "ended {{time}}",
        "finishedOn": "finished {{time}}",
        "startedOn": "started {{time}}",
        "endedOn": "ended {{time}}",
        "rowAriaLabel": "{{agent}}, {{state}}. View run"
      }
    },
    "agentPresence": {
      "card": {
        "line1": {
          "working": "{{agent}} is working",
          "needsYou": "{{agent}} needs you",
          "reviewDraft": "{{agent}} · draft ready to review",
          "reviewPr": "{{agent}} · PR ready to review"
        },
        "line2": {
          "waitingForDevice": "Waiting for your Mac",
          "planReady": "Plan ready — approve to start coding",
          "paused": "Paused",
          "failed": "Couldn't finish",
          "question": "{{question}}",
          "reviewSubject": "Re: {{subject}}",
          "reviewRecipient": "To {{recipient}}",
          "reviewGeneric": "Ready to review",
          "waitingReply": "Waiting for reply"
        }
      },
      "cta": {
        "watch": "Watch",
        "answer": "Answer",
        "reviewAndSend": "Review & send",
        "reviewPr": "Review PR",
        "ariaLabel": "{{cta}}: {{subject}}",
        "reviewPlan": "Review plan"
      },
      "agentKind": {
        "localClaude": "Local Claude",
        "assistant": "Assistant"
      },
      "chip": {
        "openRunViewAriaLabel": "Open run view for {{agent}}: {{state}}",
        "statusAriaLabel": "{{agent}}: {{state}}"
      },
      "delegateButton": "Delegate",
      "delegateButtonAriaLabel": "Delegate: {{subject}}"
    },
    "agentBand": {
      "status": {
        "working": {
          "full": "is working",
          "compact": "Working"
        },
        "starting": "Starting…",
        "needsYou": {
          "full": "needs you",
          "compact": "Needs you"
        },
        "draftReady": {
          "full": "draft ready",
          "compact": "Draft ready"
        },
        "editApproval": {
          "full": "waiting for your approval",
          "compact": "Needs your approval"
        },
        "prReady": {
          "full": "PR ready",
          "compact": "PR ready"
        },
        "failed": "Failed",
        "paused": "Paused",
        "offline": "Offline",
        "waitingReply": "Waiting for reply"
      },
      "action": {
        "watch": "Watch",
        "answer": "Answer",
        "reviewAndSend": "Review & send",
        "review": "Review",
        "reviewPr": "Review PR",
        "open": "Open",
        "reviewPlan": "Review plan"
      },
      "aria": {
        "working": "{{agent}} is working — watch",
        "workingWithElapsed": "{{agent}} is working, {{elapsed}} — watch",
        "starting": "{{agent}} is starting — watch",
        "needsYou": "{{agent}} needs you — answer",
        "draftReady": "{{agent}} has a draft ready — review it",
        "editApproval": "{{agent}} is waiting for your approval — review it",
        "prReady": "{{agent}} opened a PR — review it",
        "offline": "{{agent}} is offline — open",
        "paused": "{{agent}} is paused — open",
        "failed": "{{agent}} failed — open",
        "waitingReply": "{{agent}} is waiting for a reply — open",
        "state": "{{agent}}: {{state}} — open",
        "planReady": "{{agent}} has a plan ready — review it"
      },
      "elapsedNow": "now"
    },
    "delegatePopover": {
      "ariaLabel": "Delegate this task",
      "instructionLabel": "What should it do?",
      "instructionHint": "Optional · Enter delegates",
      "agentListAriaLabel": "Agents",
      "sectionSuggested": "Suggested",
      "sectionOthers": "Other agents",
      "sectionCloud": "Cloud agents",
      "manageAgents": "Manage",
      "askBeforeActing": "Ask before acting",
      "planFirst": "Plan first, I approve",
      "delegate": "Delegate",
      "delegating": "Delegating…",
      "error": "Couldn't delegate. Try again.",
      "openInAssistant": "Open in assistant",
      "toastDelegated": "Delegated to {{agent}}"
    },
    "agentNotifications": {
      "typeLabel": {
        "error": "Agent failed",
        "decision": "Needs decision",
        "blocked": "Waiting on you",
        "done": "Completed"
      },
      "defaultTitle": {
        "decision": "The agent has a plan ready for you",
        "blocked": "The agent needs your input",
        "done": "The agent finished"
      },
      "action": {
        "openChat": "Open chat",
        "dismissAriaLabel": "Dismiss notification"
      },
      "bar": {
        "statusLine_one": "{{count}} agent needs your input",
        "statusLine_other": "{{count}} agents need your input",
        "viewAll": "View all",
        "collapse": "Collapse"
      },
      "bell": {
        "ariaLabel_one": "Agent notifications, {{count}} item pending",
        "ariaLabel_other": "Agent notifications, {{count}} items pending"
      },
      "browserTitle": "{{agent}} · {{label}}",
      "browserBody": "{{title}}",
      "completion": {
        "generic": "Agent completed successfully",
        "withSummary": "Agent completed successfully — {{summary}}"
      }
    },
    "undoToast": {
      "deletedSingle": "Deleted \"{{subject}}\"",
      "deletedMultiple": "{{count}} tasks deleted",
      "resolvedSingle": "Marked done: \"{{subject}}\"",
      "resolvedMultiple": "{{count}} tasks marked as done",
      "unresolvedSingle": "Marked not done: \"{{subject}}\"",
      "unresolvedMultiple": "{{count}} tasks marked as not done",
      "undo": "Undo",
      "commitError": "Action failed. The item will reappear on refresh.",
      "leaveTitle": "Leave page?",
      "leaveDescription": "You have pending actions. They will be executed immediately when you leave.",
      "leaveConfirm": "Leave",
      "leaveCancel": "Stay"
    },
    "rejectionDialog": {
      "title": "Please share why this suggested task wasn't helpful",
      "feedbackPlaceholder": "Please share why this suggested task wasn't helpful",
      "helpText": "Your feedback helps us improve suggested tasks for you and your team. Click Reject & delete to reject this suggestion and submit your optional feedback",
      "rejectAndDelete": "Submit",
      "feedbackTooltip": "This suggested task isn't helpful",
      "successMessage": "Feedback submitted and suggested task removed",
      "errorMessage": "Failed to submit feedback. Please try again."
    },
    "aiAssistant": {
      "title": "Create tasks with AI",
      "placeholder": "Describe the tasks you need to create...",
      "createButton": "Generate",
      "createManually": "Create manually",
      "singleTaskNotice": "AI turned your request into one task. Review it and create it.",
      "batchNotice": "Task {{current}} of {{total}} from your request. The next one opens after you create this one; cancelling discards the rest.",
      "error": "Failed to generate tasks. Please try again.",
      "examplePrompts": {
        "reviewReport": "Review the Q1 report by Friday",
        "prepareMeeting": "Prepare for tomorrow's team standup",
        "followUpEmail": "Follow up on the client proposal from last week",
        "weeklyPlanning": "Plan my tasks for the week"
      }
    },
    "postOnboarding": {
      "title": "Explore automations",
      "subtitle": "While we're syncing your emails, let's explore some automations to supercharge your inbox and Slack.",
      "dismiss": "Maybe later"
    },
    "postOnboardingAnalyze": {
      "title": "Here's what your inbox looks like",
      "subtitle": "We analyzed your last 90 days of email to find patterns you can automate.",
      "loading": {
        "title": "Analyzing your inbox…",
        "subtitle": "Looking for repetitive patterns across your emails."
      },
      "hero": {
        "minutesSavedPerDay": "{{duration}} saved per day",
        "interruptionsPerDay": "{{count}} fewer interruptions per day",
        "totalEmails": "Based on {{count}} emails from the last 90 days"
      },
      "empty": {
        "title": "Your inbox is already in great shape",
        "subtitle": "We didn't find meaningful patterns to automate right now. That's a good sign."
      },
      "error": {
        "title": "Something went wrong",
        "subtitle": "We couldn't analyze your inbox. Please try again.",
        "retry": "Try again"
      },
      "suggestions": {
        "title": "Suggested flows",
        "impact": "{{count}} emails / week",
        "timeSaved": "~{{duration}} saved / week"
      },
      "cardActions": {
        "labelName": "Label name",
        "labelNamePlaceholder": "e.g. Newsletters",
        "forwardTo": "Forward to",
        "forwardToPlaceholder": "name@company.com",
        "forwardToHintInvalid": "Enter a valid email address",
        "toggleAriaLabel": "Enable automation"
      },
      "cta": {
        "dismiss": "Dismiss",
        "activate": "Activate {{count}} flow",
        "activate_other": "Activate {{count}} flows"
      },
      "toast": {
        "saveSummary": "{{succeeded}} flow created",
        "saveSummary_other": "{{succeeded}} flows created",
        "saveError": "Failed to create flows. Please try again.",
        "allInvalid": "Check the fields before saving"
      },
      "validation": {
        "missingLabelId": "Set the label for \"{{value}}\"",
        "missingForwardTo": "Set the destination for \"{{value}}\"",
        "invalidForwardTo": "Invalid email in \"{{value}}\""
      }
    },
    "doBoxFormModal": {
      "titleEdit": "Edit task",
      "titleCreate": "Create task",
      "subjectLabel": "Subject",
      "subjectPlaceholder": "Enter subject",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Enter description",
      "taskGroupLabel": "List",
      "taskSubgroupLabel": "Section",
      "taskSubgroupNone": "Backlog",
      "noTaskText": "No task available",
      "taskRequired": "Task is required",
      "taskGroupRequired": "A list is required",
      "createError": "Failed to create task. Please try again.",
      "editError": "Failed to save changes. Please try again.",
      "moveError": "Changes saved, but failed to move task to the selected list.",
      "editSuccess": "Changes saved",
      "createSuccess": "Task created",
      "openTask": "Open task",
      "openTaskWithSubject": "Open: {{subject}}",
      "recurrenceLabel": "Recurring task",
      "recurrencePlaceholder": "Set recurrence",
      "recurrenceCreateError": "Task created, but failed to set recurrence. You can configure it in the details.",
      "recurrenceUpdateError": "Failed to update recurrence. Please try again.",
      "recurrenceDeleteError": "Failed to remove recurrence. Please try again.",
      "recurrenceChipClear": "Clear recurring task",
      "titleEditRecurrence": "Edit recurring task",
      "participantsLabel": "Members",
      "participantsSearchPlaceholder": "Search members...",
      "participantsEmptyState": "No members found",
      "collectionsApplyError": "Task saved, but failed to apply labels or participants. You can configure them in the details.",
      "priorityLabel": "Priority",
      "priorityPlaceholder": "No priority",
      "createWithAiButton": "Create with AI"
    },
    "welcomeDialog": {
      "title": "Your actionable messages, organized automatically",
      "subtitle": "Messages that require an action — from Slack, Teams, email and more — are automatically turned into DoBox entries, so nothing falls through the cracks."
    },
    "settings": {
      "title": "DoBox settings",
      "rules": {
        "title": "Feedback rules",
        "description": "Rules generated from your feedback. Delete any rule to stop applying it.",
        "empty": "No rules yet. Rules are created when you give feedback on DoBox suggestions.",
        "deleteLabel": "Delete rule",
        "deleteConfirmTitle": "Delete this rule?",
        "deleteConfirmBody": "This cannot be undone.",
        "deleteError": "Could not delete rule. Please try again."
      },
      "openRulesPage": "Open in Brain",
      "rulesHeading": "Your DoBox rules live in your Brain",
      "rulesDescription": "DoBox rules teach the assistant what not to turn into task suggestions. Open the Rules page to review and edit them."
    },
    "rules": {
      "title": "DoBox Rules",
      "description": "DoBox rules teach the assistant what not to turn into task suggestions.",
      "activeCount_one": "{{count}} active rule",
      "activeCount_other": "{{count}} active rules",
      "search": {
        "placeholder": "Search rules..."
      },
      "openInBrain": "Open in Brain →",
      "create": "New rule",
      "createPlaceholder": "Rule instructions...",
      "edit": "Edit",
      "delete": "Delete",
      "empty": "No rules yet",
      "manageTitle": "Manage Rules",
      "saveEdit": "Save",
      "cancelEdit": "Cancel",
      "addRule": "Add a rule",
      "addRulePlaceholder": "e.g. Don't suggest tasks for newsletter emails",
      "add": "Add",
      "done": "Done",
      "toggleActiveAriaLabel": "Toggle rule active",
      "createError": "Could not create rule. Please try again.",
      "updateError": "Could not update rule. Please try again.",
      "decisionToast": {
        "created": "Rule created — the AI will apply it going forward.",
        "replaced": "Rule updated — the AI has replaced a similar rule.",
        "merged": "Rule merged — the AI combined this with an existing rule.",
        "skipped": "No rule changes — your feedback was noted but didn't need a new rule."
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next",
        "pageInfo": "Page {{current}} of {{total}}"
      },
      "footerNote": "Rules only affect new suggestions — nothing already in your DoBox will move."
    },
    "boardAgents": {
      "title": "Board Agents",
      "description": "Choose which of your and your team's agents show up as delegate options on task cards in DoBox.",
      "empty": "No board agents yet. Agents you add here will appear in the DoBox delegate card.",
      "addAgent": "Add agent",
      "addAgentTitle": "Choose an agent",
      "noAvailableAgents": "No more agents available to add",
      "removeAriaLabel": "Remove {{name}} from board agents",
      "addAgentAriaLabel": "Add {{name}} as a board agent",
      "removeError": "Could not remove agent. Please try again.",
      "addError": "Could not add agent. Please try again.",
      "cancelAdd": "Cancel",
      "deleteAriaLabel": "Delete {{name}}",
      "deleteConfirmTitle": "Delete this agent?",
      "deleteConfirmDescription": "{{name}} will be deleted for good. Tasks already delegated to it keep their history. This cannot be undone.",
      "deleteSuccess": "Agent deleted",
      "deleteError": "Could not delete agent. Please try again."
    },
    "templates": {
      "title": "Templates",
      "description": "Reusable models for creating AI-structured tasks",
      "addTemplate": "Template",
      "empty": "No templates yet. Create one to get started.",
      "count_one": "{{count}} template",
      "count_other": "{{count}} templates",
      "blank": "Blank",
      "selector": {
        "label": "Start from a template (optional)"
      },
      "search": {
        "placeholder": "Search templates..."
      },
      "form": {
        "nameLabel": "Template name",
        "iconLabel": "Icon & color",
        "descriptionLabel": "Description (template)",
        "descriptionPlaceholder": "[Action verb] + [what]\n\nWhy: [one sentence]\n\nSolution:\n[2-4 sentences]\n\nDone when:\n- [checkpoint]\n- [checkpoint]",
        "descriptionHelp": "The AI follows this structure when writing each generated task's description.",
        "save": "Save template",
        "createTitle": "New template",
        "editTitle": "Edit template",
        "createBadge": "New",
        "editBadge": "Editing"
      },
      "delete": {
        "title": "Delete template",
        "confirmTitle": "Delete template",
        "confirmBody": "Are you sure you want to delete the template \"{{name}}\"? It will no longer appear when creating tasks with AI. This action cannot be undone.",
        "confirm": "Delete template",
        "deleteError": "Failed to delete template. Please try again."
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next",
        "pageInfo": "Page {{current}} of {{total}}"
      },
      "menu": {
        "sectionLabel": "AUTOMATION",
        "rulesTitle": "Rules",
        "recurringTitle": "Recurring tasks",
        "templatesTitle": "Templates",
        "rulesSubtitle_one": "{{count}} active rule",
        "rulesSubtitle_other": "{{count}} active rules",
        "rulesSubtitleNone": "No active rules",
        "recurringSubtitle_one": "{{count}} recurring task",
        "recurringSubtitle_other": "{{count}} recurring tasks",
        "recurringSubtitleNone": "No recurring tasks",
        "templatesSubtitle_one": "{{count}} template",
        "templatesSubtitle_other": "{{count}} templates",
        "templatesSubtitleNone": "No templates",
        "agentsTitle": "Agents",
        "agentsSubtitle_one": "{{count}} agent",
        "agentsSubtitle_other": "{{count}} agents",
        "agentsSubtitleNone": "No agents",
        "tooltip": "Automations"
      }
    },
    "bulkActions": {
      "selectedCount": "{{count}} selected",
      "selectedLabel": "selected",
      "selectAllTasks": "Select all tasks",
      "selectAllSuggestions": "Select all suggestions",
      "blockedSuggestion": "Suggestions can't be selected together with tasks. Clear the selection to select suggestions.",
      "blockedTask": "Tasks can't be selected together with suggestions. Clear the selection to select tasks.",
      "clearAll": "Clear all",
      "markDone": "Done",
      "markUndone": "Not done",
      "move": "Move",
      "priority": "Priority",
      "delete": "Delete",
      "closeSelection": "Clear selection",
      "acceptSuggestion": "Accept",
      "rejectSuggestion": "Reject",
      "deleteConfirmTitle": "Delete {{count}} task(s)?",
      "deleteConfirmBody": "This action can't be undone. The selected tasks will be permanently removed.",
      "moveTaskGroupSection": "Lists",
      "moveSubgroupSection": "Sections",
      "noSubgroup": "Backlog",
      "toast": {
        "markedDone": "{{count}} task(s) marked Done",
        "markedUndone": "{{count}} task(s) marked Undone",
        "deleted": "Deleted {{count}} task(s)",
        "moved": "Moved {{count}} task(s) to {{group}}",
        "moveLoading": "Moving tasks...",
        "moveError": "Failed to move tasks",
        "priority": "Priority set to {{level}}",
        "priorityLoading": "Updating priority...",
        "priorityError": "Failed to update priority",
        "acceptingSuggestions": "Accepting suggestions...",
        "suggestionsAccepted": "Accepted {{count}} suggestion(s)",
        "acceptSuggestionsError": "Failed to accept suggestions",
        "movedToSubgroup": "Moved {{count}} task(s) to {{subgroup}}",
        "movedOutOfSubgroup": "Moved {{count}} task(s) out of section"
      }
    },
    "keyboardShortcuts": {
      "tooltip": "Keyboard shortcuts",
      "modalTitle": "Keyboard shortcuts",
      "navigation": "Navigation",
      "actions": "Actions",
      "selection": "Selection",
      "moveItems": "Move between items",
      "firstLast": "First / last item",
      "openTask": "Open task modal",
      "closeModal": "Close modal",
      "openDropdown": "Open dropdown",
      "closeDropdown": "Close dropdown",
      "markDone": "Mark as Done",
      "acceptSuggestion": "Accept suggestion",
      "openLabels": "Open labels",
      "openParticipants": "Open participants",
      "openPriority": "Open priority",
      "delete": "Delete",
      "moveToList": "Move to list",
      "createCard": "Create new card",
      "openDueDate": "Open due date",
      "openTaskGroups": "Open task group selector",
      "openCheatsheet": "Open this cheatsheet",
      "toggleSelection": "Toggle selection",
      "selectAll": "Select all",
      "clearSelection": "Clear selection",
      "modifierClickSelect": "Toggle selection",
      "shiftClickSelect": "Select range",
      "popoverSection": "Inside popovers",
      "popoverNavigate": "Move between items",
      "popoverToggle": "Select / toggle item",
      "popoverClose": "Close popover"
    },
    "taskGroupAccessLost": {
      "title": "You're no longer part of this task group",
      "description": "Pick another list from the selector above, or ask someone in the task group to add you back."
    },
    "attachGeneratedImage": {
      "button": "Attach image",
      "modalTitle": "Choose an image",
      "toast": {
        "loading": "Attaching image…",
        "success": "Image attached.",
        "error": "Could not attach image. {{message}}"
      }
    },
    "subgroups": {
      "toggleOpen": "Toggle section",
      "editTitle": "Edit section title",
      "dragHandle": "Drag to reorder section",
      "delete": "Delete section",
      "dropToAdd": "Drop to add to {{name}}",
      "dragTasksHere": "Drag tasks here",
      "addTaskToSubgroup": "Add task to {{name}}",
      "newSubgroupTitle": "New section",
      "addSubgroup": "Section",
      "taskCount_one": "{{count}} task",
      "taskCount_other": "{{count}} tasks",
      "ungroupedEmpty": "Drag tasks here to remove them from a section",
      "deleteConfirmTitle": "Delete section?",
      "deleteConfirmBody": "Tasks in \"{{name}}\" won't be deleted — they'll be moved out of the section."
    },
    "board": {
      "viewSwitch": {
        "list": "List",
        "board": "Board",
        "ariaLabel": "Switch between list and board view"
      },
      "noSubgroup": "Backlog",
      "addColumn": "Column",
      "communicationsCount_one": "{{count}} communication",
      "communicationsCount": "{{count}} communications",
      "newReply": "New reply",
      "openConversation": "Open conversation",
      "approvalsColumnTitle": "Approvals",
      "suggestionsColumnTitle": "Task suggestions",
      "column": {
        "editTitle": "Edit column title",
        "delete": "Delete column",
        "newColumnTitle": "New column",
        "deleteConfirmTitle": "Delete column?",
        "deleteConfirmBody": "Tasks in \"{{name}}\" won't be deleted — they'll be moved out of the column."
      },
      "mover": {
        "title": "Move",
        "hint": "Drop here to choose a column",
        "ariaLabel": "Drag target — drop here to pick a column"
      },
      "moveSheet": {
        "title": "Move \"{{name}}\" to",
        "acceptTitle": "Accept \"{{name}}\" into",
        "ariaLabel": "Move task to column",
        "closeAriaLabel": "Close move sheet"
      }
    },
    "backlog": {
      "title": "Backlog",
      "empty": "Drag tasks here to move them to the Backlog",
      "createFirstCard": "Create your first card"
    }
  },
  "aria-labels": {
    "reply": "Reply",
    "replyAll": "Reply All",
    "forward": "Forward",
    "unsubscribe": "Unsubscribe from mailing list",
    "archive": "Archive",
    "openAttachment": "Open attachment",
    "clear": "Clear",
    "toggle": "Toggle",
    "close": "Close",
    "viewFile": "View file",
    "deleteFile": "Delete file",
    "previousSlide": "Previous slide",
    "nextSlide": "Next slide",
    "openMessageInNewWindow": "Open message in new window",
    "toggleRecipientsDropdown": "Toggle recipients dropdown",
    "settings": "Settings",
    "toggleFontMenu": "Toggle font menu",
    "attach": "Attach",
    "link": "Link",
    "fontSize": "Font size",
    "fontFamily": "Font family",
    "textColor": "Text color",
    "openSidebar": "Open sidebar",
    "closeSidebar": "Close sidebar",
    "floatingButton": "Floating button",
    "optionsMenu": "Options",
    "dragDropIndicator": "Drag indicator",
    "navigationButton": "Navigation button",
    "removeAttachment": "Remove attachment",
    "fileInput": "File input",
    "downloadAttachment": "Download attachment",
    "clickToPreview": "Click to preview",
    "deleteInboxEntry": "Delete inbox entry: {{subject}}",
    "selectLabel": "Select {{labelDisplayName}}",
    "filterByLabel": "Filter by {{labelDisplayName}} label",
    "toggleLabel": "Toggle {{labelDisplayName}} label",
    "collapseLabel": "Collapse {{labelDisplayName}}",
    "expandLabel": "Expand {{labelDisplayName}}",
    "time": "Time",
    "dueDateBadge": "Due date: {{date}}",
    "dueDateBadgeTooltip": {
      "overdue": "This task is past due.",
      "dueSoon": "This task is due in less than twenty-four hours.",
      "normal": "This task is due later.",
      "resolved": "This task is done."
    },
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "star": "Star",
    "unstar": "Remove star",
    "markImportant": "Mark as important",
    "unmarkImportant": "Mark as not important",
    "linkedToDoBox": "Linked to a DoBox task"
  },
  "messageEditor": {
    "tooltips": {
      "menuBar": {
        "fontColor": "Font color and formatting options",
        "attach": "Attach file",
        "link": "Insert link",
        "fontSize": "Font size",
        "fontFamily": "Font family",
        "textColor": "Text color",
        "attachFile": "Attach file",
        "formatting": {
          "bold": "Bold",
          "italic": "Italic",
          "strike": "Strikethrough",
          "highlight": "Highlight",
          "align-left": "Align left",
          "align-center": "Center",
          "align-right": "Align right",
          "align-justify": "Justify",
          "code": "Code block",
          "bullet-list": "Bullet list",
          "ordered-list": "Numbered list"
        }
      },
      "recipients": {
        "addRecipients": "Add recipients {{recipientType}} ({{recipientShortcut}})"
      }
    },
    "linkPopover": {
      "linkText": "Link text",
      "linkTextPlaceholder": "Enter link text...",
      "url": "URL",
      "urlPlaceholder": "Enter URL...",
      "addLink": "Add link",
      "updateLink": "Update link",
      "removeLink": "Remove link"
    },
    "colorPicker": {
      "presetColors": "Preset colors",
      "customColor": "Custom",
      "selectColor": "Select color",
      "customColorPicker": "Custom color picker",
      "colors": {
        "black": "Black",
        "darkGray": "Dark Gray",
        "gray": "Gray",
        "red": "Red",
        "orange": "Orange",
        "yellow": "Yellow",
        "green": "Green",
        "emerald": "Emerald",
        "blue": "Blue",
        "indigo": "Indigo",
        "purple": "Purple",
        "pink": "Pink"
      }
    }
  },
  "slackChannelPreview": {
    "unreadDivider": "NEW"
  },
  "userInfoCard": {
    "contact": "Contact"
  },
  "teamsProcessing": {
    "progressNotification": "Processing Teams chats: {{processedChats}} of {{totalChats}} chats synced.",
    "completedNotification": "Teams sync completed: {{totalChats}} chats synced successfully.",
    "failedNotification": "We couldn't finish syncing your Teams chats. We processed {{processedChats}} chats before stopping — reconnect Teams to finish."
  },
  "s3Attachments": {
    "loadAttachments": "Load attachments",
    "moreAttachments": "+{{count}} more"
  },
  "errors": {
    "attachment": {
      "downloadFailed": "Failed to download attachment"
    },
    "unexpectedError": {
      "title": "Something went wrong",
      "description": "An unexpected error occurred. Please try again.",
      "retry": "Retry"
    },
    "copy": "Failed to copy to clipboard.",
    "notFound": {
      "title": "Page not found",
      "description": "The page you're looking for doesn't exist or has been moved.",
      "backToDoBox": "Back to DoBox"
    }
  },
  "meetingAssistantPage": {
    "googleSuccessfullyConnected": {
      "title": "Google connected",
      "message": "Your Google account has been successfully connected."
    },
    "outlookSuccessfullyConnected": {
      "title": "Outlook connected",
      "message": "Your Outlook account has been successfully connected."
    },
    "integrationSuccessfullyConnected": {
      "title": "Integration connected",
      "message": "Your integration has been successfully connected."
    }
  },
  "chromeExtension": {
    "popup": {
      "title": "this+that for Gmail",
      "signInDescription": "Log in to see your DoBox items in Gmail",
      "signIn": "Log in",
      "signOut": "Sign out",
      "openDoBox": "Open DoBox",
      "openDoBoxLabel": "Open DoBox (opens in new tab)",
      "connected": "Connected",
      "loading": "Loading...",
      "defaultUserName": "User"
    },
    "doBoxIndicator": {
      "active": "DoBox",
      "resolved": "DoBox (Done)",
      "openInDoBox": "Open in this+that",
      "viewArrow": "→",
      "noticeBarLabel": "Open {{subject}} in this+that"
    },
    "sidebar": {
      "title": "DoBox",
      "appName": "this+that DoBox",
      "sectionActive": "Active",
      "sectionSuggestions": "Suggestions",
      "sectionApprovals": "Approvals",
      "sectionDone": "Done",
      "emptyTitle": "All clear!",
      "emptyDescription": "No active DoBox items right now.",
      "loadingText": "Loading...",
      "errorText": "Failed to load items",
      "retryButton": "Try again",
      "resolveButton": "Done",
      "acceptButton": "Accept",
      "showDoneLabel": "Show done",
      "unresolveButton": "Mark not done",
      "emptyDoneTitle": "No done items",
      "emptyDoneDescription": "Done tasks will appear here.",
      "createButton": "+",
      "createFormTitle": "New Task",
      "createFormSubjectLabel": "Subject",
      "createFormSubjectPlaceholder": "What needs to be done?",
      "createFormDescriptionLabel": "Description",
      "createFormDescriptionPlaceholder": "Add details...",
      "createFormSubmit": "Create",
      "createFormCancel": "Cancel",
      "createFormCreating": "Creating...",
      "createFormError": "Failed to create item. Please try again.",
      "createFormSubjectRequired": "Subject is required",
      "timeJustNow": "just now",
      "timeMinutesAgo": "{{count}}m ago",
      "timeHoursAgo": "{{count}}h ago",
      "timeDaysAgo": "{{count}}d ago",
      "toggleDoneLabel": "Toggle show done items",
      "createButtonLabel": "Create new DoBox item",
      "listSwitcherLabel": "Switch list",
      "entryListLabel": "DoBox entries",
      "approveButton": "Approve",
      "rejectButton": "Reject",
      "proposedChangeLabel": "Proposed change",
      "evidenceLabel": "Evidence",
      "evidenceCount": "Evidence ({{count}})",
      "evidenceEmpty": "No evidence attached.",
      "evidenceLoading": "Loading evidence...",
      "evidenceError": "Could not load the evidence.",
      "evidenceRetry": "Try again",
      "relatedItemsLabel": "Related items",
      "expandLabel": "Show more",
      "collapseLabel": "Show less",
      "editButton": "Edit",
      "editSubjectLabel": "Title",
      "editDescriptionLabel": "Description",
      "saveAndApproveButton": "Save and approve",
      "cancelEditButton": "Cancel",
      "actionError": "Something went wrong. Try again."
    },
    "agentTab": {
      "controlledBanner": "this+that is using this tab"
    }
  },
  "workspaceAddon": {
    "sectionActive": "Active",
    "sectionSuggestions": "Suggestions",
    "sectionDone": "Done",
    "buttonResolve": "Done",
    "buttonUnresolve": "Mark not done",
    "buttonAccept": "Accept",
    "buttonNewTask": "+ New Task",
    "buttonCreate": "Create",
    "buttonCancel": "Cancel",
    "buttonRetry": "Try again",
    "buttonOpenInDobox": "Open in DoBox",
    "buttonConnect": "Connect",
    "buttonOpen": "Open",
    "buttonRefresh": "Refresh",
    "emptyDescription": "No active DoBox items right now.",
    "emptyDoneDescription": "Done tasks will appear here.",
    "unauthenticatedTitle": "Connect your account",
    "unauthenticatedDescription": "Log in to this+that to see your DoBox items.",
    "unauthenticatedAccountRequired": "A this+that account is required.",
    "entryResolvedLabel": "Done",
    "entrySuggestionLabel": "Suggestion",
    "createFormTitle": "New Task",
    "labelSubject": "Subject",
    "labelDescription": "Description",
    "hintSubject": "What needs to be done?",
    "hintDescription": "Add details...",
    "noSubject": "(no subject)",
    "errorUpdateEntry": "Failed to update entry. Please try again.",
    "errorAcceptSuggestion": "Failed to accept suggestion. Please try again.",
    "errorLoadHomepage": "Failed to load items. Please try again.",
    "errorSwitchList": "Failed to switch list. Please try again.",
    "errorSubjectRequired": "Subject is required.",
    "errorCreateEntry": "Failed to create entry. Please try again.",
    "errorUpdateFilter": "Failed to update filter. Please try again.",
    "errorMissingEntryId": "Missing entry ID.",
    "timeJustNow": "just now",
    "timeMinutesAgo": "{{count}}m ago",
    "timeHoursAgo": "{{count}}h ago",
    "timeDaysAgo": "{{count}}d ago",
    "dropdownDone": "Done"
  },
  "pushNotifications": {
    "permissionPromptTitle": "Stay up to date",
    "permissionPromptDescription": "Enable notifications to get real-time alerts for new messages and inbox items.",
    "enableButton": "Enable notifications",
    "dismissButton": "Not now",
    "newTask": "New task in your DoBox",
    "newMessage": "New message",
    "executorAttention": {
      "SEND_FAILED": "A send failed — needs you",
      "NEEDS_APPROVAL": "Needs your approval",
      "NEEDS_INPUT": "Needs your input",
      "NEEDS_CONNECTION": "Needs a connection",
      "READY_TO_RESOLVE": "Ready to resolve",
      "SUGGESTED_DECISION": "Has a suggested decision"
    },
    "executorApprovalExpiring": "Approval expiring soon"
  },
  "flows": {
    "pageTitle": "Flows",
    "pageDescription": "Automate your workflows with custom flows",
    "create": {
      "newFlow": "New flow",
      "newFlowDescription": "One trigger → action → output",
      "newGroup": "New group",
      "newWorkflow": "New workflow",
      "newWorkflowDescription": "Bundle several flows together",
      "createManually": "Create empty group",
      "menuAriaLabel": "Create options",
      "aiFlow": "New flow · with AI",
      "aiFlowDescription": "Describe it and we'll build it",
      "manualFlow": "New flow · manually",
      "manualFlowDescription": "Start from an empty builder",
      "aiGroup": "New group · with AI",
      "aiGroupDescription": "Bundle several flows together",
      "manualGroup": "New group · manually",
      "manualGroupDescription": "Name it and add flows yourself",
      "chatManualLink": "Prefer to build it yourself? Create manually"
    },
    "empty": "No flows yet. Create your first flow to get started.",
    "aiGenerate": "AI Generate",
    "aiEdit": "AI Edit",
    "testRun": "Test",
    "run": "Run",
    "testRunStarted": "Agent run started",
    "flowSaved": "Flow saved successfully",
    "testRunError": "Failed to start test run",
    "toggleStatusError": "Failed to update flow status",
    "history": "History",
    "systemFlows": "System flows",
    "myFlows": "My flows",
    "myAgents": "My agents",
    "emptyAgents": "No agents yet. Create your first specialist agent.",
    "showSystemAgents": "Show system agents",
    "showSystemFlows": "Show system flows",
    "createAgent": "New agent",
    "agentCard": {
      "modelTier": "Model: {{tier}}",
      "maxTurns_one": "{{count}} turn",
      "maxTurns_other": "{{count}} turns",
      "toolSets_one": "{{count}} tool set",
      "toolSets_other": "{{count}} tool sets",
      "editAriaLabel": "Edit agent",
      "deleteAriaLabel": "Delete agent",
      "duplicateAriaLabel": "Duplicate agent template",
      "duplicateConfirmTitle": "Duplicate template",
      "duplicateConfirmDescription": "Create an editable copy of \"{{name}}\"?",
      "duplicateConfirmButton": "Duplicate",
      "system": "System"
    },
    "systemBadge": "System",
    "setupBadge": "Setup",
    "status": {
      "active": "Active",
      "stopped": "Stopped",
      "needsAttention": "Needs setup"
    },
    "setupRunningBanner": {
      "title": "Setting up your workspace",
      "description": "Other flows are on hold until this one-time setup finishes."
    },
    "hub": {
      "discover": "Discovery",
      "ownership": {
        "mine": "My flows",
        "team": "Team flows"
      },
      "filters": {
        "paused": "Paused"
      },
      "modeBadge": {
        "runsOnItsOwn": "Runs on its own",
        "agent": "Agent"
      },
      "updatedAt": "Updated {{time}}",
      "emptyFiltered": "No flows match these filters.",
      "counts": {
        "running_one": "{{count}} running",
        "running_other": "{{count}} running",
        "agents_one": "{{count}} agent",
        "agents_other": "{{count}} agents",
        "needsAttention_one": "{{count}} needs attention",
        "needsAttention_other": "{{count}} need attention"
      }
    },
    "actions": {
      "run": "Run",
      "edit": "Edit",
      "view": "View",
      "delete": "Delete",
      "duplicate": "Duplicate",
      "toggleStatus": "Toggle status",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "stepsCount_one": "{{count}} step",
    "stepsCount_other": "{{count}} steps",
    "notifyAssistant": {
      "description": "Post a message into the assistant when this flow runs. The message can include variables from earlier steps.",
      "messageTemplateLabel": "Message",
      "messageTemplatePlaceholder": "e.g. New lead received: {{step1.email}} — review required.",
      "conversationModeLabel": "Target conversation",
      "modeBackgroundTasks": "Shared \"Background tasks\" tab",
      "modeNewEachRun": "New conversation per execution",
      "conversationTitleLabel": "Conversation title",
      "conversationTitlePlaceholder": "e.g. Lead alert — {{step1.name}}"
    },
    "runAssistant": {
      "description": "Run the assistant with a custom prompt. A new conversation is spawned for each execution, and selected tools are auto-approved for the agent run.",
      "promptTemplateLabel": "Prompt",
      "promptTemplatePlaceholder": "e.g. Summarize this email and draft a reply: {{step1.body}}",
      "conversationTitleLabel": "Conversation title (optional)",
      "conversationTitlePlaceholder": "e.g. Email summary — {{step1.subject}}",
      "conversationModeLabel": "Conversation mode",
      "modeNewEachRun": "New conversation per execution",
      "modeBackgroundTasks": "Shared \"Background tasks\" tab (coming soon)",
      "modeReuseSame": "Reuse the same conversation",
      "autoApprovedToolsLabel": "Auto-approved tools",
      "autoApprovedToolsPlaceholder": "Add a tool…",
      "removeTool": "Remove tool",
      "nonInteractiveLabel": "Run without asking for confirmation",
      "nonInteractiveHelperText": "For automated flows: actions auto-execute and the run never waits for a human. Only the tools you auto-approve below will run; anything else is skipped. Creating flows or custom agents can never be auto-approved: each one always waits for your confirmation.",
      "closeOnCompleteLabel": "Close conversation when it finishes",
      "closeOnCompleteHelperText": "When the run completes, its conversation is removed from your assistant list (kept in history). Only available with a new conversation per execution.",
      "tools": {
        "act_on_emails": "Email actions (archive, label, etc.)",
        "send_slack_bot_message": "Send Slack message (bot)",
        "send_notification_email": "Send notification email",
        "create_dobox": "Create task",
        "update_dobox": "Update task",
        "resolve_dobox": "Resolve task",
        "accept_dobox_suggestion": "Accept task suggestion",
        "move_dobox": "Move task to list",
        "update_dobox_collections": "Update task labels / collections",
        "create_dobox_label": "Create task label",
        "add_dobox_comment": "Add task comment",
        "delete_dobox": "Delete task",
        "update_task_group_participants": "Update list participants",
        "create_task_group": "Create task list",
        "act_on_calendar_invites": "Act on calendar invites (RSVP)",
        "create_calendar_event": "Create calendar event",
        "create_email_label": "Create email label",
        "run_flow_now": "Run a flow",
        "request_from_teammate": "Request from teammate",
        "propose_flow": "Propose a flow",
        "propose_custom_agent": "Propose a custom agent",
        "execute_create_knowledge_space": "Create knowledge space",
        "execute_create_knowledge_page": "Create knowledge page",
        "execute_edit_knowledge_page": "Edit knowledge page",
        "execute_rename_knowledge_page": "Rename knowledge page",
        "execute_delete_knowledge_page": "Delete knowledge page",
        "facebook_reply_comment": "Reply to Facebook comment",
        "facebook_publish_post": "Publish Facebook post",
        "instagram_reply_comment": "Reply to Instagram comment",
        "instagram_publish_post": "Publish Instagram post",
        "gbp_reply_review": "Reply to Google Business Profile review"
      }
    },
    "askUser": {
      "description": "Pause the flow and ask the user to choose from a list of options. The selected option is available as a variable in downstream steps.",
      "messageTemplate": {
        "label": "Question",
        "placeholder": "e.g. How should I handle this email? Context: {{step1.subject}}"
      },
      "options": {
        "label": "Options",
        "optionPlaceholder": "Option {{number}}",
        "optionAriaLabel": "Option {{number}}",
        "removeOption": "Remove option {{number}}",
        "addOption": "Add option",
        "minHint": "Minimum 2 options required"
      },
      "conversationModeLabel": "Target conversation",
      "modeBackgroundTasks": "Shared \"Background tasks\" tab",
      "modeHelpText": "ASK_USER always targets the shared Background tasks conversation.",
      "conversationTitleLabel": "Conversation title (optional)",
      "conversationTitlePlaceholder": "e.g. Action required — {{step1.subject}}"
    },
    "approvalGate": {
      "description": "Pause the flow and wait for a user to approve or reject in their DoBox. The decision is available as a variable in downstream steps.",
      "titleLabel": "Approval card title (optional)",
      "titlePlaceholder": "e.g. Approve reply to {{step1.subject}}",
      "summaryPromptLabel": "Summary prompt",
      "summaryPromptPlaceholder": "e.g. Summarize what needs approval: {{step1.subject}}",
      "taskGroupLabel": "Target DoBox list",
      "taskGroupPlaceholder": "Owner's default DoBox",
      "taskGroupDescription": "Leave empty to create the approval in the flow owner's default DoBox. Choose a shared list to let others approve."
    },
    "executionHistory": {
      "title": "Execution history",
      "empty": "No executions recorded yet. Executions will appear here after the flow is triggered.",
      "loadMore": "Load more",
      "refresh": "Refresh",
      "refreshing": "Refreshing",
      "history": "History",
      "noSubject": "(No subject)",
      "duration": "{{ms}}ms",
      "steps": "Steps",
      "iterations": "Iterations",
      "iterationLabel": "Iteration {{number}}",
      "output": "Output",
      "error": "Error",
      "triggeredBy": "Triggered by {{triggerKey}}",
      "refusedRecipients_one": "{{count}} recipient was removed: only addresses typed in the flow, connected mailboxes, teammates or address-book contacts receive flow emails.",
      "refusedRecipients_other": "{{count}} recipients were removed: only addresses typed in the flow, connected mailboxes, teammates or address-book contacts receive flow emails.",
      "status": {
        "RUNNING": "Running",
        "SUCCESS": "Success",
        "PARTIAL_FAILURE": "Partial failure",
        "FAILURE": "Failed",
        "TIMEOUT": "Timed out",
        "WAITING_FOR_REPLY": "Waiting for reply",
        "REJECTED": "Rejected"
      },
      "stepStatus": {
        "SUCCESS": "Success",
        "FAILURE": "Failed",
        "SKIPPED": "Skipped",
        "TIMEOUT": "Timed out"
      }
    },
    "generator": {
      "upgrade": {
        "title": "This looks like a group objective",
        "reason": "I'd create {{count}} flows:",
        "createAsGroup": "Create as group",
        "keepAsSingleFlow": "Keep as single flow"
      }
    },
    "groups": {
      "examplePrompts": {
        "projectManager": "Create a project manager that clarifies tasks, searches for information, and schedules daily follow-ups",
        "salesPipeline": "Organize my sales inbox: classify leads, auto-reply to common questions, and send a daily pipeline report"
      },
      "systemEvents": {
        "flowMovedIn": "Flow '{{name}}' moved in",
        "flowMovedOut": "Flow '{{name}}' moved out",
        "flowCreated": "Flow '{{name}}' created",
        "flowDeleted": "Flow '{{name}}' deleted",
        "groupActivated": "Group activated",
        "groupPaused": "Group paused",
        "groupMetadataUpdated": "Group details updated"
      },
      "sectionTitle": "{{name}}",
      "ungroupedTitle": "Ungrouped",
      "memberCount_one": "{{count}} flow",
      "memberCount_other": "{{count}} flows",
      "memberCount": "{{count}} flows",
      "collapse": "Collapse",
      "expand": "Expand",
      "comingSoon": "Coming soon",
      "toggleError": "Failed to update group status",
      "deleteSuccess": "Group deleted",
      "deleteError": "Failed to delete group",
      "active": "Active",
      "paused": "Paused",
      "createdFromGroup": "Created from group '{{name}}'",
      "menu": {
        "rename": "Rename",
        "editObjective": "Edit objective",
        "delete": "Delete group",
        "openEditor": "Open editor",
        "openMenu": "Group actions",
        "moveToGroup": "Move to group...",
        "moveToGroupError": "Failed to move flow",
        "removeFromGroup": "Remove from group",
        "removeFromGroupError": "Failed to remove flow from group",
        "newGroup": "+ New group…",
        "ungrouped": "📂 Ungrouped"
      },
      "delete": {
        "confirmTitle": "Delete group?",
        "keepFlows": "Keep member flows (recommended)",
        "deleteAll": "Also delete {{count}} member flows",
        "confirm": "Delete",
        "cancel": "Cancel"
      },
      "deleteWithFlows": {
        "title": "Delete group and its flows?",
        "description": "This will permanently delete this group and all {{count}} flow(s) inside it. This cannot be undone."
      },
      "editor": {
        "backToFlows": "← Flows",
        "createGroup": "Create group",
        "addFlow": "Add flow",
        "unlinkFlow": "Remove from group",
        "editFlow": "Edit flow",
        "objectivePlaceholder": "What's the objective of this group?",
        "namePlaceholder": "Group name",
        "chatPlaceholder": "Describe the objective you want to achieve…",
        "toggleSidebar": "Toggle AI assistant",
        "aiChat": "AI Chat",
        "patchApplied": "Changes applied successfully",
        "patchDiscarded": "Changes discarded",
        "createSuccess": "Group created successfully",
        "createError": "Failed to create group",
        "deleteGroup": "Delete group",
        "createdFromGroup": "Created from group",
        "rename": "Rename group",
        "editObjective": "Edit objective"
      },
      "preview": {
        "title": "Group preview",
        "stepsCount_one": "{{count}} step",
        "stepsCount_other": "{{count}} steps",
        "createButton": "Create group",
        "emptyState": "Describe your objective to generate flows"
      },
      "patch": {
        "title": "Suggested changes",
        "adding": "Adding",
        "removing": "Removing",
        "updating": "Updating",
        "groupChanges": "Group changes",
        "apply": "Apply changes",
        "discard": "Discard",
        "applied": "Flows updated in the group",
        "error": "Failed to apply changes to the group"
      },
      "moveDialog": {
        "title": "Move to group",
        "description": "Select a group to move this flow into",
        "searchPlaceholder": "Search groups...",
        "emptyState": "No groups found",
        "cancel": "Cancel"
      },
      "createModal": {
        "title": "New group",
        "nameLabel": "Name",
        "namePlaceholder": "Group name",
        "objectiveLabel": "Objective",
        "objectivePlaceholder": "What's the objective of this group?",
        "submit": "Create group",
        "cancel": "Cancel",
        "nameRequired": "Please enter a group name"
      }
    },
    "teamFlows": "Team flows",
    "teamAgents": "Team agents",
    "team": {
      "picker": "Team",
      "allTeams": "All teams",
      "ownerBadgeYou": "You",
      "unknownMember": "Unknown member",
      "makeTeamFlow": "Make this a team flow",
      "selectTeam": "Select team",
      "managedByGroup": "Managed by group",
      "managedByGroupHint": "This flow's team is managed by its group. Move it out of the group to change its team.",
      "emptyNoTeam": "You are not a member of any team.",
      "empty": "No team flows yet.",
      "ownerLabel": "Owner",
      "makeTeamAgent": "Share this agent with your team",
      "emptyAgents": "No team agents yet.",
      "mcpAgentHint": "MCP connections are personal. Teammates running this agent won't have access to your MCP tools.",
      "mcpAgentRunHint": "Uses the owner's personal MCP connections — they won't apply in your flows.",
      "teamAgentMeta": "Shared by {{owner}}"
    }
  },
  "discover": {
    "title": "Discover templates",
    "backToFlows": "Back to flows",
    "eyebrow": "Flow Templates",
    "heroTitle": "Automate your workflow with this+that",
    "heroTitlePrefix": "Automate your workflow with",
    "heroDescription": "Streamline your inbox and manage tasks with AI-powered flows",
    "generator": {
      "eyebrow": "Flow Generator",
      "title": "What do you want to automate?",
      "description": "Describe the automation in your own words — the assistant drafts the flow, then you refine it together.",
      "inputPlaceholder": "e.g. Summarize our Slack channels into a daily digest…",
      "submitAriaLabel": "Generate flow",
      "examples": {
        "slackDigest": "Summarize Slack channels into a daily digest",
        "competitorMonitor": "Monitor competitor sites every week",
        "shipDigest": "Document what shipped each day",
        "emailToTask": "Turn important emails into DoBox tasks"
      }
    },
    "searchPlaceholder": "Describe what you want to automate...",
    "expandedTitle": "Describe a task for this+that",
    "expandedPlaceholder": "Describe what tasks to do, which apps to use, and when to do them",
    "editTitle": "Describe what you want to change",
    "editPlaceholder": "Describe what you want to change...",
    "editButton": "Apply changes",
    "tryExamplePrompts": "Try example prompts",
    "examplePrompts": {
      "dailySummary": "Send me a daily summary of unread emails",
      "labelEmails": "Label emails with action items",
      "slackDigest": "Catch me up on Slack messages",
      "followUp": "Track emails that need follow-up"
    },
    "createButton": "Create",
    "generateButton": "Generate flow",
    "generateError": "Failed to generate flow. Please try again.",
    "clarification": {
      "title": "A few more details",
      "subtitle": "Help us build the perfect flow for you",
      "backButton": "Back",
      "selectPlaceholder": "Select an option",
      "textPlaceholder": "Type your answer...",
      "optional": "optional",
      "reviewConfirmation": {
        "create": "Yes, create the agent",
        "update": "Yes, update the agent",
        "requestChanges": "No, I want to make changes"
      },
      "knowledgePagePicker": {
        "spaceLabel": "Brain space",
        "spacePlaceholder": "Select a space…",
        "pageLabel": "Page",
        "pagePlaceholder": "Select a page…",
        "pageHint": "Optional — leave blank to use the whole space."
      }
    },
    "useTemplateSuccess": "Flow created successfully",
    "useTemplateError": "Failed to create flow from template",
    "turnOn": "Turn on",
    "preview": "Try now",
    "view": "View",
    "active": "Active",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "paused": "Paused",
    "pausedNote": "This workflow already exists but is paused. Reactivate it from the My Flows tab.",
    "openWorkflow": "Open workflow",
    "openFlow": "Open flow",
    "setUpAgain": "Set up again",
    "setUpAgainConfirmTitle": "Set up this template again?",
    "setUpAgainConfirmBodyWorkflow": "A workflow was already created from this template. Continuing will create a separate copy alongside it.",
    "setUpAgainConfirmBodyFlow": "A flow was already created from this template. Continuing will create a separate copy alongside it.",
    "setUpAgainConfirmAction": "Create a copy",
    "allCategories": "All",
    "categories": {
      "email_boosters": "Email boosters",
      "dobox_tasks": "DoBox & Tasks boosters",
      "slack_automation": "Slack boosters",
      "daily_summaries": "Daily summaries",
      "workflows": "Workflows",
      "agents": "Agents"
    },
    "flowCount_one": "{{count}} flow",
    "flowCount_other": "{{count}} flows",
    "searchTemplates": "Search templates…",
    "clearSearch": "Clear search",
    "noResults": "No templates match your search.",
    "templatesLabel": "templates",
    "flowType": "Flow",
    "useTemplate": "Use template",
    "useWorkflow": "Use workflow",
    "viewDetails": "View details",
    "outcomeLabel": "Outcome",
    "objectiveLabel": "Objective",
    "scheduleLabel": "Schedule",
    "integrationsLabel": "Integrations",
    "featuredWorkflow": "Featured workflow",
    "spotlight": {
      "previous": "Previous featured workflow",
      "next": "Next featured workflow",
      "goToSlide": "Go to featured workflow {{index}}",
      "carouselLabel": "Featured workflows"
    },
    "flowsInWorkflow": "Flows in this workflow",
    "howItWorks": "How it works",
    "connectedApps": "Connected apps",
    "workflows": {
      "company-brain": {
        "title": "Company Brain",
        "description": "Build a living knowledge base from your codebase, emails, and optionally your public Slack channels — decisions and architecture captured automatically, with private-source updates gated by DoBox approval.",
        "objective": "Give the whole team instant access to decisions, architecture, and company context — captured automatically from your codebase and email, plus public Slack channels if you choose them, with private-source updates gated by DoBox approval.",
        "outcome": "A structured, always-current Brain space: decisions logged, architecture documented, and company context up to date — with private-source updates safely gated by DoBox approval.",
        "schedule": "Monitors on your chosen cadence",
        "flows": {
          "0": {
            "name": "Initial Brain seed",
            "strip": {
              "seed": "Seed Brain",
              "analyse": "AI analyse"
            }
          },
          "1": {
            "name": "Ongoing Brain monitor",
            "strip": {
              "schedule": "Scheduled",
              "monitor": "Monitor Slack"
            }
          },
          "2": {
            "name": "Email proposals",
            "strip": {
              "scan": "Scan emails",
              "propose": "Propose updates"
            }
          },
          "3": {
            "name": "Apply approved proposals",
            "strip": {
              "trigger": "DoBox approved",
              "apply": "Apply to Brain"
            }
          }
        },
        "landsIn": "Your Brain space, kept up to date automatically — plus a DoBox queue for anything that needs your approval first",
        "needs": "Optional: public Slack channels to monitor · DoBox approvals for private-source updates"
      },
      "competitor-intelligence": {
        "title": "Competitor Intelligence",
        "description": "Monitor competitors, analyse news and alerts, and surface weekly insights to your team automatically.",
        "objective": "Stay ahead of competitors without spending hours on manual research. Get a structured weekly report delivered to Slack.",
        "outcome": "A weekly Slack briefing with competitor news, product launches, and market signals — zero manual effort.",
        "schedule": "Weekly on Monday mornings",
        "integrations": {
          "slack": "Slack"
        },
        "flows": {
          "0": {
            "name": "Seed competitor pages",
            "strip": {
              "seed": "Seed pages",
              "research": "AI research"
            }
          },
          "1": {
            "name": "Competitor monitor",
            "strip": {
              "schedule": "Scheduled",
              "research": "AI research"
            }
          },
          "2": {
            "name": "Features & pricing monitor",
            "strip": {
              "scan": "Web scan",
              "updates": "AI updates"
            }
          },
          "3": {
            "name": "Weekly insight report",
            "strip": {
              "report": "Compile report",
              "share": "Post to Slack"
            }
          }
        },
        "landsIn": "A weekly report in Slack, plus your Brain space",
        "needs": "Web search (Tavily) · a list of competitor sites"
      },
      "ship-log": {
        "title": "Ship Log",
        "description": "Automatically document what shipped each day, track open tasks, and produce a weekly engineering digest.",
        "objective": "Give every team member a clear record of what was delivered, what is in progress, and what needs attention — without writing it manually.",
        "outcome": "A living ship log updated daily and a weekly digest shared to Slack — keeping the whole team aligned.",
        "schedule": "Daily evenings, digest on Mondays",
        "integrations": {
          "email": "Email",
          "slack": "Slack"
        },
        "landsIn": "Your Brain space, plus a weekly digest to Slack or email — architecture and direction changes also land in the Company Brain when it is installed",
        "needs": "A connected GitHub repository",
        "flows": {
          "0": {
            "name": "Daily activity summariser",
            "strip": {
              "schedule": "Every evening",
              "summarise": "AI summarise"
            }
          },
          "1": {
            "name": "Weekly engineering digest",
            "strip": {
              "digest": "Compile digest",
              "share": "Post to Slack"
            }
          }
        }
      },
      "daily-briefing": {
        "title": "Daily Briefing",
        "description": "Start every morning with a crisp briefing of your agenda, emails, Slack highlights and open tasks — delivered to the channels you choose.",
        "objective": "Replace inbox overload with one structured morning briefing so nothing important slips through.",
        "outcome": "A daily morning briefing delivered automatically to your Brain, DoBox, email or Slack — always in context.",
        "schedule": "Weekday mornings",
        "integrations": {
          "email": "Email",
          "slack": "Slack"
        },
        "flows": {
          "0": {
            "strip": {
              "0": "Weekday mornings",
              "1": "AI briefing across your channels"
            }
          }
        },
        "setupFlows": {
          "briefing": {
            "name": "Daily Briefing",
            "strip": {
              "schedule": "Scheduled",
              "compose": "AI compose"
            }
          }
        },
        "landsIn": "Wherever you choose — Brain, DoBox, Slack, or email",
        "needs": "At least one delivery channel"
      },
      "inbox-autopilot": {
        "title": "Inbox Autopilot",
        "description": "Classify every email, draft replies when needed, draft meeting follow-ups, and get a morning briefing — all without AI chat.",
        "objective": "Reduce manual inbox work by routing, labeling, drafting, and summarizing using deterministic flow steps.",
        "outcome": "A structured inbox: emails classified and labelled on arrival, replies drafted automatically, follow-ups tracked, and a daily digest delivered each morning.",
        "schedule": "Real-time + daily schedule",
        "integrations": {
          "email": "Email",
          "calendar": "Calendar"
        },
        "categories": {
          "toRespond": "To Respond",
          "fyi": "FYI",
          "marketing": "Marketing",
          "notification": "Notification",
          "meetingUpdate": "Meeting Update",
          "awaitingReply": "Awaiting Reply"
        },
        "flows": {
          "0": {
            "name": "Smart triage",
            "strip": {
              "trigger": "New email",
              "classify": "Classify and label",
              "draft": "Draft the reply"
            }
          },
          "1": {
            "name": "Meeting follow-ups",
            "strip": {
              "meetings": "Load meetings",
              "followup": "Draft follow-up"
            }
          },
          "2": {
            "name": "Daily briefing",
            "strip": {
              "load": "Load communications",
              "briefing": "Morning digest"
            },
            "notification": {
              "heading": "Your daily briefing"
            }
          }
        },
        "landsIn": "Your inbox — labeled, drafted, and summarized",
        "needs": "An email account to monitor"
      },
      "manage-distractions": {
        "title": "Distraction Remover",
        "description": "Automatically archive promotional, forum, and social emails as they arrive, then get a weekday report of what was filtered so nothing slips by unnoticed.",
        "objective": "Keep your inbox clear of low-priority noise without missing anything important by routing category emails out of sight and surfacing a daily summary.",
        "outcome": "Promotions, forums, and social emails are labeled and archived on arrival. A weekday report lands in your assistant or inbox so you can scan what was filtered at a glance.",
        "schedule": "Real-time + weekday report",
        "integrations": {
          "email": "Email"
        },
        "flows": {
          "0": {
            "name": "Auto-archive distractions",
            "strip": {
              "trigger": "Distraction email arrives",
              "label": "Label and archive"
            }
          },
          "1": {
            "name": "Daily distraction report",
            "strip": {
              "load": "Load archived distractions",
              "report": "Generate report"
            }
          }
        },
        "landsIn": "Archived automatically, with a report in your inbox or the assistant",
        "needs": "An email account to monitor"
      },
      "pr-review-copilot": {
        "title": "PR Review Copilot",
        "description": "An AI review lands on every pull request the moment it opens, reviewers get pinged instantly, and stale PRs get a nudge before they're forgotten.",
        "objective": "Cut the time pull requests sit waiting for feedback by giving every PR an instant first-pass review and keeping reviewers and authors nudged until it lands.",
        "outcome": "Every PR gets an AI review and a Slack ping the moment it needs attention, plus a daily nudge for anything going stale.",
        "schedule": "Real-time on GitHub events, plus stale-PR checks",
        "flows": {
          "0": {
            "name": "AI review on PR opened",
            "strip": {
              "trigger": "PR opened",
              "review": "AI review"
            }
          },
          "1": {
            "name": "Review requested ping",
            "strip": {
              "trigger": "Review requested",
              "notify": "Notify reviewer"
            }
          },
          "2": {
            "name": "Stale PR nudge",
            "strip": {
              "schedule": "Weekday mornings",
              "nudge": "Nudge stale PRs"
            }
          },
          "3": {
            "name": "Review guidelines setup",
            "strip": {
              "inspect": "Inspect repo",
              "write": "Write guidelines"
            }
          }
        },
        "landsIn": "Slack or email for reviews, plus a Code Review Guidelines page in your Brain, kept up to date from your repo",
        "needs": "The GitHub App installed on the repository (this is what delivers the events), plus a GitHub MCP connection for reading the diff, and Slack or email for review notifications"
      },
      "dependency-security": {
        "title": "Dependency Vulnerability Monitor",
        "description": "Monitor Dependabot security alerts, immediately escalate critical and high-severity vulnerabilities, summarize remaining exposure weekly, and follow up on items that exceed their remediation SLA.",
        "objective": "Make sure every Dependabot security alert gets seen and tracked — critical and high severity issues escalated the moment they appear, a full picture of remaining exposure every week, and nothing left open past its SLA without a nudge.",
        "outcome": "High-risk vulnerabilities are escalated immediately, every open alert remains visible until resolved, and overdue security issues are automatically followed up.",
        "schedule": "Polls Dependabot on your schedule, weekly digest every Monday, daily overdue check",
        "flows": {
          "0": {
            "name": "Alert triage & lifecycle",
            "strip": {
              "trigger": "Poll Dependabot alerts",
              "triage": "Triage, notify & track lifecycle"
            }
          },
          "1": {
            "name": "Weekly vulnerability digest",
            "strip": {
              "scan": "Scan all open alerts",
              "digest": "Post digest to Slack"
            }
          },
          "2": {
            "name": "Overdue vulnerability escalation",
            "strip": {
              "schedule": "Daily",
              "reminder": "Escalate overdue alerts"
            }
          }
        },
        "landsIn": "A DoBox for each qualifying alert, plus Slack or email alerts, weekly digests, and overdue escalations",
        "needs": "Dependabot alerts enabled on the repository, a connected GitHub account, plus Slack or email for alerts and digests"
      },
      "bug-intake": {
        "title": "Bug Intake",
        "description": "Every bug report becomes a triaged DoBox ticket with a repro checklist, GitHub issues get mirrored automatically, and merged fixes close the ticket on their own.",
        "objective": "Turn scattered bug reports into a single tracked queue — classified by severity, with repro steps captured, and closed automatically when the fix ships.",
        "outcome": "Bug report pages and GitHub issues both land as DoBox tickets with a repro checklist, and merged pull requests close the matching ticket without anyone touching it.",
        "schedule": "Real-time on bug pages, GitHub issues, and merged PRs",
        "flows": {
          "0": {
            "name": "Bug page triage",
            "strip": {
              "trigger": "Bug page created",
              "triage": "Classify and ticket"
            }
          },
          "1": {
            "name": "GitHub issue mirror",
            "strip": {
              "trigger": "GitHub issue opened",
              "mirror": "Mirror as DoBox"
            }
          },
          "2": {
            "name": "PR merged closes ticket",
            "strip": {
              "trigger": "PR merged",
              "close": "Close matching ticket"
            }
          }
        },
        "landsIn": "A Bug Reports space in the Brain, plus a DoBox ticket per bug",
        "needs": "A team, Slack or email for notifications, and optionally the GitHub App installed on the repository (this is what delivers the events)"
      },
      "incident-response": {
        "title": "Incident Response",
        "description": "Alerts from your monitoring tools and messages in your incidents channel both become tracked DoBox tickets, and a postmortem gets drafted automatically once an incident ticket is resolved.",
        "objective": "Keep every incident signal in one place while it is happening, then turn the resolved ticket into a postmortem without anyone having to write it from scratch.",
        "outcome": "Alerts and incident-channel messages accumulate on a tracked DoBox ticket, and resolving a genuinely incident-related ticket drafts a postmortem page and notifies the team.",
        "schedule": "Real-time on alerts, incident messages, and resolutions",
        "flows": {
          "0": {
            "name": "Alert triage",
            "strip": {
              "trigger": "Alert email arrives",
              "triage": "Track on a DoBox"
            }
          },
          "1": {
            "name": "Incident channel capture",
            "strip": {
              "trigger": "Incident channel message",
              "capture": "Track on a DoBox"
            }
          },
          "2": {
            "name": "Postmortem draft",
            "strip": {
              "trigger": "DoBox resolved",
              "draft": "Draft postmortem"
            }
          }
        },
        "landsIn": "An Incidents space in the Brain, DoBox tickets, and Slack or email notices",
        "needs": "Alert sender domains, plus Slack or email for notices; an incidents Slack channel is optional"
      },
      "team-rituals": {
        "title": "Team Rituals",
        "description": "An async standup posts every weekday, a celebratory brag doc rounds up the week's shipped pull requests, and a monthly retro pack compares the month against the one before.",
        "objective": "Keep the team's lightweight rituals running on their own — standups, weekly wins, and monthly retros — without anyone having to remember to write them.",
        "outcome": "A yesterday/today/blockers standup lands in Slack every weekday, a weekly brag doc celebrates what shipped, and a monthly retro page compares progress month over month.",
        "schedule": "Weekday standups, Friday brag doc, first-of-month retro",
        "flows": {
          "0": {
            "name": "Async standup",
            "strip": {
              "schedule": "Weekday mornings",
              "standup": "Post standup"
            }
          },
          "1": {
            "name": "Friday brag doc",
            "strip": {
              "schedule": "Fridays 4pm",
              "brag": "Celebrate the week"
            }
          },
          "2": {
            "name": "Monthly retro pack",
            "strip": {
              "schedule": "1st of the month",
              "retro": "Compile retro"
            }
          }
        },
        "landsIn": "A Team Rituals space in the Brain, plus Slack or email updates",
        "needs": "A connected GitHub repository, plus Slack or email for rituals updates"
      },
      "engineering-knowledge": {
        "title": "Docs & Knowledge",
        "description": "Questions asked in the dev-help channel get answered straight from the Brain, new decision docs get announced in Slack, and GitHub issues tagged needs-spec turn into a drafted spec page automatically.",
        "objective": "Keep engineering knowledge answered, announced, and drafted without anyone chasing it down — dev-help questions get sourced answers, new docs get broadcast, and needs-spec issues get a starting point.",
        "outcome": "Dev-help questions get an answer from the Brain or a tracked FAQ draft, every new doc in Engineering Docs gets a 3-line Slack summary, and needs-spec issues land as a drafted spec page.",
        "schedule": "Real-time on questions, new docs, and needs-spec issues",
        "flows": {
          "0": {
            "name": "Dev-help FAQ bot",
            "strip": {
              "trigger": "Question in dev-help",
              "answer": "Search Brain, answer or draft"
            }
          },
          "1": {
            "name": "ADR announcer",
            "strip": {
              "trigger": "New doc published",
              "announce": "Summarize and notify"
            }
          },
          "2": {
            "name": "Issue needs-spec",
            "strip": {
              "trigger": "Issue tagged needs-spec",
              "draft": "Draft spec page"
            }
          }
        },
        "landsIn": "An Engineering Docs space in the Brain, plus Slack or email notices",
        "needs": "Slack or email for notifications, and a team; a dev-help Slack channel is optional, and the needs-spec flow needs the GitHub App installed on the repository (this is what delivers the events)"
      },
      "release-notes": {
        "title": "Release Notes",
        "description": "Every published release gets its changelog rewritten in customer-facing language and queued for a teammate's review before it goes out to Slack, email, and the Brain.",
        "objective": "Turn a raw GitHub changelog into customer-ready release notes automatically, with a human review gate before anything reaches customers.",
        "outcome": "A drafted, customer-facing release notes page and a review ticket appear the moment a release is published; once a teammate approves it, the notes post to Slack, the release page is finalized, and stakeholders get it by email if configured.",
        "schedule": "Real-time on matching GitHub releases and review approvals",
        "flows": {
          "0": {
            "name": "Draft release notes for review",
            "strip": {
              "trigger": "Release published",
              "draft": "Draft and request review"
            }
          },
          "1": {
            "name": "Publish on approval",
            "strip": {
              "trigger": "Review approved",
              "publish": "Post to Slack and email"
            }
          }
        },
        "landsIn": "A Releases space in the Brain, a Slack or email notice, and optionally a stakeholder email",
        "needs": "A tag pattern, the GitHub App installed on the repository (this is what delivers the events), Slack or email for release notices, and a team"
      },
      "inbound-response-desk": {
        "title": "Inbound Response Desk",
        "description": "Sorts everything that lands in your marketing inbox and gets the leads that matter in front of sales while they are still warm.",
        "objective": "Every message reaching the marketing address is classified, routed and answered inside the window that still converts — demos in minutes, press in hours, vendor pitches never.",
        "outcome": "Every demo request reaches the sales channel within minutes, and vendor pitches stop competing for your attention with real inbound.",
        "schedule": "On every inbound email, with a weekly recap",
        "landsIn": "Slack for hot leads, your inbox as labels and drafts, DoBox for the follow-ups",
        "needs": "Gmail or Outlook · Slack · DoBox · Brain",
        "categories": {
          "demo": "Demo request",
          "press": "Press",
          "partnership": "Partnership",
          "vendor": "Vendor pitch",
          "community": "Community"
        },
        "flows": {
          "0": {
            "name": "Sort the marketing inbox",
            "strip": {
              "trigger": "On new email",
              "classify": "Classify and label",
              "handoff": "Hand off hot leads",
              "draft": "Draft the reply"
            }
          },
          "1": {
            "name": "Weekly inbound recap",
            "strip": {
              "load": "Load the week",
              "recap": "Write the recap"
            }
          }
        }
      },
      "content-operations": {
        "title": "Content Operations",
        "description": "Keeps your content strategy, your briefs and your repurposed derivatives in one place, so the pre-writing work never starts from a blank page.",
        "objective": "Take the two expensive halves of content production off your hands — the research before writing and the redistribution after publishing — both anchored to the same written strategy.",
        "outcome": "Your writers get a finished brief instead of a topic, and every published asset comes back as a set of channel-ready derivatives.",
        "schedule": "Weekly briefs, repurposing on publish, monthly audit",
        "landsIn": "Your Brain as strategy, briefs and derivatives, with the queue in Slack",
        "needs": "Brain · Slack · web search connection (Tavily) · Gmail or Outlook. The label has to be applied on arrival — set up a filter in your mail provider, since a label added by hand later does not start the flow.",
        "flows": {
          "0": {
            "name": "Seed the content strategy",
            "strip": {
              "seed": "Seed the space",
              "research": "Research clusters"
            }
          },
          "1": {
            "name": "Build this week's briefs",
            "strip": {
              "research": "Research the SERP",
              "briefs": "Write the briefs"
            }
          },
          "2": {
            "name": "Repurpose what we published",
            "strip": {
              "trigger": "On Published label",
              "repurpose": "Build derivatives"
            }
          },
          "3": {
            "name": "Monthly content gap audit",
            "strip": {
              "audit": "Audit coverage",
              "share": "Post to Slack"
            }
          }
        }
      },
      "approval-chaser": {
        "title": "Approval Chaser",
        "description": "Chase every approver on a task until it is signed off, and report exactly who is blocking it.",
        "objective": "Stop being the reminder system. Every approver is asked directly, every answer is recorded, and the person blocking is named instead of guessed.",
        "outcome": "You stop being the reminder system — the status of every approver is visible without you asking anyone.",
        "schedule": "When a DoBox task is created",
        "landsIn": "Slack as the questions, DoBox as the running status",
        "needs": "Slack · DoBox",
        "flows": {
          "0": {
            "name": "Chase the approvers",
            "strip": {
              "ask": "Ask each approver",
              "track": "Track the answers"
            }
          }
        }
      },
      "account-pulse": {
        "title": "Account Pulse",
        "description": "Keeps one living page per account in your Brain, warns you when an account goes quiet, and writes the QBR brief for you.",
        "objective": "Replace the \"last interaction\" spreadsheet and the pre-QBR dig with a per-account state that updates itself from email, Slack and calendar.",
        "outcome": "You walk into every customer call with a one-page brief you did not spend three hours building.",
        "schedule": "Daily risk sweep, weekly recap, briefs on demand",
        "landsIn": "Your Brain as one page per account, with alerts in Slack and tasks in DoBox",
        "needs": "Gmail or Outlook · Slack · Calendar · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Seed account pages",
            "strip": {
              "seed": "Create the pages",
              "accounts": "Fill from history"
            }
          },
          "1": {
            "name": "Weekly account recap",
            "strip": {
              "schedule": "Every Monday",
              "update": "Update the pages"
            }
          },
          "2": {
            "name": "Daily risk sweep",
            "strip": {
              "sweep": "Check for silence",
              "task": "Open the outreach"
            }
          },
          "3": {
            "name": "QBR brief",
            "strip": {
              "gather": "Gather the period",
              "brief": "Write the brief"
            }
          }
        }
      },
      "customer-onboarding-cockpit": {
        "title": "Customer Onboarding Cockpit",
        "description": "Turns every new customer into a tracked onboarding plan, with the deal context already written down and stalled steps chased for you.",
        "objective": "Close the gap between signed contract and first value delivered — the point where kickoff slips a week or two and a blocked task costs another fortnight.",
        "outcome": "Kickoff happens with the context already in hand, and nothing sits blocked for two weeks without someone noticing.",
        "schedule": "On the New Customer label, swept daily, reported Fridays",
        "landsIn": "A kickoff page in your Brain, the plan in DoBox, chases in Slack and email",
        "needs": "Gmail or Outlook · Slack · Brain · DoBox. The label has to be applied on arrival — set up a filter in your mail provider, since a label added by hand later does not start the flow.",
        "flows": {
          "0": {
            "name": "Kickoff pack",
            "strip": {
              "trigger": "On New Customer",
              "plan": "Build the plan"
            }
          },
          "1": {
            "name": "Stalled step sweep",
            "strip": {
              "sweep": "Find what stalled",
              "chase": "Chase the owner"
            }
          },
          "2": {
            "name": "Time-to-value report",
            "strip": {
              "report": "Compile the state",
              "share": "Post to Slack"
            }
          }
        }
      },
      "month-end-close": {
        "title": "Month-End Close Coordinator",
        "description": "Runs your month-end close checklist end to end — chases owners for accruals and variance explanations, and posts a daily close status to Slack.",
        "objective": "Turn the close spreadsheet into a process that runs itself during the close window, with the owners actively chased and one single place to see status.",
        "outcome": "You stop being the reminder engine: the close checklist chases itself and you see what is blocked before it blocks you.",
        "schedule": "Accruals at cut-off, daily standup, variance at D+3",
        "landsIn": "Slack for the questions and the standup, Brain for the log, DoBox for the tasks",
        "needs": "Slack · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Seed the close checklist",
            "strip": {
              "read": "Read the checklist",
              "tasks": "Create the tasks"
            }
          },
          "1": {
            "name": "Cut-off and accruals request",
            "strip": {
              "ask": "Ask the owners",
              "log": "Write the log"
            }
          },
          "2": {
            "name": "Daily close standup",
            "strip": {
              "schedule": "Every morning",
              "standup": "Post the status"
            }
          },
          "3": {
            "name": "Variance commentary chase",
            "strip": {
              "ask": "Ask for the why",
              "consolidate": "Consolidate by line"
            }
          }
        }
      },
      "contract-renewal-radar": {
        "title": "Contract Renewal Radar",
        "description": "Builds a register of every vendor contract from your inbox and warns you before each cancellation window closes.",
        "objective": "The email already holds the truth about your contracts — order forms, annual invoices, renewal notices. Pull that truth into a living register and raise the alarm inside the notice window, not after the invoice.",
        "outcome": "No contract ever auto-renews because nobody saw the notice window.",
        "schedule": "Daily alarm, quarterly commitment review",
        "landsIn": "A contract register in your Brain, alerts in Slack, decisions in DoBox",
        "needs": "Gmail or Outlook · Slack · Brain · DoBox. The label has to be applied on arrival — set up a filter in your mail provider, since a label added by hand later does not start the flow.",
        "flows": {
          "0": {
            "name": "Seed the contract register",
            "strip": {
              "seed": "Build the register",
              "scan": "Scan 12 months"
            }
          },
          "1": {
            "name": "Renewal mail catcher",
            "strip": {
              "trigger": "On Contracts label",
              "update": "Update the vendor"
            }
          },
          "2": {
            "name": "Notice window alarm",
            "strip": {
              "alarm": "Check the deadlines",
              "task": "Ask for a decision"
            }
          },
          "3": {
            "name": "Quarterly commitment review",
            "strip": {
              "review": "Sum the quarter",
              "share": "Post to Slack"
            }
          }
        }
      },
      "ops-pulse": {
        "title": "Ops Pulse",
        "description": "Asks every project owner the same three questions on Slack, waits for their answers, and publishes one structured weekly operations report.",
        "objective": "Replace the manual loop of individual DMs, a tracking spreadsheet and copy-paste into a doc with an automatic cycle of collect, consolidate and publish — with the project register living in the Brain as the single source.",
        "outcome": "Your weekly ops report writes itself from real answers, and you stop spending Wednesday afternoon in fifteen separate DMs.",
        "schedule": "Collection midweek, report the next day",
        "landsIn": "Slack as the report, your Brain as the register and the weekly history",
        "needs": "Slack · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Seed the project register",
            "strip": {
              "seed": "Create the register",
              "register": "One line per project"
            }
          },
          "1": {
            "name": "Collect status from owners",
            "strip": {
              "ask": "Ask each owner",
              "record": "Record the answers"
            }
          },
          "2": {
            "name": "Assemble and publish the pulse",
            "strip": {
              "assemble": "Build the report",
              "publish": "Post to Slack"
            }
          },
          "3": {
            "name": "Open a DoBox for every blocker",
            "strip": {
              "blockers": "Find the blockers",
              "task": "Open the task"
            }
          }
        }
      },
      "okr-check-in": {
        "title": "OKR Check-in",
        "description": "Asks every key result owner for the current number and the reason behind it, then publishes what is on pace and what is not.",
        "objective": "Stop OKRs dying in week nine because nobody looked in week six. Each cycle the numbers are collected from the people who own them and measured against the pace needed to land.",
        "outcome": "Every key result has a current number with a date on it, and being behind shows up while there is still time to act.",
        "schedule": "Every two weeks, or monthly",
        "landsIn": "Your Brain as the register and each dated check-in, with the short version in Slack",
        "needs": "Slack · Brain",
        "flows": {
          "0": {
            "name": "Seed the OKR register",
            "strip": {
              "seed": "Create the register",
              "objectives": "Objectives and KRs"
            }
          },
          "1": {
            "name": "Collect the current numbers",
            "strip": {
              "ask": "Ask each owner",
              "record": "Record the numbers"
            }
          },
          "2": {
            "name": "Publish the check-in",
            "strip": {
              "compute": "Measure the pace",
              "publish": "Post to Slack"
            }
          }
        }
      },
      "onboarding-runway": {
        "title": "Onboarding Runway",
        "description": "Turns every new hire's start date into a ready-made 30-day runway across calendar, tasks and Slack.",
        "objective": "Turn the onboarding checklist — the one that lives in a hand-copied template today — into flows that fire themselves from a start date recorded once.",
        "outcome": "Every new hire gets the same well-run first month without you rebuilding the checklist from scratch.",
        "schedule": "Checked daily against each start date",
        "landsIn": "DoBox and your calendar, with a page per hire in your Brain and the welcome in Slack",
        "needs": "Google or Outlook Calendar · Slack · Brain · DoBox. There is no date trigger — a daily sweep reads the start dates from the Brain.",
        "flows": {
          "0": {
            "name": "New hire intake",
            "strip": {
              "intake": "Collect the details",
              "tasks": "Open the D-7 tasks"
            }
          },
          "1": {
            "name": "Week-one schedule builder",
            "strip": {
              "schedule": "Find who starts",
              "weekone": "Book week one"
            }
          },
          "2": {
            "name": "Day-one welcome",
            "strip": {
              "announce": "Introduce them",
              "welcome": "Send the welcome"
            }
          },
          "3": {
            "name": "Milestone check-in chaser",
            "strip": {
              "checkin": "Open the check-in",
              "ask": "Ask how it is going"
            }
          }
        }
      },
      "hiring-loop": {
        "title": "Hiring Loop",
        "description": "Keeps every open role moving: triages incoming applications, chases interview feedback, and assembles the debrief packet.",
        "objective": "Close the three gaps that stall a funnel: an application nobody read, an interview that never became a scorecard, and a committee that starts without the data on the table.",
        "outcome": "You walk into the hiring committee with every scorecard already collected, summarised and contrasted.",
        "schedule": "On each application, chased daily, debrief on committee day",
        "landsIn": "Your Brain as candidate and debrief pages, DoBox for decisions, Slack for the chasing",
        "needs": "Gmail or Outlook · Calendar · Slack · Brain · DoBox. The label has to be applied on arrival — set up a filter in your mail provider, since a label added by hand later does not start the flow.",
        "flows": {
          "0": {
            "name": "Application intake",
            "strip": {
              "trigger": "On Candidates label",
              "screen": "Write the note"
            }
          },
          "1": {
            "name": "Interview feedback chaser",
            "strip": {
              "interviews": "Read today's interviews",
              "chase": "Chase the scorecard"
            }
          },
          "2": {
            "name": "Debrief packet",
            "strip": {
              "assemble": "Collect the scorecards",
              "contrast": "Surface disagreement"
            }
          },
          "3": {
            "name": "Candidate silence alert",
            "strip": {
              "silence": "Find the silence",
              "draft": "Draft the update"
            }
          }
        }
      },
      "legal-request-desk": {
        "title": "Legal Request Desk",
        "description": "Turn scattered legal requests from Slack and email into one tracked queue, with the missing details collected before anyone opens a document.",
        "objective": "Replace intake-by-DM without asking the business to learn a new tool. The request is still made where it is already made — what changes is that it becomes complete, tracked and visible.",
        "outcome": "Every legal request arrives complete, lands in one queue, and you know each morning whose court the ball is in.",
        "schedule": "On intake mail and on every request in the channel, standup each morning",
        "landsIn": "DoBox as the queue, a private Slack channel for the standup, the original thread for what is missing",
        "needs": "Gmail or Outlook · Slack · Brain · DoBox. The label has to be applied on arrival — set up a filter in your mail provider, since a label added by hand later does not start the flow.",
        "flows": {
          "0": {
            "name": "Intake from email",
            "strip": {
              "trigger": "On Legal/Intake",
              "matter": "Open the matter"
            }
          },
          "1": {
            "name": "Intake from Slack",
            "strip": {
              "sweep": "On channel message",
              "matter": "Open the matter"
            }
          },
          "2": {
            "name": "Queue standup",
            "strip": {
              "load": "Load the queue",
              "standup": "Post the standup"
            }
          },
          "3": {
            "name": "Answered before",
            "strip": {
              "search": "Search the playbook",
              "answer": "Answer or escalate"
            }
          }
        }
      },
      "payment-change-guard": {
        "title": "Payment Change Guard",
        "description": "Quarantines any email asking to change bank details, runs the fraud checks, and holds the change behind a human approval.",
        "objective": "Invoice fraud succeeds on an email thread nobody verified out of band. This makes the verification a step the payment cannot skip, rather than a habit that holds until the week someone is busy.",
        "outcome": "No bank detail change is actioned on an email alone, and a skipped check is visible rather than silent.",
        "schedule": "On every payment-change request",
        "landsIn": "A quarantine label on the message, an alert in the finance channel, and an approval task holding the callback steps",
        "needs": "Gmail or Outlook · Slack · DoBox",
        "flows": {
          "0": {
            "name": "Quarantine and verify a payment change",
            "strip": {
              "detect": "Spot the request",
              "verify": "Run the checks",
              "hold": "Hold for a human"
            }
          }
        }
      },
      "support-triage-desk": {
        "title": "Support Triage Desk",
        "description": "Labels, queues and drafts a first reply for every message arriving in the shared support inbox, so a human opens a worked queue instead of a pile.",
        "objective": "The shared inbox is where support debt accumulates invisibly. This makes the state of every message explicit the moment it lands, rather than when someone finally scrolls to it.",
        "outcome": "Every support message arrives labelled, queued and — when it is straightforward — already drafted.",
        "schedule": "On every message in the support inbox",
        "landsIn": "Labels on the message, a DoBox task per request, a draft reply in the thread",
        "needs": "Gmail or Outlook · DoBox",
        "categories": {
          "urgent": "Urgent",
          "question": "Question",
          "bug": "Bug"
        },
        "flows": {
          "0": {
            "name": "Triage a support message",
            "strip": {
              "triage": "Label and classify",
              "queue": "Queue and draft"
            }
          }
        }
      },
      "privacy-request-log": {
        "title": "Privacy Request Log",
        "description": "Logs every data subject request the day it arrives with the statutory clock already computed, and drafts a neutral acknowledgement for the lawyer.",
        "objective": "A privacy request found on day twenty-nine is a breach in the making. The deadline has to exist as a tracked date from day one, not as something someone remembers to work out.",
        "outcome": "No data subject request is discovered late, and none of the requester data is copied anywhere new.",
        "schedule": "On every message in the privacy inbox",
        "landsIn": "A DoBox task with the type and the deadline, a draft acknowledgement for review",
        "needs": "Gmail or Outlook · DoBox",
        "flows": {
          "0": {
            "name": "Log a data subject request",
            "strip": {
              "clock": "Compute the deadline",
              "log": "Log the request"
            }
          }
        }
      },
      "ops-intake-queue": {
        "title": "Ops Intake Queue",
        "description": "Turns each genuine request posted in the ops channel into a tracked task with a type, an owner and a response window — and tells the requester what to expect.",
        "objective": "Ops requests arrive as messages and die as messages. This keeps the asking where people already ask, and adds the tracking that was missing.",
        "outcome": "Every ops request is tracked with a response window, and the requester knows it was received.",
        "schedule": "On every message in the ops channel",
        "landsIn": "A DoBox task per request, a confirmation in the same Slack channel",
        "needs": "Slack · DoBox",
        "flows": {
          "0": {
            "name": "Route an ops request",
            "strip": {
              "read": "Judge the message",
              "route": "Classify and track"
            }
          }
        }
      },
      "people-policy-line": {
        "title": "People Policy Line",
        "description": "Answers employee policy questions in Slack from what is actually written in the People Ops space, quoting the rule and linking the page.",
        "objective": "The same six questions reach People Ops every month. Answering them from the written policy — with the link — is both faster and the only version that stays consistent.",
        "outcome": "Routine policy questions are answered from the written source, and anything the Brain does not cover reaches a human instead of being improvised.",
        "schedule": "On every question in the people channel",
        "landsIn": "A reply in the same Slack channel, with the source page linked",
        "needs": "Slack · Brain",
        "flows": {
          "0": {
            "name": "Answer a policy question",
            "strip": {
              "search": "Search the Brain",
              "answer": "Answer with the source"
            }
          }
        }
      },
      "marketing-performance-read": {
        "title": "Marketing Performance Read",
        "description": "Turns the numbers your team already logs into a written weekly read — what moved, the likely reason, and the one decision it implies — split by audience.",
        "objective": "A dashboard shows what changed but never says what to do about it. The written read is the part that gets acted on, and it is the part nobody has time to write.",
        "outcome": "Leadership gets the headline and the decision; the channel owner gets the detail. Neither is assembled by hand.",
        "schedule": "Weekly on Monday mornings",
        "landsIn": "A short read in the leadership channel, the full one in the marketing channel",
        "needs": "Brain · Slack",
        "flows": {
          "0": {
            "name": "Write the weekly read",
            "strip": {
              "read": "Read the numbers",
              "deliver": "Deliver by audience"
            }
          }
        }
      }
    },
    "setup": {
      "next": "Next",
      "confirm": "Set it up",
      "settingUp": "Setting up…",
      "review": {
        "resources": "Resources to create",
        "flows": "Flows to activate",
        "brainSpace": "Brain space",
        "brainPage": "Brain page",
        "emailLabel": "Gmail label: {{name}}",
        "agentTemplate": "Agent: {{name}}"
      },
      "fields": {
        "chips": {
          "add": "Add",
          "placeholder": "Type and press Enter"
        },
        "slackChannel": {
          "loading": "Loading channels…",
          "placeholder": "Select a channel",
          "error": "Could not load Slack channels",
          "workspace": "Workspace",
          "workspacePlaceholder": "Select a workspace",
          "noWorkspace": "No Slack workspace connected. Connect Slack in your integrations settings.",
          "noBotChannels": "No channels where the bot is a member. Invite the bot to a channel in Slack (/invite @bot), then reopen this.",
          "searchPlaceholder": "Search channels",
          "selectedCount": "{{count}} selected",
          "noMatches": "No channels match your search"
        },
        "team": {
          "label": "Assign to team",
          "personalNote": "No team found. The workflow will be created in your personal workspace.",
          "personalOption": "Personal (no team)",
          "loading": "Loading teams…"
        },
        "mcpConnection": {
          "connected": "Connected",
          "notConnected": "Not connected. Connect {{service}} in your integrations settings, then click Recheck.",
          "connect": "Go to Integrations",
          "recheck": "Recheck",
          "hint": "This workflow needs the {{service}} MCP server connected to work.",
          "loading": "Checking connection…",
          "services": {
            "github": "GitHub",
            "tavily": "Tavily (web search)"
          }
        },
        "digestDelivery": {
          "slackLabel": "Slack channel (optional)",
          "emailLabel": "Email address (optional)",
          "emailPlaceholder": "e.g. team@example.com",
          "hint": "At least one delivery method is required — Slack, email, or both."
        },
        "deliveryChannels": {
          "label": "Where to deliver the briefing",
          "loading": "Loading integrations…",
          "channels": {
            "assistantPage": {
              "label": "Brain page",
              "description": "Save the briefing to your Brain each day"
            },
            "dobox": {
              "label": "DoBox",
              "description": "Create a DoBox entry for the briefing"
            },
            "email": {
              "label": "Email",
              "description": "Sent to your inbox automatically by the this+that assistant.",
              "selectLabel": "Send to"
            },
            "slack": {
              "label": "Slack",
              "description": "The assistant bot sends the briefing to you as a direct message on Slack.",
              "workspaceSelectLabel": "Workspace"
            }
          }
        },
        "emailAccount": {
          "placeholder": "Select an account",
          "noAccounts": "No email accounts connected. Connect an email account in your integrations settings."
        },
        "githubRepository": {
          "add": "Add",
          "placeholder": "Add another, e.g. owner/repo",
          "allHint": "Leave empty to watch every repository.",
          "noRepositories": "No repositories synced yet. Connect GitHub, or type the full owner/repo name below.",
          "invalid": "Use the full repository name, like acme/backend.",
          "remove": "Remove {{repository}}"
        }
      },
      "inbox-autopilot": {
        "params": {
          "emailAccount": {
            "label": "Email account",
            "description": "Which email account should the flows monitor?"
          }
        }
      },
      "competitor-intelligence": {
        "params": {
          "team": {
            "label": "Team"
          },
          "tavily": {
            "label": "Web search (Tavily)"
          },
          "companyName": {
            "label": "Company name",
            "placeholder": "e.g. Acme"
          },
          "website": {
            "label": "Company website",
            "placeholder": "e.g. https://acme.com"
          },
          "description": {
            "label": "What does your app do? (key features)",
            "placeholder": "Brief description of your product and its main features"
          },
          "competitors": {
            "label": "Competitors to monitor"
          },
          "slackChannel": {
            "label": "Slack channel for weekly report"
          },
          "cadence": {
            "label": "Report cadence",
            "options": {
              "weekly-monday": "Weekly on Monday",
              "daily": "Daily (Mon–Fri)"
            }
          }
        }
      },
      "company-brain": {
        "params": {
          "team": {
            "label": "Team"
          },
          "companyName": {
            "label": "Company name",
            "placeholder": "e.g. Acme Corp"
          },
          "githubRepo": {
            "label": "GitHub repo (optional)",
            "placeholder": "e.g. owner/repo"
          },
          "description": {
            "label": "What does the company do? (optional)",
            "placeholder": "Brief description of the company, product, and team — fills the Company & Market page together with what is found in Slack and email"
          },
          "sourceChannels": {
            "label": "Public Slack channels to monitor (optional)"
          },
          "cadence": {
            "label": "Monitor cadence",
            "options": {
              "hourly": "Hourly",
              "every-4h": "Every 4 hours",
              "daily": "Daily (8 AM)"
            }
          }
        }
      },
      "ship-log": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "github": {
            "label": "GitHub connection"
          },
          "githubRepo": {
            "label": "GitHub repository",
            "placeholder": "e.g. owner/repo"
          },
          "digest": {
            "label": "Weekly digest delivery"
          }
        }
      },
      "daily-briefing": {
        "params": {
          "briefingTime": {
            "label": "Delivery time",
            "options": {
              "07": "7:00 AM (weekdays)",
              "08": "8:00 AM (weekdays)",
              "09": "9:00 AM (weekdays)"
            }
          },
          "delivery": {
            "label": "Delivery channels"
          }
        }
      },
      "manage-distractions": {
        "params": {
          "emailAccount": {
            "label": "Email account"
          },
          "categories": {
            "label": "Auto-archive these tabs",
            "options": {
              "promotions": "Promotions",
              "forums": "Forums",
              "social": "Social",
              "updates": "Updates",
              "personal": "Primary"
            }
          },
          "reportTime": {
            "label": "Report time",
            "options": {
              "morning": "8:00 AM (weekdays)",
              "noon": "12:00 PM (weekdays)",
              "evening": "6:00 PM (weekdays)"
            }
          },
          "deliveryMode": {
            "label": "Report delivery",
            "options": {
              "assistant": "Assistant conversation",
              "email": "Email (note: the report email may land in your Gmail Promotions tab)",
              "both": "Both assistant and email"
            }
          }
        }
      },
      "pr-review-copilot": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "github": {
            "label": "GitHub connection"
          },
          "githubRepo": {
            "label": "GitHub repositories"
          },
          "destination": {
            "label": "Notification delivery"
          }
        }
      },
      "dependency-security": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "github": {
            "label": "GitHub connection"
          },
          "githubRepos": {
            "label": "GitHub repositories (owner/repo)"
          },
          "destination": {
            "label": "Notification delivery"
          },
          "severityThreshold": {
            "label": "Notify immediately for",
            "options": {
              "critical-only": "Critical only",
              "critical-high": "Critical + high",
              "critical-high-medium": "Critical + high + medium"
            }
          },
          "pollCadence": {
            "label": "Poll cadence",
            "options": {
              "hourly": "Hourly",
              "every-4h": "Every 4 hours",
              "daily": "Daily"
            }
          },
          "slaPreset": {
            "label": "Remediation SLA",
            "options": {
              "standard": "Standard (24h / 3d / 14d / 30d)",
              "aggressive": "Aggressive (12h / 1d / 7d / 14d)",
              "relaxed": "Relaxed (3d / 7d / 30d / 60d)"
            }
          }
        }
      },
      "bug-intake": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "github": {
            "label": "GitHub connection (optional)"
          },
          "githubRepo": {
            "label": "GitHub repositories"
          },
          "destination": {
            "label": "Notification delivery"
          }
        }
      },
      "incident-response": {
        "params": {
          "alertSenders": {
            "label": "Alert sender domains"
          },
          "incidentsSource": {
            "label": "Incidents Slack channel (optional)"
          },
          "destination": {
            "label": "Notification delivery"
          },
          "team": {
            "label": "Assign to team"
          }
        }
      },
      "team-rituals": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "github": {
            "label": "GitHub connection"
          },
          "githubRepo": {
            "label": "GitHub repositories"
          },
          "destination": {
            "label": "Notification delivery"
          },
          "standupTime": {
            "label": "Standup time",
            "options": {
              "10": "10:00 AM",
              "08": "8:00 AM",
              "09": "9:00 AM"
            }
          }
        }
      },
      "engineering-knowledge": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "devHelp": {
            "label": "Dev-help Slack channel (optional)"
          },
          "destination": {
            "label": "Notification delivery"
          }
        }
      },
      "release-notes": {
        "params": {
          "tagPattern": {
            "label": "Release tag pattern",
            "placeholder": "e.g. prod-*"
          },
          "destination": {
            "label": "Notification delivery"
          },
          "stakeholderEmail": {
            "label": "Stakeholder email (optional)",
            "placeholder": "e.g. customers@company.com"
          },
          "team": {
            "label": "Assign to team"
          }
        }
      },
      "inbound-response-desk": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Marketing inbox"
          },
          "companyPitch": {
            "label": "What your company sells",
            "placeholder": "e.g. Acme — scheduling software for dental clinics"
          },
          "salesChannel": {
            "label": "Where hot leads are posted"
          },
          "noiseSignals": {
            "label": "Always-noise domains and terms"
          },
          "autoArchiveNoise": {
            "label": "Archive noise instead of just labelling it"
          },
          "recapCadence": {
            "label": "Recap cadence",
            "options": {
              "weekly-monday": "Weekly, Monday morning",
              "daily": "Every weekday"
            }
          }
        }
      },
      "content-operations": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "searchConnection": {
            "label": "Web search connection"
          },
          "emailAccount": {
            "label": "Inbox carrying the Published label"
          },
          "companyContext": {
            "label": "Company, site and who you sell to",
            "placeholder": "e.g. Acme — acme.com — ops leads at 50-500 person clinics"
          },
          "topicClusters": {
            "label": "Seed topic clusters"
          },
          "briefsPerWeek": {
            "label": "Briefs per week",
            "options": {
              "2": "2 briefs",
              "3": "3 briefs",
              "5": "5 briefs"
            }
          },
          "derivativeChannels": {
            "label": "Derivatives to produce",
            "options": {
              "linkedin": "LinkedIn post",
              "newsletter": "Newsletter",
              "social": "Social short-form",
              "one-pager": "Sales one-pager",
              "thread": "Thread"
            }
          },
          "contentChannel": {
            "label": "Where the queue is posted"
          },
          "briefCadence": {
            "label": "Brief cadence",
            "options": {
              "weekly-monday": "Weekly, Monday morning",
              "daily": "Every weekday"
            }
          }
        }
      },
      "approval-chaser": {
        "params": {
          "approvers": {
            "label": "Approvers"
          },
          "approvalChannel": {
            "label": "Where approvers are asked"
          },
          "reminderHours": {
            "label": "How long to wait before escalating",
            "options": {
              "4": "4 hours",
              "24": "24 hours",
              "48": "48 hours"
            }
          }
        }
      },
      "account-pulse": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Email account to sweep"
          },
          "accounts": {
            "label": "Accounts to track (name — domain)"
          },
          "accountChannels": {
            "label": "Customer Slack channels"
          },
          "silenceThresholdDays": {
            "label": "Days of silence before an alert",
            "options": {
              "30": "30 days",
              "45": "45 days",
              "60": "60 days",
              "90": "90 days"
            }
          },
          "renewalNoticeDays": {
            "label": "Warn this many days before renewal",
            "options": {
              "30": "30 days",
              "60": "60 days",
              "90": "90 days"
            }
          },
          "alertChannel": {
            "label": "Where alerts and recaps are posted"
          }
        }
      },
      "customer-onboarding-cockpit": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Inbox carrying the New Customer label"
          },
          "milestones": {
            "label": "Onboarding milestones"
          },
          "stallDays": {
            "label": "Days without movement before chasing",
            "options": {
              "3": "3 days",
              "5": "5 days",
              "7": "7 days"
            }
          },
          "internalChannel": {
            "label": "Where nudges and the report are posted"
          }
        }
      },
      "month-end-close": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "slackChannel": {
            "label": "Close channel"
          },
          "closeOwners": {
            "label": "Close task owners"
          },
          "budgetOwners": {
            "label": "Cost centre owners"
          },
          "targetCloseDay": {
            "label": "Target close day",
            "options": {
              "3": "Close by D+3",
              "5": "Close by D+5",
              "10": "Close by D+10"
            }
          }
        }
      },
      "contract-renewal-radar": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Inbox holding contract mail"
          },
          "slackChannel": {
            "label": "Where alerts are posted"
          },
          "seedVendors": {
            "label": "Known vendors to seed the register"
          },
          "alertThresholds": {
            "label": "Warn this many days before the notice deadline",
            "options": {
              "14": "14 days",
              "30": "30 days",
              "60": "60 days",
              "90": "90 days"
            }
          },
          "defaultOwner": {
            "label": "Default owner when a contract has none",
            "placeholder": "e.g. Head of Finance"
          }
        }
      },
      "ops-pulse": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "reportChannel": {
            "label": "Where the pulse is published"
          },
          "projects": {
            "label": "Projects to track"
          },
          "owners": {
            "label": "Owner Slack IDs, in the same order as the projects"
          },
          "collectionDay": {
            "label": "Collection day (the report goes out the next day)",
            "options": {
              "monday": "Monday",
              "tuesday": "Tuesday",
              "wednesday": "Wednesday"
            }
          },
          "chaseNonResponders": {
            "label": "Re-ask once after four hours of silence"
          }
        }
      },
      "okr-check-in": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "reportChannel": {
            "label": "Where the check-in is published"
          },
          "objectives": {
            "label": "Objectives for this quarter"
          },
          "krOwners": {
            "label": "Key result owner Slack IDs"
          },
          "checkInCadence": {
            "label": "Check-in cadence",
            "options": {
              "biweekly": "Every two weeks",
              "monthly": "Monthly"
            }
          }
        }
      },
      "onboarding-runway": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "announcementChannel": {
            "label": "Where new hires are introduced"
          },
          "itOwner": {
            "label": "Who owns tool access",
            "placeholder": "e.g. Sam in IT"
          },
          "preStartChecklist": {
            "label": "Before-day-one checklist"
          },
          "weekOneSessions": {
            "label": "Week-one sessions to book",
            "options": {
              "welcome-1-1": "Welcome one-to-one",
              "buddy": "Buddy session",
              "product-tour": "Product tour",
              "team-intro": "Team introductions"
            }
          },
          "checkInMilestones": {
            "label": "Check-in milestones",
            "options": {
              "30": "30 days",
              "60": "60 days",
              "90": "90 days"
            }
          }
        }
      },
      "hiring-loop": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Inbox receiving applications"
          },
          "hiringChannel": {
            "label": "Where the debrief is announced"
          },
          "openRoles": {
            "label": "Open roles"
          },
          "feedbackSlaHours": {
            "label": "Hours before a scorecard counts as late",
            "options": {
              "12": "12 hours",
              "24": "24 hours",
              "48": "48 hours"
            }
          },
          "silenceThresholdDays": {
            "label": "Days of candidate silence before an alert",
            "options": {
              "5": "5 days",
              "7": "7 days",
              "14": "14 days"
            }
          }
        }
      },
      "legal-request-desk": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "intakeInbox": {
            "label": "Inbox receiving legal requests"
          },
          "requestsChannel": {
            "label": "Channel where the business asks"
          },
          "legalPrivateChannel": {
            "label": "Private legal channel (standup and escalations)"
          },
          "requestTypes": {
            "label": "Request types"
          },
          "ndaSla": {
            "label": "NDA response window",
            "options": {
              "1": "1 business day",
              "2": "2 business days",
              "3": "3 business days",
              "5": "5 business days"
            }
          },
          "autoAskMissingFields": {
            "label": "Automatically ask for the missing fields"
          },
          "escalationTopics": {
            "label": "Topics that go straight to the lawyer, never to the queue",
            "options": {
              "litigation": "Litigation",
              "investigation": "Internal investigation",
              "regulator": "Regulator",
              "termination": "Termination",
              "ma": "Acquisition"
            }
          }
        }
      },
      "payment-change-guard": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Inbox receiving vendor mail"
          },
          "financeChannel": {
            "label": "Finance channel for alerts"
          }
        }
      },
      "support-triage-desk": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "emailAccount": {
            "label": "Shared support inbox"
          }
        }
      },
      "privacy-request-log": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "privacyInbox": {
            "label": "Inbox receiving privacy requests"
          },
          "responseBufferDays": {
            "label": "Buffer before the statutory deadline",
            "options": {
              "3": "3 days",
              "5": "5 days",
              "10": "10 days"
            }
          }
        }
      },
      "ops-intake-queue": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "intakeChannel": {
            "label": "Channel where ops requests arrive"
          }
        }
      },
      "people-policy-line": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "questionsChannel": {
            "label": "Channel where people ask HR questions"
          }
        }
      },
      "marketing-performance-read": {
        "params": {
          "team": {
            "label": "Assign to team"
          },
          "leadershipChannel": {
            "label": "Leadership channel (headline)"
          },
          "teamChannel": {
            "label": "Marketing channel (full read)"
          }
        }
      }
    },
    "templates": {
      "triageEmails": {
        "title": "Triage emails",
        "description": "Automatically sort and prioritize incoming emails by category and urgency"
      },
      "smartReplies": {
        "title": "Smart replies",
        "description": "Draft AI-powered reply suggestions for your most important emails",
        "prompt": "Create a flow that triggers when I receive a new email.\n\nStep 1: Determine if the email requires a reply.\nOnly proceed if ALL conditions below are met:\n- The email is written by a human (not automated, not from no-reply addresses, not system-generated).\n- The email clearly expects or benefits from a response (e.g., contains a question, request, decision pending, or requires confirmation).\n- The conversation is not already concluded (e.g., no \"thanks\", \"got it\", \"noted\", or closure signals without open loops).\n\nDo NOT generate a draft if:\n- The email is a notification, marketing, newsletter, receipt, or platform alert.\n- The sender is an automated system or bot.\n- The message is informational only and does not require action.\n- The thread is already resolved or does not need a response.\n\nStep 2: If a reply is needed:\n- Load my recent sent emails to learn my tone, style, and phrasing.\n- Match my natural writing style (concise, friendly, and direct).\n- Reply in the same language as the original email.\n\nStep 3: Generate the reply:\n- Write a complete, clean, and well-formatted response.\n- Do not include explanations, comments, or metadata.\n- The output must be ready to send as-is.\n\nStep 4: Draft a reply in my email account where the email arrived for review.",
        "outcome": "Every email that deserves a reply already has one drafted and waiting for you.",
        "landsIn": "Your inbox, as a draft",
        "needs": "A connected Gmail account"
      },
      "smartDoboxPipeline": {
        "title": "Smart DoBox Pipeline",
        "description": "Auto-validate, check existing entries, and generate tasks from your communications"
      },
      "dailyUnreadSummary": {
        "title": "Daily unread summary",
        "description": "Get a summary of unread emails every morning",
        "prompt": "Create a scheduled flow that runs every morning at 8 AM and sends me a summary of all unread emails from the last 24 hours. The summary should be sent as a notification email with the key highlights, grouped by urgency.",
        "outcome": "Every morning, your unread emails are already summarized for you.",
        "landsIn": "Your inbox, as a morning email",
        "needs": "A connected Gmail account"
      },
      "vipEmailAlerts": {
        "title": "VIP email alerts",
        "description": "Get notified on Slack when an email arrives from someone you care about.",
        "prompt": "Watch my inbox for emails from specific senders and domains I consider VIPs. When a match arrives, immediately send me a Slack message in a private channel with the sender, subject, preview, and a link to open the email. Start by asking me which emails and domains to monitor.",
        "outcome": "The moment someone important emails you, you get a Slack ping.",
        "landsIn": "Slack, as a direct message",
        "needs": "Gmail · Slack"
      },
      "autoLabelActionItems": {
        "title": "Auto-label action items",
        "description": "Automatically label emails that require action",
        "prompt": "Create a flow that automatically labels emails containing action items. When an email arrives that requires me to do something, add an 'Action Required' label to it.",
        "outcome": "Emails that need action are already labeled before you open your inbox.",
        "landsIn": "Your inbox, as a label",
        "needs": "A connected Gmail account"
      },
      "draftReply": {
        "title": "Draft reply",
        "description": "Automatically draft replies to emails that need a response, matching your writing style",
        "prompt": "Create a flow that triggers only on emails in the Primary category (CATEGORY_PERSONAL). When a Primary email arrives, determine if it requires a reply — skip automated notifications, no-reply senders, already-concluded threads, and messages with the SENT label. If a reply is needed, load my last 5 sent emails to understand my writing style, tone, and language. Then draft a reply that matches how I naturally write, keeping the same language as the original email. Save the draft in my email account, ready for me to review and send.",
        "outcome": "Your replies are already drafted, in your voice, waiting for a quick read.",
        "landsIn": "Your inbox, as a draft",
        "needs": "A connected Gmail account"
      },
      "meetingActionItems": {
        "title": "Meeting action items",
        "description": "Extract tasks from meeting summary emails",
        "prompt": "When an email arrives from Gemini, Granola, Fireflies, Otter, Fathom, or any other meeting-notes assistant, parse the email body for action items. For each detected action item, create a DoBox entry with the action as the title, a reference link to the source email, and — if a deadline is mentioned — set the due date accordingly. Group the created entries so the user can see they all came from the same meeting.",
        "outcome": "Every action item from your meeting notes becomes a task automatically.",
        "landsIn": "DoBox, as tasks",
        "needs": "A connected Gmail account"
      },
      "followUpTracker": {
        "title": "Follow-up tracker",
        "description": "Track emails that need follow-up",
        "prompt": "Every weekday at 9am, scan all emails I've sent in the last 7 days that haven't received a reply. For each one, create a DoBox entry titled 'Follow up with <recipient>' with the original subject as context and a reminder due today. Skip emails marked as informational or newsletters.",
        "outcome": "Emails you're still waiting on turn into a follow-up reminder by themselves.",
        "landsIn": "DoBox, as a reminder",
        "needs": "A connected Gmail account"
      },
      "channelDigest": {
        "title": "Channel digest",
        "description": "Daily summary of important Slack channels",
        "prompt": "Create a flow that sends me a daily digest of important Slack messages from my channels. Summarize the key discussions and highlight anything that needs my attention.",
        "outcome": "Your Slack channels are already summarized before you check them.",
        "landsIn": "Slack, as a direct message",
        "needs": "A connected Slack workspace"
      },
      "slackToDobox": {
        "title": "Slack to DoBox",
        "description": "Convert important Slack messages into DoBox items"
      },
      "morningBriefing": {
        "title": "Morning briefing",
        "description": "Wake up to a 30-second summary of every Slack message and email that arrived overnight.",
        "prompt": "Every weekday at 8am, scan all Slack channels I follow and my primary inbox for messages received since yesterday evening. Group them by urgency and send me a briefing with the top 3 things I need to know and any actions required.",
        "outcome": "Wake up to the handful of things that actually need your attention today.",
        "landsIn": "Your inbox, as a briefing",
        "needs": "Gmail · Slack"
      },
      "endOfDayReport": {
        "title": "End of day report",
        "description": "A summary of your day's email and meetings, sent to your inbox every evening.",
        "prompt": "Every weekday at 6pm, collect the emails I received and sent today and the meetings on my calendar today. Group them by whether they still need something from me, and send me an email summary with the counts, the threads still waiting on my reply, and anything I committed to in a meeting.",
        "outcome": "Every evening you get a recap of what came in, what you sent, and what is still waiting on you.",
        "landsIn": "Your inbox, as an evening email",
        "needs": "A connected Gmail account"
      }
    },
    "agentType": "Agent",
    "useAgent": "Use agent",
    "openAgent": "Open agent",
    "agents": {
      "toolsLabel": "Tools used",
      "leadResearcher": {
        "title": "Lead Researcher",
        "description": "Researches a company or person from the web and your CRM contacts, then returns a structured briefing.",
        "outcome": "Ask about any company or contact and get a ready-to-use briefing back.",
        "landsIn": "The conversation, as a structured briefing",
        "needs": "Web search connection (Tavily) · your CRM contacts"
      },
      "emailTriageAssistant": {
        "title": "Email Triage Assistant",
        "description": "Scans your recent inbox, flags what needs a reply or action, and creates DoBox tasks for anything actionable.",
        "outcome": "Run it and your inbox is triaged, with tasks already waiting in DoBox.",
        "landsIn": "DoBox, as tasks — plus a summary in the conversation",
        "needs": "A connected Gmail account"
      },
      "dailySlackDigest": {
        "title": "Daily Slack Digest",
        "description": "Summarizes yesterday's important Slack conversations, decisions, and open questions into one concise digest.",
        "outcome": "Catch up on yesterday's Slack in one short digest instead of scrolling.",
        "landsIn": "The conversation, or a Slack DM",
        "needs": "A connected Slack workspace"
      },
      "followUpWriter": {
        "title": "Follow-up Writer",
        "description": "Drafts polite, context-aware follow-up emails for threads that have gone quiet.",
        "outcome": "A polite, on-point follow-up is drafted for every thread that's gone quiet.",
        "landsIn": "Your inbox, as drafts",
        "needs": "A connected Gmail account"
      },
      "knowledgeCurator": {
        "title": "Knowledge Curator",
        "description": "Turns raw notes and threads into organized Brain pages and keeps your knowledge space tidy.",
        "outcome": "Messy notes go in, an organized Brain page comes out.",
        "landsIn": "Brain, as organized pages",
        "needs": "Notes or a thread to organise"
      },
      "meetingPrepAssistant": {
        "title": "Meeting Prep Assistant",
        "description": "Pulls attendee context from your CRM and past emails before each meeting and produces a one-page prep note.",
        "outcome": "Walk into every meeting with a one-page briefing on who you're meeting.",
        "landsIn": "The conversation, as a one-page prep note",
        "needs": "Calendar · Gmail · your CRM contacts"
      },
      "performanceReporter": {
        "title": "Performance Reporter",
        "description": "Turns the marketing numbers you already have into a short written read, and delivers a different depth of it to each audience.",
        "outcome": "One set of numbers becomes the leadership headline, the team detail and the client update, without rewriting the same email three times.",
        "landsIn": "Slack and email, with the write-up saved to your Brain",
        "needs": "Slack · Gmail or Outlook · Brain"
      },
      "battlecardKeeper": {
        "title": "Battlecard Keeper",
        "description": "Answers the sales team's competitor questions from your battlecards, and updates the page with whatever it had to look up.",
        "outcome": "Sales gets the agreed positioning in the channel where they asked, and the battlecard stops going stale between quarters.",
        "landsIn": "Slack, with the battlecard page updated in your Brain",
        "needs": "Slack · Brain · web search connection (Tavily)"
      },
      "experimentLogger": {
        "title": "Experiment Logger",
        "description": "Captures the result of every marketing test into one structured log, so nobody re-runs a test that has already been answered.",
        "outcome": "\"Did we already try that?\" gets an answer with a date and a number instead of a shrug.",
        "landsIn": "Your Brain, as a quarterly experiment log",
        "needs": "Brain · Slack"
      },
      "supportInboxTriage": {
        "title": "Support Inbox Triage",
        "description": "Triages your shared support inbox: classifies every message, labels it, drafts the easy replies, and opens a task for whatever needs a human.",
        "outcome": "You start the day with a sorted queue instead of an undifferentiated pile of unread mail.",
        "landsIn": "Your inbox as labels and drafts, plus a DoBox work queue",
        "needs": "Gmail or Outlook · DoBox"
      },
      "supportReplyComposer": {
        "title": "Support Reply Composer",
        "description": "Writes support replies grounded in your Brain's documented answers, cites the pages it used, and tells you when the documentation is missing.",
        "outcome": "The same question gets the same good answer every time, and you find out which articles you still need to write.",
        "landsIn": "Your inbox, as a draft reply with its sources",
        "needs": "Gmail or Outlook · Brain"
      },
      "escalationPackager": {
        "title": "Escalation Packager",
        "description": "Turns a messy customer thread into an engineering-ready bug report with repro steps, environment and evidence — then files it.",
        "outcome": "Engineering picks up your escalation without bouncing it back for more detail.",
        "landsIn": "Your engineering tracker when an issue-tracker MCP connection is attached, with the link posted back to Slack",
        "needs": "Gmail or Outlook · Slack · Brain · GitHub connection"
      },
      "voiceOfCustomerAnalyst": {
        "title": "Voice of Customer Analyst",
        "description": "Reads a month of support email and customer Slack and reports the three or four themes product actually needs to hear.",
        "outcome": "Product gets evidence-backed themes with account counts, not your three loudest anecdotes.",
        "landsIn": "Your Brain as a dated page, plus a short version in Slack",
        "needs": "Gmail or Outlook · Slack · Brain"
      },
      "invoiceApprovalChaser": {
        "title": "Invoice Approval Chaser",
        "description": "Finds supplier invoices sitting in your inbox, turns each one into a tracked task, and chases the approver until the payment run is ready.",
        "outcome": "You walk into the weekly payment run knowing exactly what is approved and who is holding up the rest.",
        "landsIn": "DoBox as one task per invoice, with the chasing done in Slack",
        "needs": "Gmail or Outlook · Slack · DoBox"
      },
      "paymentChangeVerifier": {
        "title": "Payment Change Verifier",
        "description": "Catches any email asking to change bank or payment details, quarantines it, and hands you an out-of-band verification checklist.",
        "outcome": "A vendor payment-detail change never gets actioned on the word of an email thread alone.",
        "landsIn": "A Slack alert, a quarantine label, and a DoBox checklist",
        "needs": "Gmail or Outlook · Slack · DoBox · Brain · your CRM contacts"
      },
      "vendorDocumentChaser": {
        "title": "Vendor Document Chaser",
        "description": "Requests the onboarding and tax documents every new vendor owes you, tracks who has replied, and re-chases the ones who have not.",
        "outcome": "New vendors are fully documented before their first payment, and year-end has no last-minute scramble.",
        "landsIn": "Your vendor register in Brain, with requests sent by email",
        "needs": "Gmail or Outlook · Brain"
      },
      "boardPackWriter": {
        "title": "Board Pack Writer",
        "description": "Collects each function's monthly update, drafts the narrative around the numbers you supply, and assembles the board pack.",
        "outcome": "The board pack is drafted before the meeting instead of the night before it.",
        "landsIn": "Your Brain, as a dated pack ready to review",
        "needs": "Slack · Gmail or Outlook · Brain · Calendar"
      },
      "actionItemCloser": {
        "title": "Action Item Closer",
        "description": "Turns every meeting commitment into an owned, dated task and keeps re-surfacing the ones that have not moved.",
        "outcome": "Nothing decided in a meeting quietly disappears — every commitment has a name, a date and a follow-up.",
        "landsIn": "DoBox as one task per commitment, with a weekly Slack snapshot",
        "needs": "Google or Outlook Calendar · Slack · DoBox"
      },
      "opsIntakeRouter": {
        "title": "Ops Intake Router",
        "description": "Turns ops requests scattered across Slack and email into one prioritised queue, acknowledges every requester, and flags what is running late.",
        "outcome": "Every request has a ticket, an owner and a response window — and you can finally say how many came in this week.",
        "landsIn": "DoBox as the queue, with confirmations sent in Slack",
        "needs": "Slack · Gmail or Outlook · DoBox"
      },
      "runbookKeeper": {
        "title": "Runbook Keeper",
        "description": "Answers \"how do we do X?\" from the Brain, and writes the missing runbook whenever the answer had to come from a person instead.",
        "outcome": "Every process question you answer once becomes a page anyone can find, and stale runbooks get flagged.",
        "landsIn": "Your Brain, as runbook pages under one parent",
        "needs": "Brain · Slack or Gmail"
      },
      "peoplePolicyAssistant": {
        "title": "People Policy Assistant",
        "description": "Answers employee policy questions from the handbook in your Brain, with the source page attached.",
        "outcome": "The same twenty questions stop landing in your DMs, and everyone gets the same answer.",
        "landsIn": "Whichever channel the question arrived in",
        "needs": "Brain · Slack · Gmail or Outlook"
      },
      "candidateScreener": {
        "title": "Candidate Screener",
        "description": "Reads incoming applications and writes an evidence-based screening note against the role's written requirements.",
        "outcome": "Every application gets a consistent first read, and you spend your time on the shortlist instead of the pile.",
        "landsIn": "DoBox, as a screening note and a decision task",
        "needs": "Gmail or Outlook · Brain · DoBox"
      },
      "reviewEvidenceCollector": {
        "title": "Review Evidence Collector",
        "description": "Gathers six months of what someone actually did — shipped work, decisions, feedback — into a dated evidence pack before review season.",
        "outcome": "Managers write reviews from a documented period instead of from the last three weeks they remember.",
        "landsIn": "A private Brain page — never a channel",
        "needs": "Slack · Gmail or Outlook · Brain · DoBox"
      },
      "offboardingCoordinator": {
        "title": "Offboarding Coordinator",
        "description": "Builds the full exit plan from a name and a last day — handover, assets, exit interview, access requests.",
        "outcome": "Nothing about a departure is discovered a week after the person has gone.",
        "landsIn": "DoBox and Calendar, with a handover page in your Brain",
        "needs": "Google or Outlook Calendar · Slack · Brain · DoBox"
      },
      "legalIntakeTriager": {
        "title": "Legal Intake Triager",
        "description": "Turns every 'quick question' into a complete, tracked legal request before it reaches your desk.",
        "outcome": "You stop asking who the counterparty is for the third time.",
        "landsIn": "DoBox, with the missing details requested in the original thread",
        "needs": "Slack · Gmail or Outlook · DoBox"
      },
      "contractDeadlineWatcher": {
        "title": "Contract Deadline Watcher",
        "description": "Reads executed contracts as they land, records the dates that matter, and warns you before a notice window closes.",
        "outcome": "You find out about an auto-renewal sixty days early instead of sixty days late.",
        "landsIn": "A contract register in your Brain, plus DoBox and your calendar",
        "needs": "Gmail or Outlook · Slack · Brain · DoBox · Calendar"
      },
      "legalPlaybookAnswerer": {
        "title": "Legal Playbook Answerer",
        "description": "Answers routine legal questions with the position your team already approved, and escalates the ones it hasn't.",
        "outcome": "The same question stops reaching you for the fifth time this month.",
        "landsIn": "The original Slack thread, or a private message when it escalates",
        "needs": "Brain · Slack"
      },
      "privacyRequestClerk": {
        "title": "Privacy Request Clerk",
        "description": "Logs every data subject request the day it arrives and keeps the statutory clock in front of you.",
        "outcome": "You never discover a subject request on day twenty-nine.",
        "landsIn": "DoBox as metadata only, with a draft acknowledgement in your inbox",
        "needs": "Gmail or Outlook · DoBox · Slack"
      }
    },
    "meta": {
      "landsInLabel": "Lands in",
      "needsLabel": "Needs",
      "setupMinutes": "Setup ~{{count}} min",
      "setupInstant": "One-click setup"
    },
    "integrationApps": {
      "email": "Email",
      "slack": "Slack",
      "calendar": "Calendar",
      "dobox": "DoBox",
      "brain": "Brain",
      "web": "Web search",
      "github": "GitHub"
    },
    "areas": {
      "engineering": "Engineering",
      "hr_people": "HR & People",
      "sales": "Sales",
      "marketing": "Marketing",
      "support_cs": "Support & CS",
      "finance": "Finance",
      "operations": "Operations",
      "legal": "Legal",
      "founder_leadership": "Founder & Leadership",
      "everyone": "Everyone"
    },
    "filters": {
      "allAreas": "All",
      "areasGroupLabel": "Filter by area",
      "runsWithLabel": "Runs with",
      "runsWithGroupLabel": "Filter by connected app"
    },
    "shelves": {
      "popularAll": "Popular",
      "popularForArea": "Popular with {{area}} teams",
      "biggerJobsAll": "Bigger jobs",
      "biggerJobsForArea": "Bigger jobs for {{area}}",
      "biggerJobsSubtitle": "Several steps, one outcome, installed as one thing",
      "seeAll": "See all {{count}}"
    }
  },
  "flowEditor": {
    "pageTitle": "Flow Editor",
    "untitledFlow": "Untitled flow",
    "starterRequired": "Please select a starter (trigger) before saving the flow.",
    "systemFlowReadOnly": "This is a system flow. You can toggle it on/off but cannot edit its configuration.",
    "systemSlackChannelsOnlyEditable": "This is a system flow. You can edit the channel selection only.",
    "systemEmailContactsOnlyEditable": "This is a system flow. You can only change whether it processes emails from your contacts only.",
    "setupOnlyReadOnly": "This flow ran once during setup and can't be edited or run again. You can still view its execution history.",
    "unsavedChanges": {
      "title": "Unsaved changes",
      "description": "You have unsaved changes. Would you like to save before leaving?",
      "save": "Save",
      "leave": "Leave"
    },
    "chooseStarter": "Choose a starter",
    "addStep": "Add step",
    "starter": {
      "title": "Choose a starter",
      "description": "Select what triggers this flow",
      "schedule": "On a schedule",
      "email": "When I get an email",
      "tagApplied": "When a tag is applied",
      "slackMessage": "When I get a Slack message",
      "slack_message": "When I get a Slack message",
      "slack": "When I get a Slack message",
      "instagram": "When I get an Instagram message",
      "instagram_content": "When someone comments on my Instagram post",
      "googleChat": "When I get a Google Chat message",
      "google_chat": "When I get a Google Chat message",
      "dobox": "When a DoBox event happens",
      "manual": "Run manually",
      "knowledge_page": "When a new page is created",
      "github": "When a GitHub event happens",
      "people": "When a person is created",
      "google_business": "When I get a Google Business Profile review",
      "facebook": "When someone comments on my Facebook post",
      "facebook_messenger": "When I get a Facebook message",
      "lockedTooltip": "Only team admins or owners can create this trigger. Ask an admin to enable it.",
      "whatsapp": "When I get a WhatsApp message",
      "teams": "When I get a Microsoft Teams message"
    },
    "instagramTrigger": {
      "title": "Instagram trigger",
      "description": "Runs when a new Instagram direct message arrives on the selected account.",
      "accountLabel": "Instagram account",
      "accountPlaceholder": "Select an Instagram account",
      "noAccountsTitle": "Connect an Instagram account",
      "noAccountsMessage": "Your team has no Instagram account connected yet.",
      "noAccountsCta": "Go to Integrations",
      "changeStarter": "Change trigger",
      "insufficientRoleError": "Only workspace admins or owners can create Instagram triggers.",
      "accountNotFoundError": "The selected Instagram account is no longer connected to this team.",
      "accountRequiredError": "Please select an Instagram account before saving.",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "debounceMinutes": "Debounce delay (minutes)",
      "onlyStoryReplies": "Only story replies",
      "onlyStoryRepliesDescription": "Only trigger this flow for direct messages that reply to one of your Instagram stories. Other direct messages are ignored."
    },
    "instagramContentTrigger": {
      "title": "Instagram post comment trigger",
      "description": "Runs when someone comments on a post from the selected Instagram account.",
      "accountLabel": "Instagram account",
      "accountPlaceholder": "Select an Instagram account",
      "noAccountsTitle": "Connect an Instagram account",
      "noAccountsMessage": "Your team has no Instagram account connected yet.",
      "noAccountsCta": "Go to Integrations",
      "postLabel": "Post (optional)",
      "postPlaceholder": "e.g. 17895695668004550",
      "postHelperText": "We couldn't load your recent posts, so enter the Instagram media ID manually. Leave it empty to trigger on comments from any post on this account.",
      "anyPostOption": "Any post",
      "postLoadingHelperText": "Loading your recent posts…",
      "postSelectHelperText": "Choose a specific post to scope this trigger to it, or keep Any post selected to trigger on comments from any post on this account.",
      "changeStarter": "Change trigger"
    },
    "doboxTrigger": {
      "title": "DoBox trigger",
      "description": "Configure when this flow should trigger based on DoBox activity",
      "triggerType": "Event type",
      "doboxCreated": "DoBox created",
      "commentAdded": "Comment added",
      "participantAdded": "Member added",
      "labelAdded": "Label added",
      "labelRemoved": "Label removed",
      "taskGroupChanged": "List changed",
      "taskGroupScope": "Apply to lists",
      "taskGroupScopeAll": "All lists",
      "taskGroupScopeSelected": "Selected lists",
      "selectTaskGroups": "Select lists",
      "selectTaskGroupsPlaceholder": "Choose one or more lists",
      "selectLabels": "Select labels",
      "selectLabelsPlaceholder": "Choose one or more labels",
      "changeStarter": "Change starter",
      "doboxResolved": "DoBox resolved",
      "doboxApproved": "DoBox approved",
      "doboxRejected": "DoBox rejected",
      "doboxReopened": "DoBox reopened"
    },
    "githubTrigger": {
      "title": "GitHub trigger",
      "description": "Runs when a pull request, issue, review, or release event happens on the selected GitHub installation.",
      "loading": "Loading GitHub installations…",
      "loadError": "Could not load your GitHub installations. Close and reopen this trigger to try again.",
      "installationsLabel": "GitHub installations",
      "installationsHint": "Pick the installations to watch, then narrow each to specific repositories. Leave all unchecked to watch every installation.",
      "installationLabel": "GitHub installation",
      "installationPlaceholder": "Select a GitHub installation",
      "eventsLabel": "Events",
      "actionsLabel": "Actions",
      "anyEventHint": "Leave empty to match any event",
      "anyActionHint": "Leave empty to match any action",
      "eventsSubtitle": "Turn on an event, then pick which of its actions fire.",
      "off": "Off",
      "anyAction": "Any action",
      "actionsForThisEvent": "Actions for this event",
      "removeTag": "Remove {{value}}",
      "repositories": {
        "label": "Repositories",
        "placeholder": "owner/repo",
        "hint": "Leave empty to watch every repository in this installation, including ones created later."
      },
      "refPatterns": {
        "release": {
          "label": "Release tags",
          "placeholder": "prod-all-*",
          "hint": "Type a tag and press Enter or comma. Use * as a wildcard. Leave empty to match any tag."
        },
        "push": {
          "label": "Branches",
          "placeholder": "main",
          "hint": "Type a branch and press Enter or comma. Use * as a wildcard. Leave empty to watch the default branch only."
        }
      },
      "changeStarter": "Change trigger",
      "noAccountsTitle": "Connect a GitHub installation",
      "noAccountsMessage": "Your team has no GitHub installation connected yet.",
      "noAccountsCta": "Go to Integrations",
      "events": {
        "pullRequest": "Pull request",
        "pullRequestReview": "Pull request review",
        "issues": "Issue",
        "issueComment": "Issue comment",
        "release": "Release",
        "push": "Push"
      },
      "actions": {
        "opened": "Opened",
        "reopened": "Reopened",
        "closed": "Closed",
        "merged": "Merged",
        "assigned": "Assigned",
        "reviewRequested": "Review requested",
        "submitted": "Submitted",
        "created": "Created",
        "deleted": "Deleted",
        "published": "Published",
        "pushed": "Pushed"
      }
    },
    "gbpTrigger": {
      "title": "Google Business Profile trigger",
      "description": "Runs when a review is posted or updated on a connected Google Business Profile location.",
      "triggerType": "Trigger type",
      "newReview": "New review",
      "updatedReview": "Updated review",
      "changeStarter": "Change trigger",
      "noAccountsTitle": "Connect Google Business Profile",
      "noAccountsMessage": "Your account has no Google Business Profile connected yet.",
      "noAccountsCta": "Go to Integrations"
    },
    "facebookTrigger": {
      "title": "Facebook page comment trigger",
      "description": "Runs when someone comments on a post on a connected Facebook page.",
      "pageLabel": "Facebook page",
      "pagePlaceholder": "Select a Facebook page",
      "noPagesTitle": "Connect a Facebook page",
      "noPagesMessage": "Your team has no Facebook page connected yet.",
      "noPagesCta": "Go to Integrations",
      "changeStarter": "Change trigger",
      "pageRequiredError": "Please select a Facebook page before saving."
    },
    "facebookMessengerTrigger": {
      "title": "Facebook trigger",
      "description": "Runs when a new Facebook direct message arrives on the selected page.",
      "pageLabel": "Facebook page",
      "pagePlaceholder": "Select a Facebook page",
      "noPagesTitle": "Connect a Facebook page",
      "noPagesMessage": "Your team has no Facebook page connected yet.",
      "noPagesCta": "Go to Integrations",
      "changeStarter": "Change trigger",
      "pageRequiredError": "Please select a Facebook page before saving.",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "debounceMinutes": "Debounce delay (minutes)"
    },
    "slackTrigger": {
      "title": "Slack trigger",
      "description": "Configure when this flow should trigger based on incoming Slack messages",
      "triggerType": "Trigger type",
      "allMessages": "All Slack messages",
      "channelMatch": "Channel match",
      "authorMatch": "Author match",
      "workspace": "Workspace",
      "workspacePlaceholder": "Select a workspace",
      "channel": "Channel",
      "channelPlaceholder": "Select a channel",
      "author": "Author",
      "authorPlaceholder": "Select a person",
      "loadingOptions": "Loading options...",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "channels": "Channels",
      "channelsAllHelp": "Leave empty to watch all channels",
      "changeStarter": "Change starter",
      "workspacesScopeLabel": "Workspaces & channels",
      "allWorkspacesHelp": "Watching all workspaces and all channels. Select workspaces below to narrow.",
      "allChannelsHelp": "All channels in this workspace. Pick channels to narrow.",
      "includeWorkspace": "Include this workspace"
    },
    "googleChatTrigger": {
      "title": "Google Chat trigger",
      "description": "Configure when this flow should trigger based on incoming Google Chat messages",
      "triggerType": "Trigger type",
      "allMessages": "All Google Chat messages",
      "spaceMatch": "Space match",
      "authorMatch": "Author match",
      "account": "Google account",
      "accountPlaceholder": "Select a Google account",
      "space": "Space",
      "spaceForAuthor": "Space",
      "spacePlaceholder": "Select a space",
      "spaceForAuthorPlaceholder": "Select a space",
      "author": "Author",
      "authorPlaceholder": "Select a person",
      "loadingAccounts": "Loading accounts...",
      "loadingOptions": "Loading options...",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "connectTitle": "Connect your Google account",
      "connectDescription": "Automate actions based on Google Chat messages — process updates, alerts, and summaries from your spaces as part of your flow.",
      "connectButton": "Connect Google",
      "changeStarter": "Change starter"
    },
    "teamsTrigger": {
      "title": "Microsoft Teams trigger",
      "description": "Configure when this flow should trigger based on new Microsoft Teams chat messages. Messages you send do not trigger it.",
      "account": "Microsoft account",
      "allAccounts": "All accounts",
      "chatsSectionLabel": "Chats",
      "limitToChats": "Limit to specific chats",
      "chats": "Chats",
      "chatsPlaceholder": "Select chats",
      "chatsSearchPlaceholder": "Search chats",
      "chatsEmptyMessage": "No chats found",
      "chatsSelectionRequired": "Select at least one chat",
      "chatsSelectionRequiredError": "Select at least one chat on the Microsoft Teams trigger before saving.",
      "untitledChat": "Untitled chat",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "debounceMinutes": "Debounce delay (minutes)",
      "noAccountsTitle": "Connect Microsoft Teams",
      "noAccountsMessage": "You have no Microsoft Teams account connected yet. Go to Integrations to connect one.",
      "noAccountsCta": "Go to Integrations",
      "changeStarter": "Change starter"
    },
    "emailTrigger": {
      "title": "Email trigger",
      "description": "Configure when this flow should trigger based on incoming emails",
      "triggerType": "Trigger type",
      "primaryInbox": "Primary inbox",
      "allEmails": "All emails",
      "labelMatch": "Label match",
      "labelMatchPlaceholder": "e.g. Important, Newsletter...",
      "categoryMatch": "Category match",
      "emailMatch": "Sender email match",
      "emailMatchPlaceholder": "e.g. john@example.com",
      "domainMatch": "Sender domain match",
      "domainMatchPlaceholder": "e.g. example.com",
      "sentEmails": "Sent emails",
      "changeStarter": "Change starter",
      "emailAccountScope": "Apply to email accounts",
      "allAccounts": "All email accounts",
      "selectedAccounts": "Selected email accounts",
      "contactFilter": {
        "toggleLabel": "Only from my contacts"
      },
      "directToFilter": {
        "toggleLabel": "Only when I'm a direct recipient"
      }
    },
    "knowledgePageTrigger": {
      "starterLabel": "When a new page is created",
      "title": "New Knowledge page",
      "description": "Run this flow whenever a new page is created in a Knowledge Space.",
      "spaceLabel": "Space",
      "spacePlaceholder": "Select a space…",
      "spaceTeamBadge": "team",
      "parentPageLabel": "Parent page (optional)",
      "parentPagePlaceholder": "Any page in the space",
      "parentPageHelp": "Leave blank to match any page in the space. When set, matches any page anywhere below this one (children, grandchildren, etc.).",
      "missingSpaceError": "Pick a space to continue.",
      "changeStarter": "Change trigger (Knowledge page)"
    },
    "contentFilter": {
      "title": "Content filter",
      "description": "Only trigger when message content matches a condition.",
      "typeLabel": "Filter type",
      "typeKeyword": "Keyword (contains)",
      "typeRegex": "Regex (pattern match)",
      "fieldLabel": "Search in",
      "fieldAny": "Any field",
      "fieldSubject": "Subject",
      "fieldMessage": "Message body",
      "fieldAuthor": "Author name",
      "fieldAuthorEmail": "Author email",
      "keywordLabel": "Keyword",
      "keywordPlaceholder": "e.g. github, urgent, /review-pr",
      "regexLabel": "Regex pattern",
      "regexPlaceholder": "e.g. ^URGENT:|review-pr\\s+#\\d+",
      "regexInvalid": "This regex is invalid or potentially unsafe. Simplify the pattern (avoid nested groups like (a+)+ ).",
      "regexDocs": "Regex cheatsheet",
      "testLabel": "Test your regex",
      "testPlaceholder": "Paste a sample message to test...",
      "testMatch": "Match!",
      "testNoMatch": "No match",
      "logicLabel": "Filter mode",
      "logicInclude": "Include — only trigger when content matches",
      "logicExclude": "Exclude — skip when content matches",
      "descriptionExclude": "Skip triggering when message content matches a condition."
    },
    "schedule": {
      "title": "On a schedule",
      "description": "Start at a set date and time. Have it run once or repeat on a schedule.",
      "presetMondayMorning": "Monday at 8 AM",
      "presetWeekdays": "Weekdays at 8 AM",
      "presetIn10Min": "In 10 minutes",
      "startTooSoonError": "For a one-time schedule, pick a start at least {{minutes}} minutes in the future.",
      "startDateAndTime": "Start date and time",
      "date": "Date",
      "time": "Time",
      "repeat": "Repeat",
      "doesNotRepeat": "Does not repeat",
      "everyHour": "Every hour",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "customDays": "Custom days",
      "selectDays": "Run on these days",
      "dayMon": "Mon",
      "dayTue": "Tue",
      "dayWed": "Wed",
      "dayThu": "Thu",
      "dayFri": "Fri",
      "daySat": "Sat",
      "daySun": "Sun",
      "repeatHelperText": "For daily and less frequent repeats, runs start within 3 minutes of the set time",
      "ends": "Ends",
      "ends1Week": "1 week",
      "ends1Month": "1 month",
      "ends3Months": "3 months",
      "ends6Months": "6 months",
      "endsNever": "Never",
      "changeStarter": "Change starter"
    },
    "steps": {
      "title": "Add a step",
      "description": "Choose an action to add to your flow",
      "AI_ASK": "AI Ask",
      "DECIDE": "Decide",
      "SUMMARIZE": "Summarize",
      "CHECK_IF": "Check if",
      "FORWARD": "Forward",
      "ARCHIVE": "Archive",
      "NOTIFY_EMAIL": "Notify via email",
      "DRAFT_EMAIL": "Draft an email",
      "DRAFT_REPLY": "Draft a reply",
      "ADD_LABEL": "Add label",
      "ADD_LABELS": "Add labels",
      "REMOVE_LABEL": "Remove label",
      "REMOVE_LABELS": "Remove labels",
      "DELETE": "Delete",
      "MARK_READ": "Mark as read",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_UNREAD": "Mark as unread",
      "CHANGE_CATEGORY": "Change category",
      "NOTIFY_BY_EMAIL": "Notify by email",
      "SEND_NOTIFICATION_EMAIL": "Send notification email",
      "SEND_EMAIL": "Send email",
      "SEND_SLACK_MESSAGE": "Send Slack message",
      "SEND_USER_SLACK_MESSAGE": "Send Slack message as you",
      "SEND_BOT_SLACK_MESSAGE": "Send Slack message as bot",
      "GENERATE_DOBOX": "Generate DoBox",
      "CREATE_DOBOX": "Create DoBox",
      "LOAD_DOBOX": "Load DoBox",
      "LOAD_COMMUNICATIONS": "Load Communications",
      "RESOLVE_DOBOX": "Resolve DoBox",
      "ACCEPT_DOBOX_SUGGESTION": "Accept DoBox Suggestion",
      "ADD_DOBOX_COMMENT": "Add DoBox Comment",
      "UPDATE_DOBOX_PARTICIPANTS": "Update DoBox Participants",
      "UPDATE_DOBOX_LABELS": "Update DoBox Labels",
      "VALIDATE_DOBOX_RULES": "Validate DoBox Rules",
      "CLASSIFY_ACTIONABILITY": "Classify Actionability",
      "RAG_SEARCH": "RAG Search",
      "APPEND_TO_DOBOX": "Append to DoBox",
      "CHECK_AND_APPEND_DOBOX": "Check & Append",
      "PROCESS_DOBOX": "Process DoBox",
      "SEND_INSTAGRAM_MESSAGE": "Send Instagram message",
      "REPLY_INSTAGRAM_COMMENT": "Reply to Instagram comment",
      "PUBLISH_INSTAGRAM_POST": "Publish Instagram post",
      "FOR_EACH": "For Each",
      "MCP_TOOL_CALL": "MCP Tool",
      "CALENDAR_RSVP": "RSVP to Meeting",
      "CALENDAR_CREATE_EVENT": "Create Calendar Event",
      "CALENDAR_DELETE_EVENT": "Delete Calendar Event",
      "CALENDAR_RESCHEDULE_EVENT": "Reschedule Event",
      "CALENDAR_ADD_ATTENDEES": "Add Attendees",
      "CALENDAR_REMOVE_ATTENDEES": "Remove Attendees",
      "calendarRsvpDescription": "Respond to a calendar event invitation (accept, decline, or tentative). Works with Gmail and Outlook calendars.",
      "calendarCreateEventDescription": "Create a new calendar event with title, time, attendees, and location. Works with Gmail and Outlook calendars.",
      "calendarDeleteEventDescription": "Delete or cancel a calendar event. Optionally notifies attendees of the cancellation.",
      "calendarRescheduleEventDescription": "Change the start and end time of an existing calendar event.",
      "calendarAddAttendeesDescription": "Add new participants to an existing calendar event.",
      "calendarRemoveAttendeesDescription": "Remove participants from an existing calendar event.",
      "calendarResponseStatus": "Response Status",
      "calendarResponseStatusPlaceholder": "Select a response status",
      "calendarRsvpAccepted": "Accepted",
      "calendarRsvpDeclined": "Declined",
      "calendarRsvpTentative": "Tentative",
      "calendarSummary": "Event Title",
      "calendarSummaryPlaceholder": "e.g. Team Standup",
      "calendarStartDateTime": "Start Date/Time (ISO 8601)",
      "calendarStartDateTimePlaceholder": "e.g. 2026-04-01T09:00:00",
      "calendarEndDateTime": "End Date/Time (ISO 8601)",
      "calendarEndDateTimePlaceholder": "e.g. 2026-04-01T09:30:00",
      "calendarTimeZone": "Time Zone",
      "calendarTimeZonePlaceholder": "e.g. America/New_York",
      "calendarDescription": "Description",
      "calendarDescriptionPlaceholder": "Event description...",
      "calendarLocation": "Location",
      "calendarLocationPlaceholder": "e.g. Conference Room A",
      "calendarAttendees": "Attendees (comma-separated emails)",
      "calendarAttendeesPlaceholder": "e.g. alice@example.com, bob@example.com",
      "calendarSendCancellation": "Send Cancellation",
      "calendarSendCancellationPlaceholder": "Notify attendees about the cancellation",
      "AGENT_TASK": "Agent Task",
      "NOTIFY_ASSISTANT": "Notify assistant",
      "ASK_USER": "Ask user",
      "APPROVAL_GATE": "Approval gate",
      "RUN_ASSISTANT": "Run assistant",
      "LOAD_MEETINGS": "Load Meetings",
      "LOAD_TEAM_MEMBERS": "Load Team Members",
      "CHECK_TEAM_CALENDAR": "Check Team Calendar",
      "LOAD_KNOWLEDGE_PAGE": "Load Knowledge Page",
      "SEARCH_PEOPLE": "Search People",
      "UPDATE_PERSON_NOTES": "Update Person Notes",
      "LOAD_TEAM_PEOPLE": "Load Team People",
      "CREATE_PERSON_EVENT": "Log Timeline Event",
      "searchPeopleDescription": "Search your contacts by name, email, or job title. Combine results with a For Each step to act on each match.",
      "searchPeopleHelpTitle": "At least one field is required",
      "searchPeopleHelpText": "Fill in name, email, or job title (or any combination) to narrow the search. Leaving all three empty is not allowed.",
      "searchPeopleNameLabel": "Name",
      "searchPeopleNamePlaceholder": "e.g. Jane Doe or {{step.step-0.output}}",
      "searchPeopleEmailLabel": "Email",
      "searchPeopleEmailPlaceholder": "e.g. jane@example.com",
      "searchPeopleJobTitleLabel": "Job title",
      "searchPeopleJobTitlePlaceholder": "e.g. Product Manager",
      "searchPeopleMissingCriteriaError": "Fill in at least one of name, email, or job title on the Search People step before saving.",
      "updatePersonNotesDescription": "Append to or replace the notes on a person's profile.",
      "updatePersonNotesPersonIdLabel": "Person ID",
      "updatePersonNotesPersonIdPlaceholder": "e.g. {{person.id}}",
      "updatePersonNotesTemplateLabel": "Notes",
      "updatePersonNotesTemplatePlaceholder": "e.g. Follow up scheduled for {{step.step-0.output}}",
      "updatePersonNotesModeLabel": "Write mode",
      "updatePersonNotesModePlaceholder": "Select a write mode",
      "updatePersonNotesModeAppend": "Append (default)",
      "updatePersonNotesModeReplace": "Replace",
      "updatePersonNotesMissingNotesError": "Fill in the notes template on the Update Person Notes step before saving.",
      "createPersonEventDescription": "Log a timeline event on a person's contact record — a dated fact, distinct from a durable note.",
      "createPersonEventHelpTitle": "Exactly one of Person ID or Person Email is required",
      "createPersonEventHelpText": "Fill in Person ID or Person Email, not both. Use Person ID when you already have it (e.g. from a starter or a previous step); use Person Email to look the person up by email instead.",
      "createPersonEventPersonIdLabel": "Person ID",
      "createPersonEventPersonIdPlaceholder": "e.g. {{person.id}}",
      "createPersonEventPersonEmailLabel": "Person Email",
      "createPersonEventPersonEmailPlaceholder": "e.g. jane@example.com",
      "createPersonEventTitleTemplateLabel": "Title",
      "createPersonEventTitleTemplatePlaceholder": "e.g. Called about renewal",
      "createPersonEventDescriptionTemplateLabel": "Description (optional)",
      "createPersonEventDescriptionTemplatePlaceholder": "e.g. Discussed pricing for {{step.step-0.output}}",
      "GBP_REPLY_REVIEW": "Reply to review",
      "gbpReplyReviewDescription": "Post a reply (or update the existing reply) on a Google Business Profile review.",
      "gbpReplyTextLabel": "Reply text",
      "gbpReplyTextPlaceholder": "e.g. Thanks for the review, {{starter.gbp.authorName}}!",
      "gbpReplyTextMissingError": "Fill in the reply text on the Reply to review step before saving.",
      "gbpReviewNameLabel": "Review (optional)",
      "gbpReviewNamePlaceholder": "e.g. {{starter.gbp.reviewName}}",
      "gbpReviewNameHelpTitle": "Defaults to the triggering review",
      "gbpReviewNameHelpText": "Leave empty to reply to the review that triggered this flow. Only set this to reply to a different review.",
      "PUBLISH_FACEBOOK_POST": "Publish Facebook post",
      "facebookKindLabel": "Post type",
      "facebookKindPlaceholder": "Select a post type",
      "facebookKindText": "Text post",
      "facebookKindLink": "Link post",
      "facebookKindPhoto": "Photo post",
      "facebookMessageLabel": "Message",
      "facebookMessagePlaceholder": "Type your message...",
      "facebookLinkLabel": "Link",
      "facebookLinkPlaceholder": "e.g. https://example.com/article",
      "facebookImageUrlLabel": "Image URL",
      "facebookImageUrlPlaceholder": "e.g. https://example.com/photo.jpg",
      "facebookScheduledAtLabel": "Schedule for (optional)",
      "facebookScheduledAtPlaceholder": "e.g. 2026-04-01T09:00:00-03:00",
      "facebookPageIdLabel": "Facebook page (optional)",
      "facebookPageIdPlaceholder": "Select a Facebook page",
      "facebookPublishPostDescription": "Publish a text, link, or photo post to a connected Facebook page. A scheduled post is queued on Facebook — it is not live yet until the scheduled time arrives.",
      "facebookScheduledAtHelpTitle": "A scheduled post is not live yet",
      "facebookScheduledAtHelpText": "When Schedule for is set, Facebook queues the post instead of publishing it immediately. The step succeeds and returns scheduled: true, but the post won't appear on the page until the scheduled time.",
      "REPLY_FACEBOOK_COMMENT": "Reply to Facebook comment",
      "facebookCommentIdLabel": "Comment ID (optional)",
      "facebookCommentIdPlaceholder": "e.g. {{starter.facebook.commentId}}",
      "facebookAsPrivateReplyLabel": "Private reply",
      "facebookAsPrivateReplyPlaceholder": "Send as a private message instead of a public reply. Allowed once per comment and only within 7 days of it being posted — this can't be undone.",
      "facebookReplyCommentDescription": "Reply to a comment on a connected Facebook page post, publicly or as a private message.",
      "facebookPrivateReplyHelpTitle": "Private replies are limited",
      "facebookPrivateReplyHelpText": "A private reply is only allowed once per comment, and only within 7 days of the comment being posted. It can't be undone, and a second attempt will fail.",
      "LOAD_FACEBOOK_POSTS": "Load Facebook posts",
      "LOAD_FACEBOOK_COMMENTS": "Load Facebook comments",
      "facebookLimitLabel": "Limit",
      "facebookLimitPlaceholder": "e.g. 20",
      "facebookPostIdLabel": "Post ID (optional)",
      "facebookPostIdPlaceholder": "e.g. {{starter.facebook.postId}}",
      "loadFacebookPostsDescription": "Load recent posts from a connected Facebook page to use in later steps.",
      "loadFacebookCommentsDescription": "Load comments from a Facebook page post to use in later steps. Defaults to the post from the triggering comment.",
      "facebookReplyMessageMissingError": "Fill in the reply text on the Reply to Facebook comment step before saving.",
      "SEND_FACEBOOK_MESSAGE": "Send Facebook message",
      "mcpToolCallDescription": "Call an external tool via an MCP server connection. Configure the connection, select the tool, and provide its arguments.",
      "agentTaskDescription": "Configure an AI agent that autonomously decides which tools to use to accomplish a goal.",
      "agentTaskGoalLabel": "Goal",
      "agentTaskGoalPlaceholder": "Describe what the agent should accomplish. Supports {{variables}}.",
      "agentTaskSystemPromptLabel": "System Prompt (role / persona)",
      "agentTaskSystemPromptPlaceholder": "Optional. Define who the agent is — its role, tone and persona. Prepended to the built-in execution rules so you can keep it out of the goal.",
      "agentTaskToolSetsLabel": "Tool Sets",
      "agentTaskMaxTurnsLabel": "Max Turns",
      "agentTaskModelTierLabel": "Model",
      "agentTaskModelStandard": "Standard (Sonnet)",
      "agentTaskModelFast": "Fast (Haiku)",
      "agentTaskToolSet_EMAIL_ACTIONS": "Email Actions (send, draft, archive, labels)",
      "agentTaskToolSet_COMMUNICATIONS": "Load Communications (read emails, Slack messages)",
      "agentTaskToolSet_NOTIFICATIONS": "Notifications (Slack messages and system emails)",
      "agentTaskToolSet_DOBOX": "DoBox (tasks, entries)",
      "agentTaskToolSet_MCP": "Connected apps",
      "agentTaskToolSet_CONVERSATIONAL": "Conversational (ask questions, wait for replies)",
      "agentTaskToolSet_MEMORY": "Memory (recall, save, history)",
      "agentTaskToolSet_KNOWLEDGE": "Brain read-only (search & read pages)",
      "agentTaskToolSet_KNOWLEDGE_WRITE": "Brain read/write (search, read, create & edit pages)",
      "agentTaskToolSet_CALENDAR": "Calendar (events, meetings, RSVP)",
      "agentTaskToolSet_LOAD_MEETINGS": "Meetings (read-only calendar lookups)",
      "agentTaskToolSet_PEOPLE": "People (search, view, create & edit contacts, log timeline events)",
      "agentTaskToolSet_WHATSAPP": "WhatsApp (numbers, read messages, send)",
      "agentTaskToolSet_FACEBOOK": "Facebook Page read-only (list posts & comments)",
      "agentTaskMcpSelectConnections": "Choose which connected apps it can use:",
      "agentTaskMcpAllConnections": "All connections enabled (uncheck to restrict)",
      "agentTaskMcpNoConnections": "No connected apps found. Add one in Integrations first.",
      "agentTaskConversationalSettings": "Conversational settings",
      "agentTaskWaitStrategy": "Reply strategy",
      "agentTaskWaitStrategyAll": "Wait for all replies",
      "agentTaskWaitStrategyAny": "Resume on first reply",
      "agentTaskWaitTimeout": "Reply timeout",
      "agentTaskWaitTimeout15": "15 minutes",
      "agentTaskWaitTimeout30": "30 minutes",
      "agentTaskWaitTimeout60": "1 hour",
      "agentTaskWaitTimeout120": "2 hours",
      "agentTaskWaitTimeout480": "8 hours",
      "agentTaskWaitTimeout1440": "24 hours",
      "agentTaskSubAgentsLabel": "Sub-Agents",
      "agentTaskCreateSubAgent": "+ Create Agent",
      "agentTaskModeInline": "Configure inline",
      "agentTaskModeSavedAgent": "Use a saved agent",
      "agentTaskNoSavedAgents": "No saved agents yet. Create an agent in the Agents tab first.",
      "agentTaskSavedGoalLabel": "Goal (optional)",
      "agentTaskSavedGoalPlaceholder": "Leave empty to run the agent on its saved instructions. Supports {{variables}}.",
      "agentTaskTurns": "turns",
      "agentTaskToolSetsShort": "tool sets",
      "agentToolSetAsksFirstTag": "Asks first",
      "agentTemplateModalTitleCreate": "Create Sub-Agent",
      "agentTemplateModalTitleEdit": "Edit agent",
      "agentTemplateSavingTitle": "Saving Sub-Agent",
      "agentTemplateSavingDescription": "Please wait while we save your changes.",
      "agentTemplateNameLabel": "Name",
      "agentTemplateNamePlaceholder": "e.g. Email Analyst",
      "agentTemplateDescriptionLabel": "Description",
      "agentTemplateDescriptionPlaceholder": "What this agent does, when to use it...",
      "agentTemplateSystemPromptLabel": "Instructions",
      "agentTemplateSystemPromptPlaceholder": "You are a specialist that...",
      "agentTemplateToolSetsLabel": "Available Tools",
      "agentTemplateModelTierLabel": "Model",
      "agentTemplateMaxTurnsLabel": "Max Turns",
      "agentTemplateMaxTurnsHint": "A turn is one step of the agent's work: reading, thinking or using a tool. With too few, it stops before finishing.",
      "agentTemplateIconLabel": "Icon (emoji)",
      "agentTemplateIconPlaceholder": "e.g. 📧",
      "agentTemplateSave": "Save",
      "agentTemplateCancel": "Cancel",
      "agentTemplateSavedSuccess": "Agent saved successfully",
      "agentTemplateWizard": {
        "title": "Create an agent",
        "subtitle": "Step {{step}} of {{total}}",
        "advancedSubtitle": "Advanced settings",
        "actions": {
          "build": "Build",
          "continue": "Continue",
          "create": "Create agent"
        },
        "describe": {
          "title": "What should your agent do?",
          "helper": "Describe the job in plain language. We'll draft the instructions, pick the tools, and choose a model. You review and edit everything next.",
          "prompt": "e.g. Summarize my calendar meetings each day and send me a digest",
          "examples": "Need a starting point?"
        },
        "examples": {
          "calendar": "Summarize my calendar meetings",
          "email": "Review & categorize customer emails",
          "landingPage": "Build on-brand landing pages"
        },
        "review": {
          "helper": "Here's what we built — tweak anything",
          "descriptionHint": "shown when someone picks an agent",
          "systemPromptHint": "what the agent always follows"
        },
        "configure": {
          "helper": "We pre-selected what this job needs. Adjust if you like, or just continue.",
          "tools": "What it can use",
          "selectedCount": "{{count}} selected",
          "share": "Share with your team",
          "shareHint": "Connected apps stay personal.",
          "sharing": "Sharing",
          "models": {
            "fast": "Best for quick, straightforward work",
            "standard": "Best balance of quality and speed"
          }
        },
        "edit": {
          "intro": "Editing this agent — changes apply when you save",
          "save": "Save changes"
        },
        "creating": {
          "title": "Building your agent...",
          "description": "Setting everything up from your description."
        },
        "buildSteps": {
          "goal": "Understanding the goal",
          "instructions": "Writing the instructions",
          "tools": "Selecting the right tools",
          "model": "Choosing model & limits",
          "finish": "Finishing up"
        },
        "preview": {
          "personal": "Private",
          "emptyDescription": "No description provided",
          "model": "Model",
          "turns": "turns",
          "maxTurns": "{{count}} turns",
          "sharing": "Sharing"
        },
        "progress": {
          "describe": "Describe",
          "review": "Review",
          "configure": "Configure"
        },
        "success": {
          "title": "{{name}} is ready",
          "description": "Saved to your agents. You can run it now or wire it into a flow.",
          "createAnother": "Create another",
          "done": "Done"
        },
        "tools": {
          "EMAIL_ACTIONS": "send, draft, archive, labels",
          "COMMUNICATIONS": "read emails, Slack messages",
          "NOTIFICATIONS": "Slack messages & system emails",
          "DOBOX": "tasks, entries",
          "MCP": "connect outside services",
          "MEMORY": "recall, save, history",
          "KNOWLEDGE": "search & read pages",
          "CALENDAR": "events, meetings, RSVP"
        },
        "discard": {
          "title": "Discard this agent?",
          "description": "Your changes will be lost.",
          "cancel": "Keep editing",
          "confirm": "Discard"
        },
        "validation": {
          "nameRequired": "Enter an agent name.",
          "systemPromptRequired": "Enter the agent instructions.",
          "invalidTeam": "Select a team you belong to."
        },
        "errors": {
          "createFailed": "We couldn't create the agent. Please try again.",
          "saveFailed": "We couldn't save the agent. Please try again.",
          "generateFailed": "We couldn't generate your agent. Please try again.",
          "approvalModeForbidden": "Only the person who created this agent can change how it asks for approval. Nothing was saved.",
          "outboundRejected": "Couldn't save where this agent can send. Check that each Slack workspace is connected for the \"Send as\" you chose."
        }
      },
      "mcpSelectConnection": "MCP Connection",
      "mcpConnectionPlaceholder": "Select a connection...",
      "mcpLoadingConnections": "Loading connections...",
      "mcpNoConnections": "No MCP connections configured. Add one in Settings.",
      "mcpSelectTool": "Tool",
      "mcpToolPlaceholder": "Select a tool...",
      "mcpNoTools": "No tools available. Try syncing the connection.",
      "mcpArguments": "Arguments",
      "configTitle": "Configure step",
      "stepNameLabel": "Step name (for variables)",
      "stepNamePlaceholder": "e.g. loadMessages",
      "prompt": "Prompt",
      "promptPlaceholder": "Enter your prompt...",
      "aiAskDescription": "Have AI create text for any purpose, from summaries to replies, to use in later steps. Give context from earlier steps with variables.",
      "aiAskPromptPlaceholder": "e.g. Analyze the provided email and extract all required action items...",
      "summarizeInstructions": "Additional instructions",
      "summarizePlaceholder": "AI will summarize highlights from the thread. You can also describe what to always include, length or style.",
      "decideDescription": "Have AI report if your conditions are true or false",
      "decidePromptLabel": "Enter a prompt",
      "decidePromptPlaceholder": "e.g. Is this email urgent?",
      "decideHelpTitle": "How Decide works",
      "decideHelpText": "After Decide, use a Check if step to set which actions to take based on the result. For example, star an email only if it's urgent. If AI doesn't have enough information to decide, it defaults to false.",
      "required": "Required",
      "senderEmailAddress": "From",
      "senderEmailAddressPlaceholder": "Select sender email...",
      "recipient": "Recipient",
      "recipientPlaceholder": "Enter recipient...",
      "recipients": "Recipients",
      "addRecipient": "Add recipient",
      "removeRecipient": "Remove recipient {{position}}",
      "recipientAt": "Recipient {{position}}",
      "subject": "Subject",
      "subjectPlaceholder": "Enter subject...",
      "body": "Body",
      "bodyPlaceholder": "Enter body...",
      "duration": "Duration",
      "durationPlaceholder": "e.g. 1 hour",
      "condition": "Condition",
      "conditionPlaceholder": "Enter filter condition...",
      "channel": "Channel",
      "labels": "Labels",
      "labelsPlaceholder": "e.g. important, follow-up...",
      "channelPlaceholder": "Select a channel...",
      "message": "Message",
      "messagePlaceholder": "Enter message...",
      "workspace": "Workspace",
      "workspacePlaceholder": "Select a workspace...",
      "slackConnectTitle": "Connect your Slack workspace",
      "slackConnectDescription": "Automate messages to your team — send updates, alerts, and summaries directly to Slack channels or teammates as part of your flow.",
      "slackConnectButton": "Connect Slack",
      "sendSlackMessageDescription": "Send a message to a Slack channel or direct message using your connected workspace.",
      "sendAs": "Send as",
      "sendAsUser": "My behalf",
      "sendAsBot": "Bot",
      "destination": "Send to",
      "destinationPlaceholder": "Select a channel or person...",
      "destinationChannels": "Channels",
      "destinationDirectMessages": "Direct Messages",
      "useVariable": "Use variable",
      "useDropdown": "Use dropdown",
      "workspaceVariablePlaceholder": "e.g. {{starter.slack.workspaceId}}",
      "destinationVariablePlaceholder": "e.g. {{starter.slack.channelId}}",
      "loadingDestinations": "Loading channels and contacts...",
      "generateDoBoxDescription": "AI will create a DoBox task based on your prompt and the email context.",
      "validateDoBoxRulesDescription": "Validates the communication against user feedback rules before generating DoBox items",
      "classifyActionabilityDescription": "Classifies whether a communication is actionable (ACTIONABLE / NOT_ACTIONABLE)",
      "validateDoBoxRulesInputModeLabel": "Validation input",
      "validateDoBoxRulesInputModeCommunication": "Current communication",
      "validateDoBoxRulesInputModeCommunicationHelper": "Validates the incoming email or message that triggered the agent.",
      "validateDoBoxRulesInputModeCommunicationsBatch": "Batch from previous step",
      "validateDoBoxRulesInputModeCommunicationsBatchHelper": "Validates an aggregated batch of messages loaded by a previous step.",
      "validateDoBoxRulesCommunicationsInputLabel": "Communications variable",
      "validateDoBoxRulesCommunicationsInputPlaceholder": "{{step.step-0.output}}",
      "validateDoBoxRulesCommunicationsInputHelper": "Reference the step output that loaded the communications batch.",
      "generateDoBoxPromptPlaceholder": "e.g. Create a task with the action items from this email...",
      "taskGroup": "Task Group",
      "taskGroupPlaceholder": "Default task group",
      "taskGroupDescription": "Select which task group to create entries in. Leave empty to use your default.",
      "taskGroupVariablePlaceholder": "e.g. {{variable.taskGroupId}}",
      "loadingTaskGroups": "Loading task groups...",
      "ragSearchDescription": "Search your communications using semantic search to retrieve relevant context for later steps.",
      "ragSearchQueryLabel": "Search query",
      "ragSearchQueryPlaceholder": "e.g. {{email.subject}} {{email.senderName}} — finds related conversations and context",
      "loadDoBoxDescription": "Load DoBox entries to use as context in later steps.",
      "loadDoBoxTaskGroups": "Task groups to load (required)",
      "loadDoBoxTaskGroupsEmpty": "No task groups yet — create one in DoBox first.",
      "loadDoBoxStatus": "Status filter",
      "loadDoBoxStatusOpen": "Open",
      "loadDoBoxStatusResolved": "Done",
      "loadDoBoxStatusSuggestion": "Suggestion",
      "loadDoBoxStatusAll": "All",
      "loadDoBoxDaysBack": "Days back",
      "loadDoBoxDaysBackPlaceholder": "e.g. 30",
      "loadDoBoxSortLabel": "Sort by last updated",
      "loadDoBoxSortDesc": "Most recently updated first",
      "loadDoBoxSortAsc": "Oldest updated first",
      "loadDoBoxLimitLabel": "Limit",
      "loadDoBoxLimitPlaceholder": "e.g. 20",
      "loadDoBoxLimitHelp": "Up to {{max}} entries. Bounds how many a downstream loop can process.",
      "appendToDoBoxDescription": "Appends communications to an existing DoBox entry",
      "appendToDoBoxEntryIdLabel": "DoBox entry ID",
      "appendToDoBoxEntryIdPlaceholder": "e.g. {{step.step-0.matchedEntryId}}",
      "appendToDoBoxCommunicationIdsLabel": "Communication IDs",
      "appendToDoBoxCommunicationIdsPlaceholder": "e.g. {{email.messageId}} or comma-separated IDs",
      "checkAndAppendDoBoxDescription": "Checks if communications match existing DoBox entries and appends them automatically",
      "checkAndAppendCommunicationsSourceLabel": "Communications source",
      "checkAndAppendCommunicationsSourcePlaceholder": "e.g. {{step.step-1.output}}",
      "checkAndAppendIncludeResolvedLabel": "Include resolved entries",
      "checkAndAppendDaysBackLabel": "Resolved entries days back",
      "checkAndAppendDaysBackPlaceholder": "e.g. 7",
      "processDoBoxDescription": "Analyzes the messages loaded from the conversation, creates new DoBox entries for action items, and appends related messages to existing entries.",
      "loadingGoogleChatDestinations": "Loading spaces and members...",
      "sendGoogleChatMessage": "Send Google Chat message",
      "SEND_GOOGLE_CHAT_MESSAGE": "Send Google Chat message",
      "SEND_USER_GOOGLE_CHAT_MESSAGE": "Send Google Chat message",
      "sendTeamsMessage": "Send Microsoft Teams message",
      "SEND_TEAMS_MESSAGE": "Send Microsoft Teams message",
      "teamsConnectTitle": "Connect your Microsoft Teams account",
      "teamsConnectDescription": "Automate messages to your team — send updates, alerts, and summaries directly to Microsoft Teams chats as part of your flow.",
      "teamsConnectButton": "Connect Microsoft Teams",
      "sendTeamsMessageDescription": "Send a message to a Microsoft Teams chat using your connected Microsoft account.",
      "teamsAccount": "Microsoft account",
      "teamsAccountPlaceholder": "Select a Microsoft account",
      "teamsChat": "Chat",
      "teamsChatPlaceholder": "Select a chat",
      "teamsChatVariablePlaceholder": "e.g. {{starter.teams.chatId}}",
      "loadingTeamsChats": "Loading chats...",
      "googleChatConnectTitle": "Connect your Google account",
      "googleChatConnectDescription": "Automate messages to your team — send updates, alerts, and summaries directly to Google Chat spaces or direct messages as part of your flow.",
      "googleChatConnectButton": "Connect Google",
      "sendGoogleChatMessageDescription": "Send a message to a Google Chat space or direct message using your connected Google account.",
      "googleChatAccount": "Google account",
      "googleChatAccountPlaceholder": "Select a Google account",
      "googleChatAccountVariablePlaceholder": "e.g. {{starter.googleChat.emailAddress}}",
      "googleChatSpace": "Space",
      "googleChatSpacePlaceholder": "Select a space or direct message",
      "googleChatSpaceVariablePlaceholder": "e.g. {{starter.googleChat.spaceName}}",
      "googleChatDestinationSpaces": "Spaces",
      "googleChatDestinationDMs": "Direct Messages",
      "googleChatThreadName": "Thread name (optional)",
      "googleChatThreadNamePlaceholder": "e.g. {{starter.googleChat.threadName}}",
      "sendInstagramMessageDescription": "Send a message to an Instagram conversation using your connected account.",
      "sendInstagramAccount": "Instagram account",
      "sendInstagramAccountPlaceholder": "Select an Instagram account...",
      "sendInstagramConversation": "Conversation",
      "sendInstagramConversationPlaceholder": "Select a conversation...",
      "sendInstagramConversationVariablePlaceholder": "e.g. {{starter.instagram.conversationId}}",
      "sendInstagramMessageLabel": "Message",
      "sendInstagramMessagePlaceholder": "Type your message...",
      "processInstagramDoBoxSourceLabel": "Communications source",
      "sendFacebookMessageDescription": "Send a message into a conversation on a connected Facebook page.",
      "sendFacebookPage": "Facebook page",
      "sendFacebookPagePlaceholder": "Select a Facebook page",
      "sendFacebookPagePlaceholderDefault": "Defaults to the triggering page",
      "sendFacebookConversation": "Conversation",
      "sendFacebookRecipient": "Recipient",
      "sendFacebookRecipientPlaceholder": "Select a recipient...",
      "sendFacebookRecipientPlaceholderDefault": "Defaults to the triggering sender",
      "sendFacebookRecipientVariablePlaceholder": "e.g. {{starter.facebookMessenger.authorId}}",
      "sendFacebookRecipientDefaultHint": "Leave empty to reply to the person who started this flow, on that page.",
      "sendFacebookMessageLabel": "Message",
      "sendFacebookMessagePlaceholder": "Type your message...",
      "replyInstagramCommentDescription": "Reply to an Instagram comment on your connected account, either publicly or as a private direct message.",
      "replyInstagramCommentId": "Comment",
      "replyInstagramCommentIdPlaceholder": "{{starter.instagramContent.commentId}} or a comment ID",
      "replyInstagramAsPrivateReply": "Send as private reply",
      "replyInstagramAsPrivateReplyDescription": "Sends a direct message to the commenter instead of a public reply. Instagram allows only one private reply per comment, within 7 days of it being posted.",
      "publishInstagramPostDescription": "Publish a new post to your connected Instagram account.",
      "publishInstagramPostApprovalWarning": "This step must be preceded by an Approval Gate step in the flow. Instagram posts publish immediately and cannot be undone.",
      "publishInstagramUnavailableTitle": "Instagram publishing is temporarily unavailable",
      "publishInstagramUnavailableMessage": "This step can't run right now because Instagram post publishing is disabled. Remove it to continue, or check back later.",
      "publishInstagramKind": "Post type",
      "publishInstagramKindImage": "Image",
      "publishInstagramKindReels": "Reels",
      "publishInstagramKindStory": "Story",
      "publishInstagramKindCarousel": "Carousel",
      "publishInstagramImageUrl": "Image URL",
      "publishInstagramImageUrlPlaceholder": "https://... or a variable",
      "publishInstagramGeneratedImageId": "Generated image ID",
      "publishInstagramGeneratedImageIdPlaceholder": "Image ID or a variable",
      "publishInstagramGeneratedImageIdHint": "Use the imageId of an image from your image library (uploaded via the Assistant, from Google Drive, or a screenshot) instead of the image URL — this step sits behind a mandatory Approval Gate, which can pause the flow for hours or days, long past the URL's 1-hour expiry.",
      "publishInstagramVideoUrl": "Video URL",
      "publishInstagramVideoUrlPlaceholder": "https://... or a variable",
      "publishInstagramCoverUrl": "Cover image URL",
      "publishInstagramCoverUrlPlaceholder": "https://... or a variable",
      "publishInstagramStoryHint": "Provide an image URL, a generated image ID, or a video URL for the story.",
      "publishInstagramShareToFeed": "Also share to feed",
      "publishInstagramShareToFeedDescription": "Also publish this Reel to the main feed grid, in addition to the Reels tab.",
      "publishInstagramCaption": "Caption",
      "publishInstagramCaptionPlaceholder": "Write a caption...",
      "publishInstagramCarouselImages": "Carousel images",
      "publishInstagramCarouselHint": "Add between 2 and 10 images.",
      "publishInstagramCarouselGeneratedImageIdPlaceholder": "Image ID or a variable",
      "publishInstagramCarouselGeneratedImageIdHint": "Each image can also be set from the imageId of an image in your image library (uploaded via the Assistant, from Google Drive, or a screenshot), instead of a URL — use it when this step follows the mandatory Approval Gate, since the gate can pause the flow past the URL's 1-hour expiry.",
      "publishInstagramAddCarouselImage": "Add image",
      "publishInstagramRemoveCarouselImage": "Remove image",
      "updateDoBoxDescription": "Update an existing DoBox entry: add labels, participants, due date, comments, or mark as done.",
      "updateDoBoxEntryIdLabel": "DoBox entry ID",
      "updateDoBoxEntryIdPlaceholder": "e.g. {{step.step-0.matchedEntryId}}",
      "updateDoBoxActionsTitle": "Actions",
      "updateDoBoxLabelsLabel": "Add labels",
      "updateDoBoxLabelsPlaceholder": "Label IDs (comma-separated or variable)",
      "updateDoBoxParticipantsLabel": "Add participants",
      "updateDoBoxParticipantsPlaceholder": "User IDs (comma-separated or variable)",
      "updateDoBoxParticipantsSearchPlaceholder": "Search by name or email...",
      "updateDoBoxParticipantsEmpty": "No team members found",
      "updateDoBoxDueDateLabel": "Due date",
      "updateDoBoxDueDatePlaceholder": "Select a date and time",
      "updateDoBoxCommentLabel": "Add comment",
      "updateDoBoxCommentPlaceholder": "e.g. Automatically added by flow",
      "updateDoBoxResolveLabel": "Mark as done",
      "createDoBoxDescriptionLabel": "Description",
      "createDoBoxDescriptionPlaceholder": "Enter description (optional)...",
      "removeDoBoxParticipantsLabel": "Remove participants",
      "removeDoBoxParticipantsPlaceholder": "User IDs (comma-separated or variable)",
      "removeDoBoxLabelsLabel": "Remove labels",
      "removeDoBoxLabelsPlaceholder": "Label IDs (comma-separated or variable)",
      "forEachDescription": "Iterate over each item in a list and run the steps below for every item. Use variables from a previous AI Ask step that returns an array.",
      "forEachSourceLabel": "Source array",
      "forEachSourcePlaceholder": "e.g. {{step.step-0.output.ids}}",
      "forEachSourceEmpty": "Select a variable from a previous step",
      "forEachAvailableVars": "Variables available inside the loop:",
      "forEachVarItem": "The current item in each iteration",
      "forEachVarIndex": "The current position (0, 1, 2...)",
      "forEachVarTotal": "Total number of items",
      "forEachMaxIterationsLabel": "Max iterations",
      "forEachMaxIterationsPlaceholder": "e.g. 20",
      "forEachMaxIterationsHelp": "Caps how many items the loop processes (max {{max}}). Lower it to bound cost and time.",
      "forEachMaxIterationsCappedBySource": "Capped at {{max}} by the source step's load limit.",
      "outputSchemaToggle": "Advanced: Structured output",
      "outputSchemaDescription": "By default, AI returns free text. Enable this to get a structured response (JSON) — useful when you need specific data like a list of IDs, categories, or values to use in later steps.",
      "outputSchemaLabel": "Output format (JSON)",
      "outputSchemaPlaceholder": "Paste your output format here...",
      "outputSchemaExampleTitle": "Example:",
      "outputSchemaInvalidJson": "Invalid JSON — the structured output will be ignored and no fields will be available in CHECK_IF.",
      "outputSchemaNoProperties": "Add a top-level \"properties\" object — without it, no fields are detected.",
      "outputSchemaFieldsDetected": "Detected fields: {{fields}}",
      "variableRequiredWarning": "Insert at least one variable to provide context for the AI. Use the Variables button above to add one.",
      "variableRequired": "Prompt field is required",
      "notifyEmailDescription": "Send an email notification with custom content.",
      "sendMode": "Send mode",
      "sendModePersonal": "Send on my behalf",
      "sendModeNotification": "Notification email",
      "heading": "Heading",
      "headingPlaceholder": "Enter email heading...",
      "notifyContent": "Content",
      "notifyContentPlaceholder": "Enter email content (supports markdown and {{variables}})...",
      "SEND_WHATSAPP_MESSAGE": "Send WhatsApp message",
      "whatsappPhoneNumberId": "WhatsApp number",
      "whatsappPhoneNumberIdPlaceholder": "e.g. {{starter.whatsapp.phoneNumberId}}",
      "whatsappTo": "Recipient",
      "whatsappToPlaceholder": "e.g. {{starter.whatsapp.counterpartId}}",
      "whatsappSendKind": "Message type",
      "whatsappSendKindPlaceholder": "Select a message type",
      "whatsappSendKindText": "Free-form text (within 24h window)",
      "whatsappSendKindTemplate": "Approved template (any time)",
      "whatsappMessage": "Message",
      "whatsappMessagePlaceholder": "Type your message...",
      "whatsappTemplateName": "Template name",
      "whatsappTemplateNamePlaceholder": "Approved template name from WhatsApp Manager",
      "whatsappTemplateLanguageCode": "Template language",
      "whatsappTemplateLanguageCodePlaceholder": "e.g. pt_BR",
      "LOAD_CHAT_COMMUNICATIONS": "Load conversation messages",
      "loadChatCommunicationsDescription": "Load messages from a chat platform for processing in subsequent steps. Choose the platform below, then use variables to dynamically set its identifiers from the trigger.",
      "loadChatPlatformLabel": "Platform",
      "loadChatPlatformSlack": "Slack",
      "loadChatPlatformTeams": "Microsoft Teams",
      "loadChatPlatformGoogleChat": "Google Chat",
      "loadChatPlatformInstagram": "Instagram",
      "loadChatPlatformWhatsapp": "WhatsApp",
      "loadChatPlatformMessenger": "Facebook Messenger",
      "loadChatWorkspaceLabel": "Workspace",
      "loadChatWorkspacePlaceholder": "e.g. {{starter.slack.workspaceId}}",
      "loadChatChannelLabel": "Channel",
      "loadChatChannelPlaceholder": "e.g. {{starter.slack.channelId}}",
      "loadChatTeamsChatLabel": "Chat",
      "loadChatTeamsChatPlaceholder": "e.g. {{starter.teams.chatId}}",
      "loadChatGoogleAccountLabel": "Google account",
      "loadChatGoogleAccountPlaceholder": "e.g. {{starter.googleChat.emailAddress}}",
      "loadChatGoogleSpaceLabel": "Space",
      "loadChatGoogleSpacePlaceholder": "e.g. {{starter.googleChat.spaceName}}",
      "loadChatInstagramAccountLabel": "Instagram account",
      "loadChatInstagramAccountPlaceholder": "e.g. {{starter.instagram.accountId}}",
      "loadChatInstagramConversationLabel": "Conversation",
      "loadChatInstagramConversationPlaceholder": "e.g. {{starter.instagram.conversationId}}",
      "loadChatMessengerPageLabel": "Facebook page",
      "loadChatMessengerPagePlaceholder": "e.g. {{starter.facebookMessenger.pageId}}",
      "loadChatMessengerConversationLabel": "Conversation",
      "loadChatMessengerConversationPlaceholder": "e.g. {{starter.facebookMessenger.conversationId}}",
      "loadChatTimeRange": "Time range",
      "loadChatTimeRangeSinceLastExecution": "Since last execution",
      "loadChatTimeRange30m": "Last 30 minutes",
      "loadChatTimeRange1h": "Last 1 hour",
      "loadChatTimeRange2h": "Last 2 hours",
      "loadChatTimeRange3h": "Last 3 hours",
      "loadChatTimeRange6h": "Last 6 hours",
      "loadChatTimeRange12h": "Last 12 hours",
      "loadChatTimeRange24h": "Last 24 hours",
      "loadChatLimit": "Message limit",
      "loadChatContextMessageCount": "Context messages",
      "loadChatContextNone": "None",
      "loadChatAdvancedSettings": "Advanced settings",
      "agentTaskToolSet_INSTAGRAM": "Instagram (list posts & comments, read insights, reply to comments, DMs — publishing is a separate step)",
      "agentTaskToolSet_TEAMS": "Microsoft Teams (list chats, send messages)",
      "agentTaskToolSet_ARTIFACT": "Artifacts (build and export documents)"
    },
    "categories": {
      "ai_skills": "AI Skills",
      "tools": "Tools",
      "communications": "Communications",
      "gmail": "Gmail",
      "google_chat": "Google Chat",
      "slack": "Slack",
      "instagram": "Instagram",
      "dobox": "DoBox",
      "external": "External Tools (MCP)",
      "calendar": "Calendar",
      "teams": "Teams",
      "knowledge": "Knowledge",
      "people": "People",
      "google_business": "Google Business Profile",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook",
      "microsoft_teams": "Microsoft Teams"
    },
    "labelPicker": {
      "systemLabels": "System labels",
      "yourLabels": "Your labels",
      "empty": "No labels found. Create labels in Gmail first.",
      "unread": "Unread",
      "important": "Important",
      "starred": "Starred",
      "sent": "Sent",
      "inbox": "Inbox",
      "draft": "Draft"
    },
    "categoryPicker": {
      "title": "Gmail categories",
      "primary": "Primary",
      "updates": "Updates",
      "social": "Social",
      "promotions": "Promotions",
      "forums": "Forums"
    },
    "variables": {
      "insert": "Variables",
      "removeVariable": "Remove variable",
      "triggerTitle": "When I get an email",
      "stepsTitle": "Previous steps",
      "knowledgePageTitle": "Knowledge page title",
      "knowledgePagePath": "Knowledge page path",
      "knowledgePageContent": "Knowledge page content (markdown)",
      "knowledgePageId": "Knowledge page ID",
      "knowledgeSpaceId": "Knowledge space ID",
      "knowledgePageVersion": "Knowledge page version",
      "knowledgeParentPageId": "Knowledge parent page ID",
      "knowledgeOwnerType": "Knowledge space owner type",
      "knowledgeOwnerId": "Knowledge space owner ID",
      "emailSubject": "Email subject",
      "emailBody": "Email body",
      "emailDateTime": "Email date and time",
      "emailTo": "Email addresses in 'To'",
      "emailCc": "Email addresses in 'Cc'",
      "senderDisplayName": "Sender display name",
      "senderEmail": "Sender email",
      "emailAttachments": "Email attachments (text)",
      "slackMessage": "Slack message",
      "slackChannel": "Slack channel",
      "slackChannelId": "Slack channel ID",
      "slackWorkspaceId": "Slack workspace ID",
      "slackAuthor": "Slack author",
      "slackAuthorId": "Slack author ID",
      "slackDateTime": "Slack date and time",
      "slackAttachments": "Slack attachments",
      "googleChatMessage": "Google Chat message",
      "googleChatSpaceName": "Google Chat space name",
      "googleChatSpaceId": "Google Chat space ID",
      "googleChatSpaceType": "Google Chat space type",
      "googleChatEmailAddress": "Google Chat account",
      "googleChatAuthor": "Google Chat author",
      "googleChatAuthorId": "Google Chat author ID",
      "googleChatAuthorEmail": "Google Chat author email",
      "googleChatThreadName": "Google Chat thread name",
      "googleChatDateTime": "Google Chat date and time",
      "outputSendGoogleChatMessageResult": "Send result",
      "teamsMessage": "Microsoft Teams message",
      "teamsChatId": "Microsoft Teams chat ID",
      "teamsChatName": "Microsoft Teams chat name",
      "teamsChatType": "Microsoft Teams chat type",
      "teamsAuthorName": "Microsoft Teams author name",
      "teamsAuthorEmail": "Microsoft Teams author email",
      "teamsMessageUrl": "Microsoft Teams message URL",
      "teamsTenantId": "Microsoft Teams tenant ID",
      "teamsHomeAccountId": "Microsoft Teams account",
      "teamsMessageId": "Microsoft Teams message ID",
      "teamsReceivedAt": "Microsoft Teams date and time",
      "instagramMessage": "Instagram message",
      "instagramSenderName": "Instagram sender name",
      "instagramAuthorId": "Instagram sender ID",
      "instagramConversationId": "Instagram conversation ID",
      "instagramAccountId": "Instagram account ID",
      "instagramAccountUsername": "Instagram account username",
      "instagramDateTime": "Instagram date and time",
      "instagramStoryId": "Instagram story ID",
      "instagramStoryUrl": "Instagram story URL",
      "instagramContentPostId": "Instagram post ID",
      "instagramContentCommentId": "Instagram comment ID",
      "instagramContentParentCommentId": "Instagram parent comment ID",
      "instagramContentCommentText": "Instagram comment text",
      "instagramContentAuthorUsername": "Instagram commenter username",
      "githubEvent": "GitHub event",
      "githubAction": "GitHub action",
      "githubRepository": "GitHub repository",
      "githubRef": "GitHub branch or tag",
      "githubUrl": "GitHub URL",
      "githubAuthor": "GitHub author",
      "githubBody": "GitHub body",
      "gbpReviewName": "Review resource name",
      "gbpReviewId": "Review ID",
      "gbpRating": "Review rating",
      "gbpAuthorName": "Reviewer name",
      "gbpReviewText": "Review text",
      "gbpLocationName": "Location resource name",
      "gbpIsUpdate": "Is updated review",
      "gbpExistingReply": "Existing reply text",
      "gbpCreatedAt": "Review date and time",
      "facebookCommentId": "Facebook comment ID",
      "facebookCommentText": "Facebook comment text",
      "facebookPostId": "Facebook post ID",
      "facebookPageId": "Facebook page ID",
      "facebookPageName": "Facebook page name",
      "facebookAuthorName": "Facebook commenter name",
      "facebookAuthorId": "Facebook commenter ID",
      "facebookParentCommentId": "Facebook parent comment ID",
      "facebookDateTime": "Facebook comment date and time",
      "facebookMessengerMessage": "Facebook message",
      "facebookMessengerSenderName": "Facebook sender name",
      "facebookMessengerAuthorId": "Facebook sender ID",
      "facebookMessengerConversationId": "Facebook conversation ID",
      "facebookMessengerPageId": "Facebook page ID",
      "facebookMessengerPageName": "Facebook page name",
      "facebookMessengerDateTime": "Facebook date and time",
      "outputSummary": "Summary",
      "outputResponse": "AI Response",
      "outputDecision": "Decision",
      "outputDoBoxId": "DoBox ID",
      "outputDoBoxEntries": "DoBox entries",
      "outputCommunications": "Communications",
      "outputChatCommunications": "Chat Communications",
      "outputValidationResult": "Validation result (PROCEED/BLOCK)",
      "outputActionabilityResult": "Actionability verdict (ACTIONABLE / NOT_ACTIONABLE)",
      "outputRagContext": "RAG Context",
      "outputAppendedEntryId": "Appended entry ID",
      "outputCheckAndAppendResult": "Match result (MATCHED/NO_MATCH)",
      "outputProcessDoBoxResult": "Created and appended DoBox entries",
      "outputMcpToolCallResult": "MCP Tool result",
      "outputCalendarRsvpResult": "RSVP result",
      "outputCalendarCreatedEvent": "Created event ID",
      "outputCalendarDeleteResult": "Delete result",
      "outputCalendarRescheduleResult": "Reschedule result",
      "outputCalendarAddAttendeesResult": "Add attendees result",
      "outputCalendarRemoveAttendeesResult": "Remove attendees result",
      "outputAgentTaskResult": "Agent output",
      "outputMeetings": "Meetings",
      "outputPeopleSearchResults": "Matching people",
      "outputTeamPeople": "Team people",
      "outputUpdatePersonNotesResult": "Update notes result",
      "outputCreatePersonEventResult": "Create person event result",
      "forEachItem": "Current item",
      "forEachIndex": "Current index",
      "forEachTotal": "Total items",
      "calendarTitle": "Calendar",
      "calendarEventId": "Calendar event ID",
      "calendarSummary": "Calendar event title",
      "calendarResponseStatus": "Calendar RSVP status",
      "calendarOrganizer": "Organizer email",
      "calendarOrganizerName": "Organizer name",
      "calendarStartTime": "Event start time",
      "calendarEndTime": "Event end time",
      "calendarTimeZone": "Event time zone",
      "doboxInboxEntryId": "DoBox entry ID",
      "doboxSubject": "DoBox subject",
      "doboxDescription": "DoBox description",
      "doboxTaskGroupName": "DoBox list name",
      "doboxTaskLabelNames": "DoBox label names",
      "doboxDueAt": "DoBox due date",
      "doboxAddedParticipantNames": "Added member names",
      "doboxAddedLabelNames": "Added label names",
      "doboxRemovedLabelNames": "Removed label names",
      "doboxNewTaskGroupName": "New list name",
      "doboxCommentId": "Comment ID",
      "doboxCommentMessage": "Comment message",
      "doboxCommentAuthor": "Comment author",
      "outputKnowledgePageContent": "Knowledge page content",
      "emailMessageId": "Email message ID",
      "personId": "Person ID",
      "personDisplayName": "Person display name",
      "personEmails": "Person emails",
      "personPhones": "Person phones",
      "personJobTitle": "Person job title",
      "personNotes": "Person notes",
      "personOrigin": "Person origin",
      "personTeamId": "Person team ID",
      "whatsappMessage": "WhatsApp message",
      "whatsappSenderName": "WhatsApp sender name",
      "whatsappSenderUsername": "WhatsApp sender username",
      "whatsappCounterpartId": "WhatsApp counterpart ID",
      "whatsappPhoneNumberId": "WhatsApp number ID",
      "whatsappDisplayPhoneNumber": "WhatsApp display number",
      "whatsappDateTime": "WhatsApp message date",
      "scheduleFiredAt": "Fire timestamp",
      "scheduleFireDateLocal": "Fire date (local)",
      "scheduleFireTimeLocal": "Fire time (local)",
      "manualTriggeredAt": "Triggered at",
      "manualTriggeredByUserId": "Triggered by (user ID)",
      "emailRecipients": "All recipients"
    },
    "step": {
      "stepLabel": "Step {{number}}",
      "outputAgentTaskResult": "Agent output",
      "doboxInboxEntryId": "DoBox entry ID",
      "doboxSubject": "DoBox subject",
      "doboxDescription": "DoBox description",
      "doboxTaskGroupName": "DoBox list name",
      "doboxTaskLabelNames": "DoBox label names",
      "doboxDueAt": "DoBox due date",
      "doboxAddedParticipantNames": "Added member names",
      "doboxAddedLabelNames": "Added label names",
      "doboxRemovedLabelNames": "Removed label names",
      "doboxNewTaskGroupName": "New list name",
      "doboxCommentId": "Comment ID",
      "doboxCommentMessage": "Comment message",
      "doboxCommentAuthor": "Comment author"
    },
    "checkIf": {
      "description": "Do the next steps only if specific conditions are met.",
      "if": "If",
      "also": "Also",
      "and": "AND",
      "or": "OR",
      "selectVariable": "Select a variable...",
      "valuePlaceholder": "Enter a value...",
      "addCondition": "Add condition",
      "removeCondition": "Remove condition",
      "operatorLabel": "Operator",
      "starterPrefix": "Starter",
      "stepPrefix": "Step",
      "stepLabel": "Step {{number}}",
      "substepLabel": "Step {{number}}",
      "addSubstep": "Add substep",
      "noSubsteps": "No substeps yet. Add one below.",
      "operators": {
        "contains": "contains",
        "not_contains": "does not contain",
        "equals": "equals",
        "not_equals": "does not equal",
        "starts_with": "starts with",
        "ends_with": "ends with",
        "is_empty": "is empty",
        "is_not_empty": "is not empty",
        "is_true": "is true",
        "is_false": "is false"
      }
    },
    "forEach": {
      "stepLabel": "Step {{number}}",
      "substepLabel": "Step {{number}}",
      "addSubstep": "Add step to loop",
      "noSubsteps": "No steps yet. Add one to run for each item."
    },
    "loadCommunications": {
      "description": "Load communications from a specific platform within a time range. Use filters to narrow down results.",
      "platform": "Platform",
      "platformGmail": "Gmail",
      "platformOutlook": "Outlook",
      "platformSlack": "Slack",
      "platformTeams": "Teams",
      "timeInterval": "Time interval",
      "intervalLastHours": "Last X hours",
      "intervalToday": "Today",
      "intervalThisWeek": "This week",
      "intervalThisMonth": "This month",
      "hours": "Number of hours",
      "hoursPlaceholder": "e.g. 24",
      "filterBy": "Filter by",
      "filterPlaceholder": "Select a filter...",
      "gmailFilterAll": "All emails",
      "gmailFilterByLabel": "By label",
      "gmailFilterByAuthorEmail": "By sender email",
      "gmailFilterByCategory": "By category",
      "gmailFilterByArchived": "Archived emails",
      "slackFilterAll": "All messages",
      "slackFilterByChannel": "By channel",
      "slackFilterByPerson": "By person",
      "authorEmail": "Sender email",
      "authorEmailPlaceholder": "e.g. john@example.com",
      "category": "Category",
      "categoryPlaceholder": "Select a category...",
      "channel": "Channel name",
      "channelPlaceholder": "e.g. #general",
      "person": "Person",
      "personPlaceholder": "e.g. @john"
    },
    "loadMeetings": {
      "description": "Load meetings from your calendar within a time range.",
      "platform": "Calendar provider",
      "platformGmail": "Google Calendar",
      "platformOutlook": "Outlook Calendar",
      "timeInterval": "Time interval",
      "intervalLastHours": "Last X hours",
      "intervalToday": "Today",
      "intervalThisWeek": "This week",
      "hours": "Number of hours",
      "hoursPlaceholder": "e.g. 24",
      "calendarAccount": "Calendar account",
      "calendarAccountPlaceholder": "Select an account",
      "calendar": "Calendar",
      "calendarPlaceholder": "Select a calendar"
    },
    "loadTeamMembers": {
      "description": "Loads your team members. Pair with a For Each step to act on each member individually — use {{forEach.item.userId}}, {{forEach.item.email}}, or {{forEach.item.name}} in downstream steps.",
      "teamIdLabel": "Team ID (optional)",
      "teamIdPlaceholder": "Leave blank to load all teams",
      "teamIdHelperText": "Leave blank to load members from all your teams, or enter a specific team ID to restrict to one team."
    },
    "loadTeamPeople": {
      "description": "Loads people (contacts) shared with a team. Pair with a For Each step to act on each person individually.",
      "teamIdLabel": "Team ID",
      "teamIdPlaceholder": "e.g. {{step.step-0.output.teamId}}",
      "teamIdHelperText": "The team whose shared people should be loaded.",
      "queryLabel": "Search query (optional)",
      "queryPlaceholder": "Leave blank to load all people shared with the team",
      "queryHelperText": "When set, only people matching this search are returned instead of the full list."
    },
    "checkTeamCalendar": {
      "description": "Check teammates' calendars. Privacy-gated: free/busy and public events only.",
      "modeLabel": "Mode",
      "modeAvailability": "Availability (find mutual free slots)",
      "modeEvents": "Public events (list calendar entries)",
      "membersLabel": "Members",
      "membersPlaceholder": "e.g. {{step.step-0.output.members}}",
      "membersHelperText": "Accepts a variable reference to a members list, a single {{forEach.item.userId}}, or a comma-separated list of userIds/emails.",
      "rangeLabel": "Time range shorthand (optional)",
      "rangePlaceholder": "Select a shorthand range…",
      "rangeHelperText": "Ignored when both Time Min and Time Max are set.",
      "rangeToday": "Today",
      "rangeThisWeek": "This week",
      "rangeNext7Days": "Next 7 days",
      "timeMinLabel": "Time min (optional)",
      "timeMinPlaceholder": "e.g. 2024-01-01T00:00:00+00:00",
      "timeMaxLabel": "Time max (optional)",
      "timeMaxPlaceholder": "e.g. 2024-01-07T23:59:59+00:00",
      "timeRangeHelperText": "ISO 8601 with UTC offset. When both are set, the range shorthand above is ignored.",
      "durationMinutesLabel": "Slot duration (minutes)",
      "durationMinutesPlaceholder": "Default: 30",
      "maxSlotsLabel": "Max slots to return",
      "maxSlotsPlaceholder": "Default: 5 (max 10)",
      "maxSlotsHelperText": "Maximum number of available slots to return (1–10).",
      "includeSelfLabel": "Include your own calendar",
      "includeSelfYes": "Yes (include my calendar)",
      "includeSelfNo": "No (teammates only)",
      "subjectContainsLabel": "Subject contains (optional)",
      "subjectContainsPlaceholder": "Filter events by subject keyword"
    },
    "loadKnowledgePage": {
      "spaceLabel": "Space",
      "spacePlaceholder": "Select a space…",
      "spaceTeamBadge": "team",
      "pageLabel": "Page",
      "pagePlaceholder": "Select a page…",
      "pageHelp": "Select the specific page to load from the chosen space."
    },
    "actions": {
      "save": "Save",
      "run": "Run",
      "saveBeforeRun": "Save the flow before running it",
      "testRun": "Test run",
      "turnOn": "Turn on"
    },
    "manualTrigger": {
      "title": "Manual trigger",
      "description": "This agent runs manually on demand. Save the flow, then click Run to execute it.",
      "changeStarter": "Change starter"
    },
    "peopleTrigger": {
      "title": "New person created",
      "description": "Run this flow whenever a new person is added to your contacts, whether created manually, imported, or synced from an integration.",
      "scopeLabel": "Contacts that start this flow",
      "personalScope": "My contacts",
      "personalScopeHelp": "Fires when a new contact is added to your personal contacts.",
      "teamsLabel": "Teams",
      "teamsHelp": "Fires when a new contact is added to a checked team's shared contacts.",
      "teamUnavailable": "(no longer a member)",
      "lockedScopeMarker": "(locked)",
      "lockedScopeReason": "This is the only contact source selected — leaving none selected would mean this trigger could never fire. Check another scope to unlock it.",
      "teamNameUnknown": "Unknown team",
      "teamsLoadError": "Couldn't load your teams.",
      "neverFiresError": "Select at least one scope for this trigger — with none selected, it could never fire.",
      "teamMembershipError": "You're no longer a member of one of the checked teams — uncheck it before saving.",
      "changeStarter": "Change starter"
    },
    "editorMode": {
      "label": "Editor mode",
      "builder": "Builder",
      "aiChat": "AI Chat"
    },
    "aiChat": {
      "placeholder": "Describe what you want your agent to do...",
      "send": "Send",
      "welcomeMessage": "Hi! Describe the agent you want to create and I'll build it for you.",
      "flowApplied": "Flow updated! Switch to Builder to see details or keep chatting to refine.",
      "generating": "Generating your flow...",
      "building": "Building your flow...",
      "emptyState": "Try one of these prompts to get started",
      "generationTimeout": "Generation timed out. Please try again."
    },
    "whatsappTrigger": {
      "title": "WhatsApp trigger",
      "description": "Runs when a new WhatsApp message arrives on the selected business number. Messages you send do not trigger it.",
      "numberLabel": "WhatsApp number",
      "numberPlaceholder": "Select a WhatsApp number",
      "noAccountsTitle": "Connect a WhatsApp number",
      "noAccountsMessage": "You have no WhatsApp Business number connected yet. Go to Integrations to connect one.",
      "noAccountsCta": "Go to Integrations",
      "changeStarter": "Change trigger",
      "executionType": "Execution type",
      "immediate": "Immediate",
      "debounce": "Debounce",
      "debounceMinutes": "Debounce delay (minutes)"
    }
  },
  "flowPlan": {
    "panel": {
      "untitled": "New automation",
      "statusDraft": "Draft",
      "statusReady": "Ready",
      "statusActive": "Active"
    },
    "plan": {
      "triggerPrefix": "Trigger: {{trigger}}"
    }
  },
  "flowCostEstimate": {
    "title": "Estimated cost",
    "perRun_one": "{{credits}} credit per run",
    "perRun_other": "{{credits}} credits per run",
    "perRun_belowOne": "Less than 1 credit per run",
    "perMonth_one": "{{credits}} credit per month",
    "perMonth_other": "{{credits}} credits per month",
    "perMonth_belowOne": "Less than 1 credit per month",
    "upToPerMonth_one": "Up to {{credits}} credit per month",
    "upToPerMonth_other": "Up to {{credits}} credits per month",
    "upToPerMonth_belowOne": "Less than 1 credit per month",
    "unknownExecutions": "Not enough data yet to estimate how often this flow will run each month.",
    "partialPricingNote": "Some steps in this flow can't be priced yet — the totals above are a minimum.",
    "freeSteps_one": "{{count}} step runs for free",
    "freeSteps_other": "{{count}} steps run for free",
    "pricedSteps_one": "{{count}} step priced from real usage",
    "pricedSteps_other": "{{count}} steps priced from real usage",
    "unpricedSteps_one": "{{count}} step not priced yet",
    "unpricedSteps_other": "{{count}} steps not priced yet",
    "actualMonthToDate_one": "Spent so far this month: {{credits}} credit",
    "actualMonthToDate_other": "Spent so far this month: {{credits}} credits",
    "actualMonthToDate_belowOne": "Spent so far this month: less than 1 credit",
    "error": "Couldn't load the cost estimate.",
    "runsPerMonth": {
      "label": "Runs per month",
      "placeholder": "e.g. 100",
      "reset": "Use suggested value",
      "source": {
        "schedule": "Exact — from this flow's own schedule.",
        "debounced": "Estimated from grouped messages, batched into one run every {{minutes}} minutes.",
        "communication": "Estimated as one run per message received.",
        "similarFlows": "Reference number from your other flows with a similar trigger — the least reliable estimate.",
        "unknown": "Not enough data to suggest a number. Enter how many times you expect this flow to run each month."
      }
    }
  },
  "automationChat": {
    "header": {
      "back": "Back to flows",
      "title": "Create an automation",
      "subtitle": "Tell me what you want to automate in plain words",
      "viewSteps": "View steps"
    },
    "mobileView": {
      "chat": "Chat",
      "workspace": "Plan"
    },
    "composer": {
      "placeholder": "Describe what you want to automate...",
      "send": "Send"
    },
    "attachments": {
      "attachButtonLabel": "Attach files",
      "removeLabel": "Remove {{name}}",
      "tooManyFiles": "You can attach up to {{max}} files.",
      "tooLarge": "Attached files are too large. Please keep the combined content under 80,000 characters.",
      "unsupportedType": "\"{{name}}\" isn't a supported file type. Use .txt, .md, .csv, .json, .log, .yml or .yaml.",
      "readFailed": "Couldn't read \"{{name}}\". Please try again."
    },
    "chat": {
      "greeting": "Hi — tell me what you'd like to automate, in plain words. I'll ask a couple of quick questions, set it up, and you can run it right here.",
      "generating": "Working on it...",
      "clarificationNeeded": "I need a bit more detail before I can build this.",
      "upgradeSuggested": "This sounds like it needs a few connected automations working together as a workflow. I can build it that way, or keep it as one single flow if you prefer.",
      "answersSubmitted": "Here are my answers.",
      "flowCreatedSchedule": "I built \"{{name}}\" — {{schedule}} Run now executes it once right away too.",
      "flowCreatedManual": "I built \"{{name}}\" as a manual automation — it only runs when you press Run now.",
      "flowCreatedEvent": "I built \"{{name}}\" — it triggers {{trigger}}. Run now does a single test run without a real event; activate it so it runs automatically whenever that happens.",
      "runFinishedSuccess": "Run finished successfully.",
      "runFinishedFailure": "Run finished with errors.",
      "runFinishedSuccessWithSummary": "Run finished successfully — {{summary}}",
      "runFinishedFailureWithSummary": "Run finished with errors — {{summary}}",
      "flowUpdated": "Done — I updated \"{{name}}\". The panel on the right shows the new plan. You can keep tweaking it here, run it, or open it in the editor.",
      "groupCreated": "I built \"{{name}}\" as a workflow of {{count}} connected automations. Each one runs independently on its own trigger — expand a flow on the right to see its plan or run it on its own.",
      "groupUpdated": "Done — I updated the \"{{name}}\" workflow. The panel on the right shows the new plan.",
      "validationWarnings": "A few things worth double-checking: {{issues}}"
    },
    "chips": {
      "runNow": "Run it now",
      "activate": "Activate automation",
      "openInEditor": "Open in editor",
      "continueAsSingleFlow": "Continue as single flow",
      "createAsWorkflow": "Create as a workflow ({{count}} automations)",
      "example1": "Triage my inbox — archive the noise, create DoBox tasks for what matters",
      "example2": "Send me a daily unread summary",
      "example3": "Auto-archive newsletters"
    },
    "panel": {
      "emptyState": "A plain-language view of your automation. It fills in as we chat.",
      "checklistTitle": "Setup checklist",
      "untitled": "New automation",
      "untitledGroup": "New workflow",
      "subtitle": "A plain-language view of your automation. It fills in as we chat.",
      "groupSubtitle": "A plain-language view of your workflow's automations. It fills in as we chat.",
      "statusDraft": "Draft",
      "statusReady": "Ready",
      "statusActive": "Active",
      "updating": "Updating…"
    },
    "checklist": {
      "summary": "Setup · {{answered}} answered",
      "expandAria": "Expand setup checklist",
      "collapseAria": "Collapse setup checklist"
    },
    "plan": {
      "unknownTrigger": "when triggered",
      "triggerPrefix": "Trigger: {{trigger}}",
      "checkIfBullet": "Check if {{variable}} {{operator}} {{value}}",
      "checkIfBulletNoValue": "Check if {{variable}} {{operator}}",
      "checkIfBulletWithMore": "{{condition}} (+{{count}} more condition)",
      "forEachBullet": "Repeat for each item in {{source}}",
      "forEachBulletGeneric": "Repeat for each item"
    },
    "proposedAgents": {
      "title": "New agents this flow will create",
      "description": "These specialist sub-agents will be created and wired into the steps above.",
      "teamBadge": "Team"
    },
    "runControls": {
      "runNow": "Run now",
      "activate": "Activate",
      "openInEditor": "Open in editor",
      "noteSchedule": "Once activated it runs automatically {{schedule}}. Run now executes it once right away.",
      "noteEvent": "Run now does a single test run without a real email or message. Activate it so it runs automatically whenever a matching event arrives.",
      "noteManual": "This flow only runs when you press Run now.",
      "scheduleUnknown": "on its schedule"
    },
    "group": {
      "runNow": "Run now",
      "activate": "Activate workflow",
      "openWorkflow": "Open workflow"
    },
    "runLog": {
      "title": "Run log",
      "workingLabel": "Working...",
      "viewFullHistory": "View full history",
      "metrics": {
        "stepsRun": "Steps run",
        "succeeded": "Succeeded",
        "failed": "Failed",
        "durationSeconds": "Duration (s)"
      },
      "conditionMet": "condition met",
      "conditionNotMet": "condition not met",
      "actionsRan": "Actions inside this condition were executed."
    },
    "errors": {
      "generationFailed": "Something went wrong while building your automation. Please try again.",
      "generationTimeout": "This is taking longer than expected. Please try again.",
      "createFailed": "I built the automation but couldn't save it. Please try again.",
      "activateFailed": "Couldn't activate the automation. Please try again.",
      "updateFailed": "I couldn't apply that change. Please try again."
    },
    "progress": {
      "working": "Working on it...",
      "checkingAccounts": "Checking your connected accounts...",
      "checkingExistingFlows": "Looking for similar existing flows...",
      "checkingEmailLabels": "Checking your email labels...",
      "creatingEmailLabel": "Creating an email label...",
      "checkingTaskGroups": "Checking your task groups...",
      "checkingSlack": "Checking your Slack workspace...",
      "checkingConnections": "Checking your connected tools...",
      "checkingAgents": "Checking your agents...",
      "preparingQuestions": "Preparing a few questions for you...",
      "preparingReview": "Preparing a review of the plan...",
      "assembling": "Assembling your automation..."
    },
    "activity": {
      "sectionTitle": "Activity",
      "started": "Started building your automation",
      "questionsAsked": "Asked {{count}} question(s)",
      "answersSubmitted": "Submitted your answers",
      "planAssembled": "Assembled the plan",
      "flowCreated": "Created \"{{name}}\"",
      "groupCreated": "Created workflow \"{{name}}\"",
      "flowUpdated": "Updated \"{{name}}\"",
      "groupUpdated": "Updated workflow \"{{name}}\"",
      "runStarted": "Started a run",
      "testRunWithSample": "Test run with: {{sample}}",
      "runFinishedSuccess": "Run finished successfully",
      "runFinishedFailure": "Run finished with errors",
      "activated": "Activated the automation",
      "error": "Something went wrong"
    },
    "samplePicker": {
      "title": "Test with a real event",
      "subtitle": "Pick a recent matching event and the run will use it exactly as if it had just arrived.",
      "loading": "Looking for matching events...",
      "empty": "No recent events match this trigger — check the trigger filters, or run without a sample.",
      "runWithSelected": "Run with selected",
      "runWithoutSample": "Run without a sample",
      "simulateWithAi": "Simulate with AI",
      "cancel": "Cancel"
    },
    "scenarioSim": {
      "title": "Simulate with AI",
      "subtitle": "Generate 3 AI-written trigger events — a happy path, an edge case, and one that should not trigger — then edit and run each to see the verdict.",
      "loading": "Generating scenarios...",
      "cancel": "Cancel",
      "runScenario": "Run this scenario",
      "errors": {
        "generateFailed": "Couldn't generate scenarios. Please try again.",
        "runFailed": "Couldn't run this scenario. Please try again."
      },
      "kind": {
        "HAPPY_PATH": "Happy path",
        "EDGE_CASE": "Edge case",
        "NON_TRIGGERING": "Should not trigger"
      },
      "fields": {
        "senderName": "Sender name",
        "senderEmail": "Sender email",
        "subject": "Subject",
        "body": "Body",
        "authorName": "Author name",
        "message": "Message",
        "description": "Description",
        "commentMessage": "Comment",
        "commentAuthor": "Comment author"
      },
      "slackContext": {
        "location": "#{{channel}} · {{workspace}}",
        "locationNoChannel": "{{workspace}}"
      },
      "doboxContext": {
        "taskGroupOnly": "{{taskGroup}}",
        "taskGroupWithLabels": "{{taskGroup}} · {{labels}}",
        "addedParticipants": "Added: {{names}}",
        "addedLabels": "Labels added: {{names}}",
        "removedLabels": "Labels removed: {{names}}",
        "movedTo": "Moved to {{taskGroup}}"
      },
      "verdict": {
        "correctlyFiltered": "Correctly filtered out — this flow would not have triggered.",
        "filterTooBroad": "Triggered but should not have — the flow's filter may be too broad.",
        "triggeredAsExpected": "Triggered as expected.",
        "didNotTrigger": "Would not trigger — check the flow's filters."
      }
    },
    "restore": {
      "loading": "Loading your conversation…",
      "failed": "I couldn't restore the previous conversation, but you can keep going — just tell me what you'd like to change.",
      "resumedGreeting": "Welcome back — I've loaded \"{{name}}\". What would you like to change?",
      "resumedActivity": "Conversation resumed"
    }
  },
  "evalAnnotations": {
    "configPageTitle": "Eval configuration",
    "annotationsPageTitle": "Eval annotations",
    "sourceAccounts": "Source accounts",
    "sourceAccountsHint": "messages sampled from these users",
    "dailySampleSize": "Daily sample size",
    "dailySampleHint": "messages sampled per day",
    "positiveNegativeRatio": "Positive / negative ratio",
    "ratioHint": "{{positivePct}}% of samples must contain tasks · {{negativePct}}% without",
    "notificationRecipients": "Notification recipients",
    "messageRecipients": "Recipients",
    "notifications": "Notifications",
    "notificationsHintOn": "Recipients are notified when new annotations are ready.",
    "notificationsHintOff": "Notifications are off. Recipients will not be alerted.",
    "sampling": "Sampling",
    "discard": "Discard",
    "saveConfig": "Save configuration",
    "updated": "Updated {{date}}",
    "unsavedChanges": "Unsaved changes",
    "allChangesSaved": "All changes saved",
    "errorLoadingConfig": "Failed to load configuration",
    "configSaved": "Configuration saved successfully",
    "configSaveError": "Failed to save configuration",
    "userAdded": "User added",
    "userRemoved": "User removed",
    "addUser": "Add",
    "addUserPlaceholder": "Add by e-mail",
    "userNotFound": "User not found",
    "removeUser": "Remove",
    "unknownUser": "Unknown user",
    "noUsersAdded": "No users added yet",
    "filterByStatus": "Filter by status",
    "allStatuses": "All",
    "pending": "Pending",
    "completed": "Completed",
    "skipped": "Skipped",
    "noAnnotations": "No annotations found",
    "noAnnotationsDescription": "Configure source accounts and run the sampling pipeline to create annotations",
    "annotationId": "ID",
    "llmTaskCount_one": "{{count}} LLM task",
    "llmTaskCount_other": "{{count}} LLM tasks",
    "humanTaskCount_one": "{{count}} human",
    "humanTaskCount_other": "{{count}} human",
    "compareHint": "Click a row to compare LLM tasks with the human annotation",
    "compareHintMobile": "Tap a row to compare LLM tasks with the human annotation",
    "selectAnnotation": "Select an annotation",
    "loadMore": "Load more",
    "loading": "Loading...",
    "noSubject": "No subject",
    "tasks": "Tasks",
    "addTask": "Add task",
    "submitAndNext": "Submit & next",
    "skipAndNext": "Skip & next",
    "backToList": "Back to annotations",
    "taskTitle": "Title",
    "taskDescription": "Description",
    "taskPriority": "Priority",
    "taskDueDate": "Due date",
    "taskParticipants": "Members",
    "taskNumber": "Task {{number}}",
    "removeTask": "Remove task",
    "noTasksYet": "No tasks added yet. Click 'Add task' to begin annotating.",
    "titleRequired": "All tasks must have a title",
    "annotationSubmitted": "Annotation submitted successfully",
    "annotationSkipped": "Annotation skipped",
    "allAnnotationsComplete": "All pending annotations are complete!",
    "submitError": "Failed to submit annotation",
    "deleteError": "Failed to delete annotation",
    "deleteAnnotation": "Delete & next",
    "annotationDeleted": "Annotation deleted",
    "annotationNotFound": "Annotation not found",
    "errorLoadingAnnotation": "Failed to load annotation",
    "threadMessages": "Thread messages",
    "toRecipients": "To:",
    "ccRecipients": "CC:",
    "bccRecipients": "BCC:",
    "directMessage": "Direct message",
    "messageDetailsToggle": "Details",
    "noParticipantsAvailable": "No members available for this message",
    "llmExtracted": "LLM extracted",
    "humanAnnotation": "Human annotation",
    "noTasks": "No tasks extracted",
    "awaitingAnnotation": "Awaiting annotation",
    "skippedByAnnotator": "Skipped by the annotator",
    "wrongPerspectiveShort": "wrong perspective",
    "priorityMicro": "P{{priority}}",
    "annotate": "Annotate",
    "skip": "Skip",
    "unsavedEditTitle": "You have unsaved changes",
    "unsavedEditBody": "Switching to another annotation will discard your edits.",
    "keepEditing": "Keep editing",
    "discardChanges": "Discard changes",
    "priorityLevels": {
      "1": "1 - Highest",
      "2": "2 - High",
      "3": "3 - Medium",
      "4": "4 - Low",
      "5": "5 - Lowest"
    },
    "taskWrongPerspective": "Wrong perspective",
    "taskWrongPerspectiveHint": "Tick if the extractor picked the wrong actor (e.g., assignee = recipient instead of sender).",
    "guidelines": {
      "toggle": "Annotation guidelines",
      "policyLine": "One-line policy: Annotate each message based on what that message alone asks of the user. Don't carry context from earlier messages in the thread.",
      "bullet1": "Each message is labeled independently. The thread is visible for human comprehension, but only the message under annotation determines the labels.",
      "bullet2": "A message that asks the user to do something is a task (\"Please buy milk\").",
      "bullet3": "A message that is a statement, an acknowledgement, or the user's own outgoing reply is not a task (\"I'm going to the store\", \"I bought milk\", \"thanks!\"). These get no task annotation even if the parent message in the thread had one.",
      "bullet4": "Tasks are from the user's perspective. If the message is asking the sender to do something, that's not a task for the user.",
      "bullet5Bold": "Wrong perspective:",
      "bullet5Body": "tick the wrong-perspective checkbox on a task when the extractor invented a task by mis-reading whose responsibility it is.",
      "rationale": "Why we annotate this way: production extracts tasks one message at a time, with no thread context seeded into the prompt. Annotating against thread state would punish the model for inferences it has no input to make."
    },
    "removeUserAriaLabel": "Remove {{email}}",
    "annotationIdAriaLabel": "ID: {{id}}",
    "senderToRecipient": "→ {{recipient}}",
    "channelLabel": "Channel:",
    "channelName": "#{{channel}}"
  },
  "evalLanding": {
    "pageTitle": "Eval",
    "pageDescription": "LLM evaluation tools and configuration",
    "annotationsCardTitle": "Annotations",
    "annotationsCardDescription": "Review sampled messages and compare LLM tasks with human judgement",
    "annotationsCardAriaLabel": "Go to Eval Annotations",
    "configCardTitle": "Configuration",
    "configCardDescription": "Source accounts, recipients and sampling parameters",
    "configCardAriaLabel": "Go to Eval Configuration",
    "dashboardCardTitle": "Dashboard",
    "dashboardCardDescription": "Pipeline runs, precision / recall / F1 and field accuracy",
    "dashboardCardAriaLabel": "Go to Eval Dashboard",
    "footnote": "The pipeline samples messages from the source accounts daily, extracts tasks with the LLM, and compares them with human annotations. Precision, recall and F1 come from that comparison.",
    "meta": {
      "pending_one": "{{count}} pending",
      "pending_other": "{{count}} pending",
      "sampling": "{{size}} / day · {{ratio}}% positive",
      "f1": "F1 {{value}}"
    }
  },
  "evalNav": {
    "ariaLabel": "Eval sections",
    "home": "Overview",
    "annotations": "Annotations",
    "config": "Configuration",
    "dashboard": "Dashboard",
    "meta": {
      "tools_one": "{{count}} tool",
      "tools_other": "{{count}} tools",
      "annotations": "{{pending}} · {{notifications}}",
      "notificationsOn": "notifications on",
      "notificationsOff": "notifications off",
      "config": "config \"{{configId}}\"",
      "dashboard": "{{from}} – {{to}}"
    }
  },
  "evalDashboard": {
    "pageTitle": "Eval dashboard",
    "averagePrecision": "Avg precision",
    "averageRecall": "Avg recall",
    "averageF1Score": "Avg F1 score",
    "totalPipelineRuns": "Total runs",
    "runningCount_one": "{{count}} running",
    "runningCount_other": "{{count}} running",
    "rangeCaption": "{{start}} – {{end}}",
    "runHistoryTitle": "Pipeline run history",
    "newestFirst": "newest first",
    "noRuns": "No pipeline runs found",
    "noRunsDescription": "Trigger a pipeline run to start evaluating LLM performance",
    "statusRunning": "Running",
    "statusCompleted": "Completed",
    "statusFailed": "Failed",
    "samplesProgress": "{{completed}} / {{total}}",
    "runFooterCompleted": "P {{precision}} · R {{recall}} · F1 {{f1}} · {{duration}}",
    "runFooterRunning": "Started {{date}}",
    "confusionTitle": "Confusion",
    "confusionTruePositives": "True positives",
    "confusionTruePositivesSub": "LLM and human agree",
    "confusionFalsePositives": "False positives",
    "confusionFalsePositivesSub": "LLM invented a task",
    "confusionFalseNegatives": "False negatives",
    "confusionFalseNegativesSub": "LLM missed a task",
    "noConfusionData": "No confusion data available",
    "fieldAccuracyTitle": "Field accuracy breakdown",
    "exactVsSemantic": "exact match vs semantic match",
    "fieldTitle": "Title",
    "fieldDescription": "Description",
    "noFieldAccuracy": "No field accuracy data available",
    "annotationStatsTitle": "Annotation statistics",
    "annotationsTotalCount_one": "{{count}} total",
    "annotationsTotalCount_other": "{{count}} total",
    "noAnnotationStats": "No annotation data available",
    "pendingAnnotations": "Pending",
    "completedAnnotations": "Completed",
    "skippedAnnotations": "Skipped",
    "triggerRunButton": "Trigger pipeline run",
    "triggerConfirmTitle": "Trigger pipeline run",
    "triggerConfirmMessage": "Are you sure you want to trigger a new pipeline run? This will process all pending annotations.",
    "triggerConfirm": "Trigger",
    "triggerSuccess": "Pipeline run triggered successfully",
    "triggerError": "Failed to trigger pipeline run",
    "runInProgress": "A pipeline run is in progress",
    "loadMore": "Load more",
    "errorLoadingRuns": "Failed to load pipeline runs",
    "errorLoadingMetrics": "Failed to load dashboard metrics",
    "durationSeconds": "{{seconds}}s",
    "durationMinutes": "{{minutes}}m {{seconds}}s",
    "performanceChartTitle": "Performance over time",
    "precision": "Precision",
    "recall": "Recall",
    "f1Score": "F1 score",
    "noChartData": "No completed runs with metrics to display",
    "latestRunLabel": "Latest run",
    "runFromDate": "Run from {{date}}",
    "selectRunAriaLabel": "Select run from {{date}}",
    "fieldAccuracyValue": "{{exact}}% exact · {{semantic}}% semantic"
  },
  "mcpConnections": {
    "pageTitle": "MCP Connections",
    "pageDescription": "Connect external MCP servers to use their tools in your flows.",
    "addButton": "Add Connection",
    "addTitle": "Add MCP Connection",
    "addSubtitle": "Connect to an external MCP server to discover and use its tools.",
    "editTitle": "Edit MCP Connection",
    "editSubtitle": "Update connection settings and manage enabled tools.",
    "nameLabel": "Connection Name",
    "namePlaceholder": "e.g. GitHub, Notion, Custom API...",
    "serverUrlLabel": "Server URL",
    "serverUrlPlaceholder": "e.g. https://api.example.com/mcp/",
    "authTypeLabel": "Authentication",
    "credentialsLabel": "Credentials",
    "credentialsPlaceholder": "Enter API key or token...",
    "credentialsUpdatePlaceholder": "Leave empty to keep current credentials",
    "authType": {
      "NONE": "None",
      "API_KEY": "API Key",
      "BEARER_TOKEN": "Bearer Token",
      "OAUTH2": "OAuth 2.0"
    },
    "status": {
      "CONNECTED": "Connected",
      "DISCONNECTED": "Not connected",
      "ERROR": "Connection error",
      "notConnected": "Not connected"
    },
    "connect": "Connect",
    "searchOnGoogle": "Search on Google",
    "toolCount": "{{discovered}} tools discovered ({{enabled}} enabled)",
    "lastSynced": "Last synced: {{time}}",
    "sync": "Sync",
    "addAndSync": "Add & Sync",
    "syncSuccess": "Connection synced successfully. Tools discovered!",
    "syncingInBackground": "Connection created! Discovering tools...",
    "syncError": "Failed to sync connection. Check the server URL and credentials.",
    "createAndSyncSuccess": "Connection created and tools discovered!",
    "createSuccessSyncFailed": "Connection created but sync failed. Try syncing manually.",
    "createError": "Failed to create connection.",
    "officialUrlMismatch": "This URL isn't valid for {{name}}. Use the default server URL or add it as a custom connection.",
    "updateSuccess": "Connection updated successfully.",
    "updateError": "Failed to update connection.",
    "deleteSuccess": "Connection deleted.",
    "deleteError": "Failed to delete connection.",
    "deleteConfirmTitle": "Delete MCP Connection",
    "deleteConfirmDescription": "Are you sure you want to delete \"{{name}}\"? This will remove it from all flows that use it.",
    "emptyTitle": "No MCP connections yet",
    "emptyDescription": "Connect external MCP servers like GitHub, Notion, or any custom tool server to use their capabilities in your flows.",
    "enabledToolsTitle": "Enabled Tools",
    "enabledToolsDescription": "Select which tools should be available in your flows.",
    "officialMcps": {
      "github": "Connect your <bold>GitHub</bold> account to read repositories, manage issues, and create pull requests from your flows.",
      "notion": "Connect your <bold>Notion</bold> account to read and write pages, databases, and comments in your workspace.",
      "dropbox": "Connect your <bold>Dropbox</bold> account to browse, upload, and manage files and folders from your flows.",
      "box": "Connect your <bold>Box</bold> account to access, share, and manage files and folders stored in your workspace.",
      "figma": "Connect your <bold>Figma</bold> account to read design files, inspect components, and pull assets from your projects.",
      "hubspot": "Connect your <bold>HubSpot</bold> account to manage contacts, companies, and deals from your flows.",
      "atlassianRovo": "Connect your <bold>Atlassian</bold> account to search across Confluence and Jira using Rovo's AI-powered tools.",
      "monday": "Connect your <bold>Monday</bold> account to read and update boards, items, and columns from your flows.",
      "asana": "Connect your <bold>Asana</bold> account to create and manage tasks, projects, and subtasks from your flows.",
      "clickup": "Connect your <bold>ClickUp</bold> account to create and manage tasks, spaces, and lists from your flows.",
      "trello": "Connect your <bold>Trello</bold> account to read and update boards, lists, and cards from your flows.",
      "motion": "Connect your <bold>Motion</bold> account to read and manage tasks, projects, and your calendar from your flows.",
      "tavily": "Connect your <bold>Tavily</bold> account to let your flows search the web, read articles, and extract content from any site.",
      "windsor": "Connect your <bold>Windsor.ai</bold> account to query marketing, CRM, and e-commerce analytics from your flows. Paste your Windsor API key when prompted — it's stored securely and never shown in the URL.",
      "granola": "Connect your <bold>Granola</bold> account to let your assistant search meeting notes and transcripts.",
      "metaAds": "Connect your <bold>Meta Ads</bold> account to manage campaigns, review insights, and build audiences from your flows.",
      "canva": "Connect your <bold>Canva</bold> account to create, edit, and export designs and creatives for your ad campaigns from your flows.",
      "shortcut": "Connect your <bold>Shortcut</bold> account to find, create, and update stories, epics, and docs from your flows.",
      "salesforce": "Connect your <bold>Salesforce</bold> org's hosted MCP server to query records and run flows and Apex actions. The endpoint is specific to your org — paste the URL from your Salesforce setup.",
      "linear": "Connect your <bold>Linear</bold> account to find, create, and update issues, projects, and comments from your flows.",
      "sourcegraph": "Connect your <bold>Sourcegraph</bold> account to search code, navigate references, and run Deep Search across your repositories.",
      "glean": "Connect your <bold>Glean</bold> account to search company knowledge, documents, and conversations from your flows.",
      "snowflake": "Connect your <bold>Snowflake</bold> account to query tables and run Cortex AI tools from your flows."
    },
    "oauthStartError": "Failed to start the authorisation flow. Please try again.",
    "oauthCompleteError": "Failed to complete the authorisation. Please try again.",
    "oauthSuccess": "Connection authorised successfully!",
    "oauthModalExplanation": "You will be redirected to authorise the connection. Return here once you have approved access.",
    "oauthAuthorize": "Authorise",
    "oauthConnecting": "Connecting…",
    "oauthConnectingDescription": "Completing your authorisation. Please wait.",
    "oauthErrorTitle": "Authorisation failed",
    "oauthCallbackMissingParams": "Missing authorisation parameters. Please try connecting again.",
    "oauthBackToIntegrations": "Back to Integrations",
    "oauthClientCredentialsLabel": "OAuth App Credentials",
    "oauthClientIdLabel": "Client ID",
    "oauthClientIdPlaceholder": "Enter your Client ID",
    "oauthClientSecretLabel": "Client Secret",
    "oauthClientSecretPlaceholder": "Enter your Client Secret",
    "oauthRedirectUrlLabel": "Redirect URL (register in your OAuth app)",
    "oauthClientModal": {
      "title": "OAuth App Credentials Required",
      "description": "This server requires you to create your own OAuth app. Register the redirect URL below in your OAuth app, then enter the credentials.",
      "redirectUrlLabel": "Redirect URL (register this in your OAuth app)",
      "copyRedirectUrl": "Copy",
      "clientIdLabel": "Client ID",
      "clientIdPlaceholder": "Enter your Client ID",
      "clientSecretLabel": "Client Secret",
      "clientSecretPlaceholder": "Enter your Client Secret",
      "authorizeButton": "Authorize",
      "genericError": "Failed to start OAuth flow. Please check your credentials and try again."
    }
  },
  "localDevices": {
    "pairButton": "Pair local device",
    "section": {
      "title": "Local Claude & Codex",
      "description": "Pair your machine so the assistant can delegate coding tasks to your local Claude Code or Codex CLI.",
      "emptyHint": "No device paired yet",
      "pairButton": "Pair local device",
      "downloadButton": "Download for Mac",
      "downloadHint": "macOS Apple Silicon",
      "requirementsPrefix": "Requires ",
      "requirementsClaudeCodeLinkText": "Claude Code",
      "requirementsOr": " or ",
      "requirementsCodexLinkText": "Codex",
      "requirementsSuffix": " installed and logged in on your Mac.",
      "usageNote": "The menu bar app shows your Codex usage — the percentage used and when it resets.",
      "requirementsTools": "Also requires: GitHub CLI (gh) and cloudflared."
    },
    "modal": {
      "title": "Pair Local Device",
      "description": "Enter the pairing code shown in your local script to connect this device.",
      "codePlaceholder": "XXXX-XXXX",
      "codeLabel": "Pairing Code",
      "submitButton": "Pair Device",
      "cancelButton": "Cancel",
      "successTitle": "Device Paired!",
      "successMessage": "{{deviceName}} is now paired. Keep the local script running — the MCP connection will appear automatically within seconds.",
      "doneButton": "Done"
    },
    "list": {
      "title": "Paired Local Devices",
      "lastSeen": "Last seen {{time}}",
      "neverSeen": "Never seen",
      "revokeButton": "Revoke",
      "confirmRevoke": "Confirm?",
      "cancelRevoke": "Cancel"
    },
    "status": {
      "connected": "Connected",
      "disconnected": "Disconnected",
      "error": "Connected, tools unavailable"
    },
    "errors": {
      "invalidCode": "Invalid pairing code. Check the code shown in your local script.",
      "expiredCode": "This pairing code has expired. Generate a new one in your local script.",
      "usedCode": "This pairing code has already been used.",
      "unknown": "Something went wrong. Please try again.",
      "revokeFailed": "Failed to revoke device."
    }
  },
  "adminHome": {
    "title": "Admin Dashboard",
    "statsDescription": "View system metrics, usage analytics, and data health",
    "statsAriaLabel": "Go to Stats",
    "evalDescription": "Manage eval annotations, run pipelines, and review dashboard metrics",
    "evalAriaLabel": "Go to Evaluation",
    "funnelDescription": "Track signups and activation through each step of the growth funnel",
    "funnelAriaLabel": "Go to Funnel",
    "noFeaturesAvailable": "No features are available for your role yet. Contact an admin if you think this is a mistake.",
    "churnDescription": "Why people closed their account, and what they had built when they did",
    "churnAriaLabel": "Go to Churn",
    "requiresRole": "Requires {{role}}",
    "roles": {
      "admin": "Admin",
      "marketing": "Marketing",
      "billing": "Billing"
    },
    "teamsDescription": "Find a team, view its plan, members, wallets and credits, or add credits",
    "teamsAriaLabel": "Go to Teams"
  },
  "adminNav": {
    "appName": "this+that Admin",
    "tag": "Admin",
    "home": "Home",
    "stats": "Stats",
    "eval": "Evaluation",
    "signOut": "Sign out",
    "funnel": "Funnel",
    "churn": "Churn",
    "teams": "Teams"
  },
  "assistant": {
    "errors": {
      "submitFailed": "Your message could not be sent. Please try again.",
      "imageFileTypeNotPermitted": "This image type is not supported.",
      "imageFileNameInvalid": "This image file name is not valid.",
      "imageUploadInfected": "This image was blocked for security reasons.",
      "imageUploadInvalidType": "The image content does not match its file type.",
      "imageUploadScanPending": "This image is still being checked. Please try again in a few seconds.",
      "tooManyImages": "You can attach at most 5 images to a message."
    },
    "emptyState": {
      "greetingMorning": "Good morning, {{name}}",
      "greetingAfternoon": "Good afternoon, {{name}}",
      "subtitle": "I have access to your email, calendar, Slack, and Instagram. I looked at your day — here's what stands out and a few things you can ask me to start.",
      "whatISeeNow": "What I see right now",
      "updatedAt": "Updated {{time}}",
      "suggestedForYou": "Suggested for you now",
      "orTrySomethingLike": "Or try something like",
      "connected": "Connected:",
      "addSource": "+ add source",
      "greetingNight": "Good evening, {{name}}"
    },
    "empty": {
      "greeting": "Hi {{name}}, what can I help with today?",
      "greetingNoName": "What can I help with today?",
      "subtitle": "Ask about your calendar, communications, or anything you've worked on recently.",
      "sphereAriaLabel": "Assistant orb, idle",
      "prompts": {
        "0": "What's on my calendar today?",
        "1": "Recent emails this week",
        "2": "Draft a reply for the most recent email",
        "3": "What did we discuss yesterday?"
      }
    },
    "delegatedSendReceipt": {
      "actions": {
        "calendarEventCreated": "Invite sent",
        "slackReply": "Reply sent"
      },
      "undo": "Undo",
      "undoing": "Undoing…",
      "undone": "Undone",
      "undoFailed": "Couldn't undo. Try again.",
      "markDone": "Mark as done"
    },
    "loading": {
      "sphereAriaLabel": "Loading conversation"
    },
    "typing": "Agent is working",
    "briefing": {
      "unreadEmails": "Unread emails",
      "needReplyToday": "Need a reply today",
      "meetingsToday": "Meetings today",
      "meetingsRemaining": "Meetings remaining",
      "slackMentions": "Slack mentions"
    },
    "input": {
      "placeholder": "Ask, request, write…"
    },
    "attachments": {
      "dropHere": "Drop images here",
      "attachLabel": "Attach an image",
      "openImage": "Open image",
      "userUploadCaption": "Image you attached",
      "errors": {
        "tooMany": "You can attach at most {{max}} images to a message."
      }
    },
    "banner": {
      "draftsPending": "{{count}} drafts awaiting your approval",
      "draftsPendingSub": "— no message is sent without your click",
      "viewPending": "View pending",
      "workingInParallel": "Working in parallel",
      "workingInParallelSub": "— you can keep using the chat normally",
      "pauseAll": "Pause all",
      "allSent": "All sent successfully",
      "allSentSub": "— {{count}} emails delivered just now",
      "viewSent": "View sent"
    },
    "draft": {
      "proposedReply": "Proposed reply",
      "notSent": "Not sent",
      "sentJustNow": "Sent · just now",
      "edit": "Edit",
      "refineTone": "Refine tone",
      "discard": "Discard",
      "send": "Send",
      "sending": "Sending…",
      "to": "To",
      "cc": "Cc",
      "from": "From",
      "addCc": "+ Cc",
      "addCcPlaceholder": "email or name",
      "removeCc": "Remove Cc",
      "clickToEdit": "Click to edit",
      "tonePlaceholder": "Or describe a tone… e.g. 'enthusiastic but professional'",
      "close": "Close",
      "editedByYou": "Edited by you",
      "editorPlaceholder": "Edit draft… (rich text supported)",
      "tonePrefix": "Tone: {{tone}}",
      "taskCreatedInToDo": "Task created in your to-do:",
      "attachmentsLabel": "{{count}} attachments",
      "actions": {
        "discard": "Discard",
        "saveDraft": "Save draft",
        "saveAndSend": "Save & send",
        "openInGmail": "Open in Gmail",
        "viewInGmail": "View in Gmail",
        "retry": "Try again"
      },
      "status": {
        "draftSaved": "Draft saved to Gmail",
        "sent": "Sent"
      },
      "errors": {
        "noGmail": "Connect your Gmail account to save or send drafts.",
        "scopeMissing": "Reconnect your Gmail account to grant draft permission.",
        "generic": "Couldn't reach Gmail. Try again."
      },
      "confirmSend": {
        "title": "Send this email?",
        "cancel": "Cancel",
        "confirm": "Send now",
        "toLabel": "To",
        "ccLabel": "Cc",
        "subjectLabel": "Subject",
        "fromLabel": "From"
      }
    },
    "batch": {
      "approveAndSendAll": "Approve and send all {{count}} at once",
      "reviewedThem": "Reviewed them? You can send as a batch.",
      "sendCount": "Send {{count}} drafts",
      "sendingCount": "Sending {{count}}…"
    },
    "calendar": {
      "day": "Day",
      "week": "Week",
      "free": "Free block",
      "title": "Today's calendar",
      "meta": "{{count}} events",
      "noAccount": "Connect a Google account to see your calendar.",
      "unavailable": "I couldn't display the calendar results.",
      "openButton": "Open",
      "openButtonAriaLabel": "Open meeting details for {{title}}"
    },
    "calendarInvite": {
      "unavailable": "Couldn't display the meeting details.",
      "joinTeams": "Join Microsoft Teams",
      "joinMeet": "Join Google Meet",
      "joinZoom": "Join Zoom",
      "joinWhereby": "Join Whereby",
      "joinCalendly": "Join meeting",
      "cancel": "Cancel",
      "reschedule": "Reschedule"
    },
    "communications": {
      "title": "Recent communications",
      "meta": "{{count}} items",
      "metaTruncated": "{{count}}+ items",
      "unavailable": "I couldn't display the message results.",
      "empty": "No communications match.",
      "yesterday": "Yesterday",
      "unread": "Unread",
      "category": {
        "primary": "Primary",
        "updates": "Updates",
        "promotions": "Promotions",
        "forums": "Forums",
        "social": "Social"
      }
    },
    "timeline": {
      "viewModeLabel": "View mode",
      "viewModeDay": "Day",
      "viewModeWeek": "Week",
      "allDayGroup": "All day",
      "today": "Today"
    },
    "changes": {
      "applyingInParallel": "Applying {{count}} changes in parallel"
    },
    "tracker": {
      "taskN": "Task {{n}} · {{label}}",
      "ready": "Ready",
      "statusReady": "Ready",
      "statusWorking": "Working",
      "working": "Working",
      "checkPattern": {
        "toolUsed": "Used {{toolName}}",
        "toolFailed": "{{toolName}} failed"
      }
    },
    "agentTimeline": {
      "working": "Working…",
      "expand": "Show steps",
      "ariaPanel": "Agent processing status",
      "ariaLabel": "Agent timeline",
      "empty": "No steps yet",
      "expandDetails": "Expand step details",
      "collapseDetails": "Collapse step details",
      "completedHeader": "Done in {{time}} · {{steps}}",
      "completedHeaderNoTime": "Done · {{steps}}",
      "expandSteps": "Expand steps",
      "collapseSteps": "Collapse steps",
      "stepsCount_one": "{{count}} step",
      "stepsCount_other": "{{count}} steps",
      "stop": "Stop",
      "stopping": "Stopping…",
      "stopError": "Could not stop the agent",
      "tools": {
        "communicationsList": "Searching communications…",
        "communicationGet": "Opening message…",
        "communicationReport": "Generating communication report…",
        "calendarListEvents": "Reading calendar…",
        "calendarEventDetail": "Reading event details…",
        "listCalendarAccounts": "Listing calendar accounts…",
        "actOnCalendarInvites": "Acting on calendar invite…",
        "createCalendarEvent": "Creating calendar event…",
        "draftCompose": "Drafting email…",
        "actOnEmails": "Acting on emails…",
        "createEmailLabel": "Creating email label…",
        "listEmailLabels": "Listing email labels…",
        "proposeActions": "Preparing actions…",
        "proposeFlow": "Preparing flow…",
        "proposeCustomAgent": "Preparing agent…",
        "proposeSlackReply": "Drafting Slack reply…",
        "sendDoboxSourceReply": "Replying in Slack…",
        "listSlackChannels": "Listing Slack channels…",
        "findSlackUsers": "Looking up Slack users…",
        "openSlackDm": "Opening Slack DM…",
        "semanticSearch": "Searching for relevant content…",
        "slackMessageContext": "Loading conversation context…",
        "listDoboxes": "Looking up tasks…",
        "getDoboxDetail": "Reading task details…",
        "listDoboxTaskGroups": "Listing task groups…",
        "listTasksInList": "Reading the tasks in this list…",
        "createDobox": "Creating task…",
        "updateDobox": "Updating task…",
        "deleteDobox": "Deleting task…",
        "resolveDobox": "Resolving task…",
        "moveDobox": "Moving task…",
        "addDoboxComment": "Adding task comment…",
        "acceptDoboxSuggestion": "Accepting suggestion…",
        "createDoboxLabel": "Creating task label…",
        "updateDoboxCollections": "Updating task collections…",
        "createTaskGroup": "Creating task group…",
        "updateTaskGroupParticipants": "Updating participants…",
        "listTeamMembers": "Looking up team members…",
        "findUserByEmail": "Resolving contact…",
        "resolvePerson": "Looking up a person…",
        "showIntegrationCard": "Showing integration…",
        "produceReport": "Producing report…",
        "delegateParallel": "Delegating tasks…",
        "listFlows": "Listing flows…",
        "getFlow": "Reading flow…",
        "runFlowNow": "Running flow…",
        "listCustomAgents": "Listing agents…",
        "echo": "Echo…",
        "mcpTool": "Calling external tool…",
        "unknown": "Executing…",
        "listTeamsChats": "Listing Teams chats…",
        "listTeamsChannels": "Listing Teams channels…",
        "teamsChatContext": "Loading Teams conversation context…",
        "proposeTeamsReply": "Drafting Teams reply…"
      }
    },
    "scene": {
      "allSentAnythingElse": "All sent. Anything else?"
    },
    "run": {
      "error": "Something went wrong: {{message}}"
    },
    "locked": {
      "tooltip": "Wait for the agent to finish."
    },
    "queue": {
      "waiting": "Waiting to send",
      "protocolConfirmed": "Approval queued",
      "protocolCancelled": "Cancellation queued",
      "protocolPicker": "Choice queued"
    },
    "error": {
      "concurrentRun": "Another request is still being processed. Please wait."
    },
    "commands": {
      "clear": {
        "description": "Clear conversation and reset context",
        "confirmationBody": "This will start a fresh conversation. Past messages stay archived for audit but the agent will lose all context.",
        "confirmButton": "Clear conversation"
      },
      "modal": {
        "title": "/{{command}}"
      },
      "menu": {
        "label": "Available commands",
        "empty": "No matching command or agent",
        "emptyHint": "Delete back to / to see the full list.",
        "shortcuts": {
          "navigate": "Navigate",
          "run": "Run",
          "complete": "Complete",
          "close": "Close"
        }
      },
      "errors": {
        "cannotClearDuringRun": "Wait for the agent to finish before clearing.",
        "unknownCommand": "No matching command. Press Esc to dismiss.",
        "commandFailed": "Couldn't run the command. Please try again."
      },
      "agentRun": {
        "defaultPrompt": "Run your goal now."
      },
      "actions": {
        "manageBoardAgents": {
          "title": "Add agent to the task group",
          "description": "Becomes available to every task in the group"
        }
      }
    },
    "mention": {
      "pickerLabel": "Select a contact",
      "empty": "No matching contact",
      "source": {
        "slack": "Slack",
        "teams": "Teams",
        "thisThat": "t+t",
        "outlook": "Outlook",
        "gmail": "Gmail",
        "googleChat": "Google Chat",
        "google": "Google"
      }
    },
    "overnight": {
      "eyebrow": "Overnight · {{from}} → {{to}}",
      "title": "Your night was quiet — {{count}} thing to review",
      "titlePlural": "Your night was quiet — {{count}} things to review",
      "periodSummary": "{{from}} → {{to}} · {{duration}}",
      "statsLabels": {
        "mentions": "mentions",
        "dms": "DMs",
        "threadsActive": "active threads",
        "emails": "emails",
        "invites": "invites"
      },
      "needsReplyTitle": "Needs your attention",
      "fyiTitle": "Worth a glance",
      "noiseTitle": "Filtered as noise",
      "noiseSummary": "{{count}} notifications",
      "replyAction": "Reply",
      "delegateAction": "Delegate",
      "openFullAction": "Open full",
      "replyingState": "Sending…",
      "sendingState": "Sending…",
      "sentState": "Replied",
      "delegatedState": "Agent on it",
      "urgentPill": "Urgent",
      "mentionPill": "@you",
      "threadCount": "{{count}} reply in thread",
      "threadCountPlural": "{{count}} replies in thread",
      "noiseExpand": "Show",
      "noiseCollapse": "Hide",
      "sectionAriaLabel": "{{title}} section",
      "sourceSlackFallback": "Slack",
      "sourceEmailFallback": "Email"
    },
    "communicationReport": {
      "header": {
        "eyebrow": "Communication report · {{from}} → {{to}}",
        "title": "{{count}} items to review this period"
      },
      "stats": {
        "mentions": "{{count}} mentions",
        "dms": "{{count}} DMs",
        "threads": "{{count}} threads",
        "emails": "{{count}} emails",
        "invites": "{{count}} invites"
      },
      "sections": {
        "needsReply": "Needs your reply",
        "fyi": "FYI · read later"
      },
      "noise": {
        "toggle": "Filtered noise"
      },
      "actions": {
        "reply": "Reply",
        "delegate": "Delegate",
        "openFull": "Open full",
        "replyTooltip": "Reply",
        "delegateTooltip": "Delegate to agent",
        "archive": "Archive",
        "delete": "Delete",
        "archived": "Archived",
        "deleted": "Deleted",
        "undo": "Undo",
        "archiveError": "Could not archive email",
        "deleteError": "Could not delete email",
        "archiving": "Archiving…",
        "deleting": "Deleting…"
      },
      "pills": {
        "urgent": "URGENT",
        "mention": "@you"
      },
      "threadCount": "{{count}} reply in thread",
      "threadCountPlural": "{{count}} replies in thread",
      "sourceSlackFallback": "Slack",
      "sourceEmailFallback": "Email",
      "unavailable": "Couldn't load communication report."
    },
    "inputContext": {
      "delegateLabel": "Delegating: {{label}}",
      "replyLabel": "Replying to {{label}}",
      "brainPageLabel": "Brain: {{label}}",
      "doboxLabel": "DoBox: {{label}}",
      "clear": "Clear context"
    },
    "selectedAgentChip": {
      "clearAriaLabel": "Remove selected agent"
    },
    "slackReply": {
      "channelLabel": "Channel",
      "workspaceLabel": "Workspace",
      "repliedAsThread": "In thread",
      "repliedAsChannel": "Also in {{channel}}",
      "repliedAsDm": "As DM",
      "sendReply": "Send to Slack",
      "sending": "Sending…",
      "threadHeader": "Thread",
      "yourReply": "Your reply",
      "notSent": "Not sent",
      "sent": "Sent · just now",
      "edit": "Edit",
      "refineTone": "Refine tone",
      "customTonePlaceholder": "Or describe a tone…",
      "discard": "Discard",
      "editReply": "Edit reply",
      "cancel": "Cancel",
      "close": "Close",
      "replyAsLabel": "Reply",
      "replyAs": {
        "thread": "In thread",
        "channel": "Also in channel",
        "dm": "As DM"
      },
      "editedByYou": "Edited by you",
      "tonePrefix": "Tone: {{tone}}",
      "editorPlaceholder": "Reply to thread… (markdown supported)",
      "send": "Send",
      "placeholder": "Edit your reply…",
      "unavailable": "Couldn't display Slack reply.",
      "dmFallbackHeader": "Direct Message"
    },
    "emailCard": {
      "openFull": "Open full"
    },
    "emailFullView": {
      "close": "Close",
      "archive": "Archive",
      "delegate": "Delegate to agent",
      "openInInbox": "Open in Inbox",
      "reply": "Reply",
      "forward": "Forward",
      "cancel": "Cancel",
      "viewModeModal": "Modal",
      "viewModeSidePanel": "Side panel",
      "viewModeAriaLabel": "View mode",
      "replyTo": "Reply to",
      "forwardTo": "Forward to",
      "composeReplyPlaceholder": "Write your reply to {{name}}…",
      "composeForwardRecipientPlaceholder": "recipient@…",
      "composeForwardNotePlaceholder": "Add a note (optional)…",
      "starred": "Starred",
      "draftWithAgent": "Draft with agent",
      "loading": "Loading email…"
    },
    "invite": {
      "respondYes": "Yes",
      "respondMaybe": "Maybe",
      "respondNo": "No",
      "proposeNewTime": "New time",
      "attendeesAcceptedCount": "{{count}} yes",
      "attendeesPendingCount": "{{count}} awaiting",
      "attendeesMaybeCount": "{{count}} maybe",
      "attendeesDeclinedCount": "{{count}} no",
      "conflictWarning": "Conflict on your calendar",
      "conflictDetail": "{{time}} — {{title}}",
      "viaVideo": "Video call",
      "atLocation": "Location",
      "durationLabel": "{{duration}}",
      "guestsLabel": "{{count}} guests",
      "statusAwaitingReply": "Awaiting your reply",
      "statusAccepted": "Accepted",
      "statusGoing": "Going",
      "statusMaybe": "Maybe",
      "statusDeclined": "Declined",
      "googleCalendarSource": "Google Calendar",
      "invitationFrom": "Invitation from {{name}}",
      "showMore": "+ {{count}} more",
      "attendeeYou": "you",
      "attendeeOrganizer": "organizer",
      "addPeopleButton": "Add people",
      "addPeoplePlaceholder": "email1@example.com, email2@example.com",
      "addPeopleSubmit": "Invite",
      "addPeopleCancel": "Cancel",
      "addPeopleInvalidEmail": "Please enter at least one valid email."
    },
    "accountPicker": {
      "title": "Choose account",
      "subtitle": "Pick which account to use",
      "unavailable": "Couldn't display your accounts.",
      "selectedPrompt": "Use {{email}}."
    },
    "actionProposal": {
      "title": "Actions to confirm",
      "selectAll": "Select all",
      "clear": "Clear",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "confirmSingle": "Confirm",
      "consumedConfirmed": "{{count}} action(s) confirmed",
      "consumedCancelled": "Cancelled",
      "consumedAutoExecuted": "{{count}} action(s) executed automatically",
      "consumedAutoExecutedWithErrors": "{{count}} action(s) executed (some failed)",
      "consumedSuperseded": "Replaced by a newer proposal",
      "unavailable": "Couldn't display action proposal.",
      "alwaysConfirm": "Always for this",
      "effect": {
        "tools": {
          "send_slack_bot_message": "Send a Slack message",
          "send_notification_email": "Send an email",
          "gbp_reply_review": "Reply to a Google Business review",
          "facebook_reply_comment": "Reply to a Facebook comment",
          "facebook_publish_post": "Publish a Facebook post",
          "instagram_reply_comment": "Reply to an Instagram comment",
          "instagram_publish_post": "Publish an Instagram post",
          "create_calendar_event": "Create a calendar event",
          "act_on_calendar_invites": "Respond to calendar invites",
          "send_dobox_source_reply": "Reply in the task's Slack thread"
        },
        "fields": {
          "to": "To: {{value}}",
          "target": "Target: {{value}}",
          "subject": "Subject: {{value}}",
          "preview": "{{value}}",
          "moreRecipients": "+{{count}} more",
          "attachments": "Attachments ({{count}})",
          "workspace": "Workspace: {{value}}"
        }
      }
    },
    "emailLabelPicker": {
      "title": "Choose label",
      "subtitle": "Pick which label to use",
      "unavailable": "Couldn't display labels.",
      "selectedPrompt": "Use the '{{name}}' label (id: {{id}})."
    },
    "slackScopePicker": {
      "title": "Filter Slack scope",
      "subtitle": "Pick which messages to show",
      "allChip": "All channels & DMs",
      "dmChip": "DMs only",
      "moreChip": "+{{count}} more",
      "unavailable": "Couldn't display Slack channels.",
      "workspaceChip": "All in {{workspace}}"
    },
    "dobox": {
      "list": {
        "title": "Tasks",
        "empty": "No DoBoxes match your filters.",
        "meta": "{{count}} items",
        "metaTruncated": "{{count}} items (more available — refine filters)",
        "labelCount": "{{count}} label",
        "selectItem": "Select {{subject}}"
      },
      "detail": {
        "unavailable": "Couldn't display DoBox details.",
        "attached": "{{count}} attached",
        "comments": "{{count}} comments"
      },
      "priority": {
        "urgent": "Urgent",
        "high": "High",
        "medium": "Medium",
        "low": "Low",
        "none": "None"
      },
      "suggestion": "Suggestion",
      "resolved": "Done",
      "editPriority": "Edit priority",
      "editDueDate": "Edit due date",
      "setDueDate": "Set due date",
      "clearDueDate": "Clear",
      "addLabel": "Add label",
      "removeLabel": "Remove label",
      "saving": "Saving…",
      "dueDateSavePicker": {
        "save": "Save",
        "cancel": "Cancel"
      },
      "actions": {
        "markDone": "Done",
        "accept": "Accept",
        "dismiss": "Dismiss",
        "move": "Move to...",
        "cancel": "Cancel",
        "reopen": "Reopen",
        "markingDone": "Marking done...",
        "accepting": "Accepting...",
        "moving": "Moving..."
      },
      "batch": {
        "markDone": "Mark {{count}} done",
        "moveTo": "Move {{count}} to...",
        "cancel": "Cancel",
        "selected": "{{count}} selected"
      },
      "filter": {
        "status": {
          "open": "Open",
          "resolved": "Resolved",
          "suggestions": "Suggestions",
          "all": "All"
        },
        "priority": {
          "urgent": "Urgent",
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "due": {
          "overdue": "Overdue",
          "today": "Today",
          "thisWeek": "This week"
        }
      },
      "editSubject": "Edit subject",
      "editDescription": "Edit description",
      "descriptionPlaceholder": "Add description…",
      "addPerson": "Add person",
      "removePerson": "Remove person",
      "searchPersonPlaceholder": "Email or name…",
      "searchPersonHint": "Type to search by email or name…",
      "noPersonMatches": "No matches",
      "userNotFound": "User not found in system. Ask them to sign up first.",
      "comments": {
        "title": "Comments",
        "empty": "No comments yet.",
        "viewAll": "View all ({{count}})",
        "placeholder": "Add a comment…",
        "send": "Send"
      },
      "openFull": "Open full",
      "openFullAria": "Open full DoBox view",
      "fullView": {
        "close": "Close",
        "closeAria": "Close full DoBox view",
        "loading": "Loading…",
        "error": "Couldn't load DoBox details."
      },
      "delegatedTicket": "Delegated ticket",
      "viaTicketPrefix": "via ticket",
      "viaTicketFallbackLabel": "ticket",
      "openTicketAriaLabel": "Open \"{{subject}}\" in DoBox"
    },
    "taskGroupPicker": {
      "title": "Pick task group",
      "unavailable": "Couldn't display task groups."
    },
    "report": {
      "metadataLabel": "Details"
    },
    "teamMembers": {
      "title": "Team members",
      "countSingular": "{{count}} member",
      "countPlural": "{{count}} members",
      "empty": "No team members",
      "truncated": "and more"
    },
    "slackConversations": {
      "title": "Slack conversations",
      "channelPrefix": "#{{name}}",
      "dmPrefix": "@{{name}}",
      "fallbackChannel": "{{id}}…",
      "loadError": "Couldn't load full thread, showing recent messages.",
      "showingLast": "Showing last {{count}} messages",
      "replyPlaceholder": "Reply to {{name}}…",
      "send": "Send",
      "sending": "Sending…",
      "replyFailed": "Couldn't send — retry",
      "you": "You",
      "shortcutHint": "{{shortcut}} to send",
      "missingWorkspace": "Cannot send: workspace information is missing.",
      "replyInThread": "Reply in thread",
      "inThread": "in thread",
      "draft": "Draft with AI",
      "drafting": "Drafting…",
      "draftFailed": "Couldn't draft a reply",
      "replyHelpText": "Type your reply, or describe what to say and click ✨ for AI drafts",
      "dismissDrafts": "Dismiss drafts",
      "variant": {
        "short": "Short",
        "friendly": "Friendly",
        "formal": "Formal"
      }
    },
    "integrationCard": {
      "title": {
        "google": "Google",
        "microsoft": "Outlook",
        "outlookMail": "Outlook Mail",
        "outlookCalendar": "Outlook Calendar",
        "teams": "Microsoft Teams",
        "slack": "Slack",
        "mcp": "MCP Integrations",
        "tavily": "Web access via Tavily",
        "windsor": "Windsor.ai analytics"
      },
      "description": {
        "google": "Connect your Gmail and Google Calendar",
        "microsoft": "Connect your Outlook mail and calendar",
        "outlookMail": "Connect your Outlook mailbox",
        "outlookCalendar": "Connect your Outlook calendar",
        "teams": "Connect your Microsoft Teams chats and channels",
        "slack": "Connect your Slack workspace",
        "mcp": "Connect external tools and data sources",
        "windsor": "Connect marketing, CRM, and e-commerce data"
      },
      "tavily": {
        "description": "Connect Tavily to let the assistant search the web, read articles, and monitor sites.",
        "step1": "Create a Tavily account",
        "step2": "Generate a Remote MCP URL in the dashboard",
        "step3": "Paste the URL in your MCP integrations",
        "openTavilyCta": "Open Tavily",
        "openMcpSettingsCta": "Open MCP settings",
        "manageCta": "Manage",
        "connectedAt": "Connected"
      },
      "windsor": {
        "description": "Connect Windsor.ai to query marketing, CRM, and e-commerce analytics from the assistant.",
        "step1": "Open Windsor.ai",
        "step2": "Create or copy your Windsor API key",
        "step3": "Add Windsor.ai in MCP settings with Bearer Token authentication",
        "openWindsorCta": "Open Windsor.ai",
        "openMcpSettingsCta": "Open MCP settings",
        "manageCta": "Manage",
        "connectedAt": "Connected"
      },
      "status": {
        "connected": "Connected",
        "notConnected": "Not connected",
        "justConnected": "Just connected"
      },
      "actions": {
        "connect": "Connect",
        "addAccount": "Add account",
        "manageSettings": "Manage in Settings",
        "addMcp": "Add MCP",
        "manageMcp": "Manage MCPs"
      },
      "accounts": "Connected: {{accounts}}",
      "mcpConnectionsOverflow": "+{{count}} more"
    },
    "mcpResultCard": {
      "header": "MCP: {{tool}}",
      "errorBadge": "Error",
      "expand": "Show details",
      "collapse": "Hide details",
      "copy": "Copy result",
      "copied": "Copied!",
      "truncated": "... (truncated, copy to see all)",
      "tool": "Tool: {{name}}"
    },
    "flowPreview": {
      "title": "Proposed flow",
      "draft": "Draft",
      "confirmed": "Created",
      "cancelled": "Cancelled",
      "actions": {
        "cancel": "Cancel",
        "openInEditor": "Open in Editor",
        "create": "Create flow"
      },
      "fields": {
        "name": "Name",
        "trigger": "Trigger",
        "steps": "Steps",
        "branchSteps": "Steps inside this branch",
        "team": "Team"
      },
      "values": {
        "personal": "Personal (no team)"
      }
    },
    "agentTemplatePreview": {
      "title": "Proposed custom agent",
      "actions": {
        "cancel": "Cancel",
        "openInEditor": "Open in Editor",
        "create": "Create agent"
      },
      "fields": {
        "name": "Name",
        "description": "Description",
        "systemPrompt": "System prompt",
        "toolSets": "Tool sets",
        "mcpConnections": "MCP connections",
        "modelTier": "Model tier",
        "maxTurns": "Max turns",
        "icon": "Icon",
        "team": "Team"
      },
      "values": {
        "personal": "Personal (no team)",
        "default": "Default",
        "noMcpConnections": "None",
        "noToolSets": "None",
        "noIcon": "None"
      }
    },
    "dock": {
      "backgroundTasks": "Background tasks"
    },
    "flowReportCard": {
      "label": "Flow report",
      "openFlow": "Open flow"
    },
    "askUserCard": {
      "label": "Flow decision needed",
      "answered": "Answered: {{value}}",
      "chooseOption": "Choose an option",
      "error": "Failed to submit your response. Please try again.",
      "expired": "This request was already handled or is no longer active.",
      "expiredToast": "This request was already handled or is no longer active."
    },
    "teamRequestComposer": {
      "label": "Request from {{fromUserName}}",
      "requestLabel": "What they're asking",
      "replyPlaceholder": "Write your reply…",
      "attachmentsLabel": "Attach Brain pages",
      "attachSearchPlaceholder": "Search your Brain…",
      "send": "Share",
      "decline": "Decline",
      "sentState": "Reply sent to {{fromUserName}}",
      "declinedState": "Declined — no reply sent to {{fromUserName}}",
      "expiredToast": "This request was already handled or has expired.",
      "expired": "This request was already handled or has expired.",
      "sendError": "Failed to send your reply. Please try again.",
      "noResults": "No Brain pages found",
      "removeAttachment": "Remove {{title}}"
    },
    "teamRequestReply": {
      "label": "Reply from {{fromUserName}}",
      "originalRequest": "Original request",
      "attachmentsLabel": "Attached",
      "attachmentKindBrainPage": "Brain page",
      "attachmentKindDobox": "DoBox",
      "attachmentKindEmail": "Email"
    },
    "meetingPoll": {
      "from": "From {{name}}",
      "duration": "{{minutes}} min",
      "bookSlot": "Book this time",
      "decline": "None of these work",
      "confirmed": "Booked — {{slot}}",
      "declined": "Declined — no time selected",
      "expired": "This poll has expired",
      "errors": {
        "bookFailed": "Could not book this slot. Please try again.",
        "declineFailed": "Could not decline. Please try again."
      },
      "timesIn": "Times in {{tz}}"
    },
    "meetingPollSent": {
      "waiting": "Waiting for a response",
      "waitingRecipient": "Waiting for {{name}} to respond",
      "confirmed": "Time confirmed",
      "declined": "Declined by recipient",
      "slotsCount": "{{count}} proposed time(s)",
      "timesIn": "Times in {{tz}}"
    },
    "artifact": {
      "loading": "Loading preview…",
      "error": "Could not load preview. Try refreshing.",
      "download": "Download",
      "exportPdf": "Download PDF",
      "exportingPdf": "Preparing PDF…",
      "expand": "Expand",
      "close": "Close",
      "versionPrefix": "v{{version}}",
      "previewTitle": "Preview: {{title}}",
      "status": {
        "draft": "Draft",
        "published": "Published"
      },
      "type": {
        "page": "Page",
        "landing": "Landing Page",
        "presentation": "Presentation",
        "microsite": "Microsite"
      },
      "publish": "Publish",
      "publishing": "Publishing…",
      "unpublish": "Unpublish",
      "publicUrlLabel": "Public URL",
      "copyLink": "Copy link",
      "copied": "Copied!",
      "open": "Open in new tab",
      "errors": {
        "downloadFailed": "Could not download the file. Please try again.",
        "publishFailed": "Could not publish the artifact. Please try again.",
        "copyFailed": "Could not copy the link. Please try again.",
        "exportPdfFailed": "Could not generate the PDF. Please try again."
      }
    },
    "delegatedTask": {
      "headerFallback": "Delegated coding task",
      "status": {
        "queued": "Queued…",
        "running": "Processing…",
        "done": "Done",
        "failed": "Failed",
        "unreachable": "Unreachable",
        "unknown": "Unknown status",
        "paused": "Paused",
        "canceled": "Canceled"
      },
      "prButton": "View pull request",
      "errorFallback": "The task failed, but no error details were returned.",
      "unreachableHint": "Your local machine may be offline or unreachable."
    },
    "generatedImageCard": {
      "error": "Could not load the image. Try again.",
      "altFallback": "Image",
      "openLightbox": "View image in full screen"
    },
    "imageLightbox": {
      "close": "Close",
      "closeAria": "Close image viewer",
      "download": "Download",
      "delete": "Delete",
      "backdropAria": "Close image viewer",
      "altFallback": "Image"
    },
    "statusDock": {
      "new": "New",
      "newAriaLabel": "Start a new conversation",
      "history": "History",
      "historyAriaLabel": "View history ({{count}} conversations)",
      "navAriaLabel": "Conversation status dock",
      "you": "YOU",
      "pillAriaLabel": "{{title}} — {{state}}",
      "pillNeedsActionAriaLabel": "{{title}} — needs your action",
      "closePillAriaLabel": "Close conversation {{title}}",
      "historyTitle": "History",
      "historyReopenAction": "Reopen",
      "historyReopenAriaLabel": "Reopen conversation {{title}}",
      "historyEmpty": "No archived conversations",
      "historyDeleteAction": "Delete",
      "historyDeleteAriaLabel": "Delete conversation {{title}}",
      "historyDeleteConfirm": "Delete permanently?",
      "historyDeleteConfirmYes": "Delete",
      "historyDeleteConfirmNo": "Cancel",
      "historyDeleting": "Deleting…",
      "closingPill": "Closing…",
      "closeConfirmTitle": "Close this conversation?",
      "closeConfirmBody": "This conversation will be moved to history. You can reopen it later from the History menu.",
      "closeConfirmAction": "Close conversation",
      "contextMenu": {
        "close": "Close",
        "stop": "Stop",
        "rename": "Rename"
      },
      "pickerAriaLabel": "Show {{count}} more conversations",
      "pickerButtonLabel": "+{{count}}",
      "pickerListAriaLabel": "Other active conversations",
      "compactPickerAriaLabel": "Switch conversation, currently {{title}}",
      "openConversationsLabel": "Open conversations",
      "historyClearAll": "Clear all",
      "historyClearAllConfirm": "Delete all permanently?",
      "historyClearAllConfirmYes": "Delete all",
      "historyClearAllConfirmCancel": "Cancel"
    },
    "activity": {
      "searchedCommunications": "Searched communications",
      "results": "{{count}} results"
    },
    "pageCard": {
      "ariaLabel": "Open Brain page: {{title}}",
      "openLabel": "Open page"
    },
    "teamsReply": {
      "notSent": "Not sent",
      "sent": "Sent · just now",
      "sendReply": "Send to Teams",
      "sending": "Sending…",
      "edit": "Edit",
      "editReply": "Edit reply",
      "cancel": "Cancel",
      "close": "Close",
      "editedByYou": "Edited by you",
      "editorPlaceholder": "Reply to chat… (markdown supported)",
      "discard": "Discard",
      "unavailable": "Couldn't display Teams reply.",
      "accountLabel": "Send from",
      "accountPlaceholder": "Choose an account",
      "chooseAccountHint": "More than one Microsoft account has Teams enabled — choose which one to send from.",
      "sendFailed": "Couldn't send the Teams reply."
    },
    "delegateComposer": {
      "targetChip": {
        "to": "To:",
        "assistant": "Assistant",
        "localClaude": "Local Claude — Mac",
        "ariaLabel": "Choose who this message goes to"
      },
      "planFirst": {
        "label": "Plan first, I approve",
        "settingsAriaLabel": "Runtime and model settings"
      },
      "activeRun": {
        "notice": "A run is already active on this task, so it can't be delegated again yet. End it to delegate to this or another agent.",
        "endRun": "End current run"
      },
      "delegateButtonLabel": "Delegate"
    }
  },
  "funnel": {
    "pageTitle": "Funnel",
    "pageDescription": "Track signups and activation through each step of the funnel.",
    "explainer": {
      "toggle": "Notes",
      "section1": {
        "title": "How are 'Marketing page views' and 'Signup page views' counted?",
        "body": "Each is the unique-user count (GA4 totalUsers metric) for the relevant pages inside the selected window. Marketing page visitors covers www; signup visitors covers /signup. Returning visitors count once per day. One caveat: we aggregate per-day and sum across the range, so a user who visited on multiple different days is counted per day, not per person. Treat the top numbers as estimates within a few percent of true uniques, not exact counts — fine for tracking marketing trends and campaign comparisons, not precise enough for strict unique-visitor reporting."
      },
      "section2": {
        "title": "Why might the stages not form strict subsets?",
        "body": "The stages are ordered by narrowing marketing intent — marketing visitors, then signup visitors, then signups, then activation, then retention — but small violations of 'each stage fits inside the one above' are expected. A visitor who goes straight to /signup from an email link skips the marketing-page stage. A user who visited /signup just before the window and signed up inside it will appear in signups without a matching signup-visit row. Large deviations might point at a bug; small ones are the normal shape of real traffic."
      },
      "section3": {
        "title": "How are retention and milestones calculated?",
        "body": "Every number below 'Signups' is restricted to the cohort who signed up inside the selected date range. 'Connected 1st account' means 'of those signups, how many later connected an account' — it is not 'accounts connected in this range'. Retention (1d/7d/30d) only counts cohort members whose signup date is at least that many days old, so freshly signed-up users don't drag the retention rate down."
      },
      "section4": {
        "title": "What does '(campaign total)' mean for email campaigns?",
        "body": "Sent, Delivered, Opens, and Clicks (campaign total) come directly from HubSpot and cover the entire lifetime of that email — they don't respect the date range. 'Visits in range' below them is unique visitors driven by the campaign inside the selected window. Comparing the two is how you tell whether a campaign is bringing in new people or re-engaging existing ones."
      },
      "section5": {
        "title": "What data isn't captured?",
        "body": "Unique visitor data for www.thisandthat.chat has only been captured since {{coverageStart}} onward. Date ranges extending before that date will under-report visitors on that hostname. The /signup page has been tracked since February 2025 and is unaffected."
      },
      "section6": {
        "title": "Why is data from April 13–15, 2026 unreliable?",
        "body": "Tracking was being reconfigured during that window (CSP fixes, CookieYes wiring, GCM v2 rollout), so pageview volume and utm attribution for 2026-04-13 through 2026-04-15 are incomplete or missing. Treat anything before 2026-04-16 as partial. The funnel is reliable starting 2026-04-16."
      }
    },
    "tabs": {
      "ariaLabel": "Funnel tabs",
      "funnel": "Funnel",
      "trends": "Trends"
    },
    "stages": {
      "title": "Stages",
      "rateLegend": "stage / overall"
    },
    "funnel": {
      "noData": "No funnel data available for the selected filters."
    },
    "filters": {
      "from": "From",
      "to": "To",
      "startDate": "Start date",
      "endDate": "End date",
      "utmSource": "UTM source",
      "allSources": "All sources",
      "showHidden": "Show hidden",
      "refresh": "Refresh",
      "hideSource": "Hide source",
      "unhideSource": "Show source",
      "hiddenSuffix": "(hidden)",
      "groupCampaigns": "Campaigns",
      "groupPages": "Pages",
      "noDataInRangeSuffix": "(no data in range)",
      "dateRangeTooLarge": "Date range cannot exceed 90 days. Please narrow your selection."
    },
    "toolbar": {
      "moreActions": "More actions"
    },
    "dateRange": {
      "yesterday": "Yesterday",
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "thisWeek": "This week",
      "lastWeek": "Last week",
      "customRange": "Custom range...",
      "apply": "Apply",
      "cancel": "Cancel",
      "customLabel": "Custom"
    },
    "chart": {
      "fromPrev": "from prev step",
      "overall": "overall",
      "noData": "No funnel data available for the selected filters.",
      "ariaLabel": "Funnel conversion chart",
      "rateHeader": "↓ step / overall",
      "tooltipCount": "{{value}} {{label}}"
    },
    "steps": {
      "uniquePageViews": "Marketing page views",
      "uniqueSignupPageViews": "Signup page views",
      "viewsCaveat": "Sum of per-day, per-path unique visitors from GA4. A user who views 3 pages in one day counts as 3. Not a true unique-human count.",
      "signups": "Signups",
      "connected": "Connected account",
      "dobox": "Used DoBox",
      "retained1d": "Retained 1 day",
      "retained7d": "Retained 7 days",
      "retained30d": "Retained 30 days"
    },
    "errors": {
      "hideSourceFailed": "Failed to hide source.",
      "unhideSourceFailed": "Failed to show source.",
      "refreshFailed": "Failed to refresh data.",
      "exportFailed": "Failed to export funnel users."
    },
    "export": {
      "button": "Export CSV",
      "exporting": "Exporting…"
    },
    "trends": {
      "title": "Weekly trends",
      "weekStarting": "week starting",
      "legend": "green up · red down vs previous week · * partial week",
      "weekOf": "Week of {{date}}",
      "partialWeek": "Partial week",
      "noData": "No trend data available for the selected filters.",
      "step": "Step",
      "count": "Count",
      "rate": "Rate",
      "showWeeks": "Show weeks",
      "hideWeeks": "Hide weeks"
    },
    "common": {
      "hide": "Hide source",
      "unhide": "Show source",
      "refresh": "Refresh",
      "hiddenBadge": "hidden"
    },
    "emailStats": {
      "ariaLabel": "Email campaign statistics",
      "heading": "Email performance",
      "openRate": "Open rate",
      "clickThroughRate": "Click-through rate",
      "bounces": "Bounces",
      "unsubscribes": "Unsubscribes",
      "spamReports": "Spam reports"
    },
    "emailHeader": {
      "sentPrefix": "Sent"
    },
    "emailNotice": {
      "noData": "No HubSpot data yet for this campaign. Showing standard funnel. Data will appear after the next daily ingest run."
    },
    "intent": {
      "title": "Conversion by intent segment",
      "firstTouch": "First-touch attribution",
      "excludeManual": "Exclude manual outreach",
      "summary": "High intent {{high}}% · Paid {{paid}}% · Social {{social}}% · Email {{email}}% · Direct {{direct}}% · Organic {{organic}}% · Low intent {{low}}%",
      "remainderNote": "Whatever these fall short of 100% is unattributed first-touch traffic.",
      "coverageNote": "First-touch coverage started {{coverageStart}}. Pageviews are consent-gated: read trends and comparisons, not absolute levels.",
      "loadError": "Failed to load intent segments.",
      "empty": "No data for this range.",
      "columns": {
        "segment": "Segment",
        "visitors": "Visitors",
        "signups": "Signups",
        "connected": "Connected",
        "conversion": "Conversion"
      },
      "tag": {
        "high": "high",
        "low": "low"
      },
      "narrow": {
        "visitors": "Visitors {{value}}",
        "signupsLabel": "Signups",
        "connected": "Connected {{value}}"
      },
      "segments": {
        "product": "Product (evaluating us)",
        "comparison": "Comparison (competitor content)",
        "ai-referral": "AI assistant referral",
        "paid": "Paid ads (Google / Meta)",
        "social": "Social (organic posts)",
        "email": "Email (our list)",
        "direct": "Direct (no referrer)",
        "organic-search": "Organic search",
        "referral": "Referral (other sites)",
        "informational": "Informational (stats)",
        "editorial": "Editorial (thought leadership)",
        "other": "Other (unrecognized)",
        "unknown-first-touch": "Unknown first-touch"
      }
    },
    "utm": {
      "title": "Signups by UTM source",
      "showingAll": "showing all",
      "zeroHidden": "{{count}} sources with 0 signups hidden",
      "empty": "No UTM sources for this range."
    },
    "users": {
      "adminOnly": "admin only · emails",
      "sortedBy": "sorted by {{column}}",
      "narrow": {
        "signupDate": "Signup date {{date}}",
        "lastActivity": "Last activity {{date}}",
        "firstTouch": "First touch: {{value}}"
      }
    }
  },
  "admin": {
    "dataTable": {
      "sortBy": "Sort by",
      "sortMenuAriaLabel": "Sort by a hidden column"
    },
    "pageInfo": {
      "ariaLabel": "Page info"
    },
    "funnel": {
      "users": {
        "tableTitle": "Signups by user",
        "empty": "No signups in this window.",
        "column": {
          "userId": "User ID",
          "email": "Email",
          "name": "Name",
          "signupDate": "Signup date",
          "firstTouchUtmSource": "First touch",
          "utmSource": "Last touch",
          "manualSource": "Manual source",
          "deepestStep": "Deepest step",
          "lastActive": "Last active"
        },
        "loading": "Loading signups…",
        "manualSource": {
          "saveError": "Couldn't save manual source. Try again."
        }
      }
    }
  },
  "featureDemo": {
    "inboxSorting": {
      "title": "Inbox",
      "allCaughtUp": "All caught up ✓",
      "tags": {
        "toRespond": "To Respond",
        "meetingUpdate": "Meeting Update",
        "fyi": "FYI",
        "toReview": "To Review",
        "promotion": "Promotion",
        "summary": "Summary"
      },
      "summaryEmail": {
        "label": "End of day digest",
        "sender": "this+that Assistant",
        "subject": "4 promotions archived today",
        "preview": "Today I archived 4 promotional emails for you: Amazon · Booking.com · Spotify · Nike — tap to review",
        "time": "6:00 PM"
      },
      "emails": [
        {
          "sender": "Nadia Osei",
          "subject": "Q4 Budget Review",
          "preview": "Hi team, I wanted to follow up on yesterday’s discussion about the Q4 allocation...",
          "time": "2:34 PM",
          "tagKey": "toRespond",
          "tagColor": "orange",
          "avatarColor": "pink",
          "isPromo": false
        },
        {
          "sender": "Amazon",
          "subject": "🎉 Flash Sale: 50% off today!",
          "preview": "Don’t miss out — biggest sale of the season ends tonight at midnight...",
          "time": "2:12 PM",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "amber",
          "isPromo": true
        },
        {
          "sender": "John Martinez",
          "subject": "Meeting Tomorrow at 2pm",
          "preview": "Just confirming our sync for tomorrow afternoon to discuss the project timeline...",
          "time": "1:15 PM",
          "tagKey": "meetingUpdate",
          "tagColor": "violet",
          "avatarColor": "violet",
          "isPromo": false
        },
        {
          "sender": "Booking.com",
          "subject": "✈️ Dream trips from $299",
          "preview": "Weekend escapes you’ll love. Book before Sunday to save on your next getaway...",
          "time": "12:48 PM",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "teal",
          "isPromo": true
        },
        {
          "sender": "Legal Team",
          "subject": "Contract Review Needed",
          "preview": "Please review the attached contract and provide your feedback by end of week...",
          "time": "11:42 AM",
          "tagKey": "fyi",
          "tagColor": "yellow",
          "avatarColor": "emerald",
          "isPromo": false
        },
        {
          "sender": "Spotify",
          "subject": "🎵 Your Discover Weekly is here",
          "preview": "Fresh music picked just for you — 30 new songs to explore this week...",
          "time": "11:20 AM",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "lime",
          "isPromo": true
        },
        {
          "sender": "Anna Williams",
          "subject": "Project kickoff documents",
          "preview": "Attached are the kickoff docs for the new initiative. Please review and share...",
          "time": "10:55 AM",
          "tagKey": "toReview",
          "tagColor": "blue",
          "avatarColor": "sky",
          "isPromo": false
        },
        {
          "sender": "Nike",
          "subject": "👟 New collection just dropped",
          "preview": "Be the first to shop limited edition styles — members get early access now...",
          "time": "10:30 AM",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "red",
          "isPromo": true
        }
      ]
    },
    "slackChannels": {
      "windowTitle": "Slack",
      "workspaceName": "Acme Workspace",
      "sectionChannels": "Channels",
      "sectionDirectMessages": "Direct messages",
      "analyzingBadge": "✨ AI analyzing 127 messages...",
      "activeChannelMembers": "42 members",
      "channels": [
        {
          "id": "general",
          "name": "general",
          "unreadCount": 12,
          "isActive": true
        },
        {
          "id": "product",
          "name": "product",
          "unreadCount": 8,
          "isActive": false
        },
        {
          "id": "engineering",
          "name": "engineering",
          "unreadCount": 5,
          "isActive": false
        },
        {
          "id": "design",
          "name": "design",
          "unreadCount": 0,
          "isActive": false
        },
        {
          "id": "random",
          "name": "random",
          "unreadCount": 15,
          "isActive": false
        },
        {
          "id": "announcements",
          "name": "announcements",
          "unreadCount": 2,
          "isActive": false
        }
      ],
      "directMessages": [
        {
          "id": "alice",
          "name": "Alice Johnson",
          "initial": "A",
          "avatarColor": "pink",
          "unreadCount": 3,
          "presence": "online"
        },
        {
          "id": "bob",
          "name": "Bob Martinez",
          "initial": "B",
          "avatarColor": "sky",
          "unreadCount": 0,
          "presence": "online"
        },
        {
          "id": "carol",
          "name": "Carol Chen",
          "initial": "C",
          "avatarColor": "emerald",
          "unreadCount": 1,
          "presence": "away"
        },
        {
          "id": "david",
          "name": "David Park",
          "initial": "D",
          "avatarColor": "violet",
          "unreadCount": 0,
          "presence": "offline"
        }
      ],
      "messages": [
        {
          "id": "m1",
          "author": "Nadia Osei",
          "initial": "S",
          "avatarColor": "pink",
          "time": "10:42 AM",
          "text": "Hey team, the launch is blocked on the design review — can we sync this afternoon?"
        },
        {
          "id": "m2",
          "author": "Mike Lopez",
          "initial": "M",
          "avatarColor": "amber",
          "time": "10:45 AM",
          "text": "I'm free after 3pm. Want me to send a calendar invite?"
        },
        {
          "id": "m3",
          "author": "Priya Patel",
          "initial": "P",
          "avatarColor": "violet",
          "time": "10:51 AM",
          "text": "Also, the new onboarding copy is ready for review in Figma 🎨"
        },
        {
          "id": "m4",
          "author": "Tom Wright",
          "initial": "T",
          "avatarColor": "teal",
          "time": "10:58 AM",
          "text": "Quick heads up — prod deploy at 4pm today, please avoid merging to main."
        }
      ],
      "digest": {
        "label": "Daily Digest",
        "title": "Here's what you missed today",
        "bullets": [
          {
            "id": "b1",
            "channel": "#general",
            "msgCount": 12,
            "summary": "Launch blocked on design review — Sarah & Mike coordinating a 3pm sync"
          },
          {
            "id": "b2",
            "channel": "#product",
            "msgCount": 8,
            "summary": "Q2 roadmap finalized, waiting on engineering signoff before Friday"
          },
          {
            "id": "b3",
            "channel": "@alice",
            "msgCount": 3,
            "summary": "Asked about the analytics dashboard link — waiting on your reply"
          },
          {
            "id": "b4",
            "channel": "#random",
            "msgCount": 15,
            "summary": "Coffee chat Friday + office dog photos 🐶"
          }
        ]
      },
      "allCaughtUp": "All caught up ✓"
    },
    "dailyUnreadSummary": {
      "windowTitle": "Inbox",
      "schedule": {
        "title": "Daily at 8:00 AM",
        "subtitle": "Scheduled flow",
        "statusWaiting": "Next run",
        "statusRunning": "⚡ Running",
        "statusSent": "✓ Sent"
      },
      "urgencyLabels": {
        "urgent": "Urgent",
        "important": "Important",
        "fyi": "FYI"
      },
      "emails": [
        {
          "id": "e1",
          "sender": "Nadia Osei",
          "subject": "Q4 budget — need signoff",
          "preview": "Hey, before the board meeting tomorrow I need your final signoff on the Q4 numbers...",
          "time": "2:34 AM",
          "avatarColor": "pink"
        },
        {
          "id": "e2",
          "sender": "Legal Team",
          "subject": "Contract review deadline Friday",
          "preview": "Please review the attached NDA and return your markup before end of day Friday...",
          "time": "11:58 PM",
          "avatarColor": "emerald"
        },
        {
          "id": "e3",
          "sender": "John Martinez",
          "subject": "Re: sync tomorrow 2pm",
          "preview": "Confirmed — I'll come prepped with the latest projections. Talk then...",
          "time": "11:42 PM",
          "avatarColor": "violet"
        },
        {
          "id": "e4",
          "sender": "Anna Williams",
          "subject": "Project kickoff docs ready",
          "preview": "Attached the kickoff deck + timeline. Let me know if anything needs adjusting...",
          "time": "10:18 PM",
          "avatarColor": "sky"
        },
        {
          "id": "e5",
          "sender": "Mike Lopez",
          "subject": "Blocked on design handoff",
          "preview": "Hey, I'm waiting on the final Figma files to unblock the engineering work...",
          "time": "9:47 PM",
          "avatarColor": "amber"
        },
        {
          "id": "e6",
          "sender": "Tom Wright",
          "subject": "Weekly newsletter digest",
          "preview": "Here's what happened this week across the company — product updates, wins...",
          "time": "8:12 PM",
          "avatarColor": "teal"
        },
        {
          "id": "e7",
          "sender": "Priya Patel",
          "subject": "Team offsite photos 📸",
          "preview": "Dropping the photos from last week's offsite in the shared drive — enjoy!...",
          "time": "7:30 PM",
          "avatarColor": "lime"
        }
      ],
      "summary": {
        "label": "Daily Briefing",
        "sender": "this+that Assistant",
        "senderGlyph": "✨",
        "subject": "Your 8 AM briefing — 7 unread",
        "sections": [
          {
            "urgency": "urgent",
            "count": 2,
            "bullets": [
              {
                "id": "u1",
                "text": "Nadia Osei — Q4 budget needs signoff before board meeting"
              },
              {
                "id": "u2",
                "text": "Legal — Contract review deadline Friday EOD"
              }
            ]
          },
          {
            "urgency": "important",
            "count": 3,
            "bullets": [
              {
                "id": "i1",
                "text": "John — Confirmed sync for 2pm tomorrow"
              },
              {
                "id": "i2",
                "text": "Anna — Project kickoff docs ready for review"
              },
              {
                "id": "i3",
                "text": "Mike — Blocked on design handoff"
              }
            ]
          },
          {
            "urgency": "fyi",
            "count": 2,
            "bullets": [
              {
                "id": "f1",
                "text": "Tom — Weekly newsletter digest"
              },
              {
                "id": "f2",
                "text": "Priya — Team offsite photos 📸"
              }
            ]
          }
        ]
      },
      "sentConfirmation": "Sent to your inbox ✓",
      "footer": "All set — see you tomorrow at 8 AM"
    },
    "morningBriefing": {
      "windowTitle": "Morning Briefing",
      "badge": "MORNING BRIEFING",
      "sender": "this+that Assistant",
      "subject": "Your morning briefing · 8 messages while you slept",
      "preview": "2 urgent Slack threads · 5 FYI emails · 1 action needed — tap to read",
      "nightLabel": "While you slept",
      "processingLabel": "AI reading overnight messages...",
      "slackMessages": [
        {
          "id": "s1",
          "sender": "Nadia Osei",
          "preview": "Deploy is blocked — can someone review the failing check?",
          "time": "2:14 AM"
        },
        {
          "id": "s2",
          "sender": "Mike Lopez",
          "preview": "Roadmap doc is ready for async review before Friday's sync",
          "time": "1:47 AM"
        },
        {
          "id": "s3",
          "sender": "Priya Patel",
          "preview": "New Figma frames are live — tagging everyone for sign-off",
          "time": "12:58 AM"
        }
      ],
      "emailMessages": [
        {
          "id": "e1",
          "sender": "Legal Team",
          "subject": "Contract deadline Friday",
          "preview": "Please return your markup on the NDA before end of day Friday...",
          "time": "11:52 PM"
        },
        {
          "id": "e2",
          "sender": "Anna Williams",
          "subject": "Project kickoff docs",
          "preview": "Attached are the updated kickoff deck and timeline for review...",
          "time": "11:04 PM"
        },
        {
          "id": "e3",
          "sender": "Tom Wright",
          "subject": "Weekly newsletter digest",
          "preview": "Here's what happened across the company this week — wins, updates...",
          "time": "9:30 PM"
        }
      ]
    },
    "endOfDayReport": {
      "windowTitle": "Inbox · this+that",
      "badge": "END OF DAY REPORT",
      "sender": "this+that Assistant",
      "subject": "Here's what you got done today · 89 items handled",
      "preview": "47 archived · 12 replies sent · 4 drafts · 4 meetings — tap to review",
      "duskLabel": "Today, so far…",
      "processingLabel": "Wrapping up your day…",
      "handledMessages": [
        {
          "id": "m1",
          "sender": "Replied to 12 Slack threads",
          "preview": "12 threads replied",
          "time": "5:58 PM"
        },
        {
          "id": "m2",
          "sender": "Draft reply sent for 4 emails",
          "preview": "4 drafts sent",
          "time": "4:31 PM"
        },
        {
          "id": "m3",
          "sender": "Attended 4 calls, 2 archived",
          "preview": "4 meetings",
          "time": "3:15 PM"
        }
      ],
      "completedActions": [
        {
          "id": "a1",
          "label": "Archived 47 promotional emails",
          "category": "Email",
          "detail": "47 emails archived",
          "time": "6:01 PM"
        },
        {
          "id": "a2",
          "label": "Auto-labeled 23 FYI emails",
          "category": "Email",
          "detail": "23 labels applied",
          "time": "5:44 PM"
        },
        {
          "id": "a3",
          "label": "Processed 89 inbox items",
          "category": "Inbox",
          "detail": "89 items handled",
          "time": "6:00 PM"
        }
      ]
    },
    "meetingActionItems": {
      "windowTitle": "Inbox · this+that",
      "geminiSender": "Gemini",
      "geminiSubject": "Meeting notes · Q4 planning sync",
      "geminiPreview": "Summary, key decisions, and action items from today's call…",
      "geminiTime": "9:12 AM",
      "inboxBackdropRows": [
        {
          "id": "r1",
          "sender": "Nadia Osei",
          "subject": "Re: Q4 budget signoff",
          "preview": "Confirmed, I'll get those numbers to you by end of week...",
          "time": "8:47 AM"
        },
        {
          "id": "r2",
          "sender": "Legal Team",
          "subject": "NDA revision ready",
          "preview": "The updated draft is attached — please review before Friday...",
          "time": "8:30 AM"
        },
        {
          "id": "r3",
          "sender": "Anna Williams",
          "subject": "Kickoff docs updated",
          "preview": "I've incorporated all feedback from yesterday's review session...",
          "time": "8:15 AM"
        }
      ],
      "detailHeader": {
        "timestamp": "9:12 AM"
      },
      "meetingNoteLines": [
        {
          "id": "n1",
          "text": "Discussed Q4 roadmap priorities and phasing",
          "isAction": false
        },
        {
          "id": "n2",
          "text": "Follow up with Sarah on budget approval by Friday",
          "isAction": true
        },
        {
          "id": "n3",
          "text": "Key risks: vendor delays, open headcount",
          "isAction": false
        },
        {
          "id": "n4",
          "text": "Schedule design review with engineering next week",
          "isAction": true
        },
        {
          "id": "n5",
          "text": "Decision: ship v2 in November, feature freeze Oct 18",
          "isAction": false
        },
        {
          "id": "n6",
          "text": "Send proposal draft to legal by Thursday EOD",
          "isAction": true
        }
      ],
      "extractedTasks": [
        {
          "id": "t1",
          "title": "Follow up with Sarah on budget approval",
          "context": "From: Meeting notes · Q4 planning sync",
          "dueLabel": "Friday",
          "priority": "high",
          "dueStatus": "soon"
        },
        {
          "id": "t2",
          "title": "Schedule design review with engineering",
          "context": "From: Meeting notes · Q4 planning sync",
          "dueLabel": "Next week",
          "priority": "medium",
          "dueStatus": "normal"
        },
        {
          "id": "t3",
          "title": "Send proposal draft to legal",
          "context": "From: Meeting notes · Q4 planning sync",
          "dueLabel": "Thu EOD",
          "priority": "urgent",
          "dueStatus": "soon"
        }
      ],
      "doBoxPaneTitle": "DoBox · just now",
      "processingLabel": "Extracting action items…",
      "priority": {
        "urgent": "Urgent",
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      }
    },
    "followUpTracker": {
      "windowTitle": "this+that",
      "folderLabel": "Sent",
      "processingLabel": "Scanning for replies…",
      "statusReplied": "Replied",
      "statusNoReply": "No reply",
      "doBoxPaneTitle": "DoBox · Follow-ups",
      "sentEmails": [
        {
          "id": "e1",
          "recipient": "Nadia Osei",
          "recipientAvatarLetter": "S",
          "subject": "Q4 budget numbers — final review",
          "sentLabel": "2 days ago",
          "needsFollowUp": false
        },
        {
          "id": "e2",
          "recipient": "Legal Team",
          "recipientAvatarLetter": "L",
          "subject": "Contract revision — please review",
          "sentLabel": "6 days ago",
          "needsFollowUp": true
        },
        {
          "id": "e3",
          "recipient": "John Martinez",
          "recipientAvatarLetter": "J",
          "subject": "Proposal draft for Q1 initiative",
          "sentLabel": "8 days ago",
          "needsFollowUp": true
        },
        {
          "id": "e4",
          "recipient": "Anna Williams",
          "recipientAvatarLetter": "A",
          "subject": "Kickoff doc feedback",
          "sentLabel": "yesterday",
          "needsFollowUp": false
        },
        {
          "id": "e5",
          "recipient": "Mike Lopez",
          "recipientAvatarLetter": "M",
          "subject": "Design handoff — next steps",
          "sentLabel": "14 days ago",
          "needsFollowUp": true
        }
      ],
      "extractedTasks": [
        {
          "id": "t1",
          "title": "Follow up with Legal Team",
          "context": "Contract revision — please review · sent 6 days ago",
          "dueLabel": "Today",
          "priority": "urgent",
          "dueStatus": "soon"
        },
        {
          "id": "t2",
          "title": "Follow up with John Martinez",
          "context": "Proposal draft for Q1 initiative · sent 8 days ago",
          "dueLabel": "Tomorrow",
          "priority": "high",
          "dueStatus": "soon"
        },
        {
          "id": "t3",
          "title": "Follow up with Mike Lopez",
          "context": "Design handoff — next steps · sent 14 days ago",
          "dueLabel": "This week",
          "priority": "medium",
          "dueStatus": "normal"
        }
      ],
      "priority": {
        "urgent": "Urgent",
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      }
    },
    "vipEmailAlerts": {
      "windowTitle": "this+that",
      "vipPanelTitle": "VIP list",
      "vipPanelSubtitle": "Emails and domains we'll watch",
      "addVipLabel": "+ Add VIP",
      "typeLabelEmail": "email",
      "typeLabelDomain": "domain",
      "processingLabel": "VIP match detected — alerting Slack…",
      "slackChannelLabel": "vip-alerts",
      "slackBotName": "this+that Assistant",
      "slackBotBadge": "APP",
      "slackTimestamp": "just now",
      "vipList": [
        {
          "id": "v1",
          "value": "ceo@acme.com",
          "avatarLetter": "C",
          "type": "email"
        },
        {
          "id": "v2",
          "value": "@importantclient.com",
          "avatarLetter": "I",
          "type": "domain"
        },
        {
          "id": "v3",
          "value": "investor@capital.vc",
          "avatarLetter": "V",
          "type": "email"
        },
        {
          "id": "v4",
          "value": "@legal.firm.com",
          "avatarLetter": "L",
          "type": "domain"
        }
      ],
      "inboxBackdropRows": [
        {
          "id": "r1",
          "sender": "Nadia Osei",
          "subject": "Re: Q4 budget signoff",
          "preview": "Confirmed, I'll get those numbers to you by end of week...",
          "time": "8:47 AM"
        },
        {
          "id": "r2",
          "sender": "Legal Team",
          "subject": "NDA revision ready",
          "preview": "The updated draft is attached — please review before Friday...",
          "time": "8:30 AM"
        },
        {
          "id": "r3",
          "sender": "Anna Williams",
          "subject": "Kickoff docs updated",
          "preview": "I've incorporated all feedback from yesterday's review session...",
          "time": "8:15 AM"
        }
      ],
      "vipMatchEmail": {
        "sender": "CEO · Acme Corp",
        "subject": "Q4 board deck — review needed",
        "preview": "Hi team, attached is the draft for Thursday's board meeting…",
        "time": "just now",
        "vipBadge": "VIP"
      },
      "slackMessageLines": [
        {
          "id": "l1",
          "text": "🔔 VIP email from CEO",
          "style": "bold-header"
        },
        {
          "id": "l2",
          "text": "Subject: Q4 board deck — review needed",
          "style": "field"
        },
        {
          "id": "l3",
          "text": "Hi team, attached is the draft for Thursday's board meeting…",
          "style": "preview"
        },
        {
          "id": "l4",
          "text": "",
          "style": "buttons"
        }
      ],
      "slackButtons": [
        {
          "id": "open",
          "label": "Open in Gmail"
        },
        {
          "id": "seen",
          "label": "Mark as seen"
        }
      ]
    },
    "aiDrafting": {
      "windowTitle": "Inbox",
      "newEmail": {
        "sender": "Nadia Osei",
        "subject": "Quick question — Q4 budget timing",
        "preview": "Hey! Do you have 15 min later this week to sync on the Q4 numbers? Want to make sure we're aligned before the board...",
        "time": "Just now",
        "tagKey": "toRespond"
      },
      "compose": {
        "header": "Reply to Nadia Osei",
        "aiBadge": "✨ AI draft",
        "to": "To:",
        "toValue": "sarah@company.com",
        "subject": "Subject:",
        "subjectValue": "Re: Quick question — Q4 budget timing",
        "draftLabel": "Draft — not sent",
        "draftFooter": "💾 Draft saved to your inbox · review before sending"
      },
      "replyBody": "Hey Sarah! 👋\n\nYeah totally, happy to sync. I've got Thursday afternoon or Friday morning free — which works better for you?\n\nI'll come prepped with the latest numbers so we can dig in quickly.\n\nTalk soon,\nB",
      "backgroundEmails": [
        {
          "sender": "Nadia Osei",
          "subject": "Q4 Budget Review",
          "preview": "Hi team, I wanted to follow up on yesterday's discussion about the Q4 allocation...",
          "time": "2:34 PM",
          "tagKey": "toRespond",
          "tagColor": "orange",
          "avatarColor": "pink",
          "isPromo": false
        },
        {
          "sender": "John Martinez",
          "subject": "Meeting Tomorrow at 2pm",
          "preview": "Just confirming our sync for tomorrow afternoon to discuss the project timeline...",
          "time": "1:15 PM",
          "tagKey": "meetingUpdate",
          "tagColor": "violet",
          "avatarColor": "violet",
          "isPromo": false
        },
        {
          "sender": "Legal Team",
          "subject": "Contract Review Needed",
          "preview": "Please review the attached contract and provide your feedback by end of week...",
          "time": "11:42 AM",
          "tagKey": "fyi",
          "tagColor": "yellow",
          "avatarColor": "emerald",
          "isPromo": false
        },
        {
          "sender": "Anna Williams",
          "subject": "Project kickoff documents",
          "preview": "Attached are the kickoff docs for the new initiative. Please review and share...",
          "time": "10:55 AM",
          "tagKey": "toReview",
          "tagColor": "blue",
          "avatarColor": "sky",
          "isPromo": false
        }
      ]
    },
    "autoLabeling": {
      "windowTitle": "Inbox",
      "badges": {
        "unorganized": "6 emails · unorganized",
        "classifying": "✨ AI classifying...",
        "classified": "✓ Classified",
        "stats": "3 important · 3 distractions"
      },
      "footerTagline": "Focus on what matters ✓",
      "labels": {
        "important": "Important",
        "distraction": "Distraction"
      },
      "emails": [
        {
          "sender": "Nadia Osei",
          "subject": "Q4 Budget Review",
          "preview": "Hi team, I wanted to follow up on yesterday's discussion about the Q4 allocation...",
          "time": "2:34 PM",
          "avatarColor": "pink",
          "classification": "important"
        },
        {
          "sender": "Amazon",
          "subject": "📦 Your order has shipped",
          "preview": "Track your package — estimated delivery Thursday between 10am and 2pm...",
          "time": "2:12 PM",
          "avatarColor": "amber",
          "classification": "distraction"
        },
        {
          "sender": "John Martinez",
          "subject": "Meeting Tomorrow at 2pm",
          "preview": "Just confirming our sync for tomorrow afternoon to discuss the project timeline...",
          "time": "1:15 PM",
          "avatarColor": "violet",
          "classification": "important"
        },
        {
          "sender": "LinkedIn",
          "subject": "👀 5 people viewed your profile",
          "preview": "Stand out in search — see who's been checking out your LinkedIn profile this week...",
          "time": "12:48 PM",
          "avatarColor": "sky",
          "classification": "distraction"
        },
        {
          "sender": "Legal Team",
          "subject": "Contract Review Needed",
          "preview": "Please review the attached contract and provide your feedback by end of week...",
          "time": "11:42 AM",
          "avatarColor": "emerald",
          "classification": "important"
        },
        {
          "sender": "Nike",
          "subject": "👟 New sneakers just dropped",
          "preview": "Be the first to shop limited edition styles — members get early access now...",
          "time": "11:20 AM",
          "avatarColor": "red",
          "classification": "distraction"
        }
      ]
    },
    "unsubscribeReport": {
      "windowTitle": "Inbox",
      "weekHeader": "This week",
      "weekFooter": "We noticed you archived these without reading...",
      "archivedBadge": "archived · unread",
      "archivedEmails": [
        {
          "sender": "Medium Daily Digest",
          "subject": "Today in startups: 10 must-read stories",
          "time": "Mon 8:00 AM"
        },
        {
          "sender": "TechCrunch",
          "subject": "Daily crunch: AI funding roundup",
          "time": "Tue 8:00 AM"
        },
        {
          "sender": "Product Hunt Weekly",
          "subject": "This week's top 10 products",
          "time": "Wed 8:00 AM"
        },
        {
          "sender": "Substack Reads",
          "subject": "Your personalized reading list",
          "time": "Thu 8:00 AM"
        }
      ],
      "reportEmail": {
        "label": "Weekly digest",
        "sender": "this+that Assistant",
        "subject": "📊 Weekly unsubscribe report",
        "preview": "You archived 26 emails from 4 senders without reading them — tap to review",
        "time": "Monday, 9:00 AM"
      },
      "modal": {
        "title": "📊 Weekly unsubscribe report",
        "subtitle": "You archived 26 emails from these senders this week without reading them.",
        "unsubscribeButton": "Unsubscribe",
        "unsubscribedState": "✓ Unsubscribed",
        "footerHint": "Tap to unsubscribe · takes 1 second"
      },
      "senders": [
        {
          "name": "Medium Daily Digest",
          "archivedCount": 8,
          "openedCount": 0,
          "avatarColor": "orange"
        },
        {
          "name": "TechCrunch",
          "archivedCount": 7,
          "openedCount": 0,
          "avatarColor": "rose"
        },
        {
          "name": "Product Hunt Weekly",
          "archivedCount": 5,
          "openedCount": 1,
          "avatarColor": "violet"
        },
        {
          "name": "Substack Reads",
          "archivedCount": 6,
          "openedCount": 0,
          "avatarColor": "sky"
        }
      ],
      "senderSubtitle": "{{archivedCount}} emails archived · {{openedCount}} opened"
    },
    "chaosArrival": {
      "windowTitle": "Inbox",
      "timestampLabel": "Monday, 9:02 AM",
      "counterSuffix": "new this morning",
      "inboxLabel": "Inbox",
      "emptyStateSubtitle": "You're all caught up",
      "inboxEmails": [
        {
          "id": "inbox-1",
          "sender": "Nadia Osei",
          "subject": "Q4 Budget Review",
          "preview": "Follow up on yesterday's allocation discussion...",
          "time": "8:44 AM",
          "avatarColor": "rose"
        },
        {
          "id": "inbox-2",
          "sender": "Amazon",
          "subject": "Your order has shipped",
          "preview": "Your package is on its way — track it here",
          "time": "8:30 AM",
          "avatarColor": "amber"
        },
        {
          "id": "inbox-3",
          "sender": "ceo@acme.com",
          "subject": "Board deck — final review needed",
          "preview": "Please review and send back before Thursday EOD",
          "time": "8:15 AM",
          "avatarColor": "emerald"
        },
        {
          "id": "inbox-4",
          "sender": "Legal Team",
          "subject": "Contract deadline today",
          "preview": "Please return your markup on the NDA by noon...",
          "time": "7:58 AM",
          "avatarColor": "violet"
        },
        {
          "id": "inbox-5",
          "sender": "GitHub",
          "subject": "New pull request needs your review",
          "preview": "Nadia Osei opened a PR in your-repo/main",
          "time": "9:00 AM",
          "avatarColor": "gray"
        },
        {
          "id": "inbox-6",
          "sender": "Figma",
          "subject": "Dana shared a file with you",
          "preview": "Design system v2 — open in Figma",
          "time": "9:01 AM",
          "avatarColor": "teal"
        },
        {
          "id": "inbox-7",
          "sender": "Notion",
          "subject": "You were mentioned in a page",
          "preview": "Tom mentioned you in Q4 Roadmap Planning",
          "time": "9:02 AM",
          "avatarColor": "pink"
        }
      ],
      "chatNotifications": [
        {
          "id": "chat-1",
          "platform": "slack",
          "sender": "Sarah",
          "preview": "Deploy failed — anyone on it?",
          "time": "8:47 AM"
        },
        {
          "id": "chat-2",
          "platform": "slack",
          "sender": "Mike",
          "preview": "Figma file updated, need sign-off",
          "time": "8:51 AM"
        },
        {
          "id": "chat-3",
          "platform": "teams",
          "sender": "Dana",
          "preview": "Roadmap doc ready for review",
          "time": "8:53 AM"
        },
        {
          "id": "chat-4",
          "platform": "slack",
          "sender": "Alex",
          "preview": "PR blocked — need a second reviewer",
          "time": "8:55 AM"
        },
        {
          "id": "chat-5",
          "platform": "teams",
          "sender": "Jordan",
          "preview": "Heads up — CEO wants a demo Friday",
          "time": "9:00 AM"
        },
        {
          "id": "chat-6",
          "platform": "slack",
          "sender": "Riley",
          "preview": "Can you review the new onboarding flow?",
          "time": "9:01 AM"
        }
      ],
      "meetingInvite": {
        "title": "Design review · 15 min",
        "subtitle": "With Sarah, Mike + 3 others",
        "time": "10:00 AM today"
      }
    },
    "doBox": {
      "inboxWindowTitle": "Inbox",
      "doBoxWindowTitle": "DoBox",
      "convertToTaskBadge": "✨ Converting to task...",
      "linkedBadge": "✓ Linked to email",
      "acceptButton": "Accept",
      "newEmailLabel": "NEW",
      "suggestionsSection": "Task suggestions",
      "tasksSection": "Tasks",
      "inboxEmails": [
        {
          "sender": "John Martinez",
          "subject": "Meeting Tomorrow at 2pm",
          "preview": "Just confirming our sync for tomorrow afternoon...",
          "time": "1:15 PM",
          "avatarColor": "violet"
        },
        {
          "sender": "Legal Team",
          "subject": "Contract Review Needed",
          "preview": "Please review the attached contract and provide...",
          "time": "11:42 AM",
          "avatarColor": "emerald"
        },
        {
          "sender": "Anna Williams",
          "subject": "Project kickoff documents",
          "preview": "Attached are the kickoff docs for the new initiative...",
          "time": "10:55 AM",
          "avatarColor": "sky"
        }
      ],
      "priority": {
        "urgent": "Urgent",
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "existingEntries": [
        {
          "title": "Review legal contract",
          "description": "Pending signature by end of day",
          "priority": "high",
          "due": "Today",
          "dueStatus": "overdue",
          "labels": [
            {
              "title": "Legal",
              "hexColor": "#8b5cf6"
            },
            {
              "title": "Urgent",
              "hexColor": "#ef4444"
            }
          ],
          "participants": [
            {
              "initials": "LT"
            },
            {
              "initials": "CS"
            }
          ]
        },
        {
          "title": "Prepare team standup slides",
          "description": "Weekly sync with product & design",
          "priority": "medium",
          "due": "Wed",
          "dueStatus": "soon",
          "labels": [
            {
              "title": "Team",
              "hexColor": "#f59e0b"
            }
          ],
          "participants": [
            {
              "initials": "AW"
            }
          ]
        }
      ],
      "newEntry": {
        "title": "Q4 Budget Review",
        "description": "Provide input on Q4 allocation by Friday",
        "priority": "high",
        "due": "Fri",
        "dueStatus": "normal",
        "labels": [
          {
            "title": "Finance",
            "hexColor": "#10b981"
          },
          {
            "title": "Review",
            "hexColor": "#3b82f6"
          }
        ],
        "participants": [
          {
            "initials": "SC"
          }
        ]
      },
      "newEmail": {
        "sender": "Nadia Osei",
        "subject": "Q4 Budget Review",
        "preview": "Hey! Need your input on Q4 allocation by Friday...",
        "time": "Just now",
        "avatarColor": "pink"
      }
    },
    "flows": {
      "windowTitle": "Flows",
      "dialogTitle": "✨ AI Flows Generator",
      "dialogPlaceholder": "Describe the flow you want to create…",
      "examplePrompts": [
        "Daily summary",
        "Auto-label emails",
        "Slack digest",
        "Follow-ups"
      ],
      "promptText": "When I get an email from my CEO, draft a reply and notify me on Slack",
      "generateButton": "Generate",
      "generatingLabel": "Generating your flow…",
      "trigger": {
        "label": "New email from CEO"
      },
      "step1": {
        "label": "Step 1",
        "title": "Draft reply"
      },
      "step2": {
        "label": "Step 2",
        "title": "Notify Slack"
      },
      "step3": {
        "label": "Step 3",
        "title": "Add label: Important"
      },
      "sidePanel": {
        "title": "Add a step",
        "steps": [
          "Summarize",
          "Add label",
          "Archive",
          "AI ask",
          "Send Slack",
          "Create task"
        ]
      },
      "addStepPlaceholder": "+ Add Step",
      "saveButton": "Save",
      "savedToast": "Flow saved"
    },
    "destillation": {
      "windowTitle": "Inbox",
      "timestampLabel": "Monday, 9:02 AM",
      "inboxLabel": "Inbox",
      "counterBefore": {
        "value": "120",
        "suffix": "new this morning"
      },
      "counterAfter": {
        "suffix": "actionable"
      },
      "doBoxPaneTitle": "DoBox · just now",
      "priority": {
        "urgent": "Urgent",
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "echoEmails": [
        {
          "id": "echo-1",
          "sender": "Nadia Osei",
          "subject": "Q4 Budget Review",
          "preview": "Follow up on yesterday’s allocation discussion…",
          "time": "8:44 AM",
          "avatarColor": "rose"
        },
        {
          "id": "echo-2",
          "sender": "ceo@acme.com",
          "subject": "Board deck — final review needed",
          "preview": "Please review and send back before Thursday EOD",
          "time": "8:15 AM",
          "avatarColor": "emerald"
        },
        {
          "id": "echo-3",
          "sender": "Legal Team",
          "subject": "Contract deadline today",
          "preview": "Please return your markup on the NDA by noon…",
          "time": "7:58 AM",
          "avatarColor": "violet"
        },
        {
          "id": "echo-4",
          "sender": "Figma",
          "subject": "Dana shared a file with you",
          "preview": "Design system v2 — open in Figma",
          "time": "9:01 AM",
          "avatarColor": "teal"
        },
        {
          "id": "echo-5",
          "sender": "Notion",
          "subject": "You were mentioned in a page",
          "preview": "Tom mentioned you in Q4 Roadmap Planning",
          "time": "9:02 AM",
          "avatarColor": "pink"
        }
      ],
      "echoChats": [
        {
          "id": "echat-1",
          "platform": "slack",
          "sender": "Mike",
          "preview": "Figma file updated, need sign-off",
          "time": "8:51 AM"
        },
        {
          "id": "echat-2",
          "platform": "slack",
          "sender": "Sarah",
          "preview": "Deploy failed — anyone on it?",
          "time": "8:47 AM"
        },
        {
          "id": "echat-3",
          "platform": "teams",
          "sender": "Dana",
          "preview": "Roadmap doc ready for review",
          "time": "8:53 AM"
        },
        {
          "id": "echat-4",
          "platform": "teams",
          "sender": "Jordan",
          "preview": "CEO wants a demo Friday",
          "time": "9:00 AM"
        }
      ],
      "echoMeetingInvite": {
        "title": "Design review · 15 min",
        "subtitle": "With Sarah, Mike + 3 others",
        "time": "10:00 AM today"
      },
      "doBoxTasks": [
        {
          "id": "dt-1",
          "title": "Reply to Nadia Osei",
          "context": "From: Q4 Budget Review email",
          "priority": "high"
        },
        {
          "id": "dt-2",
          "title": "Review #design thread",
          "context": "From: Slack #design",
          "priority": "medium"
        },
        {
          "id": "dt-3",
          "title": "Prep board slides",
          "context": "From: Design review meeting",
          "priority": "urgent"
        },
        {
          "id": "dt-4",
          "title": "Follow up with CEO",
          "context": "From: ceo@acme.com",
          "priority": "urgent"
        },
        {
          "id": "dt-5",
          "title": "Respond to Jordan",
          "context": "From: Teams Leadership",
          "priority": "high"
        }
      ]
    }
  },
  "commentsAndActivity": {
    "title": "Comments and activity",
    "toggle": {
      "show": "Show details",
      "hide": "Hide details"
    },
    "activity": {
      "created": "created this task",
      "deleted": "deleted this task",
      "restored": "restored this task",
      "moved": "moved this task to another task group",
      "nameOverflow": "{{names}} and {{count}} more",
      "changed": {
        "subject": "renamed this task",
        "description": {
          "set": "added a description to this task",
          "cleared": "removed the description from this task",
          "updated": "updated the description on this task"
        },
        "priority": {
          "set": "set priority on this task to {{value}}",
          "cleared": "cleared the priority from this task",
          "updated": "changed priority on this task to {{value}}"
        },
        "dueAt": {
          "set": "set a due date on this task to {{value}}",
          "cleared": "cleared the due date from this task",
          "updated": "changed the due date on this task to {{value}}"
        },
        "resolvedAt": {
          "set": "marked this task as done",
          "cleared": "reopened this task"
        },
        "isSuggestion": {
          "accepted": "accepted this task as a suggestion"
        },
        "taskLabelIds": {
          "added": "added label {{names}} to this task",
          "removed": "removed label {{names}} from this task",
          "updated": "updated labels on this task"
        },
        "participantIds": {
          "added": "added {{names}} to this task",
          "removed": "removed {{names}} from this task",
          "updated": "updated participants on this task"
        },
        "communicationIds": {
          "updated": "linked new communications to this task"
        },
        "agentSetupMcpWrite": "approved an agent action on this task: {{tool}}"
      },
      "fallback": "updated this task"
    }
  },
  "billing": {
    "pageTitle": "Billing & plans",
    "pageDescription": "Manage your subscription, team members, and invoices.",
    "comingSoon": "This feature is coming soon.",
    "cycleToggle": {
      "monthly": "Monthly",
      "annual": "Annual",
      "discount": "−{{percent}}%",
      "annualNote": "Billed annually · Save 20%",
      "monthlyNote": "Billed monthly"
    },
    "noActivePlan": {
      "title": "Billing & plans",
      "subtitle": "Choose the plan that fits how your team works."
    },
    "plans": {
      "priceUnit": "/user/mo",
      "priceUnitAnnual": "/user/mo billed annually",
      "team": {
        "name": "this+that",
        "cta": "Get started",
        "features": {
          "fullProduct": "Full product: Workflows, Brain, Assistant, DoBox, Contacts, all integrations",
          "channels": "Gmail, Outlook, Slack, Microsoft Teams, Google Chat, and WhatsApp Business (Instagram and Facebook Messenger awaiting approval)",
          "sharedTasks": "Shared task view and task assignment",
          "sharedContacts": "Shared contacts, so the next person to pick up an account starts from a reconciled record",
          "crossTeamWorkflows": "Workflows that work across team members",
          "mcpServers": "20 built-in MCP servers + connect your own"
        }
      },
      "enterprise": {
        "name": "Enterprise",
        "tagline": "For larger organizations with their own security, procurement and support requirements.",
        "priceLabel": "Contact us",
        "cta": "Contact sales",
        "features": {
          "everythingAbove": "Everything above",
          "sso": "SSO (SAML)",
          "scim": "SCIM provisioning",
          "customTerms": "Terms and pricing to fit the organization"
        }
      }
    },
    "hero": {
      "currentPlanBadge": "Current plan",
      "renewsAt": "Renews {{date}}",
      "managedBy": "Managed by {{email}}",
      "priceMeta": "/ year · {{seats}} seats × ${{pricePerSeat}}",
      "managePlan": "Manage plan",
      "switchToMonthly": "Switch to monthly",
      "switchToAnnual": "Switch to annual",
      "cancel": "Cancel"
    },
    "stats": {
      "paidSeats": "Paid seats",
      "seatsAvailable": "{{count}} seats available",
      "doBoxSuggestions": "DoBox suggestions this month",
      "doBoxSuggestionsHint": "Unlimited on Team",
      "nextInvoice": "Next invoice"
    },
    "members": {
      "title": "Members of the plan",
      "inviteButton": "+ Invite member",
      "removeAriaLabel": "Remove {{name}} from plan",
      "roles": {
        "admin": "Admin",
        "member": "Member",
        "viewer": "Viewer"
      },
      "seatTypes": {
        "team": "Team",
        "free": "Free"
      }
    },
    "paymentMethod": {
      "title": "Payment method",
      "expires": "Expires {{exp}}",
      "updateButton": "Update"
    },
    "invoices": {
      "title": "Recent invoices",
      "viewAll": "View all",
      "downloadAriaLabel": "Download invoice from {{date}}",
      "statuses": {
        "paid": "Paid",
        "pending": "Pending",
        "failed": "Failed"
      },
      "empty": "No invoices yet.",
      "viewAriaLabel": "View invoice from {{date}}"
    },
    "page": {
      "planName": "this+that",
      "tagline": "The full product, priced per person. Invite your colleagues.",
      "upgradeCta": "Get started",
      "manage": {
        "badge": "Current plan",
        "subtitle": "Manage your subscription, seats, and payment method in Stripe.",
        "manageCta": "Manage subscription"
      },
      "enterprise": {
        "badge": "Coming soon",
        "cta": "Talk to sales"
      },
      "memberNotice": {
        "title": "Billing is managed by your team owner",
        "subtitleWithOwner": "Ask {{ownerName}} to upgrade this+that to keep using it.",
        "subtitleGeneric": "Ask your team owner to upgrade this+that to keep using it."
      },
      "noTeam": {
        "title": "No team selected",
        "subtitle": "Join or create a team to manage billing."
      }
    },
    "trialBanner": {
      "calm": {
        "title_one": "Trial · {{count}} day left",
        "title_other": "Trial · {{count}} days left",
        "subtitle": "Full access until {{date}}",
        "cta": "Choose a plan"
      },
      "warning": {
        "title_one": "{{count}} day until your trial ends",
        "title_other": "{{count}} days until your trial ends",
        "subtitle": "After that, the app locks until your team chooses a plan",
        "cta": "Choose a plan"
      },
      "urgent": {
        "title": "Your trial ends tomorrow",
        "subtitleWithPrice": "{{price}} /user/mo after that",
        "subtitle": "Choose a plan to keep access",
        "cta": "Choose a plan"
      },
      "expired": {
        "title": "Your trial has ended",
        "subtitle": "Choose a plan to unlock your team",
        "cta": "Choose a plan"
      },
      "memberSubtitle": "Ask your team owner to choose a plan",
      "dismiss": "Dismiss"
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Common questions",
      "items": {
        "betaEnd": {
          "question": "What happens when the beta ends?",
          "answer": "The beta ends September 1 and nobody is charged that day. Every existing account moves into a free 30-day trial starting September 1, so the earliest billing begins is a month later. Accounts created after that get 30 days from the day they sign up. You choose a plan when your trial ends, and your data is saved either way, so you pick up where you left off without re-syncing."
        },
        "switchInterval": {
          "question": "Can I switch between monthly and annual?",
          "answer": "Yes, anytime. If you switch to annual mid-cycle, we'll prorate the difference."
        },
        "whoIsUser": {
          "question": "Who counts as a user?",
          "answer": "Anyone with their own this+that account who connects their email or messaging. A shared address like support@ doesn't count as an extra user."
        },
        "workflowUsage": {
          "question": "What if I need more than the included workflow usage?",
          "answer": "We'll reach out before you reach the included limit, so you can decide whether to add usage or tune your workflows."
        },
        "reliability": {
          "question": "Is this+that reliable enough to run our team on?",
          "answer": "Yes. We run on AWS, and we commit to 99.5% uptime each calendar month. The uptime and availability commitments set out how we measure it and the two things we exclude. You can check live system status and past incidents anytime at <status>status.thisandthat.chat</status>, and our <security>security page</security> covers encryption, data handling, and compliance."
        },
        "brainMigration": {
          "question": "Do I have to move my wiki or Notion into the Brain?",
          "answer": "No, you don't have to migrate anything to get value. The Brain's unique job is the operational layer your other tools can't hold: what is going on with a customer, who knows what, the context buried in your threads. For canonical knowledge like pricing and playbooks, teams get the tightest experience by keeping it in the Brain, where the assistant and workflows read and write it directly."
        }
      }
    }
  },
  "credits": {
    "balanceRow": {
      "addLink": "+ Add",
      "noWallet": "Credits coming soon",
      "tooltip": "{{balance}} of {{total}} credits"
    },
    "status": {
      "healthy": "{{pct}}% left",
      "low": "Low balance",
      "empty": "No credits"
    },
    "amountOf": "of {{total}}",
    "unit_one": "credit",
    "unit_other": "credits",
    "chip": {
      "ariaLabel": "View credits balance",
      "tagYou": "You",
      "tagTeam": "Team"
    },
    "popover": {
      "personalTitle": "Your credits",
      "personalSubtitle": "Personal balance",
      "teamTitle": "Team credits",
      "teamSubtitle_one": "Shared across {{count}} member",
      "teamSubtitle_other": "Shared across {{count}} members",
      "rows": {
        "plan": "Monthly plan",
        "purchased": "Purchased",
        "usedThisMonth": "Used this month"
      },
      "renewsOn": "renews on {{date}}",
      "buyButton": "Add credits",
      "buyButtonTeam": "Add credits to the team",
      "noWallet": "Your credits will show up here soon."
    },
    "buyModal": {
      "title": "Add credits",
      "titleTeam": "Add credits to the team",
      "packCredits_one": "{{credits}} credit",
      "packCredits_other": "{{credits}} credits",
      "loadError": "Could not load credit packs.",
      "purchaseError": "Could not start the purchase. Try again."
    },
    "page": {
      "title": "Credits",
      "subtitle": "Track your usage and add credits",
      "scope": {
        "personal": "Personal",
        "team": "Team",
        "ariaLabel": "Select credits scope"
      },
      "balance": {
        "personalLabel": "Your balance",
        "teamLabel_one": "Team balance · {{count}} member",
        "teamLabel_other": "Team balance · {{count}} members",
        "teamLabelLoading": "Team balance",
        "teamUnavailable": "Team balance is unavailable."
      },
      "statement": {
        "title": "Statement",
        "filtersAriaLabel": "Filter the statement",
        "filters": {
          "all": "All",
          "flows": "Flows",
          "assistant": "Assistant",
          "agents": "Agents",
          "purchases": "Purchases"
        },
        "table": {
          "description": "Description",
          "by": "By",
          "date": "Date",
          "credits": "Credits"
        },
        "empty": "No transactions for this filter.",
        "loadError": "Could not load the statement.",
        "loadMore": "Load more"
      },
      "tag": {
        "flow": "Flow",
        "assistant": "Assistant",
        "agent": "Agent",
        "purchase": "Purchase",
        "plan": "Plan",
        "credit": "Adjustment",
        "other": "Other"
      },
      "nameFallback": {
        "flow": "Deleted flow",
        "assistant": "Deleted conversation",
        "agent": "Deleted agent",
        "purchase": "Purchase",
        "plan": "Monthly plan",
        "credit": "Credit adjustment",
        "other": "Transaction"
      },
      "drawer": {
        "close": "Close",
        "breakdownTitle": "Where the credits were spent",
        "paymentTitle": "Payment",
        "meta": {
          "modelCalls": "Model calls",
          "reference": "ID",
          "balanceAfter": "Balance after"
        }
      },
      "breakdown": {
        "trigger": "Trigger and data read",
        "agentTask": "AI processing",
        "summarize": "Summarization",
        "integrationAction": "Integration actions",
        "message": "Messages sent",
        "brainSearch": "Brain search",
        "reasoning": "Reasoning and planning",
        "toolCall": "Tools used",
        "response": "Final response"
      }
    }
  },
  "calendarInvite": {
    "header": {
      "source": "Google Calendar · Invitation from {{organizer}}"
    },
    "status": {
      "awaiting": "Awaiting your reply",
      "accepted": "Accepted",
      "declined": "Declined",
      "tentative": "Tentative"
    },
    "action": {
      "yes": "Yes",
      "maybe": "Maybe",
      "no": "No",
      "proposeNewTime": "New time"
    },
    "conferenceLink": {
      "googleMeet": "Google Meet"
    },
    "guests": {
      "total_one": "{{count}} guest",
      "total_other": "{{count}} guests",
      "yes": "yes",
      "maybe": "maybe",
      "no": "no",
      "awaiting": "awaiting",
      "showMore_one": "Show {{count}} more guest",
      "showMore_other": "Show {{count}} more guests",
      "showLess": "Show less"
    },
    "guestBadge": {
      "organizer": "ORGANIZER",
      "you": "YOU"
    },
    "proposeNewTime": {
      "title": "Propose a new time",
      "startLabel": "New start time",
      "endLabel": "New end time",
      "submit": "Propose",
      "error": "Couldn't propose the new time. Please try again.",
      "unavailableReason": "Proposing a new time isn't available for this invitation because it was received before this feature existed.",
      "invalidRange": "The end time must be after the start time."
    }
  },
  "floatingAssistant": {
    "panel": {
      "title": "this+that assistant",
      "minimize": "Minimize",
      "close": "Close",
      "openGallery": "Open your images",
      "openStandalone": "Open as full page",
      "ariaLabel": "this+that assistant panel",
      "resizeHandle": "Drag to resize assistant panel"
    },
    "watching": {
      "label": "Watching:",
      "inbox": "Inbox · Today",
      "inboxPreview": "Inbox · Email",
      "dobox": "DoBox · Tasks",
      "doboxPreview": "DoBox · Entry",
      "slackInbox": "Inbox · Slack",
      "teamsInbox": "Inbox · Teams",
      "inboxSent": "Inbox · Sent",
      "inboxDraft": "Inbox · Drafts",
      "inboxSpam": "Inbox · Spam",
      "inboxTrash": "Inbox · Trash",
      "inboxAll": "Inbox · All",
      "inboxLabels": "Inbox · Labels",
      "inboxSearch": "Inbox · Search",
      "flows": "Flows",
      "billing": "Billing",
      "account": "Account",
      "assistant": "Assistant",
      "brain": "Brain",
      "unknown": "App"
    },
    "suggestions": {
      "communicationReport": "Communication report",
      "calendarToday": "What's on my calendar today?",
      "whatDidIMiss": "What did I miss overnight?",
      "draftsInProgress": "Drafts in progress",
      "summarizePendingTasks": "Summarize my pending tasks",
      "whatNeedsAttention": "What needs my attention today?",
      "replyPendingDMs": "Reply to pending DMs",
      "slackChannelsOverview": "Slack channels overview",
      "summarizeActiveFlows": "Summarize my active flows"
    },
    "pill": {
      "label": "Assistant",
      "ariaLabel": "Open this+that assistant",
      "ariaLabelAttention": "this+that assistant — needs your attention"
    }
  },
  "assistantInputBar": {
    "slashPillLabel": "Type a command",
    "atPillLabel": "Mention someone",
    "sendButtonLabel": "Send"
  },
  "brain": {
    "deepLinkTeamSwitch": {
      "switched": "Switched active team to {{teamName}} to open this item",
      "switchedGeneric": "Switched active team to open this item",
      "noAccess": "You don't have access to this item's team"
    },
    "sidebar": {
      "heading": "Knowledge",
      "loading": "Loading…",
      "loadError": "Couldn't load knowledge spaces",
      "empty": "No knowledge spaces yet",
      "compose": {
        "button": "New space",
        "menu": {
          "newPage": "New page",
          "newSpace": "New space"
        }
      },
      "spaceActions": {
        "menuAriaLabel": "Space actions",
        "createPage": "Create page",
        "rename": "Rename space",
        "delete": "Delete space",
        "renameInputAriaLabel": "Space name",
        "systemSpaceTooltip": "System spaces can't be renamed or deleted",
        "renameSuccessToast": "Space renamed",
        "renameErrorToast": "Could not rename space"
      },
      "pageActions": {
        "menuAriaLabel": "Page actions",
        "createPage": "Create page",
        "rename": "Rename page",
        "delete": "Delete page",
        "renameInputAriaLabel": "Page title",
        "renameSuccessToast": "Page renamed",
        "renameErrorToast": "Could not rename page",
        "deleteErrorToast": "Could not delete page",
        "move": "Move page",
        "favorite": "Add to favorites",
        "unfavorite": "Remove from favorites",
        "systemPageTooltip": "System pages can't be renamed, moved, or deleted.",
        "systemPageAriaLabel": "System page"
      },
      "deletePage": {
        "confirmTitle": "Delete page \"{{title}}\"?",
        "confirmDescription": "This will permanently delete the page. This action cannot be undone.",
        "confirmDescriptionWithChildren": "This will permanently delete the page and its {{count}} child pages. This action cannot be undone.",
        "confirmAction": "Delete",
        "cancel": "Cancel",
        "successToast": "Page deleted",
        "errorToast": "Could not delete page"
      },
      "deleteSpace": {
        "confirmTitle": "Delete space \"{{name}}\"?",
        "confirmDescription": "This will permanently delete the space and ALL its pages. This action cannot be undone.",
        "confirmAction": "Delete",
        "cancel": "Cancel",
        "successToast": "Space deleted",
        "errorToast": "Could not delete space"
      },
      "groups": {
        "systemSpaces": "System Spaces",
        "teamSpaces": "Team Spaces",
        "userSpaces": "User Spaces",
        "teamSpacesEmpty": "Add team space.",
        "userSpacesEmpty": "Add user space."
      },
      "spaceHeader": {
        "pageCount_one": "{{count}} page",
        "pageCount_other": "{{count}} pages"
      },
      "spaceSection": {
        "empty": "No pages",
        "loadError": "Couldn't load pages",
        "retry": "Retry"
      },
      "back": "Back",
      "backToApp": "Back to app",
      "home": "Home",
      "dragHint": {
        "invalidDrop": "Cannot drop here"
      },
      "nav": {
        "favorites": "Favorites"
      }
    },
    "modals": {
      "createSpace": {
        "title": "Create new space",
        "nameLabel": "Name",
        "namePlaceholder": "Space name",
        "nameRequired": "Name is required",
        "ownerTypeLabel": "Type",
        "ownerTypeTeam": "Team",
        "ownerTypeUser": "Your own",
        "cancel": "Cancel",
        "create": "Create",
        "successToast": "Space created",
        "errorToast": "Failed to create space"
      },
      "createPage": {
        "title": "Create new page",
        "titleLabel": "Title",
        "titlePlaceholder": "Page title",
        "titleRequired": "Title is required",
        "spaceLabel": "Space",
        "spaceRequired": "Space is required",
        "parentLabel": "Parent page",
        "parentRoot": "(No parent — root page)",
        "cancel": "Cancel",
        "create": "Create",
        "successToast": "Page created",
        "errorToast": "Failed to create page",
        "ownerTypeTeam": "Team",
        "ownerTypeUser": "User"
      },
      "renamePage": {
        "title": "Rename page",
        "titleLabel": "Page title",
        "titlePlaceholder": "Enter page title",
        "titleRequired": "Title is required",
        "cancel": "Cancel",
        "save": "Save"
      },
      "movePage": {
        "title": "Move page “{{title}}”",
        "subtitle": "Choose a new location for this page",
        "targetLabel": "Move to",
        "rootOption": "{{spaceName}} (root)",
        "cancel": "Cancel",
        "submit": "Move",
        "successToast": "Page moved",
        "errors": {
          "crossOwnerTeamToUser": "Team pages cannot be moved to personal spaces",
          "crossOwnerOther": "Cannot move pages between different owners",
          "targetIsDescendant": "Cannot move into a child page",
          "noOp": "Page is already in this location",
          "exceedsDepth": "Move would exceed maximum nesting depth",
          "tooLarge": "Subtree too large to move in one operation ({{pageCount}} pages)",
          "inProgress": "This page is already being moved — try again in a moment",
          "versionConflict": "Page was edited elsewhere — please reload",
          "atCapacity": "Target space is at maximum page capacity",
          "generic": "Could not move page"
        },
        "tooltip": {
          "disabledTeamToUser": "Team pages can't be moved to personal spaces",
          "disabledCrossUser": "Only the page owner can move this page",
          "disabledCrossTeam": "Pages can only be moved within the same team",
          "disabledIsDescendant": "Cannot move into a child page",
          "disabledIsSelf": "Cannot drop on itself",
          "disabledExceedsDepth": "Would exceed maximum nesting depth",
          "disabledNoOp": "Already in this location",
          "disabledNoPermission": "You don't have permission to move pages here",
          "disabledSourceNoPermission": "You don't have permission to move this page",
          "disabledSystemParent": "System pages can't contain sub-pages",
          "disabledAtCapacity": "Target space is at maximum page capacity",
          "disabledTooLarge": "This page has too many sub-pages to move in one operation"
        },
        "recentLabel": "Recent",
        "recentChipAriaLabel": "Move to {{label}}",
        "movingTo": "Moving to",
        "selectDestination": "Select a destination",
        "currentPill": "Current"
      },
      "pageHistory": {
        "title": "Version history",
        "subtitle": "{{title}} · {{count}} versions",
        "detailTitle": "v{{version}} · {{tab}}",
        "detailSubtitle": "{{title}} · {{relative}}",
        "backAriaLabel": "Back to versions",
        "versionsHeader": "Versions",
        "currentBadge": "Current",
        "restore": "Restore",
        "restoreThisVersion": "Restore this version",
        "restoreConfirmTitle": "Restore this version?",
        "restoreConfirmDescription": "This replaces the current page content with {{version}} and creates a new version. Your current content stays in the history.",
        "cancel": "Cancel",
        "loadMore": "Load more",
        "loadMoreError": "Couldn't load more — retry",
        "versionsLoading": "Loading versions…",
        "versionsError": "Failed to load versions",
        "versionsEmpty": "No versions found",
        "diffLoading": "Loading diff…",
        "diffError": "Failed to load diff",
        "diffTooLarge": "This diff is too large to display",
        "diffEmpty": "No changes in this version",
        "restoreConflict": "This page changed while you were viewing history. The list was refreshed — try again.",
        "restoreError": "Couldn't restore this version. Please try again.",
        "initialVersion": "Initial version",
        "viewing": "Viewing {{version}}",
        "footerCurrent": "this is the current version",
        "footerRestore": "restoring replaces the current draft",
        "tabs": {
          "changes": "Changes",
          "fullFile": "Full file"
        }
      }
    },
    "page": {
      "empty": "Select a page to view its content",
      "loading": "Loading page…",
      "notFound": "Page not found",
      "renameTitleHint": "Click to rename this page",
      "loadErrorTitle": "Couldn't load this page",
      "loadErrorSubtitle": "We couldn't fetch its content.",
      "loadErrorCta": "Reload",
      "version": "v{{version}}",
      "updatedRelative": "Updated {{relative}}",
      "createdByCaption": "Created by",
      "creationDetails": "Creation details",
      "byAgentOnBehalf": "{{agent}} on behalf of {{user}}",
      "unknownUser": "a user who is no longer part of the team",
      "actions": {
        "edit": "Edit",
        "done": "Done",
        "saving": "Saving…",
        "discard": "Discard",
        "readOnly": "Read Only",
        "history": "History",
        "disabledWhileUnsaved": "Save or discard your changes first"
      },
      "status": {
        "idle": "Up to date",
        "saving": "Saving…",
        "saved": "Saved",
        "error": "Save failed: {{error}}",
        "contentRejected": "Save failed: content contains disallowed elements"
      },
      "conflict": {
        "title": "Outdated draft",
        "body": "Another user updated this page (now v{{version}}). Your local edits weren't applied.",
        "discardLocal": "Discard my changes"
      },
      "contentRejected": {
        "title": "This page can't be saved",
        "intro": "Remove the following from the page and save again:",
        "dismiss": "Dismiss",
        "issue": {
          "forbiddenTag": "HTML tag <{{detail}}>",
          "eventHandler": "Event handler attribute \"{{detail}}\"",
          "dangerousUri": "Link using the {{detail}} scheme"
        }
      },
      "editor": {
        "bold": "Bold",
        "italic": "Italic",
        "strike": "Strikethrough",
        "heading1": "Heading 1",
        "heading2": "Heading 2",
        "heading3": "Heading 3",
        "bulletList": "Bullet list",
        "orderedList": "Numbered list",
        "codeBlock": "Code block",
        "blockquote": "Blockquote",
        "inlineCode": "Inline code",
        "toolbarAriaLabel": "Text formatting",
        "expandToolbar": "Show more formatting options",
        "collapseToolbar": "Show fewer formatting options",
        "insertGeneratedImage": {
          "button": "Insert image",
          "modalTitle": "Insert image",
          "error": "Image inserted, but usage could not be recorded — it will still render correctly."
        },
        "insertImage": "Insert image",
        "attachFile": "Attach file",
        "aiAssistant": {
          "toolbarLabel": "AI writing assistant",
          "toolbarPillLabel": "AI",
          "slashMenu": {
            "ariaLabel": "AI writing actions",
            "empty": "No matching action",
            "sectionWriteWithAi": "Write with AI",
            "sectionFormat": "Format",
            "continueWriting": "Continue writing",
            "draftFromPrompt": "Draft from a prompt",
            "draftFromPromptHint": "{{shortcut}}",
            "notesToTable": "Turn notes into a table",
            "askYourSpaces": "Ask your spaces",
            "summarizePage": "Summarize this page",
            "heading2": "Heading 2",
            "bulletedList": "Bulleted list",
            "quote": "Quote"
          },
          "inlinePrompt": {
            "placeholderDraft": "Tell AI what to write…",
            "placeholderAskSpaces": "Ask your spaces a question…",
            "placeholderRewrite": "Tell AI how to rewrite the selection…",
            "orbAriaLabel": "AI assistant",
            "send": "Send",
            "contextLabel": "Context",
            "thisPageChip": "This page",
            "escHint": "Esc to cancel"
          },
          "status": {
            "orbAriaLabel": "AI is writing",
            "writing": "Writing…",
            "stop": "Stop"
          },
          "selectionBubble": {
            "ariaLabel": "AI selection actions",
            "improve": "Improve",
            "shorter": "Shorter",
            "tone": "Tone",
            "translate": "Translate",
            "fixGrammar": "Fix grammar",
            "askAi": "Ask AI",
            "askAiShortcut": "{{shortcut}}"
          },
          "toneLabel": {
            "formal": "Formal",
            "friendly": "Friendly",
            "direct": "Direct",
            "confident": "Confident"
          },
          "languageLabel": {
            "ptBr": "Portuguese (BR)",
            "es": "Spanish",
            "enUs": "English (US)"
          },
          "toast": {
            "undo": "Undo",
            "error": "AI couldn't generate a response. Please try again.",
            "addedBlocks_one": "Added {{count}} block",
            "addedBlocks_other": "Added {{count}} blocks",
            "answered": "Answered from your spaces",
            "rewritten": "Rewritten",
            "toneApplied": "Tone: {{tone}}",
            "translated": "Translated to {{language}}",
            "grammarFixed": "Grammar fixed",
            "sourcesOverflow": "{{first}} +{{count}} more"
          }
        }
      },
      "attachments": {
        "heading": "Attachments",
        "chip": {
          "uploading": "Uploading…",
          "unknownFile": "Unknown file",
          "downloadAriaLabel": "Download {{name}}",
          "editAriaLabel": "Select {{name}}",
          "fileInputLabel": "Attach a file to this page"
        },
        "uploadButton": "Attach file",
        "uploading": "Uploading…",
        "uploadAriaLabel": "Attach a file to this page",
        "empty": "No attachments yet",
        "listAriaLabel": "Page attachments",
        "openAriaLabel": "Open {{fileName}} in a new tab",
        "openInViewerAriaLabel": "Open {{fileName}}",
        "removeAriaLabel": "Remove {{fileName}}",
        "removeConfirm": "Remove \"{{fileName}}\"? This cannot be undone.",
        "countBadgeAriaLabel": "{{count}} attachment",
        "countBadgeAriaLabel_other": "{{count}} attachments",
        "widget": {
          "triggerAriaLabel": "Manage attachments",
          "title": "Attachments",
          "addFile": "Add file",
          "dropzoneHint": "Drop files here to attach",
          "dropzoneActive": "Release to attach",
          "uploadError": "Upload failed"
        },
        "errors": {
          "scanPending": "File is still being scanned for threats. Please try again in a moment.",
          "infected": "File was blocked for security reasons.",
          "invalidType": "The file does not match its declared type.",
          "uploadFailed": "Failed to upload attachment. Please try again.",
          "removeFailed": "Failed to remove attachment. Please try again."
        }
      },
      "images": {
        "brokenImageAlt": "Image not available",
        "imageAlt": "Inline image",
        "fileInputLabel": "Insert image",
        "errors": {
          "scanPending": "Image is still being scanned for threats. Please try again in a moment.",
          "infected": "Image was blocked for security reasons.",
          "invalidType": "The file does not match its declared type.",
          "uploadFailed": "Failed to upload image. Please try again."
        },
        "uploading": "Uploading…",
        "resizeAriaLabel": "Resize image"
      },
      "backToSpace": "Back to {{space}}",
      "unsavedChanges": {
        "title": "Unsaved changes",
        "description": "You have unsaved changes. Save them before leaving?",
        "save": "Save",
        "discard": "Discard"
      }
    },
    "home": {
      "greetingMorning": "Good morning, {{name}}",
      "greetingAfternoon": "Good afternoon, {{name}}",
      "greetingEvening": "Good evening, {{name}}",
      "greetingNoName": "Welcome to your Brain",
      "searchPlaceholder": "Search pages…",
      "clearSearch": "Clear search",
      "recentlyUpdated": "Recently updated",
      "yourSpaces": "Your spaces",
      "newSpace": "+ New space",
      "newPage": "New page",
      "pagesCount_one": "{{count}} page",
      "pagesCount_other": "{{count}} pages",
      "updatedRelative": "Updated {{relative}}",
      "teamBadge": "Team",
      "userBadge": "Personal",
      "emptyTitle": "Your Brain is ready",
      "emptySubtitle": "Create your first knowledge space to start organising notes, docs, and ideas with your team.",
      "emptyCta": "Create your first space",
      "searchNoResults": "No pages found for “{{query}}”",
      "searchNoResultsTitle": "No matches found",
      "pageCardAriaLabel": "Open page {{title}} in {{space}}",
      "spaceCardAriaLabel": "Open space {{name}}",
      "searching": "Searching…",
      "searchErrorFallback": "Semantic search is unavailable — showing title matches instead.",
      "bestMatch": "Best match",
      "searchResultsAriaLabel": "Search results for “{{query}}”",
      "favorites": "Favorites",
      "seeAllFavorites": "See all",
      "loadErrorTitle": "Couldn't load your spaces",
      "loadErrorSubtitle": "We couldn't reach them just now. Nothing's lost.",
      "loadErrorCta": "Reload"
    },
    "space": {
      "pagesCount_one": "{{count}} page",
      "pagesCount_other": "{{count}} pages",
      "membersCount_one": "{{count}} member",
      "membersCount_other": "{{count}} members",
      "pagesSectionLabel": "Pages in this space",
      "empty": "No pages in this space yet",
      "notFound": "Space not found",
      "renameTitleHint": "Click to rename this space",
      "pageCardAriaLabel": "Open page {{title}}",
      "back": "Back",
      "loadErrorTitle": "Couldn't open this space",
      "loadErrorSubtitle": "Its pages didn't come through this time.",
      "loadErrorCta": "Reload",
      "pagesLoadError": "Couldn't load these pages",
      "pagesLoadErrorRetry": "Retry"
    },
    "mention": {
      "sectionPeople": "People",
      "sectionTasks": "Tasks",
      "sectionPages": "Pages",
      "pickerAriaLabel": "Mention a person, task, or page",
      "youSuffix": "(You)",
      "empty": "No matching team member",
      "emptyTasks": "No matching tasks",
      "emptyPages": "No matching pages",
      "taskStatusOpen": "Open",
      "taskStatusDone": "Done",
      "taskCardOpenButton": "Open",
      "taskCardLoading": "Loading task…",
      "taskCardError": "Could not load task",
      "taskCardNotFound": "Task not found",
      "pageCardOpenButton": "Open",
      "pageCardLoading": "Loading page…",
      "pageCardError": "Could not load page",
      "pageCardNotFound": "Page not found"
    },
    "members": {
      "manageMembers": "Manage Members",
      "members": "Members",
      "addMembers": "Add Members",
      "owner": "Owner",
      "removeMember": "Remove Member",
      "roleLabel": "Role",
      "roles": {
        "viewer": "Viewer",
        "editor": "Editor",
        "manager": "Manager"
      },
      "visibility": {
        "label": "Visibility",
        "team": "Team",
        "teamDescription": "All team members can access this space",
        "restricted": "Restricted",
        "restrictedDescription": "Only invited members can access this space"
      },
      "leave": "Leave Space",
      "leaveConfirmTitle": "Leave \"{{name}}\"?",
      "leaveConfirmDescription": "You will lose access to this space. You can be re-invited later.",
      "transferOwnership": "Transfer Ownership",
      "transferConfirmTitle": "Transfer ownership of \"{{name}}\"?",
      "transferConfirmDescription": "{{newOwnerName}} will become the new owner and gain full control of this space.",
      "save": "Save",
      "cancel": "Cancel",
      "unknownMember": "Unknown member",
      "errors": {
        "versionConflict": "This space was updated elsewhere — please reload and try again",
        "forbidden": "You do not have permission to perform this action",
        "notOwner": "Only the space owner can perform this action",
        "participantAlreadyExists": "This member has already been added",
        "cannotLeaveTeamSpace": "You cannot leave a team-visible space",
        "generic": "Something went wrong — please try again"
      }
    },
    "favorites": {
      "title": "Favorites",
      "empty": "No favorites yet",
      "emptyHint": "Star a page to find it here quickly.",
      "toggleAdd": "Add to favorites",
      "toggleRemove": "Remove from favorites",
      "errorGeneric": "Couldn't update favorites. Please try again.",
      "limitReached": "You've reached the limit of {{limit}} favorites."
    }
  },
  "publishedArtifact": {
    "loading": "Loading…",
    "notFound": {
      "title": "Page not found or no longer available",
      "body": "This artifact may have been unpublished or the link may be incorrect."
    },
    "bridge": {
      "actionError": "Could not complete the action. Please try again."
    }
  },
  "generatedImages": {
    "page": {
      "title": "Your Images",
      "subtitle": "Images you've uploaded"
    },
    "gallery": {
      "empty": {
        "title": "You don't have any images yet.",
        "cta": "Open Assistant",
        "pickerHint": "Upload an image in the Assistant, then come back here to insert it."
      },
      "loadMore": "Load more",
      "error": "Could not load images. Please try again.",
      "retry": "Retry",
      "selectAria": "Select image",
      "viewAria": "View image",
      "imageAlt": "Stored image",
      "delete": {
        "confirmTitle": "Delete this image?",
        "confirmBody": "This image will be permanently deleted, including everywhere you've previously inserted it. This can't be undone.",
        "error": "Couldn't delete the image. Please try again."
      }
    }
  },
  "calendarPage": {
    "toolbar": {
      "today": "Today",
      "prev": "Previous",
      "next": "Next",
      "create": "Create",
      "viewSwitcherLabel": "View",
      "openMonthPicker": "Open month picker",
      "mode": {
        "month": "Month",
        "week": "Week",
        "day": "Day",
        "agenda": "Agenda"
      }
    },
    "miniCal": {
      "prevMonth": "Previous month",
      "nextMonth": "Next month"
    },
    "rail": {
      "myCalendars": "My calendars"
    },
    "monthView": {
      "more": "{{count}} more"
    },
    "timeGrid": {
      "allDay": "All-day",
      "moreCount": "{{count}} more",
      "showLess": "Show less"
    },
    "mobileDayStrip": {
      "dayLabel": "{{dow}} {{date}}"
    },
    "mobileMonthPicker": {
      "openAriaLabel": "Open month picker",
      "closeAriaLabel": "Close month picker"
    },
    "agendaView": {
      "empty": "No upcoming events in the next 30 days.",
      "allDay": "All-day"
    },
    "eventModal": {
      "titleNew": "New event",
      "titleEdit": "Edit event",
      "close": "Close",
      "titlePlaceholder": "Add title",
      "calendarLabel": "Calendar",
      "allDay": "All-day",
      "whenLabel": "When",
      "dragRangeHint": "Drag to select multiple days",
      "timeLabel": "Time",
      "startLabel": "Start",
      "endLabel": "End",
      "locationLabel": "Location / link",
      "locationPlaceholder": "Add a room, address, or call link",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Add a description",
      "addMeet": "Add Google Meet video conferencing",
      "addTeamsMeeting": "Add Teams meeting",
      "delete": "Delete",
      "cancel": "Cancel",
      "createAction": "Create",
      "saveAction": "Save",
      "untitled": "Untitled event",
      "guestsLabel": "Guests",
      "guestsPlaceholder": "Add guests",
      "recurrenceLabel": "Repeats",
      "recurrenceLoading": "Loading recurrence",
      "recurrence": {
        "none": "Does not repeat",
        "daily": "Every day",
        "weekly": "Weekly on {{weekday}}",
        "weekdays": "Every weekday (Mon–Fri)",
        "monthly": "Monthly",
        "yearly": "Annually"
      }
    },
    "emptyState": {
      "title": "No calendar connected",
      "description": "Connect a Google or Outlook calendar to view and manage your events here."
    },
    "errors": {
      "saveFailed": "Could not save event. Please try again.",
      "deleteFailed": "Could not delete event. Please try again.",
      "fetchFailed": "We couldn't load your calendars. Try reconnecting your account.",
      "reconnectLink": "Reconnect",
      "retryButton": "Retry",
      "rsvpFailed": "Could not update your RSVP. Please try again.",
      "copyFailed": "Could not copy to clipboard."
    },
    "eventDetails": {
      "allDay": "All day",
      "joinMeet": "Join with Google Meet",
      "joinMeeting": "Join meeting",
      "copyLink": "Copy meeting link",
      "copySuccess": "Meeting link copied",
      "guests": "{{count}} guest",
      "guests_other": "{{count}} guests",
      "guestYes": "{{count}} yes",
      "guestAwaiting": "{{count}} awaiting",
      "guestNo": "{{count}} no",
      "guestMaybe": "{{count}} maybe",
      "organizer": "Organizer",
      "rsvpLabel": "Going?",
      "rsvpYes": "Yes",
      "rsvpNo": "No",
      "rsvpMaybe": "Maybe",
      "rsvpLoading": "Updating RSVP",
      "editLabel": "Edit event",
      "deleteLabel": "Delete event",
      "closeLabel": "Close",
      "recurring": "Repeats"
    },
    "recurrenceScope": {
      "editTitle": "Edit recurring event",
      "deleteTitle": "Delete recurring event",
      "thisEvent": "This event",
      "allEvents": "All events",
      "cancel": "Cancel",
      "ok": "OK"
    }
  },
  "contacts": {
    "title": "Contacts",
    "newContact": "New contact",
    "countBadge": {
      "exact": "{{count}}",
      "plus": "{{count}}+"
    },
    "scope": {
      "personal": "My contacts",
      "team": "Team"
    },
    "search": {
      "placeholder": "Search name, email, job title…"
    },
    "filters": {
      "all": "All",
      "google": "Google",
      "outlook": "Outlook",
      "slack": "Slack",
      "landingPage": "Landing page"
    },
    "list": {
      "empty": "No contacts yet.",
      "noResults": "No contacts match your search."
    },
    "detail": {
      "back": "Back",
      "sourceVia": "via {{source}}",
      "sourceViaMultiple": "via {{sources}}",
      "empty": "Select a contact to view details.",
      "emailsTitle": "Emails",
      "phonesTitle": "Phones",
      "overflowCount": "+{{count}}",
      "primaryValue": "Primary",
      "removedByTeamMate": "This contact was removed by a teammate.",
      "mergedByTeamMate": "This contact was merged into another one by a teammate.",
      "eventRemoved": "This event was removed.",
      "copyValue": "Copy",
      "copiedValue": "Copied",
      "copyValueNamed": "Copy {{value}}",
      "copiedValueNamed": "Copied {{value}}"
    },
    "source": {
      "google": "Google",
      "outlook": "Outlook",
      "slack": "Slack",
      "manual": "Manual",
      "thisThat": "this+that",
      "landingPage": "Landing page"
    },
    "actions": {
      "mergeWith": "Merge with…",
      "sendEmail": "Send email",
      "chooseEmail": "Choose an email",
      "delete": "Delete",
      "addToTeam": "Add to team"
    },
    "notes": {
      "label": "Notes",
      "saving": "Saving…",
      "saved": "Saved",
      "placeholder": "Add notes about this contact…",
      "remoteUpdate": {
        "message": "A teammate updated these notes.",
        "action": "Show their version",
        "actionHint": "Discards the changes you haven't saved yet."
      }
    },
    "messages": {
      "title": "Recent messages",
      "titleShared": "Your interactions",
      "count_one": "{{count}} message",
      "count_other": "{{count}} messages",
      "empty": "No recent messages.",
      "untitled": "Untitled",
      "you": "You",
      "platform": "via {{platform}}",
      "openFailed": "This email is no longer available.",
      "opening": "Opening…",
      "sentBy": "Sent",
      "receivedFrom": "Received",
      "loadingMore": "Loading more messages…",
      "loadFailed": "Couldn't load messages. Please try again.",
      "capReached": "Showing the {{count}} most recent messages. We've stopped loading older ones here.",
      "newMessageArrived_one": "{{count}} new message arrived",
      "newMessageArrived_other": "{{count}} new messages arrived",
      "emptyEmail": "No emails with this contact.",
      "emptySlack": "No Slack messages with this contact.",
      "filters": {
        "ariaLabel": "Filter messages by platform",
        "all": "All",
        "email": "Emails",
        "slack": "Slack"
      }
    },
    "timeline": {
      "title": "Events",
      "count_one": "{{count}} event",
      "count_other": "{{count}} events",
      "empty": "No events recorded yet.",
      "loadingMore": "Loading more events…",
      "emptyHint": "Flows record events here as things happen.",
      "emptyAction": "Add one yourself",
      "add": "Add event"
    },
    "eventCreate": {
      "title": "New event",
      "titleLabel": "Title",
      "titlePlaceholder": "What happened",
      "descriptionLabel": "Description",
      "descriptionOptional": "optional",
      "descriptionPlaceholder": "Anything worth remembering about it",
      "whenLabel": "When",
      "whenDateLabel": "Event date",
      "whenTimeLabel": "Event time",
      "cancel": "Cancel",
      "submit": "Save event",
      "error": "Couldn't save this event. Please try again."
    },
    "eventDetails": {
      "ariaLabel": "Event details",
      "close": "Close",
      "flowSubtitle": "How this event got here.",
      "thisEvent": "this event",
      "noFlow": "This event wasn't recorded by a flow.",
      "teamVisibility": "Visible to everyone on this contact's team.",
      "openFlow": "Open flow",
      "edit": "Edit event",
      "titleLabel": "Event title",
      "descriptionLabel": "Event description",
      "descriptionPlaceholder": "Add a description",
      "cancelEdit": "Cancel",
      "saveEdit": "Save",
      "delete": "Delete",
      "deleteTitle": "Delete event",
      "deleteBody": "This will permanently delete this event. This action can't be undone.",
      "deleteBodyTeam": "This contact belongs to a team, so deleting this event removes it for everyone on that team. This action can't be undone.",
      "deleteConfirm": "Delete",
      "deleteCancel": "Cancel",
      "updateError": "Couldn't update this event. Please try again.",
      "deleteError": "Couldn't delete this event. Please try again.",
      "trigger": {
        "EMAIL": "Incoming email",
        "SLACK": "Slack message",
        "GOOGLE_CHAT": "Google Chat message",
        "INSTAGRAM": "Instagram message",
        "SCHEDULE": "Schedule",
        "DOBOX": "DoBox item",
        "MANUAL": "Manual run",
        "TELEGRAM": "Telegram message",
        "WHATSAPP": "WhatsApp message",
        "KNOWLEDGE": "Knowledge update",
        "GITHUB": "GitHub event",
        "PEOPLE": "Contact event",
        "GOOGLE_BUSINESS": "Google Business update"
      }
    },
    "create": {
      "title": "New contact",
      "name": "Name",
      "emails": "Email",
      "addEmail": "Add another email",
      "emailPlaceholder": "jane@example.com",
      "phone": "Phone",
      "addPhone": "Add another phone",
      "phonePlaceholder": "+1 415 555 0100",
      "jobTitle": "Job title",
      "teamLabel": "Team",
      "teamPersonalOption": "Personal contact",
      "submit": "Create contact",
      "cancel": "Cancel",
      "nameRequired": "Name is required.",
      "emailInvalid": "Enter a valid email address.",
      "teamCopySuccess": "{{name}} was created and added to {{team}}.",
      "teamCopyConflict": "{{name}} was created, but a contact with this email is already on {{team}}.",
      "teamOnlyContext": "Creating in {{team}}",
      "teamOnlySuccess": "{{name}} was created in {{team}}.",
      "teamOnlyConflict": "A contact with this email is already on {{team}}."
    },
    "edit": {
      "title": "Edit contact",
      "submit": "Save changes",
      "button": "Edit"
    },
    "delete": {
      "title": "Delete contact",
      "body": "This will permanently delete this contact. This action can't be undone.",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "merge": {
      "picker": {
        "title": "Merge with another contact",
        "subtitle": "Choose who to combine with {{name}}",
        "searchPlaceholder": "Search contacts",
        "selectedCount": "{{count}} selected",
        "limitWarning": "You can merge up to {{max}} contacts at once"
      },
      "confirm": {
        "title": "Merge {{count}} contacts into one",
        "info": "Emails and activity from all accounts are combined into one unified timeline. The email-integration photo becomes the primary avatar. Merging is permanent and can't be undone.",
        "warnNoEmail": "These contacts don't share an email address, so we can't verify they're the same person. Only merge if you're sure.",
        "submit": "Merge contacts"
      },
      "unifyingTimeline": "Unifying history — events and messages from merged contacts will appear here shortly.",
      "errors": {
        "limit": "You can't merge that many contacts at once.",
        "shareLimit": "One of these contacts is shared with too many teams to merge.",
        "notFound": "One of these contacts no longer exists.",
        "notOwned": "You can only merge contacts you own.",
        "generic": "Something went wrong while merging. Please try again."
      }
    },
    "addToTeam": {
      "title": "Add {{name}} to a team",
      "description": "This creates an independent copy of the contact for the team. The copy won't stay in sync with your personal contact, and this can't be undone.",
      "teamLabel": "Team",
      "selectPlaceholder": "Select a team",
      "noTeams": "You're not part of any team yet.",
      "copyGroupLabel": "Copy beyond the contact details",
      "copyNotes": "Notes",
      "copyEvents": "Timeline events",
      "discloseBase": "The {{team}} team will see the full contact details.",
      "discloseWithNotes": "The {{team}} team will see the full contact details and your notes.",
      "discloseWithEvents": "The {{team}} team will see the full contact details and the timeline events.",
      "discloseWithBoth": "The {{team}} team will see the full contact details, your notes and the timeline events.",
      "conflictMessage": "This contact is already on the team.",
      "conflictKnownName": "Already added as {{name}}.",
      "viewExisting": "View existing contact",
      "confirm": "Add to team",
      "success": "{{name}} was added to {{team}}.",
      "successWithEvents": "{{name}} was added to {{team}}. The events are being copied.",
      "errors": {
        "forbidden": "You don't have permission to add contacts to this team.",
        "notFound": "This contact is no longer available.",
        "contactsLimit": "This contact can't be copied — it has too many emails or phone numbers.",
        "generic": "Couldn't add the contact to the team. Please try again."
      }
    },
    "deepLinkTeamSwitch": {
      "switched": "Switched active team to {{teamName}} to view this contact",
      "switchedGeneric": "Switched active team to view this contact"
    },
    "errors": {
      "load": "Couldn't load contacts. Please try again.",
      "save": "Couldn't save your changes. Please try again.",
      "create": "Couldn't create the contact. Please try again.",
      "update": "Couldn't update the contact. Please try again.",
      "versionConflict": "This contact was changed by someone else. We've reloaded the latest version.",
      "delete": "Couldn't delete the contact. Please try again.",
      "search": "Couldn't search contacts. Please try again.",
      "notFound": "That contact no longer exists or isn't shared with you.",
      "nameRequired": "A contact must have a name.",
      "tooLong": "That value is too long. Please shorten it.",
      "teamForbidden": "Nothing was created — you're no longer part of that team. Choose a different team or create the contact in your personal contacts only."
    },
    "firstRunBanner": {
      "title": "Your contact list keeps itself",
      "subtitle": "Contacts arrive from the accounts you connect, and your flows keep each one current — notes, phone numbers, and a timeline of what actually happened. You never type a contact twice.",
      "status": {
        "noAccount": "No account connected yet — Google, Outlook, Slack or Teams.",
        "noAccountFootnote": "Sync runs automatically. It also picks up people you email but never saved.",
        "reading": "Syncing contacts from {{sources}}",
        "manage": "Manage",
        "connectedFootnote": "New people show up automatically, including anyone you email.",
        "justConnected": "{{platform}} connected. The first sync is already underway."
      },
      "action": {
        "connectAccount": "Connect an account",
        "connectAccountHint": "Google, Outlook, Slack or Teams.",
        "manageAccounts": "Manage accounts",
        "manageAccountsHint": "Contacts sync automatically. There is no manual sync.",
        "doneHide": "Done, hide this",
        "connectAnother": "Connect another",
        "hide": "Hide this"
      },
      "discovery": {
        "heading": "There's more in here",
        "subheading": "tap one to see it working",
        "cards": {
          "events": {
            "title": "Events",
            "description": "A flow writes what happened"
          },
          "automations": {
            "title": "Automations",
            "description": "New contact, handled"
          },
          "team": {
            "title": "Team contacts",
            "description": "One list your team shares"
          },
          "agents": {
            "title": "Agents",
            "description": "Hand a contact over"
          }
        }
      },
      "panel": {
        "close": "Close",
        "events": {
          "lede": "Every contact has a timeline. You don't write it — the flow that touched the contact records what it did, and where it came from.",
          "mockTitle1": "Notes updated",
          "mockTimestamp1": "2 days ago",
          "mockProvenance1": "How this event got here — Lead Researcher · New contact · read contact, searched people, updated notes",
          "mockTitle2": "Phone added",
          "mockTimestamp2": "5 days ago",
          "mockProvenance2": "How this event got here — Ops Intake Router · New contact · read contact, updated phones, created event",
          "cta": "Open a contact"
        },
        "automations": {
          "lede": "A new contact can trigger a flow. This one is ready to switch on:",
          "chipTrigger": "New contact",
          "chipStep1": "Agent researches them",
          "chipStep2": "Writes the notes",
          "chipStep3": "Logs an event",
          "footnote": "The trigger fires when a personal contact is created — by a sync, a landing page form, or you.",
          "cta": "Turn it on in Flows"
        },
        "team": {
          "lede": "Your list is yours. Copy a contact to the team list and everyone works from the same record.",
          "segmentMy": "My contacts",
          "segmentTeam": "Team",
          "row1Name": "Alex Rivera",
          "row1Meta": "Head of Operations · copied by you",
          "row2Name": "Ana Ribeiro",
          "row2Meta": "Product Consultant · copied by Ana Ribeiro",
          "footnote": "The team copy is a separate record. Editing it does not change your personal contact.",
          "cta": "Invite your team",
          "secondaryCta": "See the team list"
        },
        "agents": {
          "lede": "Hand a contact to an agent and it works the record on its own, then leaves the trail on the timeline.",
          "chip1": "Reads the contact",
          "chip2": "Searches your people",
          "chip3": "Writes the notes",
          "chip4": "Logs an event",
          "footnote": "Real agents already do this: Lead Researcher, Meeting Prep Assistant, Payment Change Verifier, Vendor Document Chaser, Ops Intake Router.",
          "cta": "Manage agents"
        }
      },
      "footer": {
        "fillsFrom": "Contacts also grows from",
        "chipGoogleOutlook": "Google & Outlook sync",
        "chipSlack": "Slack",
        "chipLandingPage": "Landing page forms",
        "chipFlows": "Flows",
        "chipManualEntry": "Manual entry"
      }
    }
  },
  "teamHub": {
    "roles": {
      "owner": "Owner",
      "admin": "Admin",
      "consultant": "Consultant",
      "member": "Member",
      "viewer": "Viewer",
      "pending": "Pending"
    },
    "overview": {
      "title": "Team hub",
      "subtitle": "Manage the teams you're part of, keep track of members, and collaborate in one place.",
      "searchPlaceholder": "Search teams",
      "createTeam": "Create team",
      "createCompact": "Create",
      "yourTeams": "YOUR TEAMS",
      "pendingInvites": "PENDING INVITES",
      "teamCount_one": "{{count}} team",
      "teamCount_other": "{{count}} teams",
      "countLine": "{{teamCount}} · {{inviteCount}}",
      "inviteMeta_one": "Invited by {{inviter}} · joining as {{role}} · {{count}} member",
      "inviteMeta_other": "Invited by {{inviter}} · joining as {{role}} · {{count}} members",
      "inviteMetaRelative": "Invited by {{inviter}} · {{time}}",
      "joinAs": "Join as",
      "ownerLabel": "Owner · {{name}}",
      "ownerYou": "Owner · You",
      "ownerYouUntilHandoff": "Owner · You, until handoff",
      "memberCount_one": "{{count}} member",
      "memberCount_other": "{{count}} members",
      "manage": "Manage",
      "accept": "Accept",
      "decline": "Decline",
      "teamCardAriaLabel": "{{name}} team",
      "newClientWorkspace": "New client workspace",
      "clientWorkspaceTag": "Client workspace",
      "statusInSetup": "In setup",
      "statusDelivered": "Delivered · {{date}}",
      "sections": {
        "yourTeams": {
          "label": "Your teams",
          "description": "Teams you belong to"
        },
        "inSetup": {
          "label": "Client workspaces · in setup",
          "description": "You own these until handoff"
        },
        "delivered": {
          "label": "Client workspaces · delivered",
          "description": "Owned by the client · you keep admin access"
        },
        "pendingInvites": {
          "label": "Pending invites",
          "description": "Waiting for your response"
        }
      },
      "empty": {
        "noTeams": {
          "title": "Not on a team yet",
          "text": "Create one or accept an invite.",
          "action": "Create team"
        },
        "noneInSetup": {
          "title": "Nothing in setup",
          "text": "Start a workspace you'll build for a client.",
          "action": "New workspace"
        },
        "noneDelivered": {
          "title": "Nothing delivered yet",
          "text": "Workspaces move here after handoff."
        }
      }
    },
    "detail": {
      "allTeams": "All teams",
      "inviteMembers": "Invite members",
      "editTeam": "Edit team",
      "switchTeam": "Switch team",
      "switchShort": "Switch",
      "metaMembers_one": "{{count}} member",
      "metaMembers_other": "{{count}} members",
      "metaPending": "{{count}} pending",
      "metaOwner": "Owner {{owner}}",
      "metaOwnedByYouUntilHandoff": "Owned by you until handoff"
    },
    "members": {
      "tabMembers": "Members",
      "tabPending": "Pending",
      "tabBilling": "Billing",
      "searchMembers": "Search members",
      "searchInvites": "Search invites",
      "colName": "NAME",
      "colEmail": "EMAIL",
      "colTitle": "JOB TITLE",
      "colRole": "ROLE",
      "emptyMembers": "No members found",
      "emptyPending": "No pending invitations",
      "pending": "PENDING",
      "you": "YOU",
      "noSeat": "No seat",
      "groupTeam": "Team",
      "groupConsultants": "Consultants",
      "groupSeatsNote": "{{seatsUsed}} of {{seatsTotal}} seats",
      "groupConsultantsNote": "Admin access · not billed · no seats used",
      "invitedAs": "Invited as {{role}}",
      "removeConfirmTitle": "Remove member",
      "removeConfirmDescription": "Remove {{name}} from this team? They'll lose access to its shared inbox and tasks.",
      "removeConfirmAction": "Remove",
      "cancelConfirmTitle": "Cancel invitation",
      "cancelConfirmDescription": "Cancel the invitation to {{email}}? They'll no longer be able to join with this invite."
    },
    "handoff": {
      "title": "Handoff",
      "subtitleOnce": "Once per workspace · can't be undone",
      "subtitleCompleted": "Completed {{date}}",
      "cta": "Hand off to client…",
      "steps": {
        "setup": "Set up",
        "ownerInvite": "Owner invite",
        "delivered": "Delivered"
      },
      "status": {
        "settingUp": "Setting up",
        "ownerInviteSent": "Owner invite sent",
        "delivered": "Delivered"
      },
      "settingUp": {
        "intro": "You own this workspace while you build it. When it's ready, invite the client as the new owner. The moment they accept:",
        "bullets": [
          "The client becomes the owner",
          "You stay on as a consultant with admin access, no seat used",
          "The trial period restarts for the client",
          "No more consultants can be added"
        ]
      },
      "awaiting": {
        "invitedAs": "Invited as {{role}} · {{time}}",
        "copy": "Nothing changes until they accept. You still own the workspace and can keep working in it. You can still add consultants for now.",
        "cancel": "Cancel invite",
        "resend": "Resend invite"
      },
      "delivered": {
        "acceptedOn": "Accepted {{date}} · trial restarted that day",
        "copyConsultant": "You have admin access as a consultant and don't use a seat. Leaving the workspace is in the danger zone below.",
        "copyOwner": "You're now the owner of this workspace. Consultants keep admin access to help you, without using a seat.",
        "lockedNote": "Consultants can no longer be added to this workspace.",
        "dismissAriaLabel": "Dismiss handoff card",
        "dismissError": "Couldn't dismiss this card. Please try again."
      }
    },
    "undo": {
      "accepted": "Joined {{team}}",
      "declined": "Declined invitation to {{team}}",
      "roleChanged": "{{name}} is now {{role}}",
      "error": "Something went wrong. Please try again.",
      "resent": "Invitation resent to {{email}}",
      "resending": "Resending invitation to {{email}}..."
    },
    "memberMenu": {
      "ariaLabel": "Member actions",
      "makeAdmin": "Make admin",
      "setMember": "Set as member",
      "setViewer": "Set as viewer",
      "remove": "Remove from team",
      "resend": "Resend invite",
      "cancel": "Cancel invite"
    },
    "dangerZone": {
      "deleteTitle": "Delete this team",
      "deleteDescription": "Permanently remove the team and all its data. This can't be undone.",
      "deleteAction": "Delete team",
      "leaveTitle": "Leave this team",
      "leaveDescription": "You'll lose access to this team's shared inbox and tasks.",
      "leaveAction": "Leave team",
      "deleteConfirmDescription": "This permanently removes {{teamName}} and all of its shared data for every member. This action can't be undone.",
      "leaveConfirmDescription": "Are you sure you want to leave {{teamName}}? You'll lose access to its shared inbox and tasks. This can't be undone.",
      "confirmCancel": "Cancel"
    },
    "inviteModal": {
      "title": "Invite members",
      "subtitle": "They'll get an email to join {{teamName}}",
      "emailLabel": "Email address",
      "emailPlaceholder": "name@company.com",
      "roleLabel": "Role",
      "addAnother": "Add another",
      "send": "Send invite",
      "sendMultiple": "Send {{count}} invites",
      "removeInvitee": "Remove {{email}}",
      "consultantHint": "Can invite members, edit the workspace and hand it off with you."
    },
    "inviteRoles": {
      "owner": {
        "name": "Owner",
        "description": "Full ownership of the workspace, billing included"
      },
      "admin": {
        "name": "Admin",
        "description": "Manage members, settings and billing"
      },
      "member": {
        "name": "Member",
        "description": "Create, assign and collaborate on tasks"
      },
      "viewer": {
        "name": "Viewer",
        "description": "View tasks and team activity, without editing"
      },
      "consultant": {
        "name": "Consultant",
        "description": "Admin access to help build the workspace, without using a seat"
      }
    },
    "modal": {
      "createTitleTeam": "Create a team",
      "createSubtitleTeam": "Set it up now — you can invite people right after.",
      "createTitleClient": "Create a client workspace",
      "createSubtitleClient": "You set it up as consultant and hand it off to the client.",
      "editTitle": "Edit team",
      "editSubtitle": "Update your team's name and icon color.",
      "typeSelector": {
        "label": "Who is this for?",
        "team": {
          "title": "My team",
          "description": "You own it and use a seat."
        },
        "client": {
          "title": "A client",
          "description": "You set it up as consultant, then hand it off."
        }
      },
      "nameLabelTeam": "Team name",
      "namePlaceholderTeam": "e.g. Marketing Ops",
      "nameLabelClient": "Client or workspace name",
      "namePlaceholderClient": "e.g. Acme Corp",
      "colorLabel": "Icon color",
      "previewFallbackTeam": "New team",
      "previewFallbackClient": "New client workspace",
      "previewMetaTeamCreate": "Owner · You · 1 member",
      "previewMetaClientCreate": "Consultant · You · Client becomes owner at handoff",
      "save": "Save changes",
      "createTeam": "Create team",
      "createClientWorkspace": "Create client workspace",
      "handoff": {
        "title": "Hand off {{teamName}}",
        "subtitle": "Invite the client as the new owner.",
        "emailLabel": "Client's email",
        "emailPlaceholder": "name@client.com",
        "emailHint": "They'll get an invite to join as Owner.",
        "consequences": {
          "title": "When they accept",
          "bullets": [
            "They become the owner; you become a consultant with admin access",
            "Their trial period restarts",
            "No more consultants can be added"
          ]
        },
        "confirmLabel": "I understand this happens once and can't be undone.",
        "submit": "Send owner invite"
      }
    },
    "toasts": {
      "created": "Team created successfully.",
      "consultingCreated": "Client workspace created.",
      "updated": "Team updated successfully.",
      "deleted": "Team deleted.",
      "left": "You have left the team.",
      "invitesSent": "Invitations sent.",
      "invitesSentPartial": "Sent {{sent}} of {{total}} invitations.",
      "inviteCancelled": "Invitation cancelled.",
      "inviteResent": "Invitation resent.",
      "inviteResendThrottled": "This invitation was already sent recently. Please try again in a few minutes.",
      "memberRemoved": "Member removed.",
      "roleUpdated": "Role updated.",
      "errorCreate": "Failed to create team. Please try again.",
      "errorUpdate": "Failed to update team. Please try again.",
      "errorDelete": "Failed to delete team. Please try again.",
      "errorLeave": "Failed to leave team. Please try again.",
      "errorInvitesSend": "Failed to send invitations. Please try again.",
      "errorInviteCancel": "Failed to cancel invitation. Please try again.",
      "errorInviteResend": "Failed to resend invitation. Please try again.",
      "errorRemoveMember": "Failed to remove member. Please try again.",
      "errorRoleUpdate": "Failed to update role. Please try again.",
      "errorLoad": "Failed to load team data. Please try again.",
      "errorAcceptInvite": "Failed to accept invitation. Please try again.",
      "errorDeclineInvite": "Failed to decline invitation. Please try again.",
      "declined": "Invitation declined.",
      "inviteFailure": {
        "MISSING_EMAIL": "An email address is required to send an invitation.",
        "SELF_INVITE": "You cannot invite yourself to a team.",
        "ROLE_NOT_ASSIGNABLE": "That role cannot be granted by invitation.",
        "TEAM_NOT_ACCESSIBLE": "You do not have permission to invite members to this team.",
        "ALREADY_MEMBER": "This person is already a member of the team.",
        "INVITEE_NOT_CONSULTANT": "This person does not carry the platform consultant designation.",
        "UNKNOWN": "The invitation could not be sent. Please try again."
      },
      "inviteReopenedNotSent": "Invitation reopened for {{email}}, but no email was sent — it was already sent recently.",
      "invitesFailedDetail": "Could not invite {{email}}: {{reason}}",
      "invitesSentPartialDetail": "Sent {{sent}} of {{total}} invitations. {{failures}}",
      "inviteAlreadyPending": "Invitation to {{email}} is already pending — it was sent recently, so no new email went out."
    },
    "billing": {
      "status": {
        "active": "Active",
        "trialing": "Trial",
        "pastDue": "Past due"
      },
      "pastDueBanner": {
        "title": "We couldn't process your last payment",
        "genericReason": "Please update your payment method to keep your subscription active.",
        "retryNotice": "We'll retry on {{date}}.",
        "cta": "Update payment method"
      },
      "planCard": {
        "changePlan": "Change plan",
        "manageInStripe": "Manage billing in Stripe",
        "trialEndsNotice": "Your trial ends {{date}}.",
        "cancelScheduledNotice": "Your plan will be canceled on {{date}}. You'll keep access until then.",
        "nextInvoice": "Next invoice: {{amount}} on {{date}}",
        "currentPeriod": "Current period: {{start}} – {{end}}",
        "billingContact": "Billing contact: {{email}}",
        "priceSuffix": "/user/{{interval}}"
      },
      "seats": {
        "title": "Seats",
        "editorsBreakdown": "{{count}} editors billed",
        "prorationNote": "Adding or removing members updates your bill on a prorated basis.",
        "usedOf": "{{used}} of {{total}} used",
        "inUse": "Seats in use",
        "consultants": "Consultants",
        "consultantsSuffix": "no seat",
        "consultantNote": "Consultants have admin access but don't use a seat and aren't billed. Only members added by your team count toward the plan."
      },
      "starter": {
        "title": "You're on the Starter plan",
        "subtitle": "Upgrade to Team to unlock unlimited DoBox suggestions and more.",
        "trial": {
          "title_one": "Your trial ends in {{count}} day",
          "title_other": "Your trial ends in {{count}} days",
          "subtitle": "Add a card before {{date}} to keep your Team features."
        },
        "expired": {
          "notice": "Your trial has expired. Upgrade anytime to unlock Team features again."
        }
      },
      "cancel": {
        "sectionTitle": "Cancel subscription",
        "sectionDescription": "Cancel your Team subscription. You'll lose access to Team features at the end of the billing period.",
        "action": "Cancel subscription",
        "confirmTitle": "Cancel subscription",
        "confirmDescription": "You'll keep access to Team features until {{date}}, then your team moves to Starter.",
        "confirmDescriptionNoDate": "You'll keep access to Team features until the end of the current billing period, then your team moves to Starter.",
        "confirmAction": "Cancel subscription"
      },
      "finalizing": {
        "title": "Finalizing your upgrade...",
        "message": "This can take a few seconds while we confirm your payment."
      },
      "toasts": {
        "checkoutError": "We couldn't start checkout. Please try again.",
        "portalError": "We couldn't open the billing portal. Please try again.",
        "cancelSuccess": "Your subscription will be canceled at the end of the billing period.",
        "cancelError": "Failed to cancel your subscription. Please try again.",
        "loadError": "Failed to load billing details. Please try again."
      }
    }
  },
  "churn": {
    "title": "Churn",
    "subtitle": "Why people deleted their account, and what they had built when they did.",
    "loading": "Loading deletions…",
    "empty": "No account deletions in this period.",
    "emptyBody": "Only test accounts were deleted between these dates. Turn on internal and test accounts to inspect them.",
    "error": "Could not load account deletions.",
    "rangeCaption": "{{start}} – {{end}} · follows the header date range",
    "filters": {
      "includeTestAccounts": "Include internal and test accounts"
    },
    "kpis": {
      "deletions": "Deletions",
      "deletionsSub": "{{count}} test account",
      "deletionsSub_other": "{{count}} test accounts",
      "topReason": "Top reason",
      "topReasonSub": "{{percent}}%",
      "source": "Source",
      "sourceSub": "{{count}} of {{total}}"
    },
    "reasons": {
      "cardTitle": "Reported reasons",
      "multiReason": "a deletion can carry several reasons",
      "count": "{{count}} · {{percent}}%",
      "tooExpensive": "Too expensive",
      "missingIntegration": "Missing an integration",
      "aiNotUseful": "The AI was not useful",
      "tooComplex": "Too complex",
      "switchingTool": "Switching to another tool",
      "notUsingEnough": "Not using it enough",
      "privacy": "Privacy concerns",
      "other": "Other",
      "noReasonGiven": "No reason given"
    },
    "sources": {
      "userModal": "Deletion modal",
      "clerkWebhook": "Clerk webhook",
      "admin": "Admin",
      "unattributed": "Unattributed"
    },
    "counts": {
      "agentConversations": "conversations",
      "agentExecutionHistory": "execution history",
      "agentRuns": "agent runs",
      "agentTemplates": "templates",
      "aiUsage": "AI usage",
      "artifacts": "artifacts",
      "chatSessions": "chats",
      "communicationAgents": "flows",
      "contacts": "contacts",
      "doBoxConfigs": "DoBox configs",
      "emailCounters": "counters",
      "evalConfig": "eval config",
      "flowExecution": "flow runs",
      "flowGenerationJobs": "flow jobs",
      "flowGroups": "flow groups",
      "generatedImages": "images",
      "google": "Google",
      "integrationRequests": "integration requests",
      "knowledgeFavorites": "favorites",
      "knowledgeSpaces": "spaces",
      "localDevices": "devices",
      "mcpConnections": "MCP",
      "meetingPolls": "polls",
      "metaCredentials": "Meta",
      "microsoft": "Microsoft",
      "notifications": "notifications",
      "outlookFolderCache": "Outlook cache",
      "peopleAndActivity": "people",
      "pushSubscriptions": "push",
      "scanJobs": "scan jobs",
      "scheduledEmails": "scheduled mail",
      "sessions": "sessions",
      "slack": "Slack",
      "slackWorkspaceCache": "Slack cache",
      "snoozedEmails": "snoozed mail",
      "taskGroups": "task groups",
      "teamInvites": "invites",
      "teamRequests": "requests",
      "telegram": "Telegram",
      "unreadItems": "unread",
      "userAttachments": "attachments",
      "userCommunicationsSwept": "leftover messages",
      "webSocketConnections": "live connections",
      "workflowRecommendations": "recommendations"
    },
    "billingState": {
      "ACTIVE": "Paying",
      "TRIALING": "Stripe trial",
      "PAST_DUE": "Past due",
      "STARTER": "Free",
      "APP_TRIAL": "In trial",
      "APP_TRIAL_EXPIRED": "Trial expired"
    },
    "table": {
      "title": "Deletions",
      "purgedNote": "data purged at deletion · counts are the last snapshot",
      "noSnapshot": "No snapshot",
      "testAccount": "test",
      "unknown": "Unknown",
      "none": "None",
      "teams": "Teams",
      "owner": "owner",
      "doBox": "DoBox",
      "doBoxSummary": "{{total}} total · {{resolved}} resolved · {{open}} open",
      "doBoxSplit": "{{agent}} by AI · {{manual}} by hand",
      "removed": "Removed at deletion",
      "expandRow": "Expand deletion details",
      "collapseRow": "Collapse deletion details"
    },
    "erase": {
      "action": "Erase",
      "confirm": "Erase this record",
      "cancel": "Cancel",
      "success": "Record erased.",
      "error": "Could not erase the record. Try again."
    }
  },
  "assistantMemory": {
    "title": "Assistant memory",
    "unavailable": {
      "title": "Assistant memory is not available yet"
    },
    "tabs": {
      "rules": "Rules",
      "history": "History",
      "routines": "Routines",
      "permissions": "Permissions"
    },
    "emptyState": {
      "rules": {
        "title": "No remembered rules yet",
        "subtitle": "Rules you ask the assistant to always follow will show up here."
      },
      "history": {
        "title": "No history yet",
        "subtitle": "Outcomes the assistant records as it works will show up here."
      }
    },
    "loadMore": "Load more",
    "loadError": "Couldn't load your assistant memory",
    "row": {
      "summaryLabel": "Summary",
      "updated": "Updated {{time}}"
    },
    "actions": {
      "ariaLabel": "Decision actions",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "pause": "Pause",
      "resume": "Resume",
      "forget": "Forget",
      "forgetConfirmQuestion": "Forget this decision? This can't be undone.",
      "forgetContact": "Forget everything about {{contact}}",
      "forgetContactConfirmQuestion": "Forget everything about {{contact}}? This can't be undone.",
      "neverSuggest": "Never suggest for this contact",
      "defaultContact": "this contact"
    },
    "edit": {
      "placeholder": "What should the assistant always do?",
      "emptyError": "The instruction can't be empty"
    },
    "toast": {
      "editSuccess": "Rule updated",
      "editError": "Couldn't update this rule",
      "pauseSuccess": "Rule paused",
      "pauseError": "Couldn't pause this rule",
      "resumeSuccess": "Rule resumed",
      "resumeError": "Couldn't resume this rule",
      "forgetSuccess": "Forgotten",
      "forgetError": "Couldn't forget this decision",
      "forgetContactSuccess_one": "Forgot {{count}} decision about this contact",
      "forgetContactSuccess": "Forgot {{count}} decisions about this contact",
      "forgetContactError": "Couldn't forget decisions about this contact",
      "neverSuggestSuccess": "Won't suggest for this contact again",
      "neverSuggestError": "Couldn't save that"
    }
  }
}
